'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var Styled = require('styled-components');
var Styled__default = _interopDefault(Styled);
var polished = require('polished');
var ReactDOM = _interopDefault(require('react-dom'));
var reactCustomScrollbars = require('react-custom-scrollbars');
var rebound = require('rebound');
var AutoSizer = _interopDefault(require('react-virtualized-auto-sizer'));
var Tippy = _interopDefault(require('@tippyjs/react'));
require('tippy.js/dist/tippy.css');
require('tippy.js/themes/light-border.css');
var tippy_js = require('tippy.js');
var ContentEditable = _interopDefault(require('react-contenteditable'));
var core = require('@material-ui/core');
var VisibilitySensor = _interopDefault(require('react-visibility-sensor'));
var moment = _interopDefault(require('moment'));
var d3 = require('d3-shape');
var reactChartjs2 = require('react-chartjs-2');
var chart_js = require('chart.js');
require('chartjs-adapter-moment');
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Deprecated should use the new Theme Provider!
// set all colors in the themes/theme.js file
var CSS_CONSTANTS = {
  brand_color: '#392664',
  // brand_color_dark: 'darken($brand-color, 12.5%)',
  // brand_color_light: 'lighten($brand-color, 15%)',
  brand_color_disabled: '#eee',
  brand_color_accent: '#e500d2',
  brand_brown_light: '#eee',
  error_background_color: '#eabcbc',
  error_border_color: '#cb5c5c',
  error_text_color: '#a82d2d',
  alert_color: '#cc0000',
  negative_value: '#d0021b',
  light_border_color: '#eee',
  light_hover_color: '#fefefe',
  menu_hover_color: '#fefefe',
  color_white: '#fff',
  color_dark_blue: '#1d3557',
  color_green: '#5ccb66',
  color_red: '#e63946',
  color_segment_sleepers: '#f3a030',
  color_segment_risk: '#f36530',
  color_segment_disaster: '#e63946',
  color_light_black: '#625c58',
  color_black: '#000',
  color_light_gray: '#fafafa',
  color_light_grey: '#f2f2f2',
  color_light_blue: '#4ed6f8',
  color_medium_gray: '#f3f3f3',
  color_dark_gray: '#7d7d7d',
  color_silver: 'silver',
  color_branding_purple: '#2b1951',
  color_purple_hover_active: '#6f49c5',
  color_martin_primary_salmon: '#ff7c75',
  color_martin_primary_purple: '#392664',
  color_martin_primary_blue: '#44b4ff',
  color_martin_primary_pink: '#efa7fd',
  color_martin_secondary_green: '#99ff8c',
  color_martin_secondary_purple: '#742bd6',
  color_martin_secondary_beige: '#f5ede4',
  color_martin_secondary_yellow: '#ffd761',
  color_martin_tertiary_purple: '#742bd6',
  color_martin_tertiary_brown: '#886c68',
  color_martin_tertiary_orange: '#faa434',
  color_martin_tertiary_swamp_green: '#006970',
  color_martin_tertiary_warm_purple: '#ac42a2',
  color_martin_tertiary_pink: '#e93a66',
  color_martin_tertiary_blue: '#217bf6',
  color_martin_tertiary_dark_purple: '#00001f',
  color_martin_tertiary_green: '#62d87b',
  color_martin_tertiary_light_purple: '#a56dfd',
  color_martin_timeline_border: '#ebebee',
  color_martin_timeline_background: '#f7f7f7',
  color_martin_dependency_gray: '#d8d8d8',
  delete_button_red: '#ff4e5a',
  favoured_task_yellow: '#fefdf3',
  v2_tooltip_grey: '#ebebeb',
  v2_receipt_green: '#00cc66',
  v2_input_disabled_grey: '#f3f3f3',
  v2_list_hover_purple: 'rgba(110, 15, 234, 0.1)',
  v2_list_background_purple: 'rgba(110, 15, 234, 0.05)',
  v2_list_background_purple_opaque: 'rgb(247, 243, 253)',
  v2_backdrop_gray: '#cecece',
  v2_retainer_conflict_red: '#ec4b4b',
  v2_column_header_grey: '#dfdfdf',
  v2_section_main_background: '#ffffff',
  v2_dark_green: '#00300c',
  v2_branding_purple: '#6e0fea',
  v2_dark_purple: '#560eb3',
  v2_text_light_gray: '#a1a1a1',
  v2_text_gray: '#535353',
  v2_header_text_dark_gray: '#2e2541',
  v2_background_dark_gray: '#4a5968',
  v2_light_gray: '#f6f6f6',
  v2_border_gray: '#e9e9e9',
  v2_border_invalid: '#e4253b',
  v2_create_button_green: '#05e298',
  v2_create_button_green_active: '#0ab47b',
  v2_create_button_green_alpha: '#05e298b3',
  v2_create_menu_green_border: '#00e891',
  v2_dependency_green: '#07e064',
  v2_negative_dropdown_grey: '#3f4b57',
  v2_date_picker_button_gray: '#f6f6f6',
  v2_date_picker_button_border_color: '#a1a1a1',
  v2_date_picker_day_in_range_gray: '#a4bac4',
  v2_date_picker_day_in_range_gray_8: '#a4bac4b3',
  v2_dark_grey: '#3f4b57',
  v2_grey: '#dbdbdb',
  v2_fixed_element_grey: '#f5f5f8',
  v2_row_highlight_color: '#dbdbdb',
  v2_row_highlight_border_color: '#f3f3f3',
  v2_red: '#e23f3f',
  v2_workflow_task_done_state_color: '#19e042',
  v2_workflow_task_selected_color: '#f0e7fc',
  v2_workflow_halted_task_selected_color: '#c1c1c1',
  v2_workflow_task_warning_red: '#e21e5b',
  v2_workflow_task_warning_yellow: '#ffd200',
  v2_workflow_column_category_option_grey: '#a4b9c4',
  v2_completed_green: '#19e042',
  v2_files_selected_row: '#f8f8f8',
  v2_files_upload_hover_message_color: '#efefef',
  v2_table_border_color: '#eaeaea',
  v2_dropdown_hover_grey: '#5b6671',
  v2_button_light_grey: '#dcdcdc',
  v2_button_very_light_grey: '#e6e6e6',
  v2_button_very_light_grey_hovered: '#a1a1a1',
  v2_button_medium_grey: '#f5f5f5',
  v2_add_button_blue: '#0081ff',
  v2_input_field_filled_gray: '#a7a7a7',
  v2_nested_dropdown_input_color: '#545454',
  v2_create_menu_text_color: '#133429',
  v2_projects_dropdown_project_group_indicator: '#5a18b6',
  v2_projects_dropdown_blocked: '#e01212',
  v2_pricing_list_grey: '#f5f6f8',
  v2_urban_black: '#2d095c',
  non_project_time_allocation: '#efefef',
  v2_pricing_border: '#c3c3c3',
  v2_disabled_purple: '#dccaf5',
  link_text_color: '#4a90e2',
  v2_person_dropdown_role_background_color: '#4a90e2',
  v2_global_search_criteria_background_color: '#e1e1e1',
  v2_role_shorthand_color: '#470c93',
  base_font_size: '16px',
  app_header_title_size: '2.42rem',
  base_font_regular_weight: '400',
  base_font_medium_weight: '500',
  base_font_semibold_weight: '600',
  base_font_bold_weight: '700',
  heading_font_family: "'urbane', sans-serif",
  text_font_family: "'neue-haas-grotesk-text', sans-serif",
  v2_site_header_font_family: "'neue-haas-grotesk-text', sans-serif",
  text_font_family_v2: "'neue-haas-grotesk-text', sans-serif",
  text_base_color: 'rgba(0, 0, 0, 0.87)',
  input_background: '#fbfaf8',
  input_border_color: '#e4e2db',
  input_border_color_focus: '#c8c6c1',
  input_color: '#333',
  input_placeholder_color: '#c9bdb5',
  // input_placeholder_color_focus: 'lighten($input-placeholder-color, 10%)',
  input_placeholder_color_disabled: '#c0c0c0',
  app_border_color: '#e6e6e6',
  app_hard_border_color: '#b3b3b3',
  app_branding_table_border_color: '#b3b3b3',
  app_loader_url: "'images/loaders/loader-16x16-white.svg'",
  nav_section_header: '#2d2d2d',
  app_header_height: '37px',
  section_header_height: '55px',
  app_header_logo_url: "'images/logo.svg'",
  app_header_logo_white_url: "'images/logo-white.svg'",
  app_header_logo_gray_url: "'images/logo-gray.svg'",
  app_header_logo_v2_url: "'images/logo-v2.svg'",
  app_header_logo_width: '66px',
  btn_second_pressed: '#757575',
  btn_second_active: '#e0e0e0',
  btn_white_pressed: '#c7c7c7',
  btn_white_active: '#f7f7f7',
  drop_color: '#f3f3f3',
  // chart_axis_label_color: 'darken($input-placeholder-color, 10%)',
  chart_tooltip_background_color: 'rgba(0, 0, 0, 0.8)',
  chart_tooltip_label_text_color: '#fff',
  chart_tooltip_data_outline_color: '#fff',
  chart_tooltip_data_text_color: '#ddd',
  chart_data_color_blue: '#51a7d9',
  chart_axis_label_font_size: '0.9rem',
  chart_line_dot_size: '12px',
  material_label_color: '#858585',
  material_locked_color: '#979797',
  bulk_update_selected_color: '#f1e9fa',
  onboarding_container_background_color: '#9b6bf7',
  insight_component_portfolio_report_very_positive_value: '#00ff00',
  insight_component_portfolio_report_positive_value: '#19a042',
  insight_component_portfolio_report_medium_value: '#ffe599',
  insight_component_portfolio_report_negative_value: '#e7abab',
  insight_component_portfolio_report_very_negative_value: '#ff0000',
  insight_component_portfolio_report_no_value: '#ffffff'
};
CSS_CONSTANTS = _objectSpread2(_objectSpread2({}, CSS_CONSTANTS), {}, {
  color_segment_loyal: CSS_CONSTANTS.brand_color,
  section_main_background: CSS_CONSTANTS.color_light_grey,
  chart_grid_line_color: CSS_CONSTANTS.input_border_color,
  chart_axis_line_color: CSS_CONSTANTS.input_placeholder_color,
  chart_axis_tick_color: CSS_CONSTANTS.input_placeholder_color,
  chart_data_color_green: CSS_CONSTANTS.brand_color,
  chart_tracer_color: CSS_CONSTANTS.input_border_color,
  material_focused_color: CSS_CONSTANTS.color_purple_hover_active
});
var img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='190px' height='146px' viewBox='0 0 190 146' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 62 (91390) - https://sketch.com --%3e %3ctitle%3eDiagonal lines pattern%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e %3crect id='path-1' x='0' y='0' width='190' height='146'%3e%3c/rect%3e %3c/defs%3e %3cg id='My-Timesheets' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Diagonal-lines-pattern'%3e %3cmask id='mask-2' fill='white'%3e %3cuse xlink:href='%23path-1'%3e%3c/use%3e %3c/mask%3e %3cg id='Mask' opacity='0.3'%3e%3c/g%3e %3cg id='Lines' mask='url(%23mask-2)' stroke='%23EBEBEB'%3e %3cg transform='translate(-15.000000%2c -1.000000)' id='Line'%3e %3cline x1='23.2555483' y1='0' x2='14.2555483' y2='9'%3e%3c/line%3e %3cline x1='33.2555483' y1='0' x2='13.4565584' y2='19.7989899'%3e%3c/line%3e %3cline x1='43.2555483' y1='2.27373675e-13' x2='13.5570635' y2='29.6984848'%3e%3c/line%3e %3cline x1='53.2555483' y1='-2.27373675e-13' x2='13.6575685' y2='39.5979797'%3e%3c/line%3e %3cline x1='63.2555483' y1='0' x2='13.7580736' y2='49.4974747'%3e%3c/line%3e %3cline x1='73.2555483' y1='0' x2='14' y2='59.2555483'%3e%3c/line%3e %3cline x1='83.2555483' y1='0' x2='14.1005051' y2='69.1550432'%3e%3c/line%3e %3cline x1='93.2555483' y1='-2.27373675e-13' x2='14.2010101' y2='79.0545381'%3e%3c/line%3e %3cline x1='103.255548' y1='-2.27373675e-13' x2='9.3517676' y2='93.9037807'%3e%3c/line%3e %3cline x1='113.255548' y1='-2.27373675e-13' x2='0.966991411' y2='112.288557'%3e%3c/line%3e %3cline x1='123.255548' y1='2.27373675e-13' x2='3.8959236' y2='119.359625'%3e%3c/line%3e %3cline x1='133.255548' y1='2.27373675e-13' x2='11.1184633' y2='122.137085'%3e%3c/line%3e %3cline x1='143.255548' y1='2.27373675e-13' x2='10.3194734' y2='132.936075'%3e%3c/line%3e %3cline x1='153.255548' y1='4.54747351e-13' x2='10.4199785' y2='142.83557'%3e%3c/line%3e %3cline x1='163.255548' y1='0' x2='10.5204835' y2='152.735065'%3e%3c/line%3e %3cline x1='173.255548' y1='2.27373675e-13' x2='10.6209886' y2='162.63456'%3e%3c/line%3e %3cline x1='183.255548' y1='2.27373675e-13' x2='10.862915' y2='172.392633'%3e%3c/line%3e %3cline x1='193.255548' y1='2.27373675e-13' x2='18.0344879' y2='175.22106'%3e%3c/line%3e %3cline x1='203.255548' y1='0' x2='32.2771286' y2='170.97842'%3e%3c/line%3e %3cline x1='213.255548' y1='0' x2='36.6202743' y2='176.635274'%3e%3c/line%3e %3cline x1='223.255548' y1='0' x2='54.3984489' y2='168.857099'%3e%3c/line%3e %3cline x1='233.255548' y1='4.54747351e-13' x2='64.3984489' y2='168.857099'%3e%3c/line%3e %3cline x1='239.255548' y1='4' x2='67.3273809' y2='175.928167'%3e%3c/line%3e %3cline x1='239.255548' y1='14' x2='84.398449' y2='168.857099'%3e%3c/line%3e %3cline x1='239.255548' y1='24' x2='94.3984486' y2='168.8571'%3e%3c/line%3e %3cline x1='239.255548' y1='34' x2='104.398449' y2='168.857099'%3e%3c/line%3e %3cline x1='239.255548' y1='44' x2='114.398449' y2='168.857099'%3e%3c/line%3e %3cline x1='239.25213' y1='54.003418' x2='124.398449' y2='168.857099'%3e%3c/line%3e %3cline x1='239.255548' y1='64' x2='134.398449' y2='168.857099'%3e%3c/line%3e %3cline x1='239.255548' y1='74' x2='144.398449' y2='168.857099'%3e%3c/line%3e %3cline x1='23.2555483' y1='80' x2='14.2555483' y2='89'%3e%3c/line%3e %3cline x1='239.255548' y1='84' x2='159.251263' y2='164.004286'%3e%3c/line%3e %3cline x1='239.255548' y1='94' x2='169.251263' y2='164.004286'%3e%3c/line%3e %3cline x1='239.255548' y1='104' x2='179.251263' y2='164.004286'%3e%3c/line%3e %3cline x1='239.255548' y1='114' x2='189.251263' y2='164.004286'%3e%3c/line%3e %3cline x1='239.255548' y1='124' x2='199.251263' y2='164.004286'%3e%3c/line%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var AIIconStyle = Styled__default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tbottom: 5px;\n\tleft: 6px;\n"]))); // Marius: modalView property is still in discussion if it should be used. Currently hours input has a different design in most new modals

var InputStyle = Styled__default.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: ", ";\n\tborder-radius: 4px;\n\tborder: solid ", " ", ";\n\tbackground-color: ", ";\n\tfont-size: ", ";\n\t", ";\n\tpadding: ", ";\n\tline-height: ", "; /*if we don't set it the font height is 17px wich make the input too tall*/\n\ttext-align: ", ";\n\t", ";\n\tcolor: ", ";\n\theight: ", ";\n\t", ";\n\t", ";\n\n\t::-webkit-input-placeholder {\n\t\t/* Chrome/Opera/Safari */\n\t\tfont-size: 13px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n\t::-moz-placeholder {\n\t\t/* Firefox 19+ */\n\t\tfont-size: 13px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n\t:-ms-input-placeholder {\n\t\t/* IE 10+ */\n\t\tfont-size: 13px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n\t:-moz-placeholder {\n\t\t/* Firefox 18- */\n\t\tfont-size: 13px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n\t&.non-working-day {\n\t\tbackground-image: url(", ");\n\t\tbackground-position: center;\n\t\tbackground-size: auto auto;\n\t}\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\t&:disabled,\n\t&.locked {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t}\n\t&.error {\n\t\tborder-color: ", ";\n\t}\n\t&:focus {\n\t\tborder-color: ", ";\n\t\toutline: none;\n\t}\n"])), function (props) {
  return props.width || '100%';
}, function (props) {
  return props.taskModalStyle || props.noBorder ? '0px' : '1px';
}, CSS_CONSTANTS.app_border_color, function (props) {
  return props.taskModalStyle ? 'inherit' : CSS_CONSTANTS.color_white;
}, function (props) {
  return props.modalView ? '12px' : props.taskModalStyle ? '15px' : '13px';
}, function (props) {
  return props.taskModalStyle ? 'font-weight: 700;' : '';
}, function (props) {
  return props.modalView ? '0 16px' : props.taskModalStyle ? '0' : '6px 16px 6px 10px';
}, function (props) {
  return props.modalView ? 'normal' : '16px';
}, function (props) {
  return props.alignLeft ? 'left' : 'right';
}, function (props) {
  return props.modalView ? 'flex: 0 1 auto;' : '';
}, function (props) {
  return props.modalView ? 'inherit' : CSS_CONSTANTS.v2_text_gray;
}, function (props) {
  return props.modalView ? '40px' : props.taskModalStyle ? '' : '30px';
}, function (props) {
  return props.modalView ? 'display: flex;' : '';
}, function (props) {
  return props.modalView ? 'flex-direction: row;' : '';
}, CSS_CONSTANTS.v2_button_very_light_grey_hovered, CSS_CONSTANTS.v2_button_very_light_grey_hovered, CSS_CONSTANTS.v2_button_very_light_grey_hovered, CSS_CONSTANTS.v2_button_very_light_grey_hovered, img, CSS_CONSTANTS.v2_button_very_light_grey_hovered, function (props) {
  return props.noLocked ? 'none' : CSS_CONSTANTS.v2_text_light_gray;
}, function (props) {
  return props.noLocked ? 'none' : CSS_CONSTANTS.v2_input_disabled_grey;
}, function (props) {
  return props.noLocked ? 'none' : CSS_CONSTANTS.app_border_color;
}, CSS_CONSTANTS.negative_value, CSS_CONSTANTS.v2_branding_purple);
var InputTextStyle = Styled__default(InputStyle)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\ttext-align: left;\n"])));
var HiddenSpanStyle = Styled__default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\twidth: auto;\n\tvisibility: hidden;\n\tposition: fixed;\n\toverflow: auto;\n\tfont-size: 20px;\n\tline-height: 28px;\n\tfont-weight: 500;\n\tpadding: 6px 16px 6px 10px;\n"])));
var PageHeaderInputStyle = Styled__default(InputStyle)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n\t", ";\n\tfont-size: 20px;\n\tline-height: 28px;\n\tcolor: ", ";\n\tfont-weight: 500;\n\ttext-align: left;\n\tborder-width: 0 0 1px;\n\tborder-color: ", ";\n\tborder-radius: 0px;\n\tpadding-left: 0px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\t&:focus {\n\t\t", ";\n\t}\n\t&:hover {\n\t\tborder-width: 0 0 1px;\n\t}\n\t::-webkit-input-placeholder {\n\t\t/* Chrome/Opera/Safari */\n\t\tfont-size: 20px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n\t::-moz-placeholder {\n\t\t/* Firefox 19+ */\n\t\tfont-size: 20px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n\t:-ms-input-placeholder {\n\t\t/* IE 10+ */\n\t\tfont-size: 20px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n\t:-moz-placeholder {\n\t\t/* Firefox 18- */\n\t\tfont-size: 20px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n"])), function (props) {
  return props.maxWidth ? 'max-width: 300px;' : '';
}, function (props) {
  return props.width ? 'width:' + props.width + 'px' : '';
}, function (props) {
  return props.transition ? 'transition: width 0.30s ease-in-out;' : '';
}, CSS_CONSTANTS.v2_text_gray, CSS_CONSTANTS.color_white, function (props) {
  return props.maxWidth ? 'width: 300px;' : '';
}, CSS_CONSTANTS.v2_button_very_light_grey_hovered, CSS_CONSTANTS.v2_button_very_light_grey_hovered, CSS_CONSTANTS.v2_button_very_light_grey_hovered, CSS_CONSTANTS.v2_button_very_light_grey_hovered);
var InputContainerStyle = Styled__default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: flex;\n\t", "\n\t", "\n\tflex-direction: column;\n"])), function (props) {
  return props.noMaxWidth ? 'max-width: 90px;' : 'max-width: 100%;';
}, function (props) {
  return props.modalView || props.taskModalStyle ? '' : 'height: 30px;';
});
var InputLabelStyle = Styled__default.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\theight: 11px;\n\tfont-size: 9px;\n\tfont-weight: 400;\n\tline-height: 1.22;\n\tletter-spacing: 1px;\n\t", "\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\tmargin-bottom: 5px;\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\t.required-extension {\n\t\t&:not(.inactive) {\n\t\t\tcolor: ", ";\n\t\t}\n\t\ttext-transform: none;\n\t\tfont-size: 8px;\n\t\tmargin-left: 5px;\n\t}\n"])), function (props) {
  return props.alignRight ? 'text-align: right;' : '';
}, CSS_CONSTANTS.v2_text_light_gray, CSS_CONSTANTS.negative_value);
var LockedIconStyle = Styled__default.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tbottom: -6px;\n\tleft: -2px;\n"])));
var LockedIcon = function LockedIcon(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.className
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: '9px',
    height: '10px',
    viewBox: "0 0 9 10"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: '#757575',
    fillRule: "evenodd",
    d: "M1.667 8.333h5V5h-5v3.333zm2.5-6.666c.919 0 1.666.747 1.666 1.666H2.5c0-.919.748-1.666 1.667-1.666zM7.5 3.333A3.337 3.337 0 0 0 4.167 0 3.337 3.337 0 0 0 .833 3.333.834.834 0 0 0 0 4.167v5c0 .46.373.833.833.833H7.5c.46 0 .833-.372.833-.833v-5a.834.834 0 0 0-.833-.834z"
  })));
};
var HoursInput = function HoursInput(props) {
  var inputState = props.locked ? ' locked' : props.disabled ? '' : props.hasError ? ' error' : props.nonWorkingDay ? ' non-working-day' : '';
  return /*#__PURE__*/React__default.createElement(InputContainerStyle, null, /*#__PURE__*/React__default.createElement(InputStyle, {
    className: inputState,
    type: 'text',
    placeholder: props.placeholder,
    value: props.value,
    onFocus: function onFocus(e) {
      e.preventDefault();
      e.target.select();
      props.onClick(e);
    },
    onBlur: props.onBlur,
    disabled: props.disabled || props.locked
  }), props.locked ? /*#__PURE__*/React__default.createElement(LockedIconStyle, null, /*#__PURE__*/React__default.createElement(LockedIcon, {
    className: "locked"
  })) : null);
};
LockedIcon.propTypes = {
  className: PropTypes.string
};
HoursInput.propTypes = {
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * Same as disabled, plus a visual indicator.
   */
  locked: PropTypes.bool,
  /**
   * When the input is focused the current value is selected. And the cursor ready to receive text input
   */
  onClick: PropTypes.func,
  /**
   * On blue the input parse the value to change it to the hours format (1h 30m).
   * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
   */
  onBlur: PropTypes.func,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
   * Action to execute if the validation is successful
   */
  mutation: PropTypes.func,
  /**
   * Value of the input
   */
  value: PropTypes.string,
  /**
   * State from the timesheet. It indicates if the time input belongs to a user's non working day
   */
  nonWorkingDay: PropTypes.bool
};
HoursInput.defaultProps = {
  disabled: false,
  locked: false,
  hasError: false,
  nonWorkingDay: false
};
var convertBasicInputToFloat = function convertBasicInputToFloat(inputValue) {
  var specialRule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var maxLength = arguments.length > 2 ? arguments[2] : undefined;
  var preventNumberConversion = arguments.length > 3 ? arguments[3] : undefined;
  var res = null;
  if (inputValue !== undefined) {
    if (typeof inputValue === 'number') {
      res = inputValue;
    } else if (typeof inputValue === 'string') {
      // Remove the trailing dashes
      inputValue = inputValue.replace(/-+$/, ''); // Remove the asterisk

      inputValue = inputValue.replace('*', ''); // Trim input for spaces

      inputValue = inputValue.replace(/ /g, ''); // Replace comma with dot

      inputValue = inputValue.replace(',', '.'); // Remove multiple dots

      inputValue = inputValue.replace('..', '.'); // If it's only a number

      if (!isNaN(Number(inputValue)) && inputValue.length > 0) {
        if (preventNumberConversion) {
          res = inputValue;
        } else {
          res = Number(inputValue);
        }
      } else {
        // First replace accounts for currency symbols with dots (for example "kr.")
        if (preventNumberConversion) {
          res = String(inputValue).replace(/([a-zA-Z]+[.])/g, '').replace(/[^0-9.-]+/g, '');
        } else {
          res = Number(String(inputValue).replace(/([a-zA-Z]+[.])/g, '').replace(/[^0-9.-]+/g, ''));
        }
      }
    }
  }
  if (isNaN(res)) {
    res = 0;
  }
  res = getMaxValue(res, maxLength);
  return specialRule ? specialRule(res) : res;
};
var getMaxValue = function getMaxValue(value, maxLength) {
  if (maxLength) {
    var maxValue = Math.pow(10, maxLength) - 1;
    if (value > 0) {
      value = value > maxValue ? maxValue : value;
    } else {
      maxValue = -1 * maxValue;
      value = value < maxValue ? maxValue : value;
    }
  }
  return value;
};
var convertBasicValue = function convertBasicValue(value, specialRule, showAsterisk, preventNumberConversion) {
  if (typeof value === 'string') {
    value = value.trim();
  }
  var floatVal = convertBasicInputToFloat(value, specialRule, undefined, preventNumberConversion);
  var res = {
    "float": null,
    full: null,
    error: false
  };
  if (!isNaN(floatVal)) {
    res["float"] = floatVal;
    res.full = floatVal + (showAsterisk ? ' *' : '');
  } else if (floatVal === null || floatVal === undefined || floatVal === '') {
    res["float"] = null;
    res.full = '';
  } else {
    res["float"] = floatVal;
    res.full = floatVal;
    res.error = true;
  }
  return res;
};
var convertIntoAffixedValue = function convertIntoAffixedValue(value, specialRule, affix) {
  if (typeof value === 'string') {
    value = value.trim();
  }
  var val = convertBasicInputToFloat(value, specialRule);
  var res = {
    "float": null,
    full: null,
    error: false
  };
  if (typeof val === 'number') {
    res["float"] = val;
    res.full = val + "".concat(affix);
  } else if (val === null || val === undefined || val === '') {
    res["float"] = null;
    res.full = '';
  } else {
    res["float"] = val;
    res.full = val;
    res.error = true;
  }
  return res;
};
var convertIntoPerccentageValue = function convertIntoPerccentageValue(value, specialRule, showAsterisk, additionalPercentageSignInfo, zeroToHundred, maxLength) {
  if (typeof value === 'string') {
    value = value.trim();
  }
  var percent = convertBasicInputToFloat(value, specialRule, maxLength);
  var res = {
    "float": null,
    full: null,
    error: false
  };
  if (typeof percent === 'number') {
    var roundedPercent = specialRule ? specialRule(percent) : Math.round(percent);
    res["float"] = roundedPercent / 100;
    res.full = roundedPercent + ' %' + (showAsterisk ? ' *' : additionalPercentageSignInfo ? additionalPercentageSignInfo : '');
    if (zeroToHundred && (percent < 0 || percent > 100)) {
      res.error = true;
    }
  } else if (percent === null || percent === undefined || percent === '') {
    res["float"] = null;
    res.full = '';
  } else {
    res["float"] = percent;
    res.full = percent;
    res.error = true;
  }
  return res;
};
var convertIntoCurencyValue = function convertIntoCurencyValue(value, currency, specialRule, showAsterisk, intl, maxLength) {
  if (typeof value === 'string') {
    value = value.trim();
  }
  var showCurrencyOnLeft = currencySymbolInFront(currency);
  var money = convertBasicInputToFloat(value, specialRule, maxLength);
  var res = {
    "float": null,
    full: null,
    error: false
  };
  if (typeof money === 'number') {
    //const formattedMoney = intl.formatNumber(money); //this does not work because of the . and ,
    res["float"] = money;
    res.full = showCurrencyOnLeft ? currency + ' ' + money : money + ' ' + currency;
    res.full += showAsterisk ? ' *' : '';
  } else if (money === null || money === undefined || money === '') {
    res["float"] = null;
    res.full = '';
  } else {
    res["float"] = money;
    res.full = money;
    res.error = true;
  }
  return res;
};
var currencySymbolInFront = function currencySymbolInFront(symbol) {
  return symbol === '$' || symbol === '€' || symbol === '฿' || symbol === '£';
};
var convertIntoHexValue = function convertIntoHexValue(hex) {
  var res = {
    "float": null,
    full: null,
    error: false
  };
  var formatedHex = hex && hex.replace('#', '').toUpperCase();
  if (formatedHex.length === 3) {
    formatedHex = '' + formatedHex[0] + formatedHex[0] + formatedHex[1] + formatedHex[1] + formatedHex[2] + formatedHex[2];
  }
  if (formatedHex.length === 6 && !isNaN(Number('0x' + formatedHex))) {
    res["float"] = '#' + formatedHex;
    res.full = '#' + formatedHex;
  } else if (formatedHex === null || formatedHex === undefined || formatedHex === '') {
    res["float"] = null;
    res.full = '';
  } else {
    res["float"] = hex;
    res.full = hex;
    res.error = true;
  }
  return res;
};
var BasicNumberInput = function BasicNumberInput(_ref) {
  var innerRef = _ref.innerRef,
    maxLength = _ref.maxLength,
    label = _ref.label,
    modalView = _ref.modalView,
    taskModalStyle = _ref.taskModalStyle,
    value = _ref.value,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    parentKeyDown = _ref.parentKeyDown,
    callback = _ref.callback,
    converterValue = _ref.converterValue,
    numberSymbol = _ref.numberSymbol,
    specialRule = _ref.specialRule,
    showAsterisk = _ref.showAsterisk,
    width = _ref.width,
    cy = _ref.cy,
    alignLeft = _ref.alignLeft,
    forceUpdate = _ref.forceUpdate,
    filterNonNumerics = _ref.filterNonNumerics,
    autoFocus = _ref.autoFocus,
    preventNumberConversion = _ref.preventNumberConversion,
    className = _ref.className,
    noBorder = _ref.noBorder,
    noLocked = _ref.noLocked;
  var formattedValue = React.useMemo(function () {
    return converterValue(value, specialRule, showAsterisk, preventNumberConversion);
  }, [value, numberSymbol]);
  var _useState = React.useState(formattedValue.full),
    _useState2 = _slicedToArray(_useState, 2),
    currentInputValue = _useState2[0],
    setCurrentInputValue = _useState2[1];
  var _useState3 = React.useState(formattedValue.error),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1]; // Need to find a better name, but this is internal logic only

  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dirtyWithError = _useState6[0],
    setDirtyWithError = _useState6[1]; // Will only be true if user has entered something else inside the input

  var _useState7 = React.useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDirty = _useState8[0],
    setIsDirty = _useState8[1];
  var setErrorIfDirty = function setErrorIfDirty() {
    if (dirtyWithError) {
      setError(true);
    }
  };
  React.useEffect(function () {
    setDirtyWithError(true);
    var formattedValue = converterValue(value, specialRule, showAsterisk, preventNumberConversion);
    setCurrentInputValue(formattedValue.full);
    if (formattedValue.error !== error) {
      setError(formattedValue.error);
    }
  }, [value, forceUpdate, numberSymbol]);
  var filterCharacters = function filterCharacters(value) {
    // Filter characters except 'e' which is a valid symbol for exponent in numbers
    return String(value).replace(/([a-df-zA-DF-Z])/g, '');
  };
  var handleOnChange = function handleOnChange(e) {
    if (filterNonNumerics) {
      setIsDirty(true);
      setCurrentInputValue(filterCharacters(e.target.value));
    } else {
      setIsDirty(true);
      setCurrentInputValue(e.target.value);
    }
  };
  var convertValue = function convertValue(value) {
    return converterValue(value, specialRule, showAsterisk, preventNumberConversion);
  };
  var handleValidate = function handleValidate(e) {
    var inputValue = e.target.value;
    var validValue = convertValue(inputValue);
    if (validValue.error) {
      setErrorIfDirty();
    } else {
      setError(false);
      setCurrentInputValue(validValue.full);
    }
    if (callback) {
      // else we just call the mutation;
      callback(validValue["float"], e, isDirty);
      setIsDirty(false);
    }
    if (onBlur) {
      onBlur(e, validValue["float"]);
    }
  };
  var handleKeyPressInput = function handleKeyPressInput(e) {
    if (e.key === 'Enter') {
      e.target.blur();
    }
    parentKeyDown && parentKeyDown(e, convertValue(currentInputValue));
  };
  var handleOnClick = function handleOnClick(e) {
    if (onClick) {
      onClick(e.target);
    }
  };
  var handleOnFocus = function handleOnFocus(e) {
    e.target.select();
  };
  var inputState = disabled ? '' : error || hasError ? ' error' : '';
  return /*#__PURE__*/React__default.createElement(InputContainerStyle, {
    modalView: modalView,
    taskModalStyle: taskModalStyle
  }, label ? /*#__PURE__*/React__default.createElement(InputLabelStyle, null, label) : null, /*#__PURE__*/React__default.createElement(InputStyle, {
    ref: innerRef,
    modalView: modalView,
    taskModalStyle: taskModalStyle,
    className: className + ' ' + inputState || '',
    type: 'text',
    placeholder: placeholder,
    value: currentInputValue,
    onFocus: function onFocus(e) {
      return handleOnFocus(e);
    },
    onClick: function onClick(e) {
      return handleOnClick(e);
    },
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    onBlur: function onBlur(e) {
      return handleValidate(e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyPressInput(e);
    },
    disabled: disabled,
    width: width,
    "data-cy": cy,
    alignLeft: alignLeft,
    maxLength: maxLength,
    autoFocus: autoFocus,
    noBorder: noBorder,
    noLocked: noLocked
  }));
};
BasicNumberInput.propTypes = {
  /**
   * Ref to the input
   */
  innerRef: PropTypes.object,
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Label for input
   */
  label: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * Don't show border in invoice entry number fields
   */
  noBorder: PropTypes.bool,
  /**
   * Don't lock invoice entry number fields
   */
  noLocked: PropTypes.bool,
  /**
   * When the input is focused the current value is selected. And the cursor ready to receive text input
   */
  onClick: PropTypes.func,
  /**
   * On blue the input parse the value to change it to the hours format (1h 30m).
   * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
   */
  onBlur: PropTypes.func,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
   * Action to execute if the validation is successful
   */
  callback: PropTypes.func,
  /**
   * Value of the input
   */
  value: PropTypes.any,
  /**
   *
   */
  converterValue: PropTypes.func.isRequired,
  specialRule: PropTypes.func,
  showAsterisk: PropTypes.bool,
  /**
   * Specific styling for the scheduling modals
   */
  modalView: PropTypes.bool,
  /**
   * Specific styling for the input in the task modal
   */
  taskModalStyle: PropTypes.bool,
  /**
   * Width of the input
   */
  width: PropTypes.string,
  cy: PropTypes.string,
  alignLeft: PropTypes.bool,
  maxLength: PropTypes.number,
  /**
   * Flag to force the input to re render
   */
  forceUpdate: PropTypes.any,
  intl: PropTypes.shape({
    formatNumber: PropTypes.func
  }),
  /**
   * callback when pressing key, returning event and current value
   */
  parentKeyDown: PropTypes.func,
  /**
   * additional symbol, for example currency
   */
  numberSymbol: PropTypes.string,
  /**
   * filter non numeric characters from input
   */
  filterNonNumerics: PropTypes.bool,
  /**
   * autoFocus the input
   */
  autoFocus: PropTypes.bool,
  /**
   * Prevent converting text to number to keep trailing decimals
   */
  preventNumberConversion: PropTypes.bool,
  className: PropTypes.string
};
BasicNumberInput.defaultProps = {
  disabled: false,
  hasError: false,
  specialRule: function specialRule(val) {
    return val;
  },
  converterValue: function converterValue(val, specialRule, showAsterisk, preventNumberConversion) {
    return convertBasicValue(val, specialRule, showAsterisk, preventNumberConversion);
  },
  intl: {
    formatNumber: function formatNumber(_ref2) {
      var value = _ref2.value;
      return value;
    }
  }
};
var CurrencyInput = function CurrencyInput(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    callback = _ref.callback,
    currencySymbole = _ref.currencySymbole,
    width = _ref.width,
    showAsterisk = _ref.showAsterisk,
    cy = _ref.cy,
    modalView = _ref.modalView,
    alignLeft = _ref.alignLeft,
    forceUpdate = _ref.forceUpdate,
    taskModalStyle = _ref.taskModalStyle,
    innerRef = _ref.innerRef,
    intl = _ref.intl,
    maxLength = _ref.maxLength,
    filterNonNumerics = _ref.filterNonNumerics,
    label = _ref.label,
    autoFocus = _ref.autoFocus,
    className = _ref.className,
    noBorder = _ref.noBorder,
    noLocked = _ref.noLocked;
  return /*#__PURE__*/React__default.createElement(BasicNumberInput, {
    placeholder: placeholder,
    showAsterisk: showAsterisk,
    value: value,
    hasError: hasError,
    onClick: onClick,
    onBlur: onBlur,
    onChange: onChange,
    disabled: disabled,
    converterValue: function converterValue(value, specialRule, showAsterisk) {
      return convertIntoCurencyValue(value, currencySymbole, specialRule, showAsterisk, intl, maxLength);
    },
    numberSymbol: currencySymbole,
    callback: callback,
    width: width,
    cy: cy,
    modalView: modalView,
    alignLeft: alignLeft,
    forceUpdate: forceUpdate,
    taskModalStyle: taskModalStyle,
    innerRef: innerRef,
    filterNonNumerics: filterNonNumerics,
    label: label,
    autoFocus: autoFocus,
    className: className,
    noBorder: noBorder,
    noLocked: noLocked
  });
};
CurrencyInput.propTypes = {
  /**
   
   */
  showAsterisk: PropTypes.bool,
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * When the input is focused the current value is selected. And the cursor ready to receive text input
   */
  onClick: PropTypes.func,
  /**
   * On blue the input parse the value to change it to the hours format (1h 30m).
   * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
   */
  onBlur: PropTypes.func,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
  * Don't show border in invoice entry number fields
  */
  noBorder: PropTypes.bool,
  /**
   * Don't lock invoice entry number fields
   */
  noLocked: PropTypes.bool,
  /**
   * Action to execute if the validation is successful
   */
  callback: PropTypes.func,
  /**
   * Value of the input
   */
  value: PropTypes.any,
  /**
   * Symoble of currency to display
   */
  currencySymbole: PropTypes.string.isRequired,
  /**
   * Width of the input
   */
  width: PropTypes.string,
  onChange: PropTypes.func,
  cy: PropTypes.string,
  modalView: PropTypes.bool,
  alignLeft: PropTypes.bool,
  /**
   * Flag to force the input to re render
   */
  forceUpdate: PropTypes.any,
  /**
   * Specific styling for the input in the task modal
   */
  taskModalStyle: PropTypes.bool,
  /**
   * Ref to the input
   */
  innerRef: PropTypes.object,
  intl: PropTypes.shape({
    formatNumber: PropTypes.func
  }),
  maxLength: PropTypes.number,
  /**
   * filter non numeric characters from input
   */
  filterNonNumerics: PropTypes.bool,
  /**
   * Label for input
   */
  label: PropTypes.string,
  /**
   * autoFocus the input
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string
};
CurrencyInput.defaultProps = {
  disabled: false,
  hasError: false,
  intl: {
    formatNumber: function formatNumber(_ref2) {
      var value = _ref2.value;
      return value;
    }
  }
};
var PercentageInput = function PercentageInput(_ref) {
  var innerRef = _ref.innerRef,
    value = _ref.value,
    maxLength = _ref.maxLength,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    callback = _ref.callback,
    showAsterisk = _ref.showAsterisk,
    additionalPercentageSignInfo = _ref.additionalPercentageSignInfo,
    width = _ref.width,
    modalView = _ref.modalView,
    alignLeft = _ref.alignLeft,
    cy = _ref.cy,
    showDecimals = _ref.showDecimals,
    forceUpdate = _ref.forceUpdate,
    zeroToHundred = _ref.zeroToHundred,
    noBorder = _ref.noBorder,
    noLocked = _ref.noLocked;
  var specialRule = showDecimals && value ? function (value) {
    return parseFloat(value.toFixed(2));
  } : undefined;
  return /*#__PURE__*/React__default.createElement(BasicNumberInput, {
    innerRef: innerRef,
    placeholder: placeholder,
    value: value,
    hasError: hasError,
    onClick: onClick,
    onBlur: onBlur,
    disabled: disabled,
    converterValue: function converterValue(value) {
      return convertIntoPerccentageValue(value, specialRule, showAsterisk, additionalPercentageSignInfo, zeroToHundred, maxLength);
    },
    callback: callback,
    showAsterisk: showAsterisk,
    width: width,
    modalView: modalView,
    alignLeft: alignLeft,
    cy: cy,
    specialRule: specialRule,
    forceUpdate: forceUpdate,
    noBorder: noBorder,
    noLocked: noLocked
  });
};
PercentageInput.propTypes = {
  innerRef: PropTypes.any,
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * When the input is focused the current value is selected. And the cursor ready to receive text input
   */
  onClick: PropTypes.func,
  /**
   * On blue the input parse the value to change it to the hours format (1h 30m).
   * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
   */
  onBlur: PropTypes.func,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
   * Action to execute if the validation is successful
   */
  callback: PropTypes.func,
  /**
   * Value of the input
   */
  value: PropTypes.any,
  /**
   * Don't show border in invoice entry number fields
   */
  noBorder: PropTypes.bool,
  /**
  * Don't lock invoice entry number fields
  */
  noLocked: PropTypes.bool,
  /**
   * Add an asterisk (*) after the input value
   */
  showAsterisk: PropTypes.bool,
  /**
   * Additional information after % sign 
   */
  additionalPercentageSignInfo: PropTypes.string,
  /**
   * Width of the input
   */
  width: PropTypes.string,
  /**
   * Specific styling for the scheduling modals
   */
  modalView: PropTypes.bool,
  alignLeft: PropTypes.bool,
  cy: PropTypes.string,
  showDecimals: PropTypes.bool,
  /**
   * Flag to force the input to re render
   */
  forceUpdate: PropTypes.any,
  /**
   * limite the values from 0% to 100%
   *
   * The input return an error if the values is out of thhe bounds
   */
  zeroToHundred: PropTypes.bool,
  maxLength: PropTypes.number
};
PercentageInput.defaultProps = {
  disabled: false,
  hasError: false
};
var AffixedInput = function AffixedInput(_ref) {
  var innerRef = _ref.innerRef,
    label = _ref.label,
    modalView = _ref.modalView,
    taskModalStyle = _ref.taskModalStyle,
    value = _ref.value,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    onClick = _ref.onClick,
    parentKeyDown = _ref.parentKeyDown,
    onBlur = _ref.onBlur,
    callback = _ref.callback,
    affix = _ref.affix;
  return /*#__PURE__*/React__default.createElement(BasicNumberInput, {
    innerRef: innerRef,
    placeholder: placeholder,
    value: value,
    hasError: hasError,
    onClick: onClick,
    onBlur: onBlur,
    disabled: disabled,
    parentKeyDown: parentKeyDown,
    converterValue: function converterValue(value) {
      return convertIntoAffixedValue(value, null, affix);
    },
    callback: callback,
    label: label,
    modalView: modalView,
    taskModalStyle: taskModalStyle
  });
};
AffixedInput.propTypes = {
  /**
   * ref to the input
   */
  innerRef: PropTypes.object,
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * When the input is focused the current value is selected. And the cursor ready to receive text input
   */
  onClick: PropTypes.func,
  /**
   * On blur the input parse the value to change it to the hours format (1h 30m).
   * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
   */
  onBlur: PropTypes.func,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
   * Action to execute if the validation is successful
   */
  callback: PropTypes.func,
  /**
   * Value of the input
   */
  value: PropTypes.string,
  /**
   * Affix to add after value (e.g. 'p' for points)
   */
  affix: PropTypes.string,
  /**
   * Specific styling for scheduling modal
   */
  modalView: PropTypes.bool,
  /**
   * Specific styling for input in task modal
   */
  taskModalStyle: PropTypes.bool,
  /**
   * Label attached to the input
   */
  label: PropTypes.string,
  /**
   * callback when pressing key, returning event and current value
   */
  parentKeyDown: PropTypes.func
};
AffixedInput.defaultProps = {
  disabled: false,
  hasError: false
};
var BasicTextInput = function BasicTextInput(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    callbackOnEnter = _ref.callbackOnEnter,
    callback = _ref.callback,
    modalView = _ref.modalView,
    width = _ref.width,
    maxLength = _ref.maxLength,
    focusOnMount = _ref.focusOnMount,
    cy = _ref.cy,
    type = _ref.type;
  var inputElem = React.useRef(null); // Focus input on mount if prop is passed

  React.useEffect(function () {
    if (focusOnMount) {
      inputElem.current.focus();
    }
  }, []);
  var handleOnFocus = function handleOnFocus(e) {
    e.target.select();
  };
  var handleOnClick = function handleOnClick(e) {
    if (onClick) {
      onClick(e.target);
    }
  };
  var handleOnChange = function handleOnChange(e) {
    if (onChange) {
      onChange(e.target.value);
    }
  };
  var handleValidate = function handleValidate(e) {
    var inputValue = e.target.value;
    if (onBlur) {
      onBlur(e);
    }
    if (callback) {
      // else we just call the mutation;
      callback(inputValue, e);
    }
  };
  var handleKeyPressInput = function handleKeyPressInput(e) {
    if (e.key === 'Enter') {
      if (callbackOnEnter) {
        callbackOnEnter();
      }
      handleValidate(e);
    }
  };
  var inputState = disabled ? '' : hasError ? ' error' : '';
  return /*#__PURE__*/React__default.createElement(InputContainerStyle, {
    modalView: modalView
  }, /*#__PURE__*/React__default.createElement(InputTextStyle, {
    ref: inputElem,
    className: inputState,
    type: type ? type : 'text',
    placeholder: placeholder,
    value: value,
    tabIndex: 0,
    onFocus: function onFocus(e) {
      return handleOnFocus(e);
    },
    onClick: function onClick(e) {
      return handleOnClick(e);
    },
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    onBlur: function onBlur(e) {
      return handleValidate(e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyPressInput(e);
    },
    disabled: disabled,
    width: width,
    modalView: modalView,
    "data-cy": cy,
    maxLength: maxLength
  }));
};
BasicTextInput.propTypes = {
  /**
   * Focus the input on mount
   */
  focusOnMount: PropTypes.bool,
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * When the input is focused the current value is selected. And the cursor ready to receive text input
   */
  onClick: PropTypes.func,
  /**
   * On blue the input parse the value to change it to the hours format (1h 30m).
   * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
   */
  onBlur: PropTypes.func,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
   * Action to execute if the validation is successful
   */
  callback: PropTypes.func,
  /**
   * Value of the input
   */
  value: PropTypes.string,
  /**
   * This is necessary to get the value of the input from the parent
   */
  onChange: PropTypes.func,
  /**
   * Same a the callback prop but only called when typing Enter
   */
  callbackOnEnter: PropTypes.func,
  /**
   * Specific styling for the scheduling modals
   */
  modalView: PropTypes.bool,
  /**
   * Width of the input
   */
  width: PropTypes.string,
  /**
   * The caracter limit supported
   */
  maxLength: PropTypes.number,
  cy: PropTypes.string,
  type: PropTypes.string
};
BasicTextInput.defaultProps = {
  disabled: false,
  hasError: false
};
var HexColorInput = function HexColorInput(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    callback = _ref.callback,
    modalView = _ref.modalView,
    width = _ref.width,
    alignLeft = _ref.alignLeft,
    cy = _ref.cy;
  return /*#__PURE__*/React__default.createElement(BasicNumberInput, {
    placeholder: placeholder,
    value: value,
    hasError: hasError,
    onClick: onClick,
    onBlur: onBlur,
    onChange: onChange,
    disabled: disabled,
    converterValue: function converterValue(value) {
      return convertIntoHexValue(value);
    },
    callback: callback,
    width: width,
    cy: cy,
    modalView: modalView,
    alignLeft: alignLeft
  });
};
HexColorInput.propTypes = {
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * When the input is focused the current value is selected. And the cursor ready to receive text input
   */
  onClick: PropTypes.func,
  /**
   * On blue the input parse the value to change it to the hours format (1h 30m).
   * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
   */
  onBlur: PropTypes.func,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
   * Action to execute if the validation is successful
   */
  callback: PropTypes.func,
  /**
   * Value of the input
   */
  value: PropTypes.string,
  /**
   * This is necessary to get the value of the input from the parent
   */
  onChange: PropTypes.func,
  /**
   * Same a the callback prop but only called when typing Enter
   */
  callbackOnEnter: PropTypes.func,
  /**
   * Specific styling for the scheduling modals
   */
  modalView: PropTypes.bool,
  /**
   * Width of the input
   */
  width: PropTypes.string,
  cy: PropTypes.string,
  alignLeft: PropTypes.bool
};
HexColorInput.defaultProps = {
  disabled: false,
  hasError: false
};
var InputLabel = function InputLabel(_ref) {
  var text = _ref.text,
    required = _ref.required,
    extension = _ref.extension,
    child = _ref.child,
    activeError = _ref.activeError,
    alignRight = _ref.alignRight;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputLabelStyle, {
    className: "input-title",
    alignRight: alignRight
  }, text, required ? /*#__PURE__*/React__default.createElement("span", {
    className: 'required-extension ' + (activeError === false ? 'inactive' : '')
  }, extension || '*') : null), child);
};
InputLabel.propTypes = {
  text: PropTypes.string,
  required: PropTypes.bool,
  extension: PropTypes.string,
  child: PropTypes.element,
  activeError: PropTypes.bool,
  alignRight: PropTypes.bool
};
InputLabel.defaultProps = {
  required: false,
  alignRight: false
};
var PageHeaderInput = function PageHeaderInput(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? function () {
      return false;
    } : _ref$onKeyDown,
    callback = _ref.callback,
    width = _ref.width,
    maxWidth = _ref.maxWidth,
    transition = _ref.transition,
    cy = _ref.cy,
    innerRef = _ref.innerRef;
  var handleOnFocus = function handleOnFocus(e) {
    e.target.select();
  };
  var handleOnClick = function handleOnClick(e) {
    if (onClick) {
      onClick(e.target);
    }
  };
  var handleOnChange = function handleOnChange(e) {
    if (onChange) {
      onChange(e.target.value);
    }
  };
  var handleValidate = function handleValidate(e) {
    var inputValue = e.target.value;
    if (onBlur) {
      onBlur(e);
    }
    if (callback) {
      // else we just call the mutation;
      callback(inputValue, e);
    }
  };
  var inputState = disabled ? '' : hasError ? ' error' : '';
  return /*#__PURE__*/React__default.createElement(PageHeaderInputStyle, {
    className: inputState,
    type: 'text',
    placeholder: placeholder,
    value: value,
    tabIndex: 0,
    onFocus: function onFocus(e) {
      return handleOnFocus(e);
    },
    onClick: function onClick(e) {
      return handleOnClick(e);
    },
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    onBlur: function onBlur(e) {
      return handleValidate(e);
    },
    onKeyDown: onKeyDown,
    disabled: disabled,
    width: width,
    "data-cy": cy,
    maxWidth: maxWidth,
    ref: innerRef,
    transition: transition
  });
};
PageHeaderInput.propTypes = {
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * When the input is focused the current value is selected. And the cursor ready to receive text input
   */
  onClick: PropTypes.func,
  /**
   * On blue the input parse the value to change it to the hours format (1h 30m).
   * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
   */
  onBlur: PropTypes.func,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
   * Action to execute if the validation is successful
   */
  callback: PropTypes.func,
  /**
   * Value of the input
   */
  value: PropTypes.string,
  /**
   * This is necessary to get the value of the input from the parent
   */
  onChange: PropTypes.func,
  /**
   * Same a the callback prop but only called when typing Enter
   */
  callbackOnEnter: PropTypes.func,
  /**
   * Width of the input
   */
  width: PropTypes.string,
  /**
   * The caracter limit supported
   */
  maxWidth: PropTypes.number,
  cy: PropTypes.string,
  onKeyDown: PropTypes.func,
  innerRef: PropTypes.object,
  spanRef: PropTypes.object,
  transition: PropTypes.bool
};
PageHeaderInput.defaultProps = {
  disabled: false,
  hasError: false
};
var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1;
var fontSize = '18px';
var ModalHeaderInputStyled = Styled__default(InputStyle)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n\ttext-align: left;\n\tbox-sizing: border-box;\n\tborder: 1px solid transparent;\n\tfont-size: ", ";\n\tposition: relative;\n\tleft: -16px;\n\twidth: calc(100% + 32px);\n\tz-index: 1;\n\tpadding: 0px 28px 0 16px;\n\t\n\tbackground-color: transparent;\n\t&:focus + span {\n\t    display: none;\n\t}\n\t\n\t::-webkit-input-placeholder {\n\t\tfont-size: ", ";\n\t}\n\t::-moz-placeholder {\n\t\tfont-size: ", ";\n\t}\n\t:-ms-input-placeholder {\n\t\tfont-size: ", ";\n\t}\n\t:-moz-placeholder {\n\t\tfont-size: ", ";\n\t}\n\tdiv {\n        color: red;\n\t}\n"])), fontSize, fontSize, fontSize, fontSize, fontSize);
var TextMeasurer = Styled__default.span(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n\tfont-size: ", ";\n\tvisibility: hidden;\n\tposition: absolute;\n\tmax-width: calc(100% - 16px);\n"])), fontSize);
var InputWrapper = Styled__default.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    position: relative;\n    * + span {\n        position: absolute;\n        top: 0;\n        height: 40px;\n        left: ", "px;\n    }\n"])), function (props) {
  return props.textWidth + 8;
});
var ErrorMessage = Styled__default.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n    color: red;\n    font-size: 13px;\n"])));
var _templateObject$2;
var SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var StyledSpan = Styled__default.span(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-items: center;\n\t> svg {\n\t\tpath {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\t&:hover\t{ \n\t\t> svg {\n\t\t\tpath {\n\t\t\t\tfill: ", ";\n\t\t\t}\n\t\t}\n\t}\n"])), function (_ref) {
  var size = _ref.size;
  return size + 'px';
}, function (_ref2) {
  var size = _ref2.size;
  return size + 'px';
}, function (_ref3) {
  var color = _ref3.color,
    overrideColor = _ref3.overrideColor;
  return overrideColor && color;
}, function (_ref4) {
  var color = _ref4.color,
    hoverColor = _ref4.hoverColor;
  return hoverColor ? hoverColor : color;
});
var BaseIcon = function BaseIcon(_ref5) {
  var children = _ref5.children,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? SIZE.MEDIUM : _ref5$size,
    _ref5$color = _ref5.color,
    color = _ref5$color === void 0 ? '#4C4C58' : _ref5$color,
    overrideColor = _ref5.overrideColor,
    hoverColor = _ref5.hoverColor;
  var getSize = function getSize(size) {
    switch (size) {
      case SIZE.SMALL:
        return 16;
      case SIZE.MEDIUM:
        return 20;
      case SIZE.LARGE:
        return 24;
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan, {
    size: getSize(size),
    color: color,
    overrideColor: overrideColor,
    hoverColor: hoverColor
  }, children);
};
var iconPropTypes = {
  children: PropTypes__default.node,
  size: PropTypes__default.oneOf(Object.values(SIZE)),
  color: PropTypes__default.string,
  overrideColor: PropTypes__default.bool,
  hoverColor: PropTypes__default.string
};
var iconDefaultProps = {
  size: SIZE.MEDIUM,
  color: '#4C4C58',
  overrideColor: true,
  hoverColor: '#4C4C58'
};
BaseIcon.SIZE = SIZE;
BaseIcon.propTypes = iconPropTypes;
BaseIcon.defaultProps = iconPropTypes;
var SubTaskIcon = function SubTaskIcon(_ref) {
  var props = _extends({}, _ref);
  return /*#__PURE__*/React__default.createElement(BaseIcon, props, /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.33398C3.5 3.05784 3.27614 2.83398 3 2.83398C2.72386 2.83398 2.5 3.05784 2.5 3.33398V12.2923C2.5 13.9492 3.84315 15.2923 5.5 15.2923H12.1294C12.364 16.5492 13.4667 17.5006 14.7917 17.5006C16.2874 17.5006 17.5 16.2881 17.5 14.7923C17.5 13.2965 16.2874 12.084 14.7917 12.084C13.4667 12.084 12.364 13.0354 12.1294 14.2923H5.5C4.39543 14.2923 3.5 13.3969 3.5 12.2923V7.37565H7.54606C7.78066 8.63255 8.88339 9.58396 10.2083 9.58396C11.7041 9.58396 12.9167 8.3714 12.9167 6.87563C12.9167 5.37986 11.7041 4.1673 10.2083 4.1673C8.88338 4.1673 7.78064 5.11873 7.54606 6.37565H3.5V3.33398ZM16.5 14.7923C16.5 15.7358 15.7352 16.5006 14.7917 16.5006C13.8482 16.5006 13.0833 15.7358 13.0833 14.7923C13.0833 13.8488 13.8482 13.084 14.7917 13.084C15.7352 13.084 16.5 13.8488 16.5 14.7923ZM10.2083 8.58396C11.1518 8.58396 11.9167 7.81912 11.9167 6.87563C11.9167 5.93214 11.1518 5.1673 10.2083 5.1673C9.26485 5.1673 8.5 5.93214 8.5 6.87563C8.5 7.81912 9.26485 8.58396 10.2083 8.58396Z",
    fill: "#4C4C58"
  })));
};
SubTaskIcon.propTypes = iconPropTypes;
SubTaskIcon.defaultProps = iconDefaultProps;
var _excluded = ["variant"];
var WARNING_TYPE = {
  DANGER: 'danger',
  // Exclamation point
  NO_WARNING: 'no_warning' // Check mark
};

var VARIANT = {
  DANGER: {
    warningType: WARNING_TYPE.DANGER,
    color: '#DB0900'
  },
  WARNING: {
    warningType: WARNING_TYPE.DANGER,
    color: '#ECBD00'
  },
  NO_WARNING: {
    warningType: WARNING_TYPE.NO_WARNING,
    color: '#42A04B'
  }
};
var WarningIcon = function WarningIcon(_ref) {
  var variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var warningType = variant.warningType,
    color = variant.color;
  return /*#__PURE__*/React__default.createElement(BaseIcon, _extends({}, props, {
    overrideColor: false
  }), warningType === WARNING_TYPE.NO_WARNING ? /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "2.34521",
    y: "9.99927",
    width: "11.25",
    height: "11.25",
    transform: "rotate(-45 2.34521 9.99927)",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4145 9.52855L10.7715 2.88557C10.5112 2.62522 10.0891 2.62522 9.82872 2.88557L3.18574 9.52855C2.92539 9.7889 2.92539 10.211 3.18574 10.4714L9.82872 17.1143C10.0891 17.3747 10.5112 17.3747 10.7715 17.1143L17.4145 10.4714C17.6748 10.211 17.6748 9.78889 17.4145 9.52855ZM11.4786 2.17846C10.8278 1.52759 9.77248 1.52759 9.12161 2.17846L2.47863 8.82144C1.82776 9.47231 1.82776 10.5276 2.47863 11.1785L9.12161 17.8214C9.77248 18.4723 10.8278 18.4723 11.4786 17.8214L18.1216 11.1785C18.7725 10.5276 18.7725 9.47231 18.1216 8.82144L11.4786 2.17846Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "6.31519",
    y: "10.2258",
    width: "1.2",
    height: "4.46314",
    rx: "0.6",
    transform: "rotate(-45 6.31519 10.2258)",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "13.4363",
    y: "7.80005",
    width: "1.2",
    height: "6.69472",
    rx: "0.6",
    transform: "rotate(45 13.4363 7.80005)",
    fill: "white"
  })) : /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "2.04517",
    y: "10.3788",
    width: "11.25",
    height: "11.25",
    transform: "rotate(-45 2.04517 10.3788)",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1145 9.90806L10.4715 3.26509C10.2111 3.00474 9.78902 3.00474 9.52867 3.26509L2.88569 9.90806C2.62534 10.1684 2.62534 10.5905 2.88569 10.8509L9.52867 17.4938C9.78902 17.7542 10.2111 17.7542 10.4715 17.4938L17.1145 10.8509C17.3748 10.5905 17.3748 10.1684 17.1145 9.90806ZM11.1786 2.55798C10.5277 1.90711 9.47243 1.90711 8.82156 2.55798L2.17859 9.20096C1.52771 9.85183 1.52771 10.9071 2.17859 11.558L8.82156 18.2009C9.47244 18.8518 10.5277 18.8518 11.1786 18.2009L17.8216 11.558C18.4724 10.9071 18.4724 9.85183 17.8216 9.20095L11.1786 2.55798Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90001 5.87842C10.2314 5.87842 10.5 6.16624 10.5 6.52128V10.807C10.5 11.162 10.2314 11.4498 9.90001 11.4498C9.56864 11.4498 9.30001 11.162 9.30001 10.807V6.52128C9.30001 6.16624 9.56864 5.87842 9.90001 5.87842Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.8 13.9141C10.8 14.4467 10.3971 14.8784 9.9 14.8784C9.40294 14.8784 9 14.4467 9 13.9141C9 13.3816 9.40294 12.9498 9.9 12.9498C10.3971 12.9498 10.8 13.3816 10.8 13.9141Z",
    fill: "white"
  })));
};
WarningIcon.propTypes = _objectSpread2({
  variant: PropTypes__default.oneOf(Object.values(VARIANT))
}, iconPropTypes);
WarningIcon.defaultProps = _objectSpread2({
  variant: VARIANT.DANGER
}, iconDefaultProps);
WarningIcon.VARIANT = VARIANT;
var EditIcon = function EditIcon(_ref) {
  var props = _extends({}, _ref);
  return /*#__PURE__*/React__default.createElement(BaseIcon, props, /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5681 3.78948L8.61307 11.7445C8.50595 11.8516 8.43647 11.9906 8.41507 12.1405L7.9734 15.2347C7.94226 15.4528 8.01565 15.6729 8.17148 15.8287C8.3273 15.9845 8.54738 16.0578 8.7655 16.0266L11.8588 15.5841C12.0087 15.5626 12.1476 15.4932 12.2547 15.3861L19.3233 8.31746L19.3255 8.31527L19.3277 8.31307L20.2097 7.4311C21.2153 6.42549 21.2153 4.79509 20.2097 3.78948C19.2041 2.78388 17.5737 2.78388 16.5681 3.78948ZM19.2197 4.77943C18.7609 4.32056 18.0169 4.32056 17.558 4.77943L17.1688 5.16862L18.8305 6.83034L19.2197 6.44115C19.6786 5.98228 19.6786 5.2383 19.2197 4.77943ZM11.4297 14.2312L17.8406 7.82029L16.1789 6.15857L9.76804 12.5694L9.49125 14.5085L11.4297 14.2312Z",
    fill: "#393946"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.69999 7.39999C4.69999 6.4611 5.4611 5.69999 6.39999 5.69999H11.5625C11.9491 5.69999 12.2625 5.38659 12.2625 4.99999C12.2625 4.61339 11.9491 4.29999 11.5625 4.29999H6.39999C4.68791 4.29999 3.29999 5.6879 3.29999 7.39999V17.6C3.29999 19.3121 4.6879 20.7 6.39999 20.7H16.6C18.3121 20.7 19.7 19.3121 19.7 17.6V12.4375C19.7 12.0509 19.3866 11.7375 19 11.7375C18.6134 11.7375 18.3 12.0509 18.3 12.4375V17.6C18.3 18.5389 17.5389 19.3 16.6 19.3H6.39999C5.4611 19.3 4.69999 18.5389 4.69999 17.6V7.39999Z",
    fill: "#393946"
  })));
};
EditIcon.propTypes = iconPropTypes;
EditIcon.defaultProps = iconDefaultProps;
var ModalHeaderInput = function ModalHeaderInput(_ref) {
  var cy = _ref.cy,
    value = _ref.value,
    disabled = _ref.disabled,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    errorMessage = _ref.errorMessage,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? 191 : _ref$maxLength;
  var textMeasurerRef = React.useRef();
  var _useState = React.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    textWidth = _useState2[0],
    setTextWidth = _useState2[1];
  React.useEffect(function () {
    if (textMeasurerRef.current) {
      setTextWidth(textMeasurerRef.current.clientWidth);
    }
  }, [textMeasurerRef.current, value]);
  var handleChange = function handleChange(e) {
    onChange(e.target.value);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    textWidth: textWidth
  }, /*#__PURE__*/React__default.createElement(TextMeasurer, {
    ref: textMeasurerRef
  }, value || placeholder), /*#__PURE__*/React__default.createElement(ModalHeaderInputStyled, {
    "data-cy": cy,
    type: "text",
    disabled: disabled,
    placeholder: placeholder,
    onChange: handleChange,
    value: value,
    autoFocus: autoFocus,
    maxLength: maxLength,
    autoComplete: "off",
    className: hasError ? 'error' : '',
    modalView: true
  }), /*#__PURE__*/React__default.createElement(EditIcon, {
    color: "#8E8F9F",
    hoverColor: null
  })), hasError && errorMessage ? /*#__PURE__*/React__default.createElement(ErrorMessage, {
    "data-cy": 'error-message'
  }, errorMessage) : null);
};
ModalHeaderInput.propTypes = {
  /**
   * Information when no value has been set yet.
   */
  placeholder: PropTypes.string,
  /**
   * Disable the input the user can't insert a new value or edit the current one.
   */
  disabled: PropTypes.bool,
  /**
   * Indicator to show that the input is in an invalid state
   */
  hasError: PropTypes.bool,
  /**
   * Error messages if input is invalid
   */
  errorMessage: PropTypes.string,
  /**
   * Value of the input
   */
  value: PropTypes.string,
  /**
   * This is necessary to get the value of the input from the parent
   */
  onChange: PropTypes.func,
  /**
   * Identifier for integration tests
   */
  cy: PropTypes.string,
  /**
   * Whether input field should auto focus when displaying (default: false)
   */
  autoFocus: PropTypes.bool,
  /**
   * Maximum length of input (default: 191)
   */
  maxLength: PropTypes.number
};
var _templateObject$3;
var SIZE$1 = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var CrossIcon = function CrossIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick,
    cy = _ref.cy;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$1.SMALL:
        return '16';
      case SIZE$1.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$1.SMALL:
        return '16';
      case SIZE$1.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$1, {
    "data-cy": cy,
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    idth: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M6.77426 5.92574C6.53995 5.69142 6.16005 5.69142 5.92574 5.92574C5.69142 6.16005 5.69142 6.53995 5.92574 6.77426L11.1515 12L5.92574 17.2257C5.69142 17.46 5.69142 17.8399 5.92574 18.0743C6.16005 18.3086 6.53995 18.3086 6.77426 18.0743L12 12.8485L17.2257 18.0743C17.4601 18.3086 17.8399 18.3086 18.0743 18.0743C18.3086 17.8399 18.3086 17.4601 18.0743 17.2257L12.8485 12L18.0743 6.77426C18.3086 6.53995 18.3086 6.16005 18.0743 5.92574C17.8399 5.69142 17.46 5.69142 17.2257 5.92574L12 11.1515L6.77426 5.92574Z",
    fill: color
  })));
};
CrossIcon.SIZE = SIZE$1;
CrossIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$1.SMALL, SIZE$1.STANDARD]),
  cy: PropTypes__default.string
};
CrossIcon.defaultProps = {
  color: '#565656'
};
var StyledSpan$1 = Styled__default.span(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$4, _templateObject2$2;
var SIZE$2 = {
  STANDARD: 'standard',
  SMALL: 'small',
  MEDIUM_SMALL: 'medium_small',
  BIG: 'big',
  TALL: 'tall'
};
var FONT_SIZE = {
  STANDARD: 'standard',
  LARGE: 'large'
};
var VARIANT$1 = {
  PURPLE_FILLED: 'purple_filled',
  PURPLE_OUTLINE: 'purple_outline',
  GREEN_FILLED: 'green_filled',
  VERY_LIGHT_GRAY_OUTLINE: 'very_light_gray_outline',
  VERY_LIGHT_GRAY_FILLED: 'very_light_gray_filled',
  RED_FILLED: 'red_filled',
  RED_OUTLINE: 'red_outline'
};
var ICON_POSITION = {
  FIRST: 'first',
  LAST: 'last',
  CENTER: 'center'
};
var Button = function Button(_ref) {
  var showText = _ref.showText,
    isSquare = _ref.isSquare,
    title = _ref.title,
    variant = _ref.variant,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    userpilot = _ref.userpilot,
    iconPosition = _ref.iconPosition,
    icon = _ref.icon,
    size = _ref.size,
    fontSize = _ref.fontSize,
    children = _ref.children,
    fullWidth = _ref.fullWidth,
    cy = _ref.cy;

  /**
   * proxy for the onClick of the button
   */
  var handleClick = function handleClick(e) {
    onClick(e);
  };
  var getIconColor = function getIconColor() {
    switch (variant) {
      case VARIANT$1.RED_FILLED:
      case VARIANT$1.GREEN_FILLED:
      case VARIANT$1.VERY_LIGHT_GRAY_FILLED:
      case VARIANT$1.PURPLE_FILLED:
        return '#ffffff';
      case VARIANT$1.VERY_LIGHT_GRAY_OUTLINE:
        return '#535353';
      default:
        return '#ffffff';
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledButton, {
    title: title,
    showText: showText,
    isSquare: isSquare,
    fullWidth: fullWidth,
    variant: variant,
    disabled: disabled,
    size: size,
    fontSize: fontSize,
    onClick: handleClick,
    "data-userpilot": userpilot,
    "data-cy": cy ? cy : ''
  }, iconPosition === ICON_POSITION.FIRST && /*#__PURE__*/React__default.createElement(IconWrapper, {
    noMargin: !showText || !children,
    iconPosition: iconPosition
  }, icon(getIconColor())), showText ? /*#__PURE__*/React__default.createElement("span", null, children) : null, iconPosition === ICON_POSITION.LAST && /*#__PURE__*/React__default.createElement(IconWrapper, {
    noMargin: !showText || !children,
    iconPosition: iconPosition
  }, icon(getIconColor())));
};
Button.propTypes = {
  /**
   *
   */
  showText: PropTypes__default.bool,
  /**
   * Text to be displayed on the button
   */
  children: PropTypes__default.string,
  /**
   * if fullWidth, the button width is controlled by the parent element
   */
  fullWidth: PropTypes__default.bool,
  /**
   * Predefined style of the button. accessed at Button.VARIANT...
   */
  variant: PropTypes__default.oneOf([VARIANT$1.PURPLE_FILLED, VARIANT$1.PURPLE_OUTLINE, VARIANT$1.GREEN_FILLED, VARIANT$1.VERY_LIGHT_GRAY_FILLED, VARIANT$1.VERY_LIGHT_GRAY_OUTLINE, VARIANT$1.RED_FILLED, VARIANT$1.RED_OUTLINE]),
  /**
   * Disables the button
   */
  disabled: PropTypes__default.bool,
  /**
   * position of the icon, center is for no text (Work in progress). no input = no icon
   */
  iconPosition: PropTypes__default.oneOf([ICON_POSITION.FIRST, ICON_POSITION.CENTER, ICON_POSITION.LAST]),
  /**
   * The icon to be displayed.
   */
  icon: PropTypes__default.func,
  /**
   * Title of button
   */
  title: PropTypes__default.string,
  /**
   * onClick handler
   */
  onClick: PropTypes__default.func,
  /**
   *	userpilot tag
   */
  userpilot: PropTypes__default.string,
  /**
   * size of the button - accessed at Button.SIZE
   */
  size: PropTypes__default.oneOf([SIZE$2.STANDARD, SIZE$2.SMALL, SIZE$2.MEDIUM_SMALL]),
  /**
   * size of the font - accessed at Button.FONT_SIZE
   */
  fontSize: PropTypes__default.oneOf([FONT_SIZE.STANDARD, FONT_SIZE.LARGE]),
  /**
   *
   */
  isSquare: PropTypes__default.bool,
  /**
   * Cypress id
   */
  cy: PropTypes__default.string
};
Button.VARIANT = VARIANT$1;
Button.SIZE = SIZE$2;
Button.FONT_SIZE = FONT_SIZE;
Button.ICON_POSITION = ICON_POSITION;
Button.defaultProps = {
  onClick: function onClick() {
    return false;
  },
  iconPosition: 'center',
  size: SIZE$2.STANDARD,
  fontSize: FONT_SIZE.STANDARD,
  showText: true,
  isSquare: false
};
var IconWrapper = Styled__default.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n\tmargin-right: ", ";\n\tmargin-left: ", ";\n"])), function (props) {
  return props.iconPosition === 'first' && !props.noMargin ? '8px' : 0;
}, function (props) {
  return props.iconPosition === 'last' && !props.noMargin ? '8px' : 0;
});
var StyledButton = Styled__default.button(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tjustify-content: center;\n\tbox-sizing: border-box;\n\tbox-shadow: none;\n\toutline: none;\n\tletter-spacing: 0.5px;\n\ttext-transform: uppercase;\n\tpadding: ", ";\n\tfont-weight: 550;\n\tfont-size: ", ";\n\n\twidth: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\theight: ", ";\n\tborder:  ", ";\n\tborder-style: solid;\n\tborder-color: ", ";\n\t\n\t&:hover:enabled {\n\t\topacity: ", ";\n\t\tborder-color: ", ";\n\t}\n\t&:disabled {\n\t\t//Red butons when disabled should look like the same as white buttons\n\t\tborder-style: solid;\n\t\tborder-width:", ";\n\t\tborder-color: ", ";\n\n\t\tcolor: ", ";\n\t\t\n\n\t\topacity: 0.5;\n\t\tcursor: default;\n\t}\n"])), function (props) {
  return props.showText && !props.isSquare ? '0 16px' : '0 0';
}, function (props) {
  if (props.fontSize) {
    switch (props.fontSize) {
      case FONT_SIZE.LARGE:
        return '12px';
      case FONT_SIZE.STANDARD:
        return '10px';
    }
  } else {
    switch (props.size) {
      case SIZE$2.TALL:
      case SIZE$2.STANDARD:
        return '10px';
      case SIZE$2.SMALL:
        return '9px';
    }
  }
}, function (props) {
  if (props.fullWidth) return '100%';
  if (props.showText && !props.isSquare) return 'auto';
  switch (props.size) {
    case SIZE$2.TALL:
    case SIZE$2.STANDARD:
      return '30px';
    case SIZE$2.MEDIUM_SMALL:
      return '24px';
    case SIZE$2.SMALL:
      return '22px';
    default:
      return '30px';
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.PURPLE_FILLED:
      return props.theme.colors.forecastPurple;
    case VARIANT$1.GREEN_FILLED:
      return props.theme.colors.green;
    case VARIANT$1.VERY_LIGHT_GRAY_FILLED:
      return props.theme.colors.mediumVeryLightGray;
    case VARIANT$1.RED_OUTLINE:
    case VARIANT$1.VERY_LIGHT_GRAY_OUTLINE:
    case VARIANT$1.PURPLE_OUTLINE:
      return props.theme.colors.white;
    case VARIANT$1.RED_FILLED:
      return props.theme.colors.warningRed;
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.PURPLE_FILLED:
    case VARIANT$1.GREEN_FILLED:
    case VARIANT$1.VERY_LIGHT_GRAY_FILLED:
    case VARIANT$1.RED_FILLED:
      return props.theme.colors.white;
    case VARIANT$1.VERY_LIGHT_GRAY_OUTLINE:
      return props.theme.colors.textGray;
    case VARIANT$1.PURPLE_OUTLINE:
      return props.theme.colors.forecastPurple;
    case VARIANT$1.RED_OUTLINE:
      return props.theme.colors.warningRed;
  }
}, function (props) {
  switch (props.size) {
    case SIZE$2.STANDARD:
      return '30px';
    case SIZE$2.MEDIUM_SMALL:
      return '24px';
    case SIZE$2.SMALL:
      return '22px';
    case SIZE$2.TALL:
      return '40px';
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.PURPLE_OUTLINE:
    case VARIANT$1.RED_OUTLINE:
      return '2px';
    default:
      return '1px';
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.GREEN_FILLED:
      return props.theme.colors.green;
    case VARIANT$1.VERY_LIGHT_GRAY_FILLED:
      return props.theme.colors.mediumVeryLightGray;
    case VARIANT$1.PURPLE_FILLED:
    case VARIANT$1.PURPLE_OUTLINE:
      return props.theme.colors.forecastPurple;
    case VARIANT$1.VERY_LIGHT_GRAY_OUTLINE:
      return '#ebebeb';
    case VARIANT$1.RED_FILLED:
    case VARIANT$1.RED_OUTLINE:
      return props.theme.colors.warningRed;
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.GREEN_FILLED:
    case VARIANT$1.VERY_LIGHT_GRAY_FILLED:
    case VARIANT$1.PURPLE_FILLED:
    case VARIANT$1.PURPLE_OUTLINE:
    case VARIANT$1.RED_FILLED:
    case VARIANT$1.RED_OUTLINE:
      return 0.8;
    case VARIANT$1.VERY_LIGHT_GRAY_OUTLINE:
      return 1;
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.GREEN_FILLED:
      return props.theme.colors.green;
    case VARIANT$1.VERY_LIGHT_GRAY_FILLED:
      return props.theme.colors.mediumVeryLightGray;
    case VARIANT$1.PURPLE_FILLED:
    case VARIANT$1.PURPLE_OUTLINE:
      return props.theme.colors.forecastPurple;
    case VARIANT$1.VERY_LIGHT_GRAY_OUTLINE:
      return props.theme.colors.mediumLightGray;
    case VARIANT$1.RED_FILLED:
    case VARIANT$1.RED_OUTLINE:
      return props.theme.colors.warningRed;
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.RED_FILLED:
    case VARIANT$1.RED_OUTLINE:
      return '1px';
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.RED_FILLED:
    case VARIANT$1.RED_OUTLINE:
      return '#ebebeb';
  }
}, function (props) {
  switch (props.variant) {
    case VARIANT$1.RED_FILLED:
    case VARIANT$1.RED_OUTLINE:
      return props.theme.colors.textGray;
  }
});
var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;
var StyledContainer = Styled__default.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n\tz-index: 100;\n\tposition: fixed;\n\theight: 60px;\n\tbottom: 70px;\n\tleft: 50%;\n\ttransform: translateX(-50%)\n"])));
var StyledBulkSelectPopup = Styled__default.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n\tpadding: 24px;\n\twidth: 100%;\n\tborder: solid 1px #dbdbdb;\n\tbox-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\tjustify-content: space-between;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: #fff;\n"])));
var StyledInfo = Styled__default.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: 100%;\n\twidth: 200px;\n\talign-items:center;\n\t> svg {\n\t\tcursor: pointer;\n\t\t\tg {\n\t\t\t\tstroke: #a1a1a1;\n\t\t\t}\n\t\t}\n\tspan.counter-spacing {\n\t\tmargin-left: 16px;\n\t\t\n\t}\n"])));
var StyledItemCountWrapper = Styled__default.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n\tdisplay:flex;\n\tflex-direction:row;\n\talign-items:center;\n"])));
var StyledCounterSpacing = Styled__default.span(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n    margin-left: 16px;\n"])));
var StyledCounter = Styled__default.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n\tfont-size: 13px;\n\tpadding: 0 4px;\n\tdisplay:flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 20px;\n\tmin-width: 20px;\n\tborder-radius: 2px;\n\tbackground-color: #6e0fea;\n\ttext-align:center;\n\tcolor: #fff;\n"])));
var StyledCounterText = Styled__default.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n\tfont-size: 13px;\n\tfont-weight: bold;\n\tcolor: #535353;\n\twhite-space: nowrap;\n\tmargin: 0 0 0 8px;\n\n"])));
var StyledButtonGroupContent = Styled__default.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n    position: relative;\n"])));
var StyledDropdown = Styled__default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: absolute;\n\tbottom: 40px;\n\tright: 0;\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);\n\tborder: solid 1px #e6e6e6;\n\tbackground-color: #ffffff;\n"])));
var StyledButtonGroup = Styled__default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\tmargin-left: 6px;\n\theight: 30px;\n\t.custom-button-container {\n\t\theight: 30px;\n\t}\n"])));
var StyledListSection = Styled__default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\tborder-bottom: 1px solid #e6e6e6;\n"])));
var StyledItem = Styled__default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\topacity: ", ";\n\tcursor: ", ";\n\tfont-size: 13px;\n\tcolor: ", ";\n\tpadding-left: ", ";\n\tpadding-top: 6px;\n\tpadding-bottom: 6px;\n\tpadding-right: 50px;\n\twhite-space: nowrap;\n\t&:hover {\n\t\tbackground-color: ", "\n\t}\n"])), function (props) {
  return props.disabled ? '0.5' : '1';
}, function (props) {
  return props.isTitle || props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.isTitle ? '#6e0fea' : '#535353';
}, function (props) {
  return props.indent ? props.indent * 16 + 'px' : 0;
}, function (props) {
  return !props.isTitle && 'rgba(110, 15, 234, 0.1)';
});
var FlexColumn = Styled__default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n    flex-direction: column;\n"])));
var CrossIconContainer = Styled__default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\talign-self: flex-start;\n\tmargin-top: 3px;\n"])));
var OptionsRow = Styled__default.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n    flex-direction: row;\n\talign-items: center;\n"])));
var WarningContainer = Styled__default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\tfont-family: 'Inter';\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin-left: 16px;\n\tmargin-top: 16px;\n\tfont-size: 13px;\n"])));
var WarningIconContainer = Styled__default.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n\tmargin-left: 10px;\n"])));
var BulkSelectPopup = function BulkSelectPopup(_ref) {
  var onClose = _ref.onClose,
    itemCount = _ref.itemCount,
    counterText = _ref.counterText,
    actionOptions = _ref.actionOptions,
    complexOptions = _ref.complexOptions,
    warningMessage = _ref.warningMessage,
    warningIcon = _ref.warningIcon;
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedButtonId = _useState2[0],
    setSelectedButtonId = _useState2[1]; // for registering clicks outside of button group
  // a button group is a button and associated dropdown

  var buttonGroupRef = React.useRef();
  /**
   * takes a function and calls it, if its not undefined
   * @param {Function} callback
   */

  var handleClick = function handleClick(callback) {
    if (callback) {
      setSelectedButtonId(null);
      callback();
    }
  };
  /**
   * Sets selected button. and calls the callback function
   * @param {object} button
   */

  var handleButtonClick = function handleButtonClick(button) {
    setSelectedButtonId(selectedButtonId !== button.id ? button.id : null);
    handleClick(button.callback);
  };
  /**
   * return whether id is equal to selectedButtonId
   * @param {string} id
   * @returns {boolean}
   */

  var isButtonSelected = function isButtonSelected(id) {
    return id === selectedButtonId;
  };
  /**
   * disables selectedButton if event is outside buttonGroupRef
   * @param {MouseEvent} event
   */

  var handleClickOutside = function handleClickOutside(event) {
    if (buttonGroupRef.current && !buttonGroupRef.current.contains(event.target)) {
      setSelectedButtonId(null);
    }
  };
  /**
   * Adds/ removes a Listener to mousedown event
   */

  React.useEffect(function () {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  /**
   * Recursive function calling itself with options until options do not exist
   * @param {object} options
   * @param {number} count default 1
   */

  var listOptions = function listOptions(options) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var result = [];
    result = options.map(function (option, i) {
      return option.section ? /*#__PURE__*/React__default.createElement(StyledListSection, {
        key: i + count
      }, /*#__PURE__*/React__default.createElement(StyledItem, {
        disabled: option.disabled,
        onClick: function onClick() {
          return !option.disabled && handleClick(option.callback);
        },
        indent: count,
        isTitle: option.options
      }, option.label), option.options && listOptions(option.options, count + 1)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: i + count
      }, /*#__PURE__*/React__default.createElement(StyledItem, {
        disabled: option.disabled,
        onClick: function onClick() {
          return !option.disabled && handleClick(option.callback);
        },
        indent: count,
        isTitle: option.options
      }, option.label), option.options && listOptions(option.options, count + 1));
    });
    return result;
  };
  return /*#__PURE__*/React__default.createElement(StyledContainer, null, /*#__PURE__*/React__default.createElement(StyledBulkSelectPopup, {
    className: 'animated faster fadeInUp',
    "data-userpilot": 'bulk-select-popup'
  }, /*#__PURE__*/React__default.createElement(CrossIconContainer, null, /*#__PURE__*/React__default.createElement(CrossIcon, {
    onClick: onClose
  })), /*#__PURE__*/React__default.createElement(FlexColumn, null, /*#__PURE__*/React__default.createElement(OptionsRow, null, /*#__PURE__*/React__default.createElement(StyledInfo, null, /*#__PURE__*/React__default.createElement(StyledItemCountWrapper, null, /*#__PURE__*/React__default.createElement(StyledCounterSpacing, null, /*#__PURE__*/React__default.createElement(StyledCounter, {
    "data-cy": "bulk-popup-counter"
  }, itemCount)), /*#__PURE__*/React__default.createElement(StyledCounterText, null, counterText))), complexOptions && complexOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement(StyledButtonGroup, {
      key: option.id,
      ref: isButtonSelected(option.id) ? buttonGroupRef : null,
      onClick: function onClick() {
        return handleButtonClick(option);
      }
    }, /*#__PURE__*/React__default.createElement(StyledButtonGroupContent, null, isButtonSelected(option.id) && option.options && /*#__PURE__*/React__default.createElement(StyledDropdown, null, listOptions(option.options)), option.renderButton(isButtonSelected(option.id))));
  }), actionOptions && actionOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement(StyledButtonGroup, {
      key: option.id,
      ref: isButtonSelected(option.id) ? buttonGroupRef : null
    }, /*#__PURE__*/React__default.createElement(StyledButtonGroupContent, null, isButtonSelected(option.id) && option.options && /*#__PURE__*/React__default.createElement(StyledDropdown, null, listOptions(option.options)), /*#__PURE__*/React__default.createElement(Button, {
      cy: option.cy,
      disabled: option.disabled,
      onClick: function onClick() {
        return handleButtonClick(option);
      },
      iconPosition: option.icon ? 'first' : undefined,
      icon: option.icon,
      userpilot: option.userpilot,
      variant: isButtonSelected(option.id) ? VARIANT$1.PURPLE_FILLED : option.variant
    }, option.label)));
  })), warningMessage && /*#__PURE__*/React__default.createElement(WarningContainer, null, /*#__PURE__*/React__default.createElement("div", null, warningMessage), warningIcon && /*#__PURE__*/React__default.createElement(WarningIconContainer, null, warningIcon)))));
};
BulkSelectPopup.propTypes = {
  /**
   * bulk select popup onClose function
   */
  onClose: PropTypes__default.func.isRequired,
  /**
   * a counter of how many items has been selected for bulk action
   */
  itemCount: PropTypes__default.number,
  /**
   * a name for the items selected
   */
  counterText: PropTypes__default.string,
  /**
   * options of bulk actions that can be done to the selected items
   */
  actionOptions: PropTypes__default.arrayOf(PropTypes__default.object),
  /**
   * complex options of bulk actions that like actionOptions can be done to the selected items but require custom button group content
   */
  complexOptions: PropTypes__default.arrayOf(PropTypes__default.object),
  /**
   * warning text shown at the bottom of the popup
   */
  warningMessage: PropTypes__default.arrayOf(PropTypes__default.string),
  /**
   * warning icon
   */
  warningIcon: PropTypes__default.arrayOf(PropTypes__default.element)
};
BulkSelectPopup.defaultProps = {
  actionOptions: [],
  complexOptions: [],
  counterText: 'items selected'
};
var _templateObject$6;
var SIZE$3 = {
  SMALL: 'small',
  STANDARD: 'standard'
};
/**
 * This cross icon is now deprecated, please use the CrossIcon
 */

var CrossIconOld = function CrossIconOld(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$3.SMALL:
        return '10';
      case SIZE$3.STANDARD:
        return '12';
      default:
        return '12';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$3.SMALL:
        return '10';
      case SIZE$3.STANDARD:
        return '12';
      default:
        return '12';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$2, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React__default.createElement("g", {
    stroke: color,
    strokeWidth: "2",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M2.308 9.692l7.384-7.384M2.308 2.308l7.384 7.384"
  }))));
};
CrossIconOld.SIZE = SIZE$3;
CrossIconOld.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$3.SMALL, SIZE$3.STANDARD])
};
CrossIconOld.defaultProps = {
  color: '#565656'
};
var StyledSpan$2 = Styled__default.span(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$7, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$2, _templateObject6$2;
var Container = Styled__default.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tdisplay: inline-block;\n\tmax-width: ", ";\n\tmin-width: 50px;\n\theight: 34px;\n\tborder-radius: 2px;\n\tbackground-color: ", ";\n\tpadding: 4px 7px 4px 10px;\n\tcolor: ", ";\n"])), function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return "".concat(props.maxWidth, "px");
}, function (props) {
  return props.disabled ? '#e6e6e6' : '#6e0fea';
}, function (props) {
  return props.disabled ? '#545454' : '#fff';
});
var ContentContainer = Styled__default.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n\tcursor: default;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content:space-between;\n"])));
var TextContainer = Styled__default.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n\toverflow: hidden;\n\tmargin-right: 10px;\n"])));
var Title = Styled__default.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n\topacity: 0.7;\n\tfont-size: 9px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
var Text = Styled__default.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n\toverflow: hidden;\n\tfont-size: 11px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"])));
var IconContainer = Styled__default.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n"])));
var Badge = function Badge(_ref) {
  var title = _ref.title,
    text = _ref.text,
    maxWidth = _ref.maxWidth,
    onRemoveClick = _ref.onRemoveClick,
    disabled = _ref.disabled;
  var handleRemoveClick = function handleRemoveClick() {
    onRemoveClick();
  };
  return /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: maxWidth,
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(ContentContainer, null, /*#__PURE__*/React__default.createElement(TextContainer, null, /*#__PURE__*/React__default.createElement(Title, {
    title: title
  }, title), /*#__PURE__*/React__default.createElement(Text, {
    title: text
  }, text)), onRemoveClick && /*#__PURE__*/React__default.createElement(IconContainer, {
    onClick: handleRemoveClick
  }, /*#__PURE__*/React__default.createElement(CrossIconOld, {
    color: disabled ? '#535353' : '#fff'
  }))));
};
Badge.propTypes = {
  /**
   * Top text of the badge
   */
  title: PropTypes__default.string.isRequired,
  /**
   * Content text
   */
  text: PropTypes__default.string.isRequired,
  /**
   * Adjust the max width the badge will grow too
   */
  maxWidth: PropTypes__default.number,
  /**
   * Handler for onRemove, will also enable the cross icon
   */
  onRemoveClick: PropTypes__default.func,
  /**
   * Gray out card to show its disabled
   */
  disabled: PropTypes__default.bool
};
Badge.defaultProps = {
  maxWidth: 130
};
var _templateObject$8, _templateObject2$5, _templateObject3$4;
var Container$1 = Styled__default.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n\tfont-family: ", ";\n\twidth: 100%;\n\theight: 30px;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-evenly;\n\n"])), function (props) {
  return props.theme.fontFamily;
});
var ButtonContainer = Styled__default.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tcolor: ", ";\n\tflex-grow: 1;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: ", ";\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n"])), function (props) {
  return props.isSelected ? props.theme.colors.white : props.theme.colors.textGray;
}, function (props) {
  return props.isSelected ? props.theme.colors.forecastPurple : props.theme.colors.veryVeryLightGray;
});
var Text$1 = Styled__default.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n\ttext-transform: uppercase;\n\tfont-size: 10px;\n\tletter-spacing: 1px;\n\tfont-weight: 500;\n\tflex-grow: 1;\n\ttext-align: center;\n\tborder-left: ", ";\n\tborder-right:", ";\n"])), function (props) {
  return "1px solid ".concat(props.left ? polished.transparentize(0.85, props.theme.colors.textGray) : 'transparent');
}, function (props) {
  return "1px solid ".concat(props.right ? polished.transparentize(0.85, props.theme.colors.textGray) : 'transparent');
});
var Button$1 = function Button(_ref) {
  var children = _ref.children,
    value = _ref.value,
    left = _ref.left,
    right = _ref.right,
    isSelected = _ref.isSelected,
    onClick = _ref.onClick,
    dataCy = _ref['data-cy'];
  var handleClick = function handleClick() {
    onClick(value);
  };
  return /*#__PURE__*/React__default.createElement(ButtonContainer, {
    onClick: handleClick,
    isSelected: isSelected,
    "data-cy": dataCy
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    left: left,
    right: right
  }, children));
};
Button$1.propTypes = {
  /**
   * Text to show on the button, should only contain a single string
   */
  children: PropTypes__default.string.isRequired,
  /**
   * Indicates whether a button is selected
   * Internal logic only supports one selected button atm.
   */
  isSelected: PropTypes__default.bool,
  /**
   * an optional value which is return on select
   * if not supplied, the children text will be returned on select
   */
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  /**
   * DO NOT SET - internal prop used by ButtonGroup
   */
  onClick: PropTypes__default.func,
  /**
   * DO NOT SET - internal prop used by ButtonGroup
   * sets if left border should be displyed
   */
  left: PropTypes__default.bool,
  /**
   * DO NOT SET - internal prop used by ButtonGroup
   * sets if left border should be displyed
   */
  right: PropTypes__default.bool
};
var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
    onButtonClick = _ref.onButtonClick;
  var childrenArray = React__default.Children.toArray(children);
  var childrenLength = childrenArray.length;
  var selectedElement = childrenArray.findIndex(function (child) {
    return !!child.props.isSelected;
  });
  var getBorderProps = function getBorderProps(index, selectedElement, childrenLength) {
    var left = true;
    var right = true; // check for outermost elements

    left = left && index !== 0, right = right && index !== childrenLength - 1; // check if selected or selected is next to this element

    left = left && index !== selectedElement && index - 1 !== selectedElement;
    right = right && index !== selectedElement && index + 1 !== selectedElement;
    return {
      right: right,
      left: left
    };
  };
  return /*#__PURE__*/React__default.createElement(Container$1, null, React__default.Children.map(children, function (child, i) {
    var value = child.props.value || child.props.children;
    return /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, getBorderProps(i, selectedElement, childrenLength)), {}, {
      onClick: onButtonClick,
      value: value
    }));
  }));
};
ButtonGroup.Button = Button$1;
ButtonGroup.propTypes = {
  /**
   * children - Only Components of type ButtonGroup.Button
   */
  children: PropTypes__default.node.isRequired,
  /**
   * (value) => void
   * returns value fo the button clicked
   */
  onButtonClick: PropTypes__default.func
};
ButtonGroup.defaultProps = {
  onButtonClick: function onButtonClick() {
    return false;
  }
};
var _templateObject$9;
var DIRECTION = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right'
};
var SIZE$4 = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var CaretIcon = function CaretIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick,
    direction = _ref.direction,
    title = _ref.title;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$4.SMALL:
        return '3';
      case SIZE$4.STANDARD:
        return '12';
      default:
        return '12';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$4.SMALL:
        return '12';
      case SIZE$4.STANDARD:
        return '12';
      default:
        return '12';
    }
  };
  var getRotation = function getRotation(direction) {
    switch (direction) {
      case DIRECTION.UP:
        return 180;
      case DIRECTION.RIGHT:
        return 90;
      case DIRECTION.DOWN:
        return 0;
      case DIRECTION.LEFT:
        return 270;
      default:
        return 0;
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$3, {
    onClick: handleClick,
    canClick: onClick !== undefined,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: 'caret-icon',
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 6 12"
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Artboard",
    transform: "translate(-363.000000, -2406.000000)",
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M370.379216,2409.20657 C370.812197,2408.87871 371.441132,2408.94858 371.783982,2409.36263 C372.126831,2409.77668 372.053765,2410.37812 371.620784,2410.70598 L365.950027,2414.99996 L360.381167,2410.80464 C359.947335,2410.47781 359.872705,2409.87655 360.214477,2409.46169 C360.556249,2409.04682 361.185,2408.97546 361.618833,2409.30229 L365.946858,2412.56282 L370.379216,2409.20657 Z",
    id: "Arrow-right",
    transform: "translate(365.999999, 2411.999960) scale(-1, 1) rotate(".concat(getRotation(direction), ") translate(-365.999999, -2411.999960)"),
    className: 'caret-icon-path'
  })))));
};
CaretIcon.SIZE = SIZE$4;
CaretIcon.DIRECTION = DIRECTION;
CaretIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$4.SMALL, SIZE$4.STANDARD]),
  direction: PropTypes__default.oneOf([DIRECTION.UP, DIRECTION.LEFT, DIRECTION.RIGHT, DIRECTION.DOWN]),
  title: PropTypes__default.string
};
CaretIcon.defaultProps = {
  color: '#535353'
};
var StyledSpan$3 = Styled__default.span(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n\tcursor: ", ";\n\ttransform: ", "\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
}, function (_ref2) {
  var canClick = _ref2.canClick;
  return canClick ? 'pointer' : 'normal';
}, function (props) {
  switch (props.direction) {
    case DIRECTION.DOWN:
      return 'rotate(90deg)';
    case DIRECTION.LEFT:
      return 'rotate(180deg)';
    case DIRECTION.UP:
      return 'rotate(270deg)';
    default:
      return '';
  }
});
var _templateObject$a;
var HeaderStyle = Styled__default.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tuser-select: none;\n\n\t& > div {\n\t\tmargin-right: 8px;\n\t}\n"])));
var useCollapsible = function useCollapsible(_ref) {
  var title = _ref.title,
    initiallyCollapsed = _ref.initiallyCollapsed,
    cy = _ref.cy,
    trackingEvent = _ref.trackingEvent,
    trackingId = _ref.trackingId,
    localStorageKey = _ref.localStorageKey;
  var collapsedValue = initiallyCollapsed;
  if (localStorageKey) {
    var storedCollapsedState = localStorage.getItem(localStorageKey);
    if (storedCollapsedState === 'true' || storedCollapsedState === 'false') {
      collapsedValue = storedCollapsedState === 'true';
    }
  }
  var _useState = React.useState(collapsedValue),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  React.useEffect(function () {
    if (localStorageKey) {
      localStorage.setItem(localStorageKey, collapsed);
    }
  }, [collapsed]);
  var toggleCollapsed = function toggleCollapsed() {
    var newCollapsedValue = !collapsed;
    if (trackingEvent && trackingId) {
      trackingEvent(newCollapsedValue, trackingId);
    }
    setCollapsed(newCollapsedValue);
  };
  var Collapser = function Collapser() {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(HeaderStyle, {
      "data-cy": cy,
      onClick: toggleCollapsed
    }, /*#__PURE__*/React__default.createElement("div", null, title), /*#__PURE__*/React__default.createElement(CaretIcon, {
      color: "#535353",
      size: CaretIcon.SIZE.STANDARD,
      direction: collapsed ? CaretIcon.DIRECTION.DOWN : CaretIcon.DIRECTION.UP
    })));
  };
  return {
    Collapser: Collapser,
    collapsed: collapsed
  };
}; // eslint-disable-next-line react/prop-types

var Collapsible = function Collapsible(_ref2) {
  var title = _ref2.title,
    initiallyCollapsed = _ref2.initiallyCollapsed,
    children = _ref2.children,
    cy = _ref2.cy,
    trackingEvent = _ref2.trackingEvent,
    trackingId = _ref2.trackingId,
    localStorageKey = _ref2.localStorageKey;
  var _useCollapsible = useCollapsible({
      title: title,
      initiallyCollapsed: initiallyCollapsed,
      children: children,
      cy: cy,
      trackingEvent: trackingEvent,
      trackingId: trackingId,
      localStorageKey: localStorageKey
    }),
    Collapser = _useCollapsible.Collapser,
    collapsed = _useCollapsible.collapsed;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Collapser, null), !collapsed && children);
};
var _templateObject$b, _templateObject2$6, _templateObject3$5, _templateObject4$4;
var Container$2 = Styled__default.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\tmin-width: ", ";\n\tpadding: 5px 0px;\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n\tborder: ", ";\n"])), function (props) {
  return props.minWidth && "".concat(props.minWidth, "px");
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid ".concat(theme.colors.veryLightGray);
});
var ContentContainer$1 = Styled__default.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
var PopupElement = Styled__default.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n\tcursor: ", ";\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tz-index: 1000;\n\twidth: 100%;\n\tpadding: 0 12px;\n\tbackground-color: ", ";\n\t&:hover {\n\t\tbackground-color: ", ";\n\t}\n"])), function (props) {
  return !props.disabled && 'pointer';
}, function (_ref3) {
  var showFocus = _ref3.showFocus,
    disabled = _ref3.disabled,
    theme = _ref3.theme;
  return showFocus && !disabled ? theme.colors.forecastPurpleLight : null;
}, function (_ref4) {
  var disabled = _ref4.disabled,
    theme = _ref4.theme;
  return !disabled && theme.colors.forecastPurpleLight;
});
var Element = Styled__default.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n\tflex-grow: 1;\n\theight: 100%;\n"])));
var ContextMenu = function ContextMenu(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    minWidth = _ref.minWidth;
  var handleOnClick = function handleOnClick(value, disabled) {
    if (!disabled) {
      onClick(value);
    }
  };
  return /*#__PURE__*/React__default.createElement(Container$2, {
    minWidth: minWidth
  }, /*#__PURE__*/React__default.createElement(ContentContainer$1, null, React__default.Children.map(children, function (child) {
    var _child$props = child.props,
      value = _child$props.value,
      disabled = _child$props.disabled;
    return /*#__PURE__*/React__default.createElement(PopupElement, {
      onClick: function onClick() {
        return handleOnClick(value, disabled);
      },
      disabled: disabled
    }, /*#__PURE__*/React__default.createElement(Element, null, child));
  })));
};
ContextMenu.propTypes = {
  children: PropTypes__default.node,
  onClick: PropTypes__default.func,
  minWidth: PropTypes__default.number
};
ContextMenu.defaultProps = {
  onClick: function onClick() {
    return false;
  }
};
var _templateObject$c, _templateObject2$7;
// eslint-disable-next-line no-unused-vars

var SingleText = function SingleText(_ref) {
  var children = _ref.children,
    searchString = _ref.searchString,
    value = _ref.value,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    infoText = _ref.infoText,
    cy = _ref.cy;
  var textColor = disabled && '#a1a1a1';
  return /*#__PURE__*/React__default.createElement(Container$3, {
    title: infoText
  }, /*#__PURE__*/React__default.createElement(Text$2, {
    onClick: onClick,
    color: textColor,
    "data-cy": cy,
    title: children
  }, children));
};
var Container$3 = Styled__default.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n\tbackground-color: transparent;\n\tpadding: 5px 0;\n\toverflow: hidden;\n"])));
var Text$2 = Styled__default.p(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tpadding: 0;\n\tmargin: 0;\n\tfont-size: 12px;\n\tcolor: ", ";\n"])), function (props) {
  return props.color || '#545454';
});
SingleText.propTypes = {
  children: PropTypes__default.any,
  searchString: PropTypes__default.string,
  value: PropTypes__default.any,
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  infoText: PropTypes__default.string,
  cy: PropTypes__default.string
};
var _templateObject$d;
var SIZE$5 = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var AIIcon = function AIIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    opacity = _ref.opacity,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$5.SMALL:
        return '12';
      case SIZE$5.STANDARD:
        return '14';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$5.SMALL:
        return '12';
      case SIZE$5.STANDARD:
        return '14';
      default:
        return '15';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$4, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M10.588 3.95c.78 0 1.412.654 1.412 1.463v5.123c0 .809-.632 1.464-1.412 1.464H1.412C.632 12 0 11.345 0 10.536V5.413C0 4.604.632 3.95 1.412 3.95zM8.824 6.62c-.748 0-1.355.63-1.355 1.405 0 .36.134.683.348.931H9.83a1.42 1.42 0 00.347-.93c0-.777-.606-1.406-1.354-1.406zm-5.647 0c-.748 0-1.355.63-1.355 1.405 0 .36.133.683.347.931h2.015a1.42 1.42 0 00.347-.93c0-.777-.606-1.406-1.354-1.406zM7.462 0c.755 0 1.403.502 1.613 1.21a.896.896 0 00-.522.515.225.225 0 00.42.16.445.445 0 01.46-.28c.643.118 1.141.616 1.262 1.245h-9.39a1.57 1.57 0 011.258-1.244.446.446 0 01.463.28.225.225 0 00.421-.16.896.896 0 00-.474-.501c-.015-.007-.032-.01-.047-.016A1.685 1.685 0 014.538 0c.377 0 .743.128 1.039.363a.225.225 0 01.085.176v.57a.337.337 0 00.676 0v-.57c0-.069.031-.134.085-.176A1.674 1.674 0 017.463 0z",
    fill: color,
    fillRule: "evenodd",
    opacity: opacity
  })));
};
AIIcon.SIZE = SIZE$5;
AIIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  opacity: PropTypes__default.number,
  size: PropTypes__default.oneOf([SIZE$5.SMALL, SIZE$5.STANDARD])
};
AIIcon.defaultProps = {
  opacity: 1
};
var StyledSpan$4 = Styled__default.span(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});

//export const projectColors = ['#fdcfd5', '#f2cbf3', '#b687f4', '#d3b7f8', '#cac3f5', '#97b0ea', '#6eaff0', '#ade3ff', '#fbb2b2', '#fcc3b4', '#fbc59e', '#faec8c', '#e3efab', '#caedb3', '#a3e7e1', '#dadadf'];
var projectColors = ['#BC97F5', '#CE93D8', '#F98BD2', '#F69695', '#FFCBD0', '#FFDF83', '#FDEF95', '#7DEAB7', '#80CBC3', '#8AC7FF', '#B9DCFF', '#E6E6ED'];
var ColorUtils = /*#__PURE__*/function () {
  function ColorUtils() {
    _classCallCheck(this, ColorUtils);
  }
  _createClass(ColorUtils, null, [{
    key: "getInvertedTextColor",
    value:
    /**
     * Returns best match black or white, so it can be displayed on either dark og light background
     * @param {string} backgroundColor color hex value
     */
    function getInvertedTextColor(backgroundColor) {
      var brightness = 255;
      var brightnessThreshold = 165;
      var c = parseInt(backgroundColor.slice(1), 16);
      var r = c >> 16;
      var g = c >> 8 & 0x00ff;
      var b = c & 0x0000ff;
      brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      return brightness < brightnessThreshold ? '#ffffff' : '#000000';
    }
    /**
    Pink2: #
    Purple1: #
    Purple2: #
    Purple3: #cac3f5
    Bule1: #97b0ea
    Blue2: #6eaff0
    Blue3: #ade3ff
    Red1: #fbb2b2
    Red2: #fcc3b4
    Orange1: #fbc59e
    Yellow: #faec8c
    Green1: #e3efab
    Green2: #caedb3
    Green3: #a3e7e1
    Grey: #dadadf
     */
  }]);

  return ColorUtils;
}();
var SIZE$6 = {
  SMALL: 'small',
  DROPDOWN: 'dropdown',
  TAB: 'tab',
  STANDARD: 'standard',
  BIG: 'big',
  EXTRA_BIG: 'extra_big',
  MEDIUM: 'medium'
};
function getDimensions(size) {
  switch (size) {
    case SIZE$6.SMALL:
      return '15';
    case SIZE$6.DROPDOWN:
      return '20';
    case SIZE$6.TAB:
      return '24';
    case SIZE$6.MEDIUM:
      return '35';
    case SIZE$6.BIG:
      return '65';
    case SIZE$6.EXTRA_BIG:
      return '90';
    case SIZE$6.STANDARD:
    default:
      return '28';
  }
}
var _templateObject$e, _templateObject2$8, _templateObject3$6, _templateObject4$5;
var LabelName = Styled__default.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tposition: relative;\n\tfont-size: 10px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 500;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tpadding: 0;\n\tmargin: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
});
var LabelContainer = Styled__default.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n\tbox-sizing: border-box;\n\tmax-width: calc(100% - 9px);\n\n\theight: 20px;\n\tmargin-left: 9px;\n\tborder-radius: 2px;\n\tborder-top-right-radius: 4px;\n\tborder-bottom-right-radius: 4px;\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tposition: relative;\n\tdisplay: inline-block;\n\tpadding: 0 9px 0 2px;\n\n\n\t&::before {\n\t\tposition: absolute;\n\t\t-webkit-transform: translateY(-50%) translateX(50%) rotate(-45deg);\n\t\ttransform: translateY(-50%) translateX(50%) rotate(-45deg);\n\t\ttop: 50%;\n\t\tright: 100%;\n\t\tcontent: '';\n\t\tbackground-color: inherit;\n\t\twidth: 13px;\n\t\theight: 13px;\n\t}\n"])), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.color;
});
var IconContainer$1 = Styled__default.div(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n\tz-index: 1;\n\tpadding-right: ", ";\n\tpadding-left:  ", ";\n"])), function (props) {
  return props.right && '5px';
}, function (props) {
  return props.left && '5px';
});
var Content = Styled__default.div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n\tz-index: 2;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\theight: 100%;\n\twidth: 100%;\n\tpadding-left: 5px;\n"])));
var Label = function Label(_ref2) {
  var color = _ref2.color,
    name = _ref2.name,
    onClick = _ref2.onClick,
    showAI = _ref2.showAI,
    onRemove = _ref2.onRemove;
  var handleClick = function handleClick() {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/React__default.createElement(LabelContainer, {
    title: name,
    backgroundColor: color,
    color: ColorUtils.getInvertedTextColor(color),
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(Content, null, showAI && /*#__PURE__*/React__default.createElement(IconContainer$1, {
    right: true
  }, /*#__PURE__*/React__default.createElement(AIIcon, {
    size: AIIcon.SIZE.SMALL,
    color: ColorUtils.getInvertedTextColor(color),
    opacity: 0.5
  })), /*#__PURE__*/React__default.createElement(LabelName, null, name), onRemove && /*#__PURE__*/React__default.createElement(IconContainer$1, {
    left: true
  }, /*#__PURE__*/React__default.createElement(CrossIconOld, {
    size: CrossIconOld.SIZE.SMALL,
    color: ColorUtils.getInvertedTextColor(color),
    onClick: onRemove
  }))));
};
Label.propTypes = {
  color: PropTypes__default.string,
  name: PropTypes__default.string,
  onClick: PropTypes__default.func,
  showAI: PropTypes__default.bool,
  onRemove: PropTypes__default.func
};
var _templateObject$f;
// eslint-disable-next-line no-unused-vars

var LabelLine = function LabelLine(_ref) {
  var name = _ref.name,
    color = _ref.color,
    searchString = _ref.searchString,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement(Container$4, null, /*#__PURE__*/React__default.createElement(Label, {
    name: name,
    color: color
  }));
};
var Container$4 = Styled__default.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n\tbackground-color: transparent;\n\tpadding: 5px 0;\n"])));
LabelLine.propTypes = {
  name: PropTypes__default.string,
  color: PropTypes__default.string,
  searchString: PropTypes__default.string.isRequired,
  value: PropTypes__default.any
};
ContextMenu.SingleText = SingleText;
ContextMenu.LabelLine = LabelLine;
var _templateObject$g, _templateObject2$9, _templateObject3$7, _templateObject4$6, _templateObject5$3, _templateObject6$3, _templateObject7$2, _templateObject8$2, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1;
var Container$5 = Styled__default.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tbox-sizing: border-box;\n\tposition: relative;\n\tfont-size: 12px;\n\tbackground-color: ", ";\n\tfont-family: ", ";\n\tborder-width: 1px;\n\tborder-style: solid;\n\tborder-color: ", ";\n\theight: ", ";\n\twidth: 100%;\n\tborder-radius: ", ";\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n"])), function (props) {
  return props.disabled ? '#f3f3f3' : '#fff';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (props) {
  if (props.expanded) {
    return '#6e0fea';
  }
  if (props.disabled) {
    return '#e6e6e6';
  } else {
    return '#e6e6e6';
  }
}, function (props) {
  return props.size === 'large' ? '40px' : '30px';
}, function (props) {
  return props.expanded ? props.above ? '0 0 4px 4px' : '4px 4px 0px 0px' : '4px';
}, function (props) {
  return !props.expanded && !props.disabled && '#a1a1a1';
});
var DropdownButton = Styled__default.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\talign-items: center;\n\tpadding-left: 8px;\n"])));
var Input = Styled__default.input(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n\tmin-width: 0; /* firefox fix for flex items */\n\tcursor: ", ";\n\tcolor: ", ";\n\twidth: 100%;\n\tbackground-color: transparent;\n\tborder: none;\n\theight: 100%;\n\tfont-size: 12px;\n\toutline: none;\n\tflex: 1;\n\tpadding: 0;\n\t::placeholder {\n\t\tfont-size: 12px;\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n"])), function (props) {
  return props.expanded ? 'text' : 'pointer';
}, function (props) {
  return props.disabled ? 'rgba(p0,0,0,0.87)' : '#535353';
}, function (props) {
  return props.emphasizePlaceholder && !props.disabled ? '#535353' : '#a1a1a1';
});
var IconContainer$2 = Styled__default.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n\tpadding: 0px 8px 0 8px;\n"])));
var InfoBadgeContainer = Styled__default.div(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n\tborder: 1px solid #8E8F9F;\n\tborder-radius: 10px;\n\tfont-size: 10px;\n\tpadding: 2px 8px;\n"])));
var AllAction = Styled__default.div(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n\tflex-grow: 1;\n\ttext-align: right;\n\tp {\n\t\tcolor: #535353;\n\t\tfont-size: 12px;\n\n\t\tpadding: 0;\n\t\tmargin: 0 14px 0 0;\n\t}\n"])));
var DropdownContainer = Styled__default.div(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n\toverflow: hidden;\n\tz-index: 1000;\n\tposition: absolute;\n\tleft: ", ";\n\tmargin-left: ", ";\n\tright: ", ";\n\t\n\tborder: 1px solid #6e0fea;\n\t\n\tborder-top-left-radius: ", ";\n\tborder-top-right-radius: ", ";\n\tborder-bottom-right-radius: ", ";\n\tborder-bottom-left-radius:  ", ";\n\n\tbox-sizing: border-box;\n\tbackground-color: #fff;\n\tmax-height: ", ";\n\twidth: ", ";\n\t}};\n"])), function (props) {
  if (props.dropdownAlignment === 'left') return '-1px';
  if (props.dropdownAlignment === 'center') return '50%';
  if (props.dropdownAlignment === 'none') return '-1px;';
}, function (props) {
  return props.dropdownAlignment === 'center' && "-".concat(props.width / 2, "px");
}, function (props) {
  if (props.dropdownAlignment === 'none') return '-1px;';
  if (props.dropdownAlignment === 'right') return '-1px';
}, function (_ref2) {
  var dropdownAlignment = _ref2.dropdownAlignment,
    positionAbove = _ref2.positionAbove;
  if (positionAbove) {
    return '4px';
  }
  switch (dropdownAlignment) {
    case 'center':
      return '4px';
    case 'right':
      return '4px';
    default:
      return '0';
  }
}, function (_ref3) {
  var dropdownAlignment = _ref3.dropdownAlignment,
    positionAbove = _ref3.positionAbove;
  if (positionAbove) {
    return '4px';
  }
  switch (dropdownAlignment) {
    case 'left':
      return '4px';
    case 'center':
      return '4px';
    default:
      return '0';
  }
}, function (_ref4) {
  var dropdownAlignment = _ref4.dropdownAlignment,
    positionAbove = _ref4.positionAbove;
  if (!positionAbove) {
    return '4px';
  }
  switch (dropdownAlignment) {
    case 'left':
      return '4px';
    case 'center':
      return '4px';
    default:
      return '0';
  }
}, function (_ref5) {
  var dropdownAlignment = _ref5.dropdownAlignment,
    positionAbove = _ref5.positionAbove;
  if (!positionAbove) {
    return '4px';
  }
  switch (dropdownAlignment) {
    case 'right':
      return '4px';
    case 'center':
      return '4px';
    default:
      return '0';
  }
}, function (props) {
  return "".concat(props.maxHeight, "px");
}, function (props) {
  return props.width && "".concat(props.width, "px");
});
var GroupContainer = Styled__default.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tbackground-color: transparent;\n"])));
var DropdownElement = Styled__default.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tz-index: 1000;\n\twidth: 100%;\n\tpadding: 0 ", ";\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tbackground-color: ", ";\n\t&:hover {\n\t\tbackground-color: #f0e7fc;\n\t}\n"])), function (_ref6) {
  var noPadding = _ref6.noPadding;
  return noPadding ? '0' : '12px';
}, function (_ref7) {
  var showFocus = _ref7.showFocus;
  return showFocus ? '#f0e7fc' : null;
});
var Element$1 = Styled__default.div(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n\tflex-grow: 1;\n\theight: 100%;\n\twidth: calc(100% - 16px);\n"])));
var RemoveElement = Styled__default.div(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tpadding-left: 4px;\n"])));
var GroupHeading = Styled__default.div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n\tbox-sizing: border-box;\n\tpadding: 8px 12px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tborder-bottom: 1px solid #e6e6e6;\n\tcursor: pointer;\n"])));
var GroupHeadingTextContainer = Styled__default.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n\tcolor: #535353;\n\tp {\n\t\tfont-size: 12px;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tdisplay: inline;\n\t\ttext-transform: capitalize;\n\n\t}\n"])));
var DropdownButtonPlaceholder = Styled__default.div(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n\tmin-width: 0px;\n\twidth: 100%;\n"])));
var DropdownLabel = Styled__default.div(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n\theight: 11px;\n\tfont-size: 9px;\n\tfont-weight: 500;\n\tline-height: 1.22;\n\tletter-spacing: 1px;\n\tcolor: ", ";\n\ttext-transform: uppercase;\n\tmargin-bottom: 5px;\n\twhite-space: nowrap;\n\t.required-extension {\n\t\tcolor: ", ";\n\t}\n"])), function (props) {
  return props.theme.colors.mediumLightGray;
}, function (props) {
  return props.theme.colors.negativeValue;
});
var Item = function Item(_ref) {
  var children = _ref.children,
    onSetInnerRef = _ref.onSetInnerRef,
    value = _ref.value,
    cy = _ref.cy,
    onKeyDown = _ref.onKeyDown,
    showFocus = _ref.showFocus,
    noPadding = _ref.noPadding,
    onClick = _ref.onClick,
    onRemoveClick = _ref.onRemoveClick;
  var handleRemoveClick = onRemoveClick ? function () {
    return onRemoveClick(value);
  } : false;
  var handleClick = function handleClick() {
    return onClick(value);
  };
  return /*#__PURE__*/React__default.createElement(DropdownElement, {
    ref: onSetInnerRef,
    "data-cy": cy,
    onKeyDown: onKeyDown,
    showFocus: showFocus,
    noPadding: noPadding,
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(Element$1, null, children), handleRemoveClick && /*#__PURE__*/React__default.createElement(RemoveElement, null, /*#__PURE__*/React__default.createElement(CrossIconOld, {
    onClick: handleRemoveClick
  })));
};
Item.propTypes = {
  children: PropTypes__default.any,
  onSetInnerRef: PropTypes__default.func,
  value: PropTypes__default.any,
  cy: PropTypes__default.string,
  onKeyDown: PropTypes__default.func,
  showFocus: PropTypes__default.bool,
  noPadding: PropTypes__default.bool,
  onClick: PropTypes__default.func,
  onRemoveClick: PropTypes__default.func
};
var Group = function Group(_ref) {
  var name = _ref.name,
    infoText = _ref.infoText,
    children = _ref.children,
    onElementClick = _ref.onElementClick,
    onRemoveClick = _ref.onRemoveClick,
    startIndex = _ref.startIndex,
    focusIndex = _ref.focusIndex,
    onNavigation = _ref.onNavigation,
    _onClick = _ref.onClick,
    actionType = _ref.actionType,
    onSelectAllClick = _ref.onSelectAllClick,
    onRemoveAllClick = _ref.onRemoveAllClick,
    onFocus = _ref.onFocus,
    cy = _ref.cy,
    initiallyCollapsed = _ref.initiallyCollapsed,
    isSearching = _ref.isSearching,
    hideCount = _ref.hideCount;
  var _useState = React.useState(!initiallyCollapsed),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var refs = React.useRef({});
  React.useEffect(function () {
    if (initiallyCollapsed) {
      setExpanded(isSearching);
    }
  }, [initiallyCollapsed, isSearching]);
  var shouldFocus = function shouldFocus(index) {
    if (index === focusIndex) {
      if (refs.current[index]) onFocus(refs.current[index]);
      return true;
    }
  };
  var setRef = function setRef(ref, index) {
    refs.current[index] = ref;
  };
  var childrenList = React__default.Children.map(children, function (child) {
    var index = startIndex++;
    return /*#__PURE__*/React__default.createElement(Item, {
      onSetInnerRef: function onSetInnerRef(ref) {
        return setRef(ref, index);
      },
      onKeyDown: onNavigation,
      showFocus: shouldFocus(index),
      noPadding: child.props.noPadding,
      onClick: onElementClick,
      cy: child.props.cy,
      key: child.props.value,
      value: child.props.value,
      onRemoveClick: onRemoveClick
    }, child);
  });
  var handleGroupClick = function handleGroupClick() {
    setExpanded(!expanded);
  };
  return /*#__PURE__*/React__default.createElement(GroupContainer, {
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(GroupHeading, {
    onClick: function onClick() {
      handleGroupClick(), _onClick();
    }
  }, /*#__PURE__*/React__default.createElement(GroupHeadingTextContainer, null, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("b", null, name), " ", !hideCount && /*#__PURE__*/React__default.createElement("span", null, "(", childrenList.length, ")"))), /*#__PURE__*/React__default.createElement(AllAction, null, actionType === 'clear' ? /*#__PURE__*/React__default.createElement("p", {
    onClick: onRemoveAllClick
  }, "Clear All") : null, actionType === 'select' ? /*#__PURE__*/React__default.createElement("p", {
    onClick: onSelectAllClick
  }, "Select All") : null), infoText && /*#__PURE__*/React__default.createElement(InfoBadgeContainer, null, infoText), /*#__PURE__*/React__default.createElement(IconContainer$2, null, /*#__PURE__*/React__default.createElement(CaretIcon, {
    direction: expanded ? CaretIcon.DIRECTION.UP : CaretIcon.DIRECTION.DOWN
  }))), expanded && childrenList);
};
Group.propTypes = {
  onSelectAllClick: PropTypes__default.func,
  onRemoveAllClick: PropTypes__default.func,
  actionType: PropTypes__default.oneOf(['clear', 'select']),
  onClick: PropTypes__default.func,
  onNavigation: PropTypes__default.func,
  startIndex: PropTypes__default.number,
  focusIndex: PropTypes__default.number,
  name: PropTypes__default.string.isRequired,
  infoText: PropTypes__default.string,
  children: PropTypes__default.any,
  onElementClick: PropTypes__default.func,
  onRemoveClick: PropTypes__default.func,
  onFocus: PropTypes__default.func,
  cy: PropTypes__default.string,
  initiallyCollapsed: PropTypes__default.bool,
  hideCount: PropTypes__default.bool,
  isSearching: PropTypes__default.bool
};
var TextUtils = /*#__PURE__*/function () {
  function TextUtils() {
    _classCallCheck(this, TextUtils);
  }
  _createClass(TextUtils, null, [{
    key: "normalizedIncludes",
    value: function normalizedIncludes(origin, searched) {
      if (origin == null || searched == null) return false;
      return origin.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(searched.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    }
  }, {
    key: "getInitials",
    value: function getInitials(name) {
      if (!name || name.length === 0) {
        return '';
      }
      var splitName = name // eslint-disable-next-line
      .replace(/[\x00-\x1F\x7F-\x9F]/g, ' ') // matches all UNICODE control characters
      .split(' ').filter(function (token) {
        return token !== '';
      });
      if (splitName.length === 0) {
        return '';
      }
      return "".concat(splitName[0][0]).concat(splitName.length >= 2 ? splitName[splitName.length - 1][0] : '');
    }
  }]);
  return TextUtils;
}();
var _excluded$1 = ["setScrollbarsRef", "horizontalContent", "handleScroll", "scrollParent"];
// import {EVENT_ID, dispatch} from '../containers/event_manager';

var CustomScrollDiv = /*#__PURE__*/function (_Component) {
  _inherits(CustomScrollDiv, _Component);
  var _super = _createSuper(CustomScrollDiv);
  function CustomScrollDiv() {
    _classCallCheck(this, CustomScrollDiv);
    return _super.apply(this, arguments);
  }
  _createClass(CustomScrollDiv, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setScrollbarsRef(this.scrollbars.container.firstChild);
      this.springSystem = new rebound.SpringSystem();
      this.spring = this.springSystem.createSpring();
      this.spring.setOvershootClampingEnabled(true);
      this.spring.addListener({
        onSpringUpdate: this.handleSpringUpdate.bind(this)
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.springSystem.deregisterSpring(this.spring);
      this.springSystem.removeAllListeners();
      this.springSystem = undefined;
      this.spring.destroy();
      this.spring = undefined;
    }
  }, {
    key: "setScrollTop",
    value: function setScrollTop(top) {
      this.scrollbars.scrollTop(top);
    }
  }, {
    key: "animateScrollTop",
    value: function animateScrollTop(top) {
      var scrollTop = this.scrollbars.getScrollTop();
      this.spring.setCurrentValue(scrollTop).setAtRest();
      this.spring.setEndValue(top);
    }
  }, {
    key: "scrollToLeft",
    value: function scrollToLeft() {
      return this.scrollbars.scrollToLeft();
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      return this.scrollbars.getScrollTop();
    }
  }, {
    key: "getScrollHeight",
    value: function getScrollHeight() {
      return this.scrollbars.getScrollHeight();
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.scrollbars.getClientHeight();
    }
  }, {
    key: "handleSpringUpdate",
    value: function handleSpringUpdate(spring) {
      var val = spring.getCurrentValue();
      this.scrollbars.scrollTop(val);
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart() {
      this.props.onScrollStart();
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e) {
      this.props.handleScroll(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props,
        setScrollbarsRef = _this$props.setScrollbarsRef,
        horizontalContent = _this$props.horizontalContent,
        handleScroll = _this$props.handleScroll,
        scrollParent = _this$props.scrollParent,
        rest = _objectWithoutProperties(_this$props, _excluded$1);
      delete rest.marginBottom;
      return /*#__PURE__*/React__default.createElement(reactCustomScrollbars.Scrollbars, _extends({
        ref: function ref(div) {
          _this.scrollbars = div;
        },
        onScroll: this.handleScroll.bind(this),
        onScrollStart: this.handleScrollStart.bind(this),
        className: 'custom-scrollbar-div-remove ' + (this.props.horizontalandverticalcontent ? 'view-horizontal-vertical' : horizontalContent ? 'view-horizontal' : 'view-vertical'),
        hideTracksWhenNotNeeded: true,
        autoHide: this.props.autoHide !== undefined ? this.props.autoHide : true,
        style: {
          height: 'auto',
          marginBottom: this.props.marginBottom
        },
        autoHeight: this.props.autoHeight ? this.props.autoHeight : false,
        autoHeightMin: this.props.autoHeightMin ? this.props.autoHeightMin : null,
        autoHeightMax: this.props.autoHeightMax ? this.props.autoHeightMax : null,
        renderTrackHorizontal: function renderTrackHorizontal(_ref) {
          var style = _ref.style,
            props = _ref.props;
          return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
            style: _objectSpread2(_objectSpread2({}, style), {}, {
              position: 'absolute',
              height: '6px',
              transition: 'opacity 200ms ease 0s',
              borderRadius: '3px',
              opacity: '0',
              right: '2px',
              bottom: '2px',
              left: '2px',
              visibility: 'hidden',
              zIndex: 5
            })
          }));
        },
        renderThumbHorizontal: function renderThumbHorizontal(_ref2) {
          var style = _ref2.style,
            props = _ref2.props;
          return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
            style: _objectSpread2(_objectSpread2({}, style), {}, {
              position: 'relative',
              height: '100%',
              cursor: 'pointer',
              borderRadius: 'inherit',
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
              display: 'block',
              width: '0px'
            })
          }));
        },
        renderTrackVertical: function renderTrackVertical(_ref3) {
          var style = _ref3.style,
            props = _ref3.props;
          return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
            style: _objectSpread2(_objectSpread2({}, style), {}, {
              position: 'absolute',
              width: '6px',
              transition: 'opacity 200ms ease 0s',
              right: '2px',
              bottom: '2px',
              top: '2px',
              borderRadius: '3px',
              zIndex: 5
            })
          }));
        },
        renderThumbVertical: function renderThumbVertical(_ref4) {
          var style = _ref4.style,
            props = _ref4.props;
          return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
            style: _objectSpread2(_objectSpread2({}, style), {}, {
              width: '100%',
              cursor: 'pointer',
              borderRadius: 'inherit',
              backgroundColor: 'rgba(0, 0, 0, 0.2)'
            })
          }));
        }
      }, rest));
    }
  }]);
  return CustomScrollDiv;
}(React.Component);
CustomScrollDiv.propTypes = {
  setScrollbarsRef: PropTypes__default.func,
  scrollParent: PropTypes__default.any,
  onScrollStart: PropTypes__default.func,
  handleScroll: PropTypes__default.func,
  scrollEventId: PropTypes__default.any,
  horizontalContent: PropTypes__default.any,
  horizontalandverticalcontent: PropTypes__default.any,
  autoHide: PropTypes__default.any,
  autoHeight: PropTypes__default.any,
  autoHeightMin: PropTypes__default.any,
  marginBottom: PropTypes__default.any,
  autoHeightMax: PropTypes__default.any
};
CustomScrollDiv.defaultProps = {
  setScrollbarsRef: function setScrollbarsRef() {
    return false;
  },
  onScrollStart: function onScrollStart() {
    return false;
  },
  handleScroll: function handleScroll() {
    return false;
  }
};
var Dropdown = function Dropdown(_ref) {
  var inputClassName = _ref.inputClassName,
    name = _ref.name,
    isNested = _ref.isNested,
    disabled = _ref.disabled,
    selectedItems = _ref.selectedItems,
    selectedGroupName = _ref.selectedGroupName,
    isMultiSelect = _ref.isMultiSelect,
    isClearable = _ref.isClearable,
    headerLines = _ref.headerLines,
    dropdownAlignment = _ref.dropdownAlignment,
    width = _ref.width,
    maxHeight = _ref.maxHeight,
    usePortal = _ref.usePortal,
    children = _ref.children,
    onSelect = _ref.onSelect,
    onRemove = _ref.onRemove,
    userpilot = _ref.userpilot,
    emphasizeEmptyState = _ref.emphasizeEmptyState,
    cy = _ref.cy,
    size = _ref.size,
    showSelectedCount = _ref.showSelectedCount,
    customPlaceholder = _ref.customPlaceholder,
    onExpand = _ref.onExpand,
    searchStringChangedCallback = _ref.searchStringChangedCallback,
    focusOnMount = _ref.focusOnMount,
    hideSelected = _ref.hideSelected,
    hideEmptyGroups = _ref.hideEmptyGroups,
    arrowCollapseFix = _ref.arrowCollapseFix;
  var _useState = React.useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchString = _useState2[0],
    setSearchString = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    above = _useState6[0],
    setAbove = _useState6[1];
  var _useState7 = React.useState(-1),
    _useState8 = _slicedToArray(_useState7, 2),
    focusIndex = _useState8[0],
    setFocusIndex = _useState8[1];
  var scrollRef = React.useRef(null);
  var inputRef = React.useRef();
  var itemRefs = React.useRef({});
  var values = React.useRef({});
  /*************************************************************
   * Used for listening outside clicks and close the dropdown
   */

  var dropdownRef = React.useRef(null);
  var dropdownContainerRef = React.useRef(null);
  var dropdownContainerName = "dropdown-container-".concat(name);
  var numberOfElements = 0;
  /**
   * calls onSelect with the value selected, and an array of all selected values
   * @param {string|number} value
   * @returns {void}
   */

  /**
   *  helper to add all from a group
   * @param {string[]|number[]} values
   * @returns {void}
   */

  var handleSelectAll = function handleSelectAll(values) {
    onSelect(_toConsumableArray(values), _toConsumableArray(values));
  };
  /**
   * calls onRemove with the value to be removed, and an array of all selected values after removal
   * @param {string|number} value
   * @returns {void}
   */

  var handleRemove = function handleRemove(value) {
    var filtered = selectedItems.filter(function (item) {
      return item !== value;
    });
    onRemove([value], filtered);
    inputRef.current && inputRef.current.focus();
  };
  /**
   *  helper to remove all fro dropdown
   * @param {string[]|number[]} values
   */

  var handleRemoveAll = function handleRemoveAll(values) {
    onRemove(_toConsumableArray(values), []);
  };
  /**
   *
   * @returns {void}
   */

  var enterKeyLogic = function enterKeyLogic() {
    if (focusIndex >= 0) {
      if (selectedItems.some(function (item) {
        return item === values.current[focusIndex];
      })) {
        handleRemove(values.current[focusIndex]);
      } else {
        handleSelect(values.current[focusIndex]);
      }
    }
  };
  /**
   *
   * @param {React.KeyboardEventHandler} keyboardEvent
   */

  var handleKeyDown = function handleKeyDown(keyboardEvent) {
    if (keyboardEvent.key === 'ArrowUp') {
      arrowSelect('up');
    }
    if (keyboardEvent.key === 'ArrowDown') {
      arrowSelect('down');
    }
    if (keyboardEvent.key === 'Escape') {
      collapseDropdown();
    }
    if (keyboardEvent.key === 'Enter') {
      enterKeyLogic();
    }
  };
  /**
   *
   * @param {'up'|'down'} direction
   */

  var arrowSelect = function arrowSelect(direction) {
    if (direction === 'up') {
      setFocusIndex(focusIndex - 1 < 0 ? 0 : focusIndex - 1);
    }
    if (direction === 'down') {
      setFocusIndex(focusIndex + 1 >= numberOfElements ? focusIndex : focusIndex + 1);
    }
  };
  var isTargetInCaret = function isTargetInCaret(target) {
    if (target && target.className.includes('caret-container')) {
      return true;
    }
    return false;
  };
  var isTargetInDropdown = function isTargetInDropdown(target, level) {
    if (target && target.className && (target.className.includes(dropdownContainerName) || target.className.includes('chartjs-size-monitor'))) {
      return true;
    } else if (target && level > 0) {
      return isTargetInDropdown(target.parentNode, level - 1);
    } else {
      return false;
    }
  };
  var scrollEvent = function scrollEvent(e) {
    if (e.target) {
      if (!isTargetInDropdown(e.target, 3)) {
        collapseDropdown();
      }
    }
  };
  var collapseDropdown = function collapseDropdown() {
    document.removeEventListener('scroll', scrollEvent, true);
    setSearchString('');
    if (searchStringChangedCallback) searchStringChangedCallback('');
    setFocusIndex(-1);
    inputRef.current && inputRef.current.blur();
    setExpanded(false);
  };
  var openDropdown = function openDropdown() {
    if (!disabled) {
      setExpanded(true);
      onExpand();
      inputRef.current && inputRef.current.focus();
      document.addEventListener('scroll', scrollEvent, true);
    }
  };
  var handleSelect = function handleSelect(value) {
    if (isMultiSelect) {
      onSelect([value], [].concat(_toConsumableArray(selectedItems), [value]));
    } else {
      onSelect([value], [value]);
      return collapseDropdown();
    }
    inputRef.current && inputRef.current.focus();
  };
  /**
   *
   * @param {*} event
   */

  var handleClickOutside = function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(event.target)) {
        collapseDropdown();
      }
    }
  };
  React.useEffect(function () {
    if (focusOnMount) {
      openDropdown();
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  var handleBlurOutside = function handleBlurOutside(e) {
    var newTarget = e.relatedTarget || e.explicitOriginalTarget;
    if (newTarget && !isTargetInDropdown(newTarget, 9)) {
      collapseDropdown();
    }
  };
  var handleArrowClick = function handleArrowClick() {
    if (expanded) {
      collapseDropdown();
    } else {
      openDropdown();
    }
  };
  var handleClearClick = function handleClearClick(e) {
    e.stopPropagation();
    if (!expanded) {
      handleRemoveAll(selectedItems);
    } else {
      setSearchString('');
      searchStringChangedCallback('');
      setFocusOnInput();
    }
  };
  var setFocusOnInput = function setFocusOnInput() {
    inputRef.current && inputRef.current.focus();
  };
  var scrollTo = function scrollTo(element) {
    scrollRef && scrollRef.current && scrollRef.current.setScrollTop(element.offsetTop - maxHeight + element.offsetHeight);
  };
  /**
   * Iterating through children, and putting selected items in selectd group, and removing
   * selected items from other groups
   */

  var shouldFocus = function shouldFocus(index) {
    if (index === focusIndex) {
      itemRefs.current[index] && scrollTo(itemRefs.current[index]);
      return true;
    }
  };
  var selected = [];
  var selectedValues = new Set();
  var groups = [];
  var items = [];
  var nextIndex = 0;
  if (isNested) {
    React__default.Children.forEach(children, function (group) {
      if (!group) {
        return;
      }
      var groupProps = group.props;
      if (groupProps.children) {
        React__default.Children.forEach(groupProps.children, function (element) {
          if (selectedItems.includes(element.props.value)) {
            if (!selectedValues.has(element.props.value)) {
              selected.push( /*#__PURE__*/React__default.cloneElement(element));
              selectedValues.add(element.props.value);
              if (isMultiSelect) {
                values.current[nextIndex++] = element.props.value;
              }
            }
          }
        });
      }
    });
    React__default.Children.forEach(children, function (group) {
      if (!group) {
        return;
      }
      var groupProps = group.props;
      var isSearching = searchString.trim() !== '';
      if (groupProps.children) {
        var startIndex = nextIndex;
        var _children = React__default.Children.toArray(groupProps.children).filter(function (element) {
          if (isMultiSelect && selectedItems.includes(element.props.value)) {
            return false;
          }
          var included = !isSearching || TextUtils.normalizedIncludes(element.props.searchString, searchString.trim());
          if (included) {
            values.current[nextIndex++] = element.props.value;
            return true;
          }
          return false;
        });
        if (!_children.length && hideEmptyGroups) {
          return;
        }
        groups.push( /*#__PURE__*/React__default.cloneElement(group, {
          onClick: setFocusOnInput,
          onNavigation: handleKeyDown,
          onElementClick: handleSelect,
          onSelectAllClick: function onSelectAllClick(e) {
            e.stopPropagation();
            handleSelectAll(React__default.Children.toArray(groupProps.children).reduce(function (result, element) {
              if (!selectedItems.includes(element.props.value)) {
                return [].concat(_toConsumableArray(result), [element.props.value]);
              } else {
                return result;
              }
            }, []));
          },
          onFocus: scrollTo,
          actionType: /*isMultiSelect ? 'select' :*/
          null,
          // key: groupProps.key,
          focusIndex: focusIndex,
          startIndex: startIndex,
          isSearching: isSearching,
          cy: groupProps.cy || "group-".concat(groupProps.name),
          children: _children
        }));
      }
    });
  } else {
    React__default.Children.forEach(children, function (element) {
      if (selectedItems.includes(element.props.value)) {
        selected.push( /*#__PURE__*/React__default.cloneElement(element));
      }
    });
    React__default.Children.forEach(children, function (child) {
      var included = (searchString.trim() === '' || TextUtils.normalizedIncludes(child.props.searchString, searchString.trim())) && !(hideSelected && selectedItems.includes(child.props.value));
      if (included) {
        var index = nextIndex++;
        values.current[index] = child.props.value;
        items.push( /*#__PURE__*/React__default.createElement(Item, {
          cy: child.props.cy,
          onSetInnerRef: function onSetInnerRef(ref) {
            return itemRefs.current[index] = ref;
          },
          onKeyDown: handleKeyDown,
          showFocus: shouldFocus(index),
          onClick: child.props.disabled ? function () {
            return null;
          } : handleSelect,
          key: child.props.value,
          value: child.props.value
        }, child));
      }
    });
  }
  numberOfElements = nextIndex;
  var getDropdownContent = function getDropdownContent(style, positionAbove, autoWidth) {
    if (isNested) {
      return /*#__PURE__*/React__default.createElement(DropdownContainer, {
        positionAbove: positionAbove,
        className: dropdownContainerName,
        "data-cy": 'dropdown-container',
        ref: dropdownContainerRef,
        style: style,
        width: width || autoWidth,
        maxHeight: maxHeight,
        dropdownAlignment: dropdownAlignment
      }, /*#__PURE__*/React__default.createElement(CustomScrollDiv, {
        ref: scrollRef,
        scrollParent: 'nested-dropdown',
        autoHeight: true,
        autoHeightMin: 1,
        autoHeightMax: maxHeight
      }, headerLines, isMultiSelect && !!selectedGroupName && /*#__PURE__*/React__default.createElement(Group, {
        onFocus: scrollTo,
        onRemoveAllClick: function onRemoveAllClick(e) {
          e.stopPropagation();
          handleRemoveAll(React__default.Children.map(selected, function (child) {
            return child.props.value;
          }));
        },
        key: 'selected-1',
        cy: 'group-selected',
        actionType: /*isMultiSelect && false ? 'clear' :*/
        null // still working on bulk actions
        ,

        onClick: setFocusOnInput,
        onNavigation: handleKeyDown,
        startIndex: 0,
        focusIndex: focusIndex,
        name: selectedGroupName,
        onElementClick: setFocusOnInput,
        onRemoveClick: handleRemove
      }, selected), groups));
    } else {
      return /*#__PURE__*/React__default.createElement(DropdownContainer, {
        positionAbove: positionAbove,
        className: dropdownContainerName,
        ref: dropdownContainerRef,
        style: style,
        width: autoWidth || width,
        maxHeight: maxHeight,
        dropdownAlignment: dropdownAlignment
      }, /*#__PURE__*/React__default.createElement(CustomScrollDiv, {
        ref: scrollRef,
        scrollParent: 'nested-dropdown' //handleScroll={this.props.handleScroll}
        ,

        autoHeight: true,
        autoHeightMin: 1,
        autoHeightMax: maxHeight
      }, items));
    }
  };
  var handleSetSearchString = function handleSetSearchString(e) {
    setSearchString(e.target.value);
    setFocusIndex(-1);
    if (searchStringChangedCallback) {
      searchStringChangedCallback(e.target.value);
    }
  };
  var getNameAndCount = function getNameAndCount(name, count) {
    return "".concat(name).concat(showSelectedCount && count > 0 ? " (".concat(count, ")") : '');
  };
  var handleDropdownContainerClick = function handleDropdownContainerClick() {
    if (!expanded) {
      openDropdown();
    }
  };
  var showDropdownClearIcon = function showDropdownClearIcon() {
    return !expanded && isClearable && selected.length > 0 && !disabled || searchString !== '';
  };
  var getDropdown = function getDropdown(width) {
    if (!expanded) return null;
    var positionAbove = false;
    var offset = dropdownRef.current.getBoundingClientRect();
    var maxDropdownBottomPosition = offset.bottom + maxHeight;
    var haveSpaceAbove = offset.top - maxHeight >= 0;
    if (maxDropdownBottomPosition > window.innerHeight && haveSpaceAbove) {
      positionAbove = true;
      if (above != positionAbove) {
        setAbove(positionAbove);
      }
    }
    var style = {};
    if (usePortal) {
      if (offset) {
        style = {
          position: 'absolute',
          zIndex: 999,
          //top: offset.top + offset.height - 1,
          left: dropdownAlignment === 'left' || dropdownAlignment === 'none' ? offset.left : dropdownAlignment === 'center' ? offset.left + (offset.right - offset.left) / 2 : undefined,
          right: dropdownAlignment === 'right' ? window.innerWidth - offset.right : undefined
        };
        if (positionAbove) {
          style.bottom = window.innerHeight - offset.top - 1;
        } else {
          style.top = offset.top + offset.height - 1;
        }
      }
      return /*#__PURE__*/ReactDOM.createPortal(getDropdownContent(style, positionAbove, width), document.querySelector('#root-portal-container'));
    } else {
      if (positionAbove) {
        style.bottom = size === 'large' ? '38px' : '28px';
      }
    }
    return getDropdownContent(style, positionAbove, width);
  };
  var getCollapsedPlaceholder = function getCollapsedPlaceholder() {
    if (isMultiSelect) {
      return customPlaceholder ? /*#__PURE__*/React__default.createElement(DropdownButtonPlaceholder, null, customPlaceholder) : null;
    } else if (!expanded) {
      return selected.length > 0 ? /*#__PURE__*/React__default.createElement(DropdownButtonPlaceholder, null, selected[0]) : null;
    }
  };
  var handleFocus = function handleFocus(e) {
    if (arrowCollapseFix && (isTargetInCaret(e.target) || isTargetInCaret(e.relatedTarget))) {
      return;
    }
    if (!expanded) {
      openDropdown();
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Container$5, {
    "data-cy": cy,
    disabled: disabled,
    expanded: expanded,
    above: above,
    className: dropdownContainerName,
    ref: dropdownRef,
    onClick: handleDropdownContainerClick,
    onFocus: handleFocus,
    onBlur: handleBlurOutside,
    "data-userpilot": userpilot,
    size: size
  }, /*#__PURE__*/React__default.createElement(DropdownButton, null, /*#__PURE__*/React__default.createElement(Input, {
    className: inputClassName,
    disabled: disabled,
    emphasizePlaceholder: emphasizeEmptyState,
    onKeyDown: handleKeyDown,
    ref: inputRef,
    placeholder: getNameAndCount(name, selectedItems.length),
    expanded: expanded,
    value: expanded ? searchString : '',
    onChange: handleSetSearchString
  }), !expanded && getCollapsedPlaceholder(), showDropdownClearIcon() && /*#__PURE__*/React__default.createElement(IconContainer$2, {
    onClick: handleClearClick,
    "data-cy": 'clear-icon'
  }, /*#__PURE__*/React__default.createElement(CrossIconOld, {
    color: '#535353'
  })), /*#__PURE__*/React__default.createElement(IconContainer$2, {
    className: 'caret-container',
    onClick: handleArrowClick,
    tabIndex: arrowCollapseFix ? 1 : null
  }, /*#__PURE__*/React__default.createElement(CaretIcon, {
    color: !disabled ? '#535353' : '#a1a1a1',
    direction: expanded ? CaretIcon.DIRECTION.UP : CaretIcon.DIRECTION.DOWN,
    tabIndex: "-1"
  }))), usePortal ? /*#__PURE__*/React__default.createElement(AutoSizer, null, function (_ref2) {
    var width = _ref2.width;
    return getDropdown(width);
  }) : getDropdown()));
};
Dropdown.propTypes = {
  inputClassName: PropTypes__default.string,
  onExpand: PropTypes__default.func,
  isNested: PropTypes__default.bool,
  /**
   * disables selected new options in the dropdown
   */
  disabled: PropTypes__default.bool,
  /**
   * enable dark text color on placeholder when no option is selected
   */
  emphasizeEmptyState: PropTypes__default.bool,
  /**
   * enabling option to clear dropdown without opening it
   */
  isClearable: PropTypes__default.bool,
  /**
   * Extra lines that can be placed in the top of the dropdown,
   * and is not part of the selection logic.
   */
  headerLines: PropTypes__default.any,
  /**
   * Show number of selected count in parenteses
   */
  showSelectedCount: PropTypes__default.number,
  /**
   * Children should be of type Dropdown.Group
   * These groups should contain components which have atleast two props (searchString and value)
   * The props are used for selectiong and searching
   */
  children: PropTypes__default.any,
  /**
   * Custom visual to show when dropdown is collapsed
   */
  customPlaceholder: PropTypes__default.any,
  /**
   * name displayed on the dropdown when collapsed
   */
  name: PropTypes__default.string.isRequired,
  /**
   * Array of values of the selected items, can be number or string
   */
  selectedItems: PropTypes__default.array,
  /**
   * If nested, name to display on the group which contains selected items. If set to null, will hide selections.
   */
  selectedGroupName: PropTypes__default.string,
  /**
   * can you select multiple valueses - multiselect is default and single is not developed yet
   */
  isMultiSelect: PropTypes__default.bool,
  /**
   * If not nested, hides the already selected items
   */
  hideSelected: PropTypes__default.bool,
  /**
   * If nested, hides empty groups
   */
  hideEmptyGroups: PropTypes__default.bool,
  /**
   * Pixel width of the dropdown
   */
  width: PropTypes__default.number,
  /**
   * Pixel max height of the dropdown
   */
  maxHeight: PropTypes__default.number,
  /**
   * a function which takes a value and an array of values, will be called when an item is removed, with the value to be removed and all selected values after removal
   */
  onRemove: PropTypes__default.func,
  /**
   * a function which takes a value and an array of values, will be called when an item is selected, with the selected value and all selected values
   */
  onSelect: PropTypes__default.func,
  /**
   * Alignment of the dropdown to the dropdown input
   */
  dropdownAlignment: PropTypes__default.oneOf(['left', 'center', 'right', 'none']),
  /**
   * show dropdown in a portal ( to be implemented)
   */
  usePortal: PropTypes__default.bool,
  /**
   * ID needed for onboarding tool
   */
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string,
  size: PropTypes__default.string,
  /**
   * Function to be called when the search string is changed
   */
  searchStringChangedCallback: PropTypes__default.func,
  /**
   * Force dropdown to take focus as soon as it's mounted
   */
  focusOnMount: PropTypes__default.bool,
  /**
   * Experimental approach to prevent dropdown from expanding again when clicking arrow to collapse dropdown
   */
  arrowCollapseFix: PropTypes__default.bool
};
Dropdown.defaultProps = {
  selectedGroupName: 'Selected',
  selectedItems: [],
  maxHeight: 300,
  dropdownAlignment: 'none',
  onSelect: function onSelect() {
    return false;
  },
  onRemove: function onRemove() {
    return false;
  },
  onExpand: function onExpand() {
    return false;
  },
  searchStringChangedCallback: function searchStringChangedCallback() {
    return false;
  }
};
var _templateObject$h, _templateObject2$a, _templateObject3$8;
// eslint-disable-next-line no-unused-vars

var CircleText = function CircleText(_ref) {
  var children = _ref.children,
    searchString = _ref.searchString,
    value = _ref.value,
    color = _ref.color,
    noCircleText = _ref.noCircleText;
  return /*#__PURE__*/React__default.createElement(Container$6, null, /*#__PURE__*/React__default.createElement(Circle, {
    color: color
  }, !noCircleText && TextUtils.getInitials(children)), /*#__PURE__*/React__default.createElement(Text$3, {
    title: children
  }, children));
};
var Container$6 = Styled__default.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n\tbackground-color: transparent;\n\tdisplay: flex;\n\tflex-direction: row;\n\tpadding: 5px 0;\n\talign-items: center;\n\tmax-width: 100%;\n"])));
var Circle = Styled__default.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n\theight: 30px;\n\tmin-width: 30px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 14px;\n\tborder-radius: 50%;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tmargin-right: 5px;\n\ttext-transform: uppercase;\n"])), function (props) {
  return ColorUtils.getInvertedTextColor(props.color);
}, function (props) {
  return props.color;
});
var Text$3 = Styled__default.p(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n\tpadding: 0;\n\tmargin: 0;\n\tflex-grow: 1;\n\tfont-size: 13px;\n\twidth: 100%;\n\tcolor: ", ";\n\twhite-space: nowrap;\n  \toverflow: hidden;\n  \ttext-overflow: ellipsis;\n"])), function (props) {
  return props.theme.colors.textLightGray;
});
CircleText.propTypes = {
  children: PropTypes__default.any,
  searchString: PropTypes__default.string,
  value: PropTypes__default.any,
  color: PropTypes__default.string,
  noCircleText: PropTypes__default.bool
};
CircleText.defaultProps = {
  color: '#470c93'
};
Dropdown.Group = Group;
Dropdown.SingleText = SingleText;
Dropdown.LabelLine = LabelLine;
Dropdown.CircleText = CircleText;
var _templateObject$i, _templateObject2$b, _templateObject3$9, _templateObject4$7;
var EmailLabelContainer = Styled__default.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 4px 4px 4px 4px;\n\tborder: 1px solid #c4c4cc;\n\tbox-sizing: border-box;\n\tborder-radius: 4px;\n\twidth: min-content;\n\t:focus {\n\t\toutline: none;\n\t\tborder-color: ", ";\n\t}\n"])), CSS_CONSTANTS.v2_branding_purple);
var CrossIconWrapper = Styled__default.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n\tmargin-left: 8px;\n"])));
var EmailLabelText = Styled__default.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 16px;\n\tletter-spacing: 0em;\n"])));
var BoldText = Styled__default.div(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n\tfont-size: 11px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 16px;\n\tletter-spacing: 0em;\n\tmargin-left: 4px;\n"]))); // eslint-disable-next-line react/display-name

var EmailLabel = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var text = _ref.text,
    boldText = _ref.boldText,
    onCrossClick = _ref.onCrossClick,
    tabIndex = _ref.tabIndex;
  return /*#__PURE__*/React__default.createElement(EmailLabelContainer, {
    ref: ref,
    tabIndex: tabIndex
  }, /*#__PURE__*/React__default.createElement(EmailLabelText, null, text), boldText && /*#__PURE__*/React__default.createElement(BoldText, null, boldText), /*#__PURE__*/React__default.createElement(CrossIconWrapper, null, /*#__PURE__*/React__default.createElement(CrossIcon, {
    onClick: onCrossClick,
    size: CrossIcon.SIZE.SMALL,
    color: "#4C4C58"
  })));
});
EmailLabel.propTypes = {
  text: PropTypes__default.string,
  onCrossClick: PropTypes__default.func,
  boldText: PropTypes__default.string,
  tabIndex: PropTypes__default.number
};
var _excluded$2 = ["children", "spanStyle"];
var _templateObject$j;
var TooltipStyled = Styled__default(Tippy)(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n\t&.tippy-box&[data-theme~='light-border'] {\n\t\tbackground-color: #ebebeb;\n\t\tborder-color: #e6e6e6;\n\t\tfont-size: 11px;\n\t\tcolor: #535353;\n\t\tfont-weight: 500;\n\t\tbox-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05);\n\n\t\t&[data-placement^='bottom'] > .tippy-arrow:before {\n\t\t\tborder-bottom-color: #ebebeb;\n\t\t}\n\t\t&[data-placement^='bottom'] > .tippy-arrow:after {\n\t\t\tborder-bottom-color: #e6e6e6;\n\t\t}\n\t\t&[data-placement^='top'] > .tippy-arrow:before {\n\t\t\tborder-top-color: #ebebeb;\n\t\t}\n\t\t&[data-placement^='top'] > .tippy-arrow:after {\n\t\t\tborder-top-color: #e6e6e6;\n\t\t}\n\t\t&[data-placement^='right'] > .tippy-arrow:before {\n\t\t\tborder-right-color: #ebebeb;\n\t\t}\n\t\t&[data-placement^='right'] > .tippy-arrow:after {\n\t\t\tborder-right-color: #e6e6e6;\n\t\t}\n\t\t&[data-placement^='left'] > .tippy-arrow:before {\n\t\t\tborder-left-color: #ebebeb;\n\t\t}\n\t\t&[data-placement^='left'] > .tippy-arrow:after {\n\t\t\tborder-left-color: #e6e6e6;\n\t\t}\n\t}\n\t.bold-font-weight {\n\t\tfont-weight: bold;\n\t}\n"])));
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    spanStyle = _ref.spanStyle,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React__default.createElement(TooltipStyled, _extends({}, props, {
    content: props.content && /*#__PURE__*/React__default.createElement("span", null, props.content),
    maxWidth: props.maxWidth || 250,
    placement: props.placement,
    delay: props.delay,
    disabled: !props.content || props.disabled,
    theme: "light-border",
    plugins: [tippy_js.followCursor]
  }), /*#__PURE__*/React__default.createElement("span", {
    style: spanStyle
  }, children));
};
Tooltip.propTypes = {
  children: PropTypes__default.any,
  content: PropTypes__default.any,
  delay: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.arrayOf(PropTypes__default.number)]),
  placement: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  maxWidth: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  spanStyle: PropTypes__default.object,
  props: PropTypes__default.arrayOf(PropTypes__default.any) // See https://atomiks.github.io/tippyjs/v6/all-props for valid Tippy props
};

Tooltip.defaultProps = {
  content: 'Place tooltip text here!',
  delay: [500, 200],
  placement: 'bottom',
  spanStyle: {
    width: '100%',
    display: 'flex'
  }
};
var _templateObject$k, _templateObject2$c;
var LabelGroupContainer = Styled__default.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: ", ";\n\tposition: relative;\n\toverflow: hidden;\n\tmargin-right: ", ";\n\twidth: 100%;\n\tcolumn-gap: 4px;\n"])), function (props) {
  return props.noWrap ? 'nowrap' : 'wrap';
}, function (props) {
  return props.noWrap ? '4px' : '8px';
});
var Dots = Styled__default.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n\tfont-size: 16px;\n"])));
var LabelGroup = function LabelGroup(_ref) {
  var labels = _ref.labels,
    overflowStyle = _ref.overflowStyle,
    onLabelRemove = _ref.onLabelRemove;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflowing = _useState2[0],
    setIsOverflowing = _useState2[1];
  var containerRef = React.useRef(null);
  var updateOverflowing = function updateOverflowing(labelGroupContainer) {
    if (labelGroupContainer) {
      var overflowing = labelGroupContainer.scrollWidth > labelGroupContainer.clientWidth;
      if (overflowing !== isOverflowing) {
        setIsOverflowing(overflowing);
      }
    }
  };
  React.useEffect(function () {
    updateOverflowing(containerRef.current);
  }, [labels]);
  var createLabelNames = function createLabelNames(labels) {
    return labels.map(function (label) {
      return label.name;
    }).join(', ');
  };
  var createLabelGroupContainer = function createLabelGroupContainer(noWrap) {
    return /*#__PURE__*/React__default.createElement(LabelGroupContainer, {
      noWrap: noWrap,
      ref: function ref(lg) {
        return containerRef.current = lg;
      }
    }, labels.map(function (label, index) {
      return /*#__PURE__*/React__default.createElement(Label, {
        key: index,
        color: label.color,
        name: label.name,
        onRemove: onLabelRemove
      });
    }));
  };
  switch (overflowStyle) {
    case 'TOOLTIP':
      return /*#__PURE__*/React__default.createElement(Tooltip, {
        spanStyle: {
          width: '100%',
          display: 'flex'
        },
        content: createLabelNames(labels)
      }, createLabelGroupContainer(true), isOverflowing ? /*#__PURE__*/React__default.createElement(Dots, null, "...") : null);
    case 'WRAP':
    default:
      return createLabelGroupContainer(false);
  }
};
LabelGroup.propTypes = {
  /**
   * An array of label definitions
   */
  labels: PropTypes__default.arrayOf(PropTypes__default.shape({
    /**
     * The name of the label, which is also displayed as text
     */
    name: PropTypes__default.string.isRequired,
    /**
     * The color of the label. Text color will be the inverse of this
     */
    color: PropTypes__default.string.isRequired
  })).isRequired,
  /**
   * The style used to wrap the group if it overflows.
   */
  overflowStyle: PropTypes__default.oneOf(['TOOLTIP', 'WRAP']),
  /**
   * Function to be called when a label remove icon is clicked. If no function is provided, then the icon won't be displayed
   */
  onLabelRemove: PropTypes__default.func
};
LabelGroup.defaultProps = {
  labels: [],
  overflowStyle: 'WRAP',
  onLabelRemove: null
};
var _templateObject$l, _templateObject2$d;
var Content$1 = Styled__default.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n\tfont-family: ", ";\n\tfont-size: 12px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 400;\n\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tpadding: 2px 4px 2px 4px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
});
var TagContainer = Styled__default.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n\tposition: relative;\n\twidth: fit-content;\t\n\theight: fit-content;\t\n\t\n\tborder-radius: 4px;\n\tbackground-color: #E5F4FF;\n\tcolor: #393946;\n\t\n\tdisplay: inline-block;\n"])));
var BetaTag = function BetaTag() {
  return /*#__PURE__*/React__default.createElement(TagContainer, null, /*#__PURE__*/React__default.createElement(Content$1, null, "Beta"));
};
var _templateObject$m, _templateObject2$e;
var Content$2 = Styled__default.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n\tz-index: 2;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\theight: 100%;\n\twidth: 100%;\n\tpadding: 0px 5px 0px 5px;\n"])));
var TagContainer$1 = Styled__default.div(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n\tposition: relative;\n\t\n\tfont-family: ", ";\n\tfont-size: 10px;\n\tletter-spacing: 0.5px;\n\tfont-weight: 500;\n\t\n\tbox-sizing: border-box;\n\tmax-width: calc(100% - 9px);\n\theight: 20px;\n\tmargin-left: 9px;\n\tpadding: 0 2px 0 2px;\n\t\n\tborder-style: solid;\n\tborder-width: 1px;\n\tborder-radius: 4px;\n\tborder-color: ", ";\n\tcolor: ", ";\n\t\n\tdisplay: inline-block;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});
var Tag = function Tag(_ref2) {
  var color = _ref2.color,
    name = _ref2.name;
  return /*#__PURE__*/React__default.createElement(TagContainer$1, {
    title: name,
    color: color
  }, /*#__PURE__*/React__default.createElement(Content$2, null, name));
};
Tag.propTypes = {
  color: PropTypes__default.string,
  name: PropTypes__default.string
};
var _templateObject$n, _templateObject2$f, _templateObject3$a, _templateObject4$8, _templateObject5$4;
var Container$7 = Styled__default.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n\tposition: relative;\n\tbackground-color: ", ";\n\theight: 20px;\n\tdisplay: inline-block;\n\tmin-width: 10px;\n\tmax-width: ", ";\n\tpadding: 0 3px;\n\tborder-radius: 2px;\n\tcursor:pointer;\t\n"])), function (props) {
  return props.active ? props.theme.colors ? props.theme.colors.forecastPurple : '#6e0fea' : props.theme.colors ? props.theme.colors.mediumVeryLightGray : '#a1a1a1';
}, function (props) {
  return !props.edit && "".concat(props.maxWidth, "px");
});
var ContentContainer$2 = Styled__default.div(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n"])));
var DropdownContainer$1 = Styled__default.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n\tposition: absolute;\n\t/* 5px extra for margin */\n\ttop: '30px'; \n\tleft:'0px';\n\theight: 100px;\n\tz-index: 100000;\n"])));
var TextContainer$1 = Styled__default.div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n\toverflow: hidden;\n\tdisplay:flex;\n\tmargin: 0 3px 0 3px;\n\n\tspan {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\toutline: none;\n\t\toverflow:hidden;\n\t\ttext-overflow: ellipsis;\n\t\tpadding: ", ";\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t\twhite-space: nowrap;\n\t\tborder-radius: 2px;\n\t\tcursor: ", ";\n\t\tfont-size: 11px;\n\t\t//min-width: 60px;\n\t\tmin-height:14px;\n\t\t&:empty:before{\n\t\t\tcontent: attr(data-placeholder);\n\t\t\topacity:0.3;\n\t\t}\n\t}\n"])), function (props) {
  return props.edit ? '0 6px' : '0 6px 0 6px';
}, function (props) {
  return props.active || props.edit ? '#fff' : props.theme.colors.textgray;
}, function (props) {
  return props.edit ? props.active ? 'rgba(256,256,266, .3)' : 'rgba(0,0,0,.4)' : 'transparent';
}, function (props) {
  return props.edit ? 'text' : 'pointer';
});
var IconContainer$3 = Styled__default.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n"])));
var _templateObject$o;
var SIZE$7 = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var VerticalDotsIcon = function VerticalDotsIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick,
    cy = _ref.cy;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$7.SMALL:
        return '10';
      case SIZE$7.MEDIUM:
        return '16';
      case SIZE$7.STANDARD:
        return '22';
      default:
        return '10';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$7.SMALL:
        return '10';
      case SIZE$7.MEDIUM:
        return '16';
      case SIZE$7.STANDARD:
        return '22';
      default:
        return '10';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$5, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size),
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement("svg", {
    x: "0px",
    y: "0px",
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Frame_-_24px"
  }, /*#__PURE__*/React__default.createElement("rect", {
    y: "0.001",
    fill: "none",
    width: "24",
    height: "24"
  })), /*#__PURE__*/React__default.createElement("g", {
    id: "Filled_Icons"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    cx: "12",
    cy: "5.002",
    r: "2"
  }), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    cx: "12",
    cy: "12.002",
    r: "2"
  }), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    cx: "12",
    cy: "19.001",
    r: "2"
  })))));
};
VerticalDotsIcon.SIZE = SIZE$7;
VerticalDotsIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$7.SMALL, SIZE$7.STANDARD]),
  cy: PropTypes__default.string
};
var StyledSpan$5 = Styled__default.span(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-items: center;\n\tcursor: pointer;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _this = undefined;
var SavedFilter = function SavedFilter(_ref) {
  var edit = _ref.edit,
    text = _ref.text,
    active = _ref.active,
    onChange = _ref.onChange,
    onSetChange = _ref.onSetChange,
    onDropdownClick = _ref.onDropdownClick,
    maxWidth = _ref.maxWidth,
    dropdownOptions = _ref.dropdownOptions,
    toggleActivate = _ref.toggleActivate;
  var inputRef = React.useRef();
  var _useState = React.useState(text),
    _useState2 = _slicedToArray(_useState, 2),
    filterText = _useState2[0],
    setFilterText = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dropDownVisible = _useState4[0],
    setDropdownVisible = _useState4[1];
  var handleChangeText = function handleChangeText(event) {
    setFilterText(event.target.value);
    onChange(filterText);
  };
  React.useEffect(function () {
    if (edit) {
      inputRef.current.focus();
    }
  }, [edit]);
  React.useEffect(function () {
    if (filterText !== text) setFilterText(text);
  }, [text]);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      inputRef.current.blur();
    }
    if (event.key === 'Escape') {
      setFilterText(text);
      onSetChange(filterText);
    }
  };
  var handleOnPaste = function handleOnPaste(event) {
    //avoid to be able to paste images, formated text, ...
    var pasted = (event.originalEvent || event).clipboardData.getData('text/plain');
    window.document.execCommand('insertText', false, pasted);
    event.preventDefault();
  };
  var handleSetChange = function handleSetChange() {
    onSetChange(inputRef.current.innerHTML);
  };
  var hideDropdown = function hideDropdown() {
    setDropdownVisible(false);
  };
  var showDropdown = function showDropdown() {
    setDropdownVisible(true);
  };
  var contextMenuActionOnClick = function contextMenuActionOnClick(callback) {
    callback();
    hideDropdown();
  };
  return /*#__PURE__*/React__default.createElement(Container$7, {
    title: filterText,
    edit: edit,
    active: active,
    maxWidth: maxWidth
  }, /*#__PURE__*/React__default.createElement(ContentContainer$2, {
    onClick: toggleActivate
  }, /*#__PURE__*/React__default.createElement(TextContainer$1, {
    active: active,
    edit: edit
  }, /*#__PURE__*/React__default.createElement(ContentEditable, {
    onPaste: handleOnPaste,
    onKeyDown: handleKeyDown,
    onBlur: handleSetChange,
    innerRef: inputRef,
    html: filterText,
    onChange: handleChangeText,
    tagName: "span",
    disabled: !edit,
    "data-placeholder": "New filter"
  })), /*#__PURE__*/React__default.createElement(IconContainer$3, null, dropdownOptions && /*#__PURE__*/React__default.createElement(VerticalDotsIcon, {
    onClick: showDropdown,
    size: VerticalDotsIcon.SIZE.SMALL,
    color: active ? '#fff' : '#565656'
  }))), dropDownVisible && /*#__PURE__*/React__default.createElement(core.ClickAwayListener, {
    onClickAway: hideDropdown
  }, /*#__PURE__*/React__default.createElement(DropdownContainer$1, null, /*#__PURE__*/React__default.createElement(ContextMenu, {
    onClick: onDropdownClick,
    minWidth: 190
  }, dropdownOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement(ContextMenu.SingleText, {
      key: option.value,
      value: option.value,
      onClick: contextMenuActionOnClick.bind(_this, option.callback)
    }, option.text);
  })))));
};
SavedFilter.propTypes = {
  /**
   * the text to show in the saved filter
   */
  text: PropTypes__default.string.isRequired,
  /**
   * toggle active view
   */
  active: PropTypes__default.bool,
  /**
   * Pixel maxwidth of filter label when not in edit mode
   */
  maxWidth: PropTypes__default.number,
  /**
   * Toggle edit mode
   */
  edit: PropTypes__default.bool,
  /**
   * callback when when text is changed
   */
  onSetChange: PropTypes__default.func,
  onChange: PropTypes__default.func,
  dropdownOptions: PropTypes__default.arrayOf(PropTypes__default.exact({
    text: PropTypes__default.string.isRequired,
    value: PropTypes__default.string.isRequired,
    callback: PropTypes__default.func.isRequired
  })),
  onDropdownClick: PropTypes__default.func,
  toggleActivate: PropTypes__default.func,
  inSlider: PropTypes__default.bool
};
SavedFilter.defaultProps = {
  maxWidth: 100,
  onSetChange: function onSetChange() {
    return false;
  },
  onChange: function onChange() {
    return false;
  },
  onDropdownClick: function onDropdownClick() {
    return false;
  },
  text: ''
};
var _templateObject$p;
var TabStyle = Styled__default.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n\tborder: 1px solid #e6e6e6;\n\tflex-grow: 1;\n\tdisplay: flex;\n"])));
var Tab = function Tab(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(TabStyle, null, children);
};
Tab.propTypes = {
  /**
   * The title to display in the tab
   */
  title: PropTypes__default.string.isRequired,
  /**
   * Put on the tab that should be selected pr default. If not specified on any tab, the first tab is selected pr. default.
   */
  defaultSelected: PropTypes__default.bool,
  /**
   * The content to show when the tab is selected
   */
  children: PropTypes__default.node,
  /**
   * Cypress lookup key to add to the tab as data-cy={props.cy}
   */
  cy: PropTypes__default.string
};
var _templateObject$q, _templateObject2$g, _templateObject3$b;
var TabWrapperStyle = Styled__default.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n"])));
var TabsStyle = Styled__default.div(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fit, minmax(10px, max-content));\n\tfont-weight: 500;\n"])));
var TabStyle$1 = Styled__default.div(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n\tpadding: 8px 25px;\n\tborder: 1px solid #e6e6e6;\n\tborder-bottom: 0;\n\ttext-transform: uppercase;\n\tfont-size: 10px;\n\tcolor: #a1a1a1;\n\tletter-spacing: 0.5px;\n\tposition: relative;\n\tcursor: pointer;\n\tuser-select: none;\n\n\t&:hover {\n\t\tcolor: #6e0fea;\n\t}\n\n\t&.selected {\n\t\tcolor: #6e0fea;\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t\theight: 1px;\n\t\t\tbackground: white;\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\tbottom: -1px;\n\t\t}\n\t}\n"])));
var Tabs = function Tabs(_ref) {
  var children = _ref.children;
  var _useState = React.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var _useState3 = React.useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedTabContent = _useState4[0],
    setSelectedTabContent = _useState4[1];
  React.useEffect(function () {
    var defaultSelectedTab = 0;
    React__default.Children.forEach(children, function (child, index) {
      if (child.props.defaultSelected) {
        defaultSelectedTab = index;
      }
    });
    setSelectedTab(defaultSelectedTab);
  }, []);
  React.useEffect(function () {
    React__default.Children.forEach(children, function (child, index) {
      if (child.props.isSelected) {
        setSelectedTab(index);
        return;
      }
    });
    setTabContent();
  }, [children]);
  React.useEffect(function () {
    setTabContent();
  }, [selectedTab]);
  var setTabContent = function setTabContent() {
    var foundTab = null;
    React__default.Children.forEach(children, function (child, index) {
      if (index === selectedTab) {
        foundTab = child;
      }
    });
    setSelectedTabContent(foundTab);
  };
  return /*#__PURE__*/React__default.createElement(TabWrapperStyle, null, /*#__PURE__*/React__default.createElement(TabsStyle, null, React__default.Children.map(children, function (child, index) {
    return /*#__PURE__*/React__default.createElement(TabStyle$1, {
      key: index,
      className: selectedTab === index ? ' selected' : '',
      onClick: function onClick() {
        return setSelectedTab(index);
      },
      "data-cy": child.props.cy ? child.props.cy : undefined
    }, child.props.title);
  })), selectedTabContent);
};
Tabs.propTypes = {
  /**
   * Tabs can only contain Tab elements
   */
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node]).isRequired
};
var _templateObject$r;
var ToastWrapper = Styled__default.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n    width: 290px;\n    min-height:90px; \n    border-radius: 4px;\n    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);\n    border: solid 1px #e6e6e6;\n    background-color: #ffffff;\n    padding:16px;\n    font-size: 12px;\n    color: #535353;\n    box-sizing: border-box; \n    margin-bottom:10px;\n"])));
var Toast = function Toast(_ref) {
  var coreText = _ref.coreText;
  return /*#__PURE__*/React__default.createElement(ToastWrapper, null, coreText);
};
Toast.propTypes = {
  /**
   * Main message of the toast, should be a formatted message from Web Component
   */
  coreText: PropTypes__default.func
};
Toast.defaultProps = {
  coreText: 'Toast core text'
};
var _templateObject$s, _templateObject2$h, _templateObject3$c, _templateObject4$9, _templateObject5$5, _templateObject6$4, _templateObject7$3, _templateObject8$3, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2, _templateObject15$2, _templateObject16$1, _templateObject17$1, _templateObject18, _templateObject19, _templateObject20;
/*************************************************
 * HELPERS
 ************************************************/

var TableColumnWidth = {
  EXTRA_SMALL: 'EXTRA_SMALL',
  SMALL: 'SMALL',
  MEDIUM_SMALL: 'MEDIUM_SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  EXTRA_LARGE: 'EXTRA_LARGE',
  SUPER_LARGE: 'SUPER_LARGE'
};
var TableColumnAlignment = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  SPACE_EVENLY: 'space-evenly'
};
var getExpansionWidth = function getExpansionWidth(level) {
  switch (level) {
    case 1:
      return 0;
    case 2:
      return 32;
    case 3:
      return 76;
    case 4:
      return 126;
    default:
      throw new Error("level ".concat(level, " is not valid"));
  }
};
var getWidth = function getWidth(width, level, canExpand) {
  var calculatedWidth;
  switch (width) {
    case TableColumnWidth.EXTRA_SMALL:
      calculatedWidth = 60;
      break;
    case TableColumnWidth.SMALL:
      calculatedWidth = 100;
      break;
    case TableColumnWidth.MEDIUM_SMALL:
      calculatedWidth = 130;
      break;
    case TableColumnWidth.MEDIUM:
      calculatedWidth = 160;
      break;
    case TableColumnWidth.LARGE:
      calculatedWidth = 220;
      break;
    case TableColumnWidth.EXTRA_LARGE:
      calculatedWidth = 280;
      break;
    case TableColumnWidth.SUPER_LARGE:
      // Width used for status description column in the project portfolio report table.
      // 656 pixels is equal to 82 characters.
      calculatedWidth = 656;
      break;
    default:
      calculatedWidth = 160;
  }
  if (level) {
    calculatedWidth -= getExpansionWidth(level) - 16;
    if (canExpand) {
      calculatedWidth -= 28;
    }
  }
  return calculatedWidth;
};
var alignmentToFlex = function alignmentToFlex(align) {
  switch (align) {
    case 'left':
      return 'flex-start';
    case 'right':
      return 'flex-end';
    case 'center':
      return 'center';
    case 'space-evenly':
      return 'space-evenly';
    default:
      throw new Error('Alignment prop invalid');
  }
};
var getLevelHeight = function getLevelHeight(level) {
  switch (level) {
    case 1:
      return 48;
    case 2:
      return 40;
    case 3:
    case 4:
      return 32;
    default:
      return 0;
  }
};
var getBackgroundColor = function getBackgroundColor(color) {
  switch (color) {
    case 'GREY':
      return '#F4F5F8';
  }
};
/*************************************************
 * STYLES
 ************************************************/

var TableContainer = Styled__default.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n\t\n"])));
var TableStyle = Styled__default.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    background-color: #fff;\n"])));
/*-----------------------------------------------
    Header Styles
-----------------------------------------------*/

var TableHeaderStyle = Styled__default.div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tposition: sticky;\n\ttop: ", ";\n\tborder-bottom: 1px solid #e6e6e6;\n\theight: ", ";\n\tz-index: 10;\n\tbackground-color: ", ";\n"])), function (_ref) {
  var stickyOffset = _ref.stickyOffset;
  return stickyOffset ? stickyOffset + 'px' : '0px';
}, function (_ref2) {
  var useGrouping = _ref2.useGrouping;
  return useGrouping ? "90px" : "53px";
}, function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor || '#fff';
});
var TitleStyle = Styled__default.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n\t\n\tdisplay: flex;\n\tline-height: 12px;\n\talign-items: center;\n\theight: 22px;\n\tfont-size: 9px;\n\tcolor: inherit;\n\tfont-weight: ", ";\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\tpadding: ", ";\n\t\n"])), function (_ref4) {
  var bold = _ref4.bold;
  return bold ? '700' : '400';
}, function (_ref5) {
  var usePadding = _ref5.usePadding;
  return usePadding && '0 16px';
});
/*-----------------------------------------------
    Column Styles
-----------------------------------------------*/

var BaseColumnStyle = Styled__default.div(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: row;\n\tleft: ", ";\n\tbackground-color: inherit;\n\tcolor: #2A2A37;\n\talign-items: center;\n    min-width: ", ";\n\twidth: ", ";\n\tmax-width: ", ";\n\tflex-grow: ", ";\n\ttext-align: ", ";\n\tjustify-content: ", ";\n\tbox-sizing: border-box;\n    height: 100%;\n\n"])), function (_ref6) {
  var level = _ref6.level;
  return !!level && '0px';
}, function (_ref7) {
  var wrapped = _ref7.wrapped,
    width = _ref7.width,
    level = _ref7.level,
    canExpand = _ref7.canExpand;
  return !wrapped && "".concat(getWidth(width, level, canExpand), "px");
}, function (_ref8) {
  var wrapped = _ref8.wrapped,
    width = _ref8.width,
    level = _ref8.level,
    canExpand = _ref8.canExpand;
  return !wrapped && "".concat(getWidth(width, level, canExpand), "px");
}, function (_ref9) {
  var wrapped = _ref9.wrapped,
    width = _ref9.width,
    level = _ref9.level,
    canExpand = _ref9.canExpand;
  return !wrapped && "".concat(getWidth(width, level, canExpand), "px");
}, function (_ref10) {
  var flex = _ref10.flex,
    wrapped = _ref10.wrapped;
  return wrapped ? 1 : flex;
}, function (_ref11) {
  var align = _ref11.align;
  return align;
}, function (_ref12) {
  var align = _ref12.align;
  return !!align && alignmentToFlex(align);
});
var TableHeaderColumnStyle = Styled__default.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n\talign-items: center;\n\tbackground-color: inherit;\n\tbox-sizing: border-box;\n\tcolor: ", ";\n\tcursor: ", ";\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-grow: ", ";\n\tfont-weight: 500;\n    height: 100%;\n\tjustify-content: ", ";\n\tleft: ", ";\n\tmin-width: ", ";\n\tmax-width: ", ";\n\tpadding-top: ", ";\n\tpadding-left: ", ";\n\tpadding-right: 16px;\n\tpadding-bottom: 15px;\n\ttext-align: ", ";\n\twidth: ", ";\n\t&:hover {\n\t\tcolor: ", ";\n\t\ttransition: color .1s ease-in;\n\t}\n"])), function (_ref13) {
  var sorted = _ref13.sorted;
  return sorted ? '#6e0fea' : '#7C7C9C';
}, function (_ref14) {
  var sortable = _ref14.sortable;
  return sortable && 'pointer';
}, function (_ref15) {
  var flex = _ref15.flex;
  return flex;
}, function (_ref16) {
  var align = _ref16.align;
  return !!align && alignmentToFlex(align);
}, function (_ref17) {
  var level = _ref17.level;
  return !!level && '0px';
}, function (_ref18) {
  var wrapped = _ref18.wrapped,
    width = _ref18.width,
    level = _ref18.level,
    canExpand = _ref18.canExpand;
  return !wrapped && "".concat(getWidth(width, level, canExpand), "px");
}, function (_ref19) {
  var wrapped = _ref19.wrapped,
    width = _ref19.width,
    level = _ref19.level,
    canExpand = _ref19.canExpand;
  return !wrapped && "".concat(getWidth(width, level, canExpand), "px");
}, function (_ref20) {
  var groupingWhiteSpace = _ref20.groupingWhiteSpace;
  return groupingWhiteSpace ? '52px' : '16px';
}, function (_ref21) {
  var level = _ref21.level;
  return !level && '16px';
}, function (_ref22) {
  var align = _ref22.align;
  return align;
}, function (_ref23) {
  var wrapped = _ref23.wrapped,
    width = _ref23.width,
    level = _ref23.level,
    canExpand = _ref23.canExpand;
  return wrapped ? '100%' : "".concat(getWidth(width, level, canExpand), "px");
}, function (_ref24) {
  var sortable = _ref24.sortable,
    sorted = _ref24.sorted;
  return sortable && !sorted && '#2A2A37';
});
var TableColumnStyle = Styled__default(BaseColumnStyle)(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n\twhite-space:  ", ";\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tpadding-left: ", ";\n\tpadding-right: ", ";\n\tborder-left: ", ";\n\tborder-right: ", ";\n\tbackground: ", ";\n\tfont-weight: ", ";\n\tcolor: ", ";\n\topacity: ", ";\n"])), function (_ref25) {
  var wrapText = _ref25.wrapText;
  return wrapText ? 'auto' : 'nowrap';
}, function (_ref26) {
  var usePadding = _ref26.usePadding,
    level = _ref26.level;
  return !level && usePadding && '16px';
}, function (_ref27) {
  var usePadding = _ref27.usePadding;
  return usePadding && '16px';
}, function (_ref28) {
  var borderLeft = _ref28.borderLeft;
  return borderLeft && '1px solid #e6e6e6';
}, function (_ref29) {
  var borderRight = _ref29.borderRight;
  return borderRight && '1px solid #e6e6e6';
}, function (_ref30) {
  var background = _ref30.background;
  return background && getBackgroundColor(background);
}, function (_ref31) {
  var bold = _ref31.bold;
  return bold && '700';
}, function (_ref32) {
  var negative = _ref32.negative;
  return negative && CSS_CONSTANTS.negative_value;
}, function (_ref33) {
  var greyedOut = _ref33.greyedOut;
  return greyedOut && '0.6';
});
var TableColumnsStyle = Styled__default.div(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tposition: ", ";\n\theight: ", ";\n\tfont-weight: ", ";\n\talign-items: center;\n\tborder-bottom: ", ";\n\tcursor: ", ";\n\n"])), function (_ref34) {
  var canExpand = _ref34.canExpand;
  return canExpand && 'sticky';
}, function (_ref35) {
  var level = _ref35.level,
    fixedHeight = _ref35.fixedHeight;
  return "".concat(fixedHeight || getLevelHeight(level), "px");
}, function (_ref36) {
  var level = _ref36.level;
  return level === 1 ? 500 : 'normal';
}, function (_ref37) {
  var level = _ref37.level,
    isLastRow = _ref37.isLastRow;
  return (level < 3 || isLastRow) && '1px solid #e6e6e6';
}, function (_ref38) {
  var canExpand = _ref38.canExpand;
  return canExpand ? 'pointer' : 'normal';
});
var FlexColumnStyle = Styled__default.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tmin-width: ", ";\n\twidth: ", ";\n\tflex-grow: ", ";\n\tbackground-color: inherit;\n\tcolor: #2A2A37;\n\talign-items: center;\n\ttext-align: ", ";\n\tjustify-content: ", ";\n\tbox-sizing: border-box;\n\theight: 100%;\n"])), function (_ref39) {
  var width = _ref39.width,
    level = _ref39.level,
    canExpand = _ref39.canExpand;
  return "".concat(getWidth(width, level, canExpand), "px");
}, function (_ref40) {
  var width = _ref40.width,
    level = _ref40.level,
    canExpand = _ref40.canExpand;
  return "".concat(getWidth(width, level, canExpand), "px");
}, function (_ref41) {
  var flex = _ref41.flex;
  return flex;
}, function (_ref42) {
  var align = _ref42.align;
  return align;
}, function (_ref43) {
  var align = _ref43.align;
  return !!align && alignmentToFlex(align);
});
var FirstColumnStyle = Styled__default.div(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tposition: sticky;\n\tleft: 0px;\n    height: 100%;\n\tpadding-left: 16px;\t\n\tmin-width: ", ";\n\twidth: ", ";\n\tmax-width: ", ";\n\tflex-direction: row;\n\tbackground-color: ", ";\n\tcolor: #2A2A37;\n\talign-items: center;\n\ttext-align: ", ";\n\tjustify-content: ", ";\n\theight: 100%;\n\tpadding-left: 16px;\n\t//z-index: ", ";\n\n"])), function (_ref44) {
  var width = _ref44.width;
  return "".concat(getWidth(width, null, false), "px");
}, function (_ref45) {
  var width = _ref45.width;
  return "".concat(getWidth(width, null, false), "px");
}, function (_ref46) {
  var width = _ref46.width;
  return "".concat(getWidth(width, null, false), "px");
}, function (_ref47) {
  var isHeader = _ref47.isHeader;
  return isHeader ? '#F7F8FB' : '#fff';
}, function (_ref48) {
  var align = _ref48.align;
  return align;
}, function (_ref49) {
  var align = _ref49.align;
  return !!align && alignmentToFlex(align);
}, function (_ref50) {
  var zIndex = _ref50.zIndex,
    level = _ref50.level;
  return zIndex || 5 - level;
});
var FirstColumnHeaderStyle = Styled__default.div(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tposition: sticky;\n\tleft: 0;\n\theight: 100%;\n\tpadding-left: 16px;\n\tpadding-right: ", ";\n\tz-index: 100;\n\tbox-sizing: border-box;\n\tmin-width: ", ";\n\twidth: ", ";\n\tmax-width: ", ";\n\tbackground-color: ", ";\n"])), function (_ref51) {
  var width = _ref51.width;
  return width === TableColumnWidth.EXTRA_SMALL ? '0px' : '16px';
}, function (_ref52) {
  var width = _ref52.width;
  return "".concat(getWidth(width, null, false), "px");
}, function (_ref53) {
  var width = _ref53.width;
  return "".concat(getWidth(width, null, false), "px");
}, function (_ref54) {
  var width = _ref54.width;
  return "".concat(getWidth(width, null, false), "px");
}, function (props) {
  return props.backgroundColor || '#fff';
});
var FirstColumnFlexStyle = Styled__default(FlexColumnStyle)(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral(["\n\tposition: sticky;\n\tleft: 0px;\n\theight: 100%;\n\tpadding-left: 16px;\n\tpadding-right: ", ";\n\tz-index: ", ";\n\tbackground-color: ", ";\n"])), function (_ref55) {
  var width = _ref55.width;
  return width === TableColumnWidth.EXTRA_SMALL ? '0px' : '16px';
}, function (_ref56) {
  var zIndex = _ref56.zIndex,
    level = _ref56.level;
  return zIndex || 5 - level;
}, function (_ref57) {
  var isHeader = _ref57.isHeader,
    backgroundColor = _ref57.backgroundColor;
  return backgroundColor ? backgroundColor : isHeader ? '#F7F8FB' : '#fff';
});
var TableColumnExpansion = Styled__default.div(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral(["\n\tpadding-left: ", ";\n\tpadding-right: ", "px;\n"])), function (_ref58) {
  var level = _ref58.level;
  return "".concat(getExpansionWidth(level), "px");
}, function (_ref59) {
  var canExpand = _ref59.canExpand;
  return canExpand ? 16 : 0;
});
var GroupingStyle = Styled__default.div(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral(["\n    background-color: inherit;\n\tborder-left: 1px solid #e6e6e6;\n\tborder-right: ", ";\n    height: 100%;\n\t", "\n"])), function (_ref60) {
  var lastGrouping = _ref60.lastGrouping;
  return lastGrouping && '1px solid #e6e6e6';
}, function (props) {
  return props.minWidth && 'min-width: ' + props.minWidth + ';';
});
var HeaderGroupingStyle = Styled__default.div(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteral(["\n    background-color: '#fff';\n\tpadding-top: 16px;\n\tborder-left: 1px solid white;\n\t", "\n"])), function (props) {
  return props.minWidth && 'min-width: ' + props.minWidth + ';';
});
/*-----------------------------------------------
    Row Styles
-----------------------------------------------*/

var TableRowStyle = Styled__default.div(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tfont-size: 13px;\n\tcursor: ", ";\n\tz-index: ", ";\n\tbackground-color: ", ";\n\tposition: ", ";\n\ttop: ", ";\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\t", ", ", ", ", " {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t\t.row-hover {\n\t\t\t", "\n\t\t}\n\t}\n"])), function (_ref61) {
  var clickHandled = _ref61.clickHandled;
  return clickHandled && 'pointer';
}, function (_ref62) {
  var level = _ref62.level;
  return !!level && 6 - level;
}, function (_ref63) {
  var isHeader = _ref63.isHeader;
  return isHeader ? '#F7F8FB' : '#fff';
}, function (_ref64) {
  var canExpand = _ref64.canExpand;
  return canExpand && 'sticky';
}, function (_ref65) {
  var level = _ref65.level,
    canExpand = _ref65.canExpand,
    hasGroupings = _ref65.hasGroupings;
  return canExpand && "".concat((hasGroupings ? 73 + 16 : 37 + 16) + getLevelHeight(level - 1), "px");
}, function (_ref66) {
  var isHeader = _ref66.isHeader;
  return !isHeader && '#f8f3fe';
}, FirstColumnStyle, GroupingStyle, FirstColumnFlexStyle, function (_ref67) {
  var isHeader = _ref67.isHeader;
  return !isHeader && '#f8f3fe';
}, function (props) {
  return props.hoverStyle;
});
var ButtonStyle = Styled__default.div(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\twidth: 94px;\n\theight: 32px;\n\tbackground: #FFFFFF;\n\tborder: 1px solid #E6E6E6;\n\tbox-sizing: border-box;\n\tfont-weight: 500;\n\tfont-size: 10px;\n\tcolor: #2A2A37;\n\tdisplay: flex;\n\tz-index: 20;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-transform: uppercase;\n"])));
var TableClickableColumnStyle = Styled__default.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\toutline:none;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\t&:hover{\n\t\tcolor:", ";\n\t}\n"])), function (props) {
  return props.theme.colors.hoverPurple;
});
var TableItalicColumnStyle = Styled__default.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n\tfont-style: italic;\n\tcolor:", ";\n"])), function (props) {
  return props.theme.colors.mediumLightGray;
});
var CellStyle = Styled__default.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcursor: ", ";\n\t&:hover{\n\t\tcolor:", ";\n\t}\n"])), function (_ref68) {
  var clickHandled = _ref68.clickHandled;
  return clickHandled && 'pointer';
}, function (props) {
  return props.clickHandled && props.theme.colors.hoverPurple;
});
var LayoutContext = /*#__PURE__*/React.createContext();
var Table = /*#__PURE__*/React__default.memo(function Table(_ref) {
  var children = _ref.children,
    onSort = _ref.onSort,
    initialSort = _ref.initialSort,
    cy = _ref.cy;
  // use instance variable to keep track of when first update has occured
  var firstUpdate = React.useRef(true);
  var _useState = React.useState(initialSort ? initialSort : {
      id: null,
      direction: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    sort = _useState2[0],
    setSort = _useState2[1];
  var handleSortClick = function handleSortClick(id) {
    var newSorting = _objectSpread2({}, sort);
    if (id === sort.id) {
      if (sort.direction === 'ASC') {
        newSorting.direction = 'DESC';
      }
      if (sort.direction === 'DESC') {
        newSorting.direction = null;
        newSorting.id = null;
      }
    } else {
      newSorting.id = id;
      newSorting.direction = 'ASC';
    }
    setSort(newSorting);
  };
  React.useEffect(function () {
    // We should not fire sort when first update
    // unless we have an initial sort state
    if (firstUpdate.current && !initialSort) {
      firstUpdate.current = false;
      return;
    }
    if (onSort) {
      onSort(sort);
    }
  }, [sort]);
  var parseTableHeader = function parseTableHeader(tableHeader) {
    var layout = {
      hasGroupings: false,
      columns: [],
      groupings: [],
      minGroupingWidths: [],
      sort: sort,
      onSort: handleSortClick
    };
    /**
     * Helper variablies to keep trakck of which group and column the loop has gotten too.
     * A seperate index needs to be tracked, because ONE child of tableHeader can be a columns
     * or a grouping of columns
     */

    var groupIndex = 0;
    var columnIndex = 0;
    var minGroupingWidthIndex = 0;
    if (tableHeader) {
      React__default.Children.forEach(tableHeader.props.children, function (headerChild) {
        if (headerChild.type === TableHeaderGrouping) {
          var _layout$columns;
          layout.hasGroupings = true;
          /*
                 When child type is TableHeaderGrouping, we get the columns one level lower
               */

          var columnLayouts = React__default.Children.map(headerChild.props.children, function (groupingChild) {
            layout.hasGroupings = true;
            layout.groupings[columnIndex++] = groupIndex;
            layout.minGroupingWidths[minGroupingWidthIndex++] = headerChild.props.minWidth;
            return {
              width: groupingChild.props.width,
              align: groupingChild.props.align,
              visible: groupingChild.props.visible,
              usePadding: groupingChild.props.usePadding,
              background: groupingChild.props.background,
              flex: groupingChild.props.flex
            };
          });
          groupIndex++;
          (_layout$columns = layout.columns).push.apply(_layout$columns, _toConsumableArray(columnLayouts));
        } else if (headerChild.type === TableHeaderColumn) {
          layout.columns.push({
            width: headerChild.props.width,
            align: headerChild.props.align,
            visible: headerChild.props.visible,
            bordered: headerChild.props.bordered,
            usePadding: headerChild.props.usePadding,
            background: headerChild.props.background,
            flex: headerChild.props.flex
          });
          layout.groupings[columnIndex++] = null;
          layout.minGroupingWidths[minGroupingWidthIndex++] = null;
        } else {
          // This should be checked in proptypes, but still we should never get here.
          throw new Error('Invalid child supplied to table header');
        }
      });
    } // cannot use borders if groupings is set

    if (layout.hasGroupings) {
      return layout;
    }
    var lastVisibleColumn = null;
    layout.columns.forEach(function (column, index, columns) {
      // first one cannot have borders
      if (index === 0) return;
      if (column.visible) {
        if (column.bordered) {
          column.borderLeft = true; // last column so should have both borders;

          if (index === columns.length - 1) {
            column.borderRight = false;
          }
        }
        if (lastVisibleColumn && lastVisibleColumn.bordered) {
          column.borderLeft = true;
        }
        lastVisibleColumn = column;
      }
    });
    return layout;
  };
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(TableStyle, null, /*#__PURE__*/React__default.createElement(LayoutContext.Provider, {
    value: parseTableHeader(children[0])
  }, children)));
});
Table.TABLE_COLUMN_WIDTH = TableColumnWidth;
Table.TABLE_COLUMN_ALIGNMENT = TableColumnAlignment; // TODO: Custom validator for checking that Table only has a Table header or Footer

Table.propTypes = {
  children: PropTypes__default.arrayOf(PropTypes__default.element).isRequired,
  onSort: PropTypes__default.func,
  initialSort: PropTypes__default.object,
  cy: PropTypes__default.string,
  minGroupingWidth: PropTypes__default.number
};
var TableHeader = function TableHeader(_ref) {
  var children = _ref.children,
    backgroundColor = _ref.backgroundColor,
    stickyOffset = _ref.stickyOffset;
  var layout = React.useContext(LayoutContext); // seperate column index - children can be groupings or columns, so we need to keep a seperate index indstead of the children array index

  var columnIndex = 0;
  var newChildren = React__default.Children.map(children, function (child) {
    if (child.type === TableHeaderGrouping) {
      var newProps = {
        usePadding: true,
        level: columnIndex === 0 ? 1 : null
      }; // when tableheader grouping, we iterate through the grouping's children

      var groupingChildren = [];
      React__default.Children.forEach(child.props.children, function (child) {
        if (!layout.columns[columnIndex].visible) ;else if (columnIndex === 0 && layout.columns[columnIndex].flex) {
          groupingChildren.push( /*#__PURE__*/React__default.createElement(FirstColumnFlexStyle, {
            align: layout.columns[columnIndex].align,
            flex: layout.columns[columnIndex].flex,
            zIndex: 100,
            width: child.props.width
          }, /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, newProps), {}, {
            wrapped: true,
            level: 1
          }))));
        } else if (columnIndex === 0) {
          groupingChildren.push( /*#__PURE__*/React__default.createElement(FirstColumnHeaderStyle, {
            width: child.props.width,
            backgroundColor: backgroundColor
          }, /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, newProps), {}, {
            wrapped: true,
            level: 1
          }))));
        } else if (layout.columns[columnIndex].flex) {
          groupingChildren.push( /*#__PURE__*/React__default.createElement(FlexColumnStyle, {
            zIndex: 90,
            width: child.props.width,
            backgroundColor: backgroundColor,
            flex: layout.columns[columnIndex].flex,
            align: layout.columns[columnIndex].align
          }, /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, newProps), {}, {
            wrapped: true
          }))));
        } else {
          groupingChildren.push( /*#__PURE__*/React__default.cloneElement(child, _objectSpread2({}, newProps)));
        }
        columnIndex++;
      });
      var result = groupingChildren.length === 0 ? null : /*#__PURE__*/React__default.cloneElement(child, {}, groupingChildren);
      return result;
    } else {
      var _newProps = {
        usePadding: true,
        level: columnIndex === 0 ? 1 : null,
        groupingWhiteSpace: layout.hasGroupings
      };
      var newChild = null;
      if (!layout.columns[columnIndex].visible) {
        newChild = null;
      } else if (columnIndex === 0 && layout.columns[columnIndex].flex) {
        newChild = /*#__PURE__*/React__default.createElement(FirstColumnFlexStyle, {
          align: layout.columns[columnIndex].align,
          backgroundColor: backgroundColor,
          flex: layout.columns[columnIndex].flex,
          zIndex: 100,
          width: child.props.width
        }, /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, _newProps), {}, {
          wrapped: true,
          level: 1
        })));
      } else if (columnIndex === 0) {
        newChild = /*#__PURE__*/React__default.createElement(FirstColumnHeaderStyle, {
          width: child.props.width,
          backgroundColor: backgroundColor,
          align: layout.columns[columnIndex].align
        }, /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, _newProps), {}, {
          wrapped: true,
          level: 1
        })));
      } else if (layout.columns[columnIndex].flex) {
        newChild = /*#__PURE__*/React__default.createElement(FlexColumnStyle, {
          zIndex: 90,
          width: child.props.width,
          backgroundColor: backgroundColor,
          flex: layout.columns[columnIndex].flex,
          align: layout.columns[columnIndex].align
        }, /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, _newProps), {}, {
          wrapped: true
        })));
      } else {
        newChild = /*#__PURE__*/React__default.cloneElement(child, _objectSpread2({}, _newProps));
      }
      columnIndex++;
      return newChild;
    }
  });
  return /*#__PURE__*/React__default.createElement(TableHeaderStyle, {
    useGrouping: layout.hasGroupings,
    backgroundColor: backgroundColor,
    stickyOffset: stickyOffset
  }, newChildren);
};
TableHeader.propTypes = {
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node]).isRequired,
  backgroundColor: PropTypes__default.string,
  stickyOffset: PropTypes__default.number
};
var _templateObject$t;
var SIZE$8 = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var DIRECTION$1 = {
  UP: 'up',
  DOWN: 'down'
};
var SortDirectionIcon = function SortDirectionIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick,
    direction = _ref.direction,
    updated = _ref.updated;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$8.SMALL:
        return '11';
      case SIZE$8.STANDARD:
        return '15';
      default:
        return '11';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$8.SMALL:
        return '11';
      case SIZE$8.STANDARD:
        return '15';
      default:
        return '11';
    }
  };
  var getWidthUpdated = function getWidthUpdated(size) {
    switch (size) {
      case SIZE$8.SMALL:
        return '4';
      case SIZE$8.STANDARD:
        return '8';
      default:
        return '8';
    }
  };
  var getHeightUpdated = function getHeightUpdated(size) {
    switch (size) {
      case SIZE$8.SMALL:
        return '3';
      case SIZE$8.STANDARD:
        return '6';
      default:
        return '6';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  if (updated) {
    return /*#__PURE__*/React__default.createElement(StyledSpan$6, {
      onClick: handleClick,
      width: getWidthUpdated(size),
      height: getHeightUpdated(size),
      color: color,
      updated: true
    }, /*#__PURE__*/React__default.createElement("svg", {
      width: getWidthUpdated(size),
      height: getHeightUpdated(size),
      viewBox: "0 0 8 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, direction === DIRECTION$1.UP && /*#__PURE__*/React__default.createElement("path", {
      d: "M0.839844 4.535L1.80484 3.57L3.73484 1.64C3.80509 1.56965 3.90043 1.53012 3.99984 1.53012C4.09926 1.53012 4.1946 1.56965 4.26484 1.64L6.19484 3.57L7.15984 4.535",
      stroke: color,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), direction === DIRECTION$1.DOWN && /*#__PURE__*/React__default.createElement("path", {
      d: "M0.839844 4.535L1.80484 3.57L3.73484 1.64C3.80509 1.56965 3.90043 1.53012 3.99984 1.53012C4.09926 1.53012 4.1946 1.56965 4.26484 1.64L6.19484 3.57L7.15984 4.535",
      stroke: color,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transform: "scale(1, -1) translate(0, -6)"
    })));
  } else {
    return /*#__PURE__*/React__default.createElement(StyledSpan$6, {
      onClick: handleClick,
      width: getWidth(size),
      height: getHeight(size)
    }, /*#__PURE__*/React__default.createElement("svg", {
      width: getWidth(size),
      height: getHeight(size),
      fill: color,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, direction === DIRECTION$1.UP && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
      d: "M7 14l5-5 5 5z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), direction === DIRECTION$1.DOWN && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
      d: "M7 10l5 5 5-5z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }))));
  }
};
SortDirectionIcon.DIRECTION = DIRECTION$1;
SortDirectionIcon.SIZE = SIZE$8;
SortDirectionIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  size: PropTypes__default.oneOf([SIZE$8.SMALL, SIZE$8.STANDARD]),
  direction: PropTypes__default.oneOf([DIRECTION$1.UP, DIRECTION$1.DOWN]),
  updated: PropTypes__default.bool
};
SortDirectionIcon.defaultProps = {
  direction: DIRECTION$1.UP
};
var StyledSpan$6 = Styled__default.span(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\n\tsvg {\n\t\tpath {\n\t\t\tstroke: ", ";\n\t\t}\n\t}\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
}, function (_ref2) {
  var color = _ref2.color,
    updated = _ref2.updated;
  return updated && (color ? color : 'currentColor');
});
var _templateObject$u;
var SortingIndicator = function SortingIndicator(_ref) {
  var color = _ref.color,
    sorted = _ref.sorted,
    direction = _ref.direction;
  return /*#__PURE__*/React__default.createElement(Container$8, null, /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    color: !sorted || direction === 'ASC' ? color : '#d3d3d3',
    updated: true,
    direction: SortDirectionIcon.DIRECTION.UP
  }), /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    color: !sorted || direction === 'DESC' ? color : '#d3d3d3',
    updated: true,
    direction: SortDirectionIcon.DIRECTION.DOWN
  }));
};
SortingIndicator.propTypes = {
  color: PropTypes__default.string,
  sorted: PropTypes__default.bool,
  direction: PropTypes__default.string
};
var Container$8 = Styled__default.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n    display: flex;\n    color: inherit;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 14px;\n"])));
var TableHeaderColumn = function TableHeaderColumn(_ref) {
  var children = _ref.children,
    visible = _ref.visible,
    width = _ref.width,
    groupingWhiteSpace = _ref.groupingWhiteSpace,
    align = _ref.align,
    sortId = _ref.sortId,
    level = _ref.level,
    firstColumn = _ref.firstColumn,
    wrapped = _ref.wrapped,
    _ref$usePadding = _ref.usePadding,
    usePadding = _ref$usePadding === void 0 ? true : _ref$usePadding,
    _ref$wrapText = _ref.wrapText,
    wrapText = _ref$wrapText === void 0 ? false : _ref$wrapText;
  var layoutContext = React.useContext(LayoutContext);
  if (!visible) {
    return null;
  }
  var handleClick = function handleClick() {
    if (sortId) {
      layoutContext.onSort(sortId);
    }
  };
  var sorted = layoutContext.sort.id === sortId;
  return /*#__PURE__*/React__default.createElement(TableHeaderColumnStyle, {
    wrapped: wrapped,
    firstColumn: firstColumn,
    level: level,
    sortable: sortId,
    sorted: sorted,
    onClick: handleClick,
    width: width,
    groupingWhiteSpace: groupingWhiteSpace,
    wrapText: wrapText,
    align: align,
    usePadding: usePadding
  }, children, !!sortId && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: '4px'
    }
  }, /*#__PURE__*/React__default.createElement(SortingIndicator, {
    sorted: sorted,
    direction: layoutContext.sort.direction
  })));
};
TableHeaderColumn.propTypes = {
  children: PropTypes__default.any,
  visible: PropTypes__default.bool,
  width: PropTypes__default.oneOf(Object.values(TableColumnWidth)),
  align: PropTypes__default.oneOf(Object.values(TableColumnAlignment)),
  groupingWhiteSpace: PropTypes__default.bool,
  sortId: PropTypes__default.string,
  firstColumn: PropTypes__default.bool,
  wrapped: PropTypes__default.bool,
  level: PropTypes__default.number,
  flex: PropTypes__default.number,
  usePadding: PropTypes__default.bool,
  wrapText: PropTypes__default.bool
};
var TableHeaderTitle = function TableHeaderTitle(_ref2) {
  var usePadding = _ref2.usePadding,
    children = _ref2.children,
    bold = _ref2.bold;
  return /*#__PURE__*/React__default.createElement(TitleStyle, {
    usePadding: usePadding,
    bold: bold
  }, children);
};
TableHeaderTitle.propTypes = {
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node, PropTypes__default.string, PropTypes__default.number]).isRequired,
  usePadding: PropTypes__default.bool,
  bold: PropTypes__default.bool
};
var TableRowWrapper = /*#__PURE__*/React__default.memo(function TableRowWrapper(_ref) {
  var rowData = _ref.rowData,
    isLastRow = _ref.isLastRow,
    level = _ref.level,
    nextLevel = _ref.nextLevel,
    index = _ref.index,
    render = _ref.render,
    canExpand = _ref.canExpand,
    initiallyExpanded = _ref.initiallyExpanded,
    hasGroupings = _ref.hasGroupings,
    isHeader = _ref.isHeader,
    disableVirtualization = _ref.disableVirtualization,
    onExpansion = _ref.onExpansion;
  var _useState = React.useState(initiallyExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var toggleExpansion = function toggleExpansion() {
    setExpanded(!expanded);
    if (onExpansion) {
      onExpansion(rowData, !expanded);
    }
  };
  var nextLevelProps = {
    level: nextLevel
  };
  var renderRow = function renderRow(visible) {
    var tableColumnsProps = {
      level: level,
      expanded: expanded,
      toggleExpansion: toggleExpansion,
      canExpand: canExpand,
      isVisible: visible === true,
      hasGroupings: hasGroupings,
      isHeader: isHeader,
      isLastRow: isLastRow,
      index: index
    };
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, render({
      rowData: rowData,
      tableColumnsProps: tableColumnsProps,
      nextLevelProps: nextLevelProps,
      expanded: expanded
    }));
  };
  return disableVirtualization ? renderRow(true) : /*#__PURE__*/React__default.createElement(VisibilitySensor, {
    partialVisibility: true
  }, function (_ref2) {
    var isVisible = _ref2.isVisible;
    return renderRow(isVisible);
  });
});
TableRowWrapper.propTypes = {
  index: PropTypes__default.any,
  loadMoreFunc: PropTypes__default.func,
  rowData: PropTypes__default.object.isRequired,
  level: PropTypes__default.oneOf([1, 2, 3]).isRequired,
  nextLevel: PropTypes__default.oneOf([2, 3, false]).isRequired,
  render: PropTypes__default.func.isRequired,
  canExpand: PropTypes__default.bool,
  initiallyExpanded: PropTypes__default.bool,
  hasGroupings: PropTypes__default.bool,
  isHeader: PropTypes__default.bool,
  isLastRow: PropTypes__default.bool,
  disableVirtualization: PropTypes__default.bool,
  onExpansion: PropTypes__default.func
};
var TableColumn = /*#__PURE__*/React__default.memo(function TableColumn(_ref) {
  var children = _ref.children,
    wrapped = _ref.wrapped,
    width = _ref.width,
    align = _ref.align,
    visible = _ref.visible,
    level = _ref.level,
    canExpand = _ref.canExpand,
    borderLeft = _ref.borderLeft,
    borderRight = _ref.borderRight,
    usePadding = _ref.usePadding,
    background = _ref.background,
    userpilot = _ref.userpilot,
    cy = _ref.cy,
    bold = _ref.bold,
    negative = _ref.negative,
    greyedOut = _ref.greyedOut,
    _ref$wrapText = _ref.wrapText,
    wrapText = _ref$wrapText === void 0 ? false : _ref$wrapText;
  if (!visible) {
    return null;
  }
  var column = /*#__PURE__*/React__default.createElement(TableColumnStyle, {
    wrapped: wrapped,
    borderLeft: borderLeft,
    borderRight: borderRight,
    width: width,
    level: level,
    align: align,
    canExpand: canExpand,
    usePadding: usePadding,
    background: background,
    "data-userpilot": userpilot,
    "data-cy": cy,
    bold: bold,
    negative: negative,
    greyedOut: greyedOut,
    wrapText: wrapText
  }, children);
  return column;
});
TableColumn.propTypes = {
  children: PropTypes__default.node,
  width: PropTypes__default.oneOf(Object.values(TableColumnWidth)),
  align: PropTypes__default.oneOf(Object.values(TableColumnAlignment)),
  visible: PropTypes__default.bool.isRequired,
  level: PropTypes__default.oneOf([1, 2, 3]),
  canExpand: PropTypes__default.bool,
  borderLeft: PropTypes__default.bool,
  borderRight: PropTypes__default.bool,
  usePadding: PropTypes__default.bool,
  background: PropTypes__default.oneOf(['GREY']),
  wrapped: PropTypes__default.bool,
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string,
  bold: PropTypes__default.bool,
  negative: PropTypes__default.bool,
  greyedOut: PropTypes__default.bool,
  wrapText: PropTypes__default.bool
};
TableColumn.defaultProps = {
  visible: true
};
var _templateObject$v, _templateObject2$i, _templateObject3$d;
var anim = Styled.keyframes(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["{\n    0%{background-position:100% 0%}\n    50%{background-position:0% 100%}\n    100%{background-position:100% 0%}\n}\n\n"])));
var Sizer = Styled__default.div(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    background-color: #F7F8FB;\n    border-radius: 2px;\n"])), function (_ref) {
  var width = _ref.width;
  return width ? "".concat(width, "px") : '100%;';
}, function (_ref2) {
  var height = _ref2.height;
  return height ? "".concat(height, "px") : '100%;';
});
var AnimatedSizer = Styled__default(Sizer)(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n    background: linear-gradient(270deg, #f3f3f3, #e1e1e1, #f3f3f3);\n    background-size: 200% 200%;\n    animation: ", " 2.5s ease infinite;\n    \n"])), anim);
var Placeholder = function Placeholder(_ref3) {
  var width = _ref3.width,
    height = _ref3.height,
    animate = _ref3.animate;
  return animate ? /*#__PURE__*/React__default.createElement(AnimatedSizer, {
    height: height,
    width: width
  }) : /*#__PURE__*/React__default.createElement(Sizer, {
    height: height,
    width: width
  });
};
Placeholder.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number,
  animate: PropTypes__default.bool
};
Placeholder.propTypes = {
  width: PropTypes__default.number,
  height: PropTypes__default.number,
  animate: PropTypes__default.bool
};
var _excluded$3 = ["children", "cy", "hoverStyle", "canExpandRow", "isHeader", "onClick"];
var TableRow = /*#__PURE__*/React__default.memo(function TableRow(_ref) {
  var children = _ref.children,
    cy = _ref.cy,
    hoverStyle = _ref.hoverStyle,
    canExpandRow = _ref.canExpandRow,
    isHeader = _ref.isHeader,
    onClick = _ref.onClick,
    tableColumnProps = _objectWithoutProperties(_ref, _excluded$3);
  var rowExpandable = canExpandRow !== undefined ? canExpandRow : tableColumnProps.canExpand;
  var rowIsHeader = isHeader || tableColumnProps.isHeader;
  var handleClick = function handleClick(e) {
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(TableRowStyle, {
    hoverStyle: hoverStyle,
    isHeader: rowIsHeader,
    canExpand: rowExpandable,
    level: tableColumnProps.level,
    hasGroupings: tableColumnProps.hasGroupings,
    "data-cy": cy,
    clickHandled: !!onClick,
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(TableColumns, _extends({}, tableColumnProps, {
    isHeader: rowIsHeader,
    canExpandRow: rowExpandable
  }), children));
});
TableRow.propTypes = {
  children: PropTypes__default.node,
  isHeader: PropTypes__default.bool,
  cy: PropTypes__default.string,
  hoverStyle: PropTypes__default.object,
  canExpandRow: PropTypes__default.bool,
  onClick: PropTypes__default.func
};
var LoadMorePlaceholder = function LoadMorePlaceholder(_ref) {
  var isVisible = _ref.isVisible,
    autoload = _ref.autoload,
    loading = _ref.loading,
    loadMore = _ref.loadMore,
    columns = _ref.columns,
    level = _ref.level;
  React.useEffect(function () {
    if (isVisible && autoload) loadMore();
  }, [isVisible]);
  var loadButton = null;
  if (!autoload) {
    loadButton = /*#__PURE__*/React__default.createElement("div", {
      key: "load-more-button",
      style: {
        zIndex: 11,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React__default.createElement(ButtonStyle, {
      onClick: loadMore
    }, loading ? 'Loading' : 'Load More'));
  }
  var data = {
    rows: [0, 1, 2]
  };
  return /*#__PURE__*/React__default.createElement("div", {
    key: "load-more-placeholder",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default.createElement(TableRows, {
    data: data,
    level: level,
    disableVirtualization: true
  }, function (_ref2) {
    var rowData = _ref2.rowData,
      tableColumnsProps = _ref2.tableColumnsProps;
    return /*#__PURE__*/React__default.createElement(TableRow, tableColumnsProps, columns.map(function (_, columnIndex) {
      return /*#__PURE__*/React__default.createElement(TableColumn, {
        key: "load-more-cell-".concat(rowData, "-").concat(columnIndex)
      }, /*#__PURE__*/React__default.createElement(Placeholder, {
        animate: autoload || loading,
        width: 60,
        height: 10
      }));
    }));
  }), loadButton);
};
LoadMorePlaceholder.propTypes = {
  isVisible: PropTypes__default.bool,
  autoload: PropTypes__default.bool,
  loading: PropTypes__default.bool,
  loadMore: PropTypes__default.func,
  columns: PropTypes__default.any,
  level: PropTypes__default.number
};
var TableRows = function TableRows(_ref) {
  var children = _ref.children,
    data = _ref.data,
    level = _ref.level,
    canExpand = _ref.canExpand,
    initiallyExpanded = _ref.initiallyExpanded,
    hasHeader = _ref.hasHeader,
    loadMore = _ref.loadMore,
    autoload = _ref.autoload,
    loading = _ref.loading,
    disableVirtualization = _ref.disableVirtualization,
    keyFunc = _ref.keyFunc,
    onExpansion = _ref.onExpansion;
  var tableLayout = React.useContext(LayoutContext);
  var nextLevel = level < 4 ? level + 1 : false;
  var expandEnabled = function expandEnabled(index) {
    return canExpand && (index > 0 || !hasHeader);
  };
  var rows = [];
  if (data.rows) {
    rows.push(data.rows.map(function (dataRow, index, array) {
      return /*#__PURE__*/React__default.createElement(TableRowWrapper, {
        isLastRow: index === array.length - 1 && !loadMore,
        isHeader: hasHeader && index === 0,
        key: "row-".concat(keyFunc ? keyFunc(dataRow) : index),
        hasGroupings: tableLayout.hasGroupings,
        rowData: dataRow,
        level: level,
        nextLevel: nextLevel,
        render: children,
        index: index,
        canExpand: expandEnabled(index),
        initiallyExpanded: initiallyExpanded,
        disableVirtualization: disableVirtualization,
        onExpansion: onExpansion
      });
    }));
  } // if (data.loadMoreFunc) {
  // there are more rows,
  // TODO decide if automatic or button
  // if button;
  // create fake columns

  if (loadMore) {
    rows.push( /*#__PURE__*/React__default.createElement(VisibilitySensor, {
      key: "load-more-wrapper-visibility-sensor",
      partialVisibility: true
    }, function (_ref2) {
      var isVisible = _ref2.isVisible;
      return /*#__PURE__*/React__default.createElement(LoadMorePlaceholder, {
        columns: tableLayout.columns,
        hasGroupings: tableLayout.hasGroupings,
        loading: loading,
        isVisible: isVisible,
        level: level,
        loadMore: loadMore,
        autoload: autoload
      });
    }));
  }
  return rows;
};
TableRows.propTypes = {
  level: PropTypes__default.oneOf([1, 2, 3]),
  data: PropTypes__default.shape({
    totals: PropTypes__default.object,
    rows: PropTypes__default.array.isRequired
  }).isRequired,
  /**
   * Render prop. Passes in data row as input
   */
  children: PropTypes__default.func.isRequired,
  canExpand: PropTypes__default.bool.isRequired,
  initiallyExpanded: PropTypes__default.bool.isRequired,
  hasHeader: PropTypes__default.bool,
  loadMore: PropTypes__default.func,
  keyFunc: PropTypes__default.func,
  loading: PropTypes__default.bool,
  disableVirtualization: PropTypes__default.bool,
  onExpansion: PropTypes__default.func
};
TableRows.defaultProps = {
  level: 1,
  canExpand: false,
  initiallyExpanded: false
};
var TableColumns = /*#__PURE__*/React__default.memo(function TableColumns(_ref) {
  var children = _ref.children,
    level = _ref.level,
    canExpand = _ref.canExpand,
    canExpandRow = _ref.canExpandRow,
    expanded = _ref.expanded,
    isVisible = _ref.isVisible,
    toggleExpansion = _ref.toggleExpansion,
    isHeader = _ref.isHeader,
    isLastRow = _ref.isLastRow,
    fixedHeight = _ref.fixedHeight;
  var tableLayout = React.useContext(LayoutContext);
  var handleOnClick = canExpandRow ? toggleExpansion : undefined;
  var getChildren = function getChildren() {
    var groupedChildren = [];
    React__default.Children.forEach(children, function (child, index) {
      if (!tableLayout.columns[index].visible) {
        return;
      }
      var cloneProps = _objectSpread2(_objectSpread2({}, tableLayout.columns[index]), {}, {
        usePadding: child.props.usePadding || tableLayout.columns[index].usePadding,
        align: child.props.align || tableLayout.columns[index].align,
        key: "column-".concat(index)
      });
      var clonedChild = /*#__PURE__*/React__default.cloneElement(child, cloneProps);
      if (tableLayout.groupings[index] === null) {
        groupedChildren.push({
          children: [getWrapper(index, tableLayout, isHeader, level, expanded, canExpand, canExpandRow, child, clonedChild)],
          group: null
        });
      } else {
        var lastIndex = groupedChildren.length - 1;
        if (!!groupedChildren[lastIndex] && groupedChildren[lastIndex].group === tableLayout.groupings[index]) {
          groupedChildren[lastIndex].children.push(getWrapper(index, tableLayout, isHeader, level, expanded, canExpand, canExpandRow, child, clonedChild));
        } else {
          groupedChildren.push({
            children: [getWrapper(index, tableLayout, isHeader, level, expanded, canExpand, canExpandRow, child, clonedChild)],
            group: tableLayout.groupings[index],
            minGroupingWidth: tableLayout.minGroupingWidths[index]
          });
        }
      }
    }); // Wrapped grouped children in a TableGrouping

    return groupedChildren.map(function (groupObject, index, array) {
      if (groupObject.group !== null) {
        var lastGrouping = index !== array.length - 1 && !array[index + 1].group;
        return /*#__PURE__*/React__default.createElement(TableGrouping, {
          key: "position-".concat(groupObject.group),
          lastGrouping: lastGrouping,
          minWidth: groupObject.minGroupingWidth
        }, groupObject.children);
      } else {
        return groupObject.children;
      }
    });
  };
  return /*#__PURE__*/React__default.createElement(TableColumnsStyle, {
    isLastRow: isLastRow,
    level: level,
    canExpand: canExpandRow,
    onClick: handleOnClick,
    fixedHeight: fixedHeight
  }, isVisible && getChildren());
});
TableColumns.propTypes = {
  children: PropTypes__default.node,
  level: PropTypes__default.oneOf([1, 2, 3]),
  canExpand: PropTypes__default.bool,
  expanded: PropTypes__default.bool,
  isVisible: PropTypes__default.bool.isRequired,
  toggleExpansion: PropTypes__default.func,
  isHeader: PropTypes__default.bool,
  isLastRow: PropTypes__default.bool,
  canExpandRow: PropTypes__default.bool,
  fixedHeight: PropTypes__default.number
};
function getWrapper(index, tableLayout, isHeader, level, expanded, canExpand, canExpandRow, child, clonedChild) {
  var caretComponent = null;
  if (canExpandRow) {
    caretComponent = /*#__PURE__*/React__default.createElement(CaretIcon, {
      color: "#2A2A37",
      direction: expanded ? CaretIcon.DIRECTION.UP : CaretIcon.DIRECTION.DOWN
    });
  } else if (canExpand) {
    caretComponent = /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: '12px'
      }
    });
  }
  if (index === 0 && tableLayout.columns[index].flex) {
    return /*#__PURE__*/React__default.createElement(FirstColumnFlexStyle, {
      key: "wrapper-".concat(index),
      level: level,
      flex: tableLayout.columns[index].flex,
      isHeader: isHeader,
      width: tableLayout.columns[index].width
    }, /*#__PURE__*/React__default.createElement(TableColumnExpansion, {
      level: level,
      canExpand: canExpand
    }, caretComponent), /*#__PURE__*/React__default.cloneElement(child, {
      canExpand: canExpand,
      wrapped: true,
      level: level,
      width: tableLayout.columns[index].width,
      usePadding: tableLayout.columns[index].usePadding
    }));
  } else if (index === 0) {
    return /*#__PURE__*/React__default.createElement(FirstColumnStyle, {
      key: "wrapper-".concat(index),
      align: tableLayout.columns[index].align,
      isHeader: isHeader,
      width: tableLayout.columns[index].width
    }, /*#__PURE__*/React__default.createElement(TableColumnExpansion, {
      level: level,
      canExpand: canExpand
    }, caretComponent), /*#__PURE__*/React__default.cloneElement(child, {
      canExpand: canExpand,
      wrapped: true,
      level: level,
      width: tableLayout.columns[index].width,
      usePadding: tableLayout.columns[index].usePadding
    }));
  } else if (tableLayout.columns[index].flex) {
    return /*#__PURE__*/React__default.createElement(FlexColumnStyle, {
      key: "wrapper-".concat(index),
      align: tableLayout.columns[index].align,
      flex: tableLayout.columns[index].flex,
      width: tableLayout.columns[index].width
    }, /*#__PURE__*/React__default.cloneElement(clonedChild, {
      wrapped: true
    }));
  } else {
    return clonedChild;
  }
}
var ClickableElement = /*#__PURE__*/React__default.memo(function TableColumn(_ref) {
  var children = _ref.children,
    onClickHandler = _ref.onClickHandler,
    href = _ref.href;

  /**
   * Gets the title from the children prop.
   * @param {string|array} children The children prop which can be a string or array.
   * @returns {string|null} The title, which will be the children prop if it is a string, or the first element of the array if it is an array.
   * Returns null if children is not a string or if the first element of the children prop is not a string, otherwise returns a string.
   */
  var getTitle = function getTitle(children) {
    if (typeof children === 'string') {
      return children;
    }
    if (Array.isArray(children)) {
      return getTitle(children[0]);
    }
    return null;
  };
  return /*#__PURE__*/React__default.createElement(TableClickableColumnStyle, {
    "data-cy": "task-name",
    onKeyDown: onClickHandler ? function (e) {
      return e.key === ' ' || e.key === 'Enter' ? onClickHandler(e) : null;
    } : null,
    onClick: onClickHandler ? function (e) {
      return onClickHandler(e);
    } : null,
    href: href,
    tabIndex: '0',
    title: getTitle(children)
  }, children);
});
ClickableElement.propTypes = {
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  onClickHandler: PropTypes__default.func,
  href: PropTypes__default.string
};
var ItalicElement = /*#__PURE__*/React__default.memo(function TableColumn(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(TableItalicColumnStyle, {
    tabIndex: '0'
  }, children);
});
ItalicElement.propTypes = {
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number])
};
var _excluded$4 = ["children", "name", "minWidth"];
var getVisibility = function getVisibility(children) {
  var visible = false;
  React__default.Children.forEach(children, function (child) {
    visible = child.props.visible || visible;
  });
  return visible;
};
var TableHeaderGrouping = /*#__PURE__*/React__default.memo(function TableHeaderGrouping(_ref) {
  var children = _ref.children,
    name = _ref.name,
    minWidth = _ref.minWidth,
    props = _objectWithoutProperties(_ref, _excluded$4);
  if (getVisibility(children)) {
    return /*#__PURE__*/React__default.createElement(HeaderGroupingStyle, {
      minWidth: minWidth
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: '100%',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      }
    }, name), /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex'
      }
    }, React__default.Children.map(children, function (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        usePadding: props.usePadding
      });
    })));
  } else {
    return null;
  }
});
TableHeaderGrouping.propTypes = {
  children: PropTypes__default.any,
  usePadding: PropTypes__default.bool,
  name: PropTypes__default.string,
  minWidth: PropTypes__default.number
};
var TableGrouping = /*#__PURE__*/React__default.memo(function TableGrouping(_ref2) {
  var children = _ref2.children,
    lastGrouping = _ref2.lastGrouping,
    minWidth = _ref2.minWidth;
  if (getVisibility(children)) {
    return /*#__PURE__*/React__default.createElement(GroupingStyle, {
      lastGrouping: lastGrouping,
      minWidth: minWidth
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        height: '100%'
      }
    }, children));
  } else {
    return null;
  }
});
TableGrouping.propTypes = {
  children: PropTypes__default.any,
  lastGrouping: PropTypes__default.bool,
  minWidth: PropTypes__default.number
};
var TableCell = function TableCell(_ref) {
  var children = _ref.children,
    title = _ref.title,
    onClick = _ref.onClick;
  var handleClick = function handleClick(e) {
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(CellStyle, {
    clickHandled: !!onClick,
    onClick: handleClick,
    title: title
  }, children);
};
TableCell.propTypes = {
  title: PropTypes__default.string,
  onClick: PropTypes__default.func,
  children: PropTypes__default.node
};
Table.Header = TableHeader;
Table.HeaderColumn = TableHeaderColumn;
Table.HeaderColumn.Title = TableHeaderTitle;
Table.Rows = TableRows;
Table.Row = TableRow;
Table.Column = TableColumn;
Table.Column.Cell = TableCell;
Table.Column.Clickable = ClickableElement;
Table.Column.Italic = ItalicElement;
Table.HeaderGrouping = TableHeaderGrouping;
var _templateObject$w, _templateObject2$j, _templateObject3$e;
var NavigationItem = function NavigationItem(_ref) {
  var active = _ref.active,
    onClick = _ref.onClick,
    children = _ref.children,
    cy = _ref.cy,
    userpilot = _ref.userpilot;
  var handleOnClick = function handleOnClick() {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/React__default.createElement(SubNavigationItem, {
    "data-userpilot": userpilot,
    "data-cy": cy,
    active: active,
    onClick: handleOnClick
  }, children);
};
NavigationItem.propTypes = {
  active: PropTypes__default.bool,
  onClick: PropTypes__default.func,
  children: PropTypes__default.node,
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string
};
var SelectorItem = function SelectorItem(_ref2) {
  var active = _ref2.active,
    onClick = _ref2.onClick,
    children = _ref2.children,
    cy = _ref2.cy,
    userpilot = _ref2.userpilot;
  var handleOnClick = function handleOnClick() {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/React__default.createElement(SelectorItemStyle, {
    "data-userpilot": userpilot,
    "data-cy": cy,
    active: active,
    onClick: handleOnClick
  }, children);
};
SelectorItem.propTypes = {
  active: PropTypes__default.bool,
  onClick: PropTypes__default.func,
  children: PropTypes__default.node,
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string
};
var SubNavigation = function SubNavigation(_ref3) {
  var children = _ref3.children,
    userpilot = _ref3.userpilot,
    cy = _ref3.cy;
  return /*#__PURE__*/React__default.createElement("nav", {
    "data-userpilot": userpilot,
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(List, null, children));
};
SubNavigation.SelectorItem = SelectorItem;
SubNavigation.NavigationItem = NavigationItem;
SubNavigation.propTypes = {
  children: PropTypes__default.node,
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string
};
var List = Styled__default.ul(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    \n"])));
var SelectorItemStyle = Styled__default.li(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: 10px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-right: 16px;\n    display: inline-block;\n    cursor: pointer;\n    &:hover {\n        color: #6e0fea;\n        transition: color .3s;\n    }\n    &:last-child {\n        margin-right: 0;\n    }\n"])), function (props) {
  return props.active ? '#6e0fea' : '#a1a1a1';
});
var SubNavigationItem = Styled__default.li(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n    color: ", ";\n    border-bottom: ", ";\n    font-weight: ", ";\n    font-size: 13px;\n    margin-right: 20px;\n    padding-bottom: 6px;\n    display: inline-block;\n    cursor: pointer;\n    &:hover {\n        color: #6e0fea;\n        transition: color .3s;\n    }\n    &:last-child {\n        margin-right: 0;\n    }\n"])), function (props) {
  return props.active ? '#6e0fea' : '#535353';
}, function (props) {
  return props.active && 'solid 3px #6e0fea';
}, function (props) {
  return props.active ? '500' : '400';
});
var _templateObject$x;
var PageHeader = function PageHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(PageHeaderStyle, null, children);
};
PageHeader.propTypes = {
  children: PropTypes__default.node
};
var PageHeaderStyle = Styled__default.h1(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n    color: #535353;\n    font-size: 20px;\n    font-weight: 500;\n    font-family: \"neue-haas-grotesk-text\",\"sans-serif\";\n    margin: 0;\n"])));
var _templateObject$y;
var StepButtonStyle = Styled__default.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n\twidth: 30px;\n\theight: 30px;\n\tborder: ", ";\n\tbackground-color: ", ";\n\tcursor: ", ";\n\tdisplay: flex;\n\talign-content: center;\n\tjustify-content: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return "1px solid ".concat(theme.border.primary);
}, function (_ref2) {
  var enabled = _ref2.enabled,
    theme = _ref2.theme;
  return enabled ? theme.background.primary : theme.background.secondary;
}, function (_ref3) {
  var enabled = _ref3.enabled;
  return enabled ? 'pointer' : 'normal';
});
var StepButton = function StepButton(_ref4) {
  var direction = _ref4.direction,
    onClick = _ref4.onClick,
    enabled = _ref4.enabled,
    userpilot = _ref4.userpilot,
    cy = _ref4.cy;
  var iconDirection = direction === 'back' ? CaretIcon.DIRECTION.LEFT : CaretIcon.DIRECTION.RIGHT;
  return /*#__PURE__*/React__default.createElement(StepButtonStyle, {
    onClick: onClick,
    enabled: enabled,
    "data-userpilot": userpilot,
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(CaretIcon, {
    direction: iconDirection,
    size: CaretIcon.SIZE.STANDARD,
    color: enabled ? '#4C4C58' : '#A5A5AE'
  }));
};
StepButton.propTypes = {
  direction: PropTypes.oneOf(['back', 'forward']).isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
var _templateObject$z;
var StepContentStyle = Styled__default.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tborder-top: ", ";\n\tborder-bottom: ", ";\n\theight: 30px;\n\tmin-width: fit-content;\n\twidth: ", "px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\ttext-transform: uppercase;\n\tfont-size: 10px;\n\tcolor: ", ";\n\tletter-spacing: 0.5px;\n\tfont-weight: 500;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.background.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid ".concat(theme.border.primary);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid ".concat(theme.border.primary);
}, function (_ref4) {
  var width = _ref4.width;
  return width;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typographyLight.primary;
});
var StepContent = function StepContent(_ref6) {
  var content = _ref6.content,
    width = _ref6.width,
    userpilot = _ref6.userpilot,
    cy = _ref6.cy;
  return /*#__PURE__*/React__default.createElement(StepContentStyle, {
    width: width,
    "data-userpilot": userpilot,
    "data-cy": cy
  }, content);
};
StepContent.propTypes = {
  content: PropTypes.node.isRequired,
  width: PropTypes.number.isRequired,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
var _templateObject$A;
var StepperStyle = Styled__default.div(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\n\tuser-select: none;\n"])));
var Stepper = function Stepper(_ref) {
  var children = _ref.children,
    onBack = _ref.onBack,
    onForward = _ref.onForward,
    width = _ref.width,
    canNavigateBack = _ref.canNavigateBack,
    canNavigateForward = _ref.canNavigateForward,
    userpilot = _ref.userpilot,
    cy = _ref.cy;
  var navigateBack = React.useMemo(function () {
    return canNavigateBack ? onBack : undefined;
  }, [canNavigateBack, onBack]);
  var navigateForward = React.useMemo(function () {
    return canNavigateForward ? onForward : undefined;
  }, [canNavigateForward, onForward]);
  return /*#__PURE__*/React__default.createElement(StepperStyle, {
    "data-userpilot": userpilot,
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(StepButton, {
    direction: "back",
    enabled: canNavigateBack,
    onClick: navigateBack,
    userpilot: "".concat(userpilot, "-back"),
    cy: "".concat(cy, "-back")
  }), /*#__PURE__*/React__default.createElement(StepContent, {
    content: children,
    width: width,
    userpilot: "".concat(userpilot, "-content"),
    cy: "".concat(cy, "-content")
  }), /*#__PURE__*/React__default.createElement(StepButton, {
    direction: "forward",
    enabled: canNavigateForward,
    onClick: navigateForward,
    userpilot: "".concat(userpilot, "-forward"),
    cy: "".concat(cy, "-forward")
  }));
};
Stepper.propTypes = {
  /**
   * What to be displayed in the content box. This is flexible and doesn't have to be text only. Content
   * has to fit withing 30px height
   */
  children: PropTypes.node.isRequired,
  /**
   * Callback function, invoked when the user has clicked the back button
   */
  onBack: PropTypes.func.isRequired,
  /**
   * Callback function, invoked when the user has clicked the forward button
   */
  onForward: PropTypes.func.isRequired,
  /**
   * The width of the content box
   */
  width: PropTypes.number.isRequired,
  /**
   * Determines if it is possible click the navigate back.
   */
  canNavigateBack: PropTypes.bool,
  /**
   * Determines if it is possible click the navigate forward.
   */
  canNavigateForward: PropTypes.bool,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
Stepper.defaultProps = {
  canNavigateBack: true,
  canNavigateForward: true
};
var YearStepper = function YearStepper(_ref) {
  var startYear = _ref.startYear,
    onYearChanged = _ref.onYearChanged,
    minYear = _ref.minYear,
    maxYear = _ref.maxYear,
    userpilot = _ref.userpilot,
    cy = _ref.cy;
  var _useState = React.useState(startYear),
    _useState2 = _slicedToArray(_useState, 2),
    year = _useState2[0],
    setYear = _useState2[1];
  var changeYear = function changeYear(newYear) {
    setYear(newYear);
    if (onYearChanged) {
      onYearChanged(newYear);
    }
  };
  var prevYear = function prevYear() {
    return changeYear(year - 1);
  };
  var nextYear = function nextYear() {
    return changeYear(year + 1);
  };
  var canNavigateBack = minYear !== undefined && minYear !== null ? year > minYear : true;
  var canNavigateForward = maxYear !== undefined && maxYear !== null ? year < maxYear : true;
  return /*#__PURE__*/React__default.createElement(Stepper, {
    width: 63,
    onForward: nextYear,
    onBack: prevYear,
    canNavigateBack: canNavigateBack,
    canNavigateForward: canNavigateForward,
    userpilot: userpilot,
    cy: cy
  }, year);
};
YearStepper.propTypes = {
  /**
   * Set what year to show initially. Defaults to current year
   */
  startYear: PropTypes.number,
  onYearChanged: PropTypes.func,
  minYear: PropTypes.number,
  maxYear: PropTypes.number,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
YearStepper.defaultTypes = {
  startYear: new Date().getFullYear()
};
var WeekStepper = function WeekStepper(_ref) {
  var startDate = _ref.startDate,
    onWeekChanged = _ref.onWeekChanged,
    canGoBack = _ref.canGoBack,
    canGoForward = _ref.canGoForward,
    locale = _ref.locale,
    userpilot = _ref.userpilot,
    cy = _ref.cy;
  var initialDate = React.useMemo(function () {
    var initDate = startDate ? startDate : moment();
    if (locale) {
      initDate.locale(locale);
    }
    return initDate;
  }, []);
  var _useState = React.useState(function () {
      return {
        startDate: initialDate.clone().startOf('week'),
        endDate: initialDate.clone().endOf('week')
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    selectedWeek = _useState2[0],
    setSelectedWeek = _useState2[1];
  React.useEffect(function () {
    if (onWeekChanged) {
      onWeekChanged(selectedWeek);
    }
  }, [selectedWeek]);
  var prevWeek = function prevWeek() {
    var newEndDate = selectedWeek.startDate.clone().subtract(1, 'day');
    var newStartDate = newEndDate.clone().startOf('week');
    setSelectedWeek({
      startDate: newStartDate,
      endDate: newEndDate
    });
  };
  var nextWeek = function nextWeek() {
    var newStartDate = selectedWeek.endDate.clone().add(1, 'day');
    var newEndDate = newStartDate.clone().endOf('week');
    setSelectedWeek({
      startDate: newStartDate,
      endDate: newEndDate
    });
  };
  return /*#__PURE__*/React__default.createElement(Stepper, {
    width: 110,
    onForward: nextWeek,
    onBack: prevWeek,
    canNavigateBack: canGoBack,
    canNavigateForward: canGoForward,
    userpilot: userpilot,
    cy: cy
  }, "".concat(selectedWeek.startDate.format('DD MMM'), " - ").concat(selectedWeek.endDate.format('DD MMM')));
};
WeekStepper.propTypes = {
  /**
   * Set what week to select to begin with. The date should be within the week and be a moment date.
   * Defaults to current week.
   */
  startDate: PropTypes.object,
  onWeekChanged: PropTypes.func,
  canGoBack: PropTypes.bool,
  canGoForward: PropTypes.bool,
  /**
   * Override the global locale for this specific instance. Shouldn't have to be used and is currently primarily used
   * for demo purposes.
   */
  locale: PropTypes.object,
  /**
   * ID needed for on-boarding tool
   */
  userpilot: PropTypes.string,
  /**
   * ID needed for Cypress testing
   */
  cy: PropTypes.string
};
WeekStepper.defaultTypes = {
  canGoBack: true,
  canGoForward: true
};
var _templateObject$B, _templateObject2$k, _templateObject3$f, _templateObject4$a, _templateObject5$6, _templateObject6$5, _templateObject7$4, _templateObject8$4, _templateObject9$3, _templateObject10$3, _templateObject11$3, _templateObject12$3, _templateObject13$3, _templateObject14$3, _templateObject15$3, _templateObject16$2, _templateObject17$2, _templateObject18$1, _templateObject19$1, _templateObject20$1, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30;
var getBackgroundColorStyle = function getBackgroundColorStyle(props, opaque) {
  var color = null;
  if (props.cardDisabled) color = opaque ? props.theme.colors.opaqueGray : props.theme.colors.nonOpaqueGray;else if (props.isSelected) color = props.theme.colors.forecastPurpleLight;else if (props.isFavoured) color = props.theme.colors.starYellowLight;else color = props.theme.colors.white;
  return "background-color: ".concat(color);
};
var getBorderColor = function getBorderColor(props) {
  if (props.cardDisabled) return props.theme.colors.opaqueGray;
  if (props.isSelected) return props.theme.colors.forecastPurple;
  if (props.isFavoured) return props.theme.colors.starYellowLight;else return props.theme.colors.white;
};
/******************************
 * card.js
 ******************************/

var GroupedItems = Styled__default.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n"])));
var ProgressBar = Styled__default.div(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tbottom: ", ";\n\tleft: ", ";\n\theight: ", ";\n\twidth: ", ";\n\tz-index: 10;\n\n\t.progress-bar-container {\n\t\tposition: relative;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tbackground-color: rgba(129, 192, 247, 0.3);\n\t}\n\t.progress-bar {\n\t\tposition: absolute;\n\t\twidth: ", ";\n\t\theight: 100%;\n\t\tbackground-color: ", ";\n\t}\n "])), function (props) {
  return props.isSelected ? '2px' : '0px';
}, function (props) {
  return props.isSelected && '2px';
}, function (props) {
  return props.isSelected ? '2px' : '3px';
}, function (props) {
  return props.isSelected ? 'calc(100% - 4px)' : '100%';
}, function (props) {
  return "".concat(props.progress, "%");
}, function (props) {
  return props.progress < 100 ? 'rgb(129, 192, 247)' : 'rgb(109, 212, 0)';
});
var TopLineItemHover = Styled__default.div(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n\tmargin-right: ", ";\n\tpadding: 0;\n\tdisplay: none;\n\talign-items: center;\t\n"])), function (props) {
  return !props.last && '8px';
});
var CardHoverItem = Styled__default.div(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n\tmargin-right: 8px;\n\tdisplay:none;\n\talign-items: center;\n"])));
var Container$9 = Styled__default.div(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n\theight: ", ";\n\tposition: relative;\n\t.time-registration-icon {\n\t\topacity: 0.0;\n\n\t\t\n\t\t}\n\n\t.active.time-registration-icon {\n\t\topacity: 1.0;\t\n\t}\n\tcursor: ", ";\n\toutline: none;\n\twidth: 100%;\n\t&:hover {\n\t\t .time-registration-icon {\n\t\t\topacity: 1.0;\t\n\t\t}\n\t\tdiv.shadow-box {\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\t&:hover ", ",\n\t&:hover ", " {\n\t\tdisplay: flex;\n\t}\n\n"])), function (props) {
  return props.height && "".concat(props.height, "px");
}, function (props) {
  return props.cardDisabled ? 'pointer' : 'grab';
}, function (props) {
  return !props.cardDisabled && '0 4px 8px 0 rgba(0, 0, 0, 0.15)';
}, TopLineItemHover, CardHoverItem);
var ShadowBox = Styled__default.div(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n\tbox-sizing: border-box;\n\tposition: absolute;\n\twidth: 100%;\n\theight: calc(100% - 7px);\n\tbottom: 0;\n\tbox-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);\n\tborder-left: ", ";\n\tborder-right: ", ";\n\tborder-bottom: ", ";\n\tz-index:1;\n\t", ";\n\n"])), function (props) {
  return '2px solid ' + getBorderColor(props);
}, function (props) {
  return '2px solid ' + getBorderColor(props);
}, function (props) {
  return '2px solid ' + getBorderColor(props);
}, function (props) {
  return getBackgroundColorStyle(props, true);
});
var ContentContainer$3 = Styled__default.div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n\tz-index: 1;\n\tposition: relative;\n\twidth: 100%;\n\theight: calc(100% - 11px);\n\tpadding: 0 16px 12px;\n\toverflow:visible;\n\tbackground-color: transparent;\n\n\n\tbox-sizing: border-box;\n\n"])));
var TopLine = Styled__default.div(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\theight: 18px;\n\talign-items: center;\n"])));
var TopLineSection = Styled__default.div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n\n"])));
var TopLineItem = Styled__default.div(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral(["\n\tmargin-right: ", ";\n\tpadding: 0;\n\tdisplay: flex;\n\talign-items: center;\t\n"])), function (props) {
  return !props.last && '8px';
});
var IdText = Styled__default.div(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\tfont-weight: 700;\n\tfont-size: 12px;\n\tpadding: 0;\n\tmargin: 0;\n\tcolor: rgb(161, 161, 161);\n"])));
var DeadlineSection = Styled__default.div(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteral(["\n\tmargin: 16px 0 0 0;\n\tdisplay: block;\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tp {\n\t\tdisplay: inline-block;\n\t\tcolor: #a1a1a1;\n\n\t\tmargin: 0 4px 0 0;\n\t}\n"])));
var ClientSection = Styled__default.div(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tp {\n\t\tdisplay: inline-block;\n\t\tcolor: #a1a1a1;\n\n\t\tmargin: 0 4px 0 0;\n\t}\n"])));
var ParentTaskNameSection = Styled__default.div(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteral(["\n\tmargin: 16px 0 0 0;\n\tdisplay: block;\n\tfont-size: 11px;\n\tfont-weight: 400;\n\tp {\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 0px;\n\t\tdisplay: inline-block;\n\t\tcolor: #a1a1a1;\n\t}\n"])));
var SubTaskIconItem = Styled__default.div(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteral(["\n\talign-self: flex-start;\n\tmargin: 4px 4px 0 0;\n"])));
var DateText = Styled__default(IdText)(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteral(["\t\n\tfont-size: 11px;\n\tfont-weight: 400;\n\tcolor: '#535353';\n"])));
var NameText = Styled__default.div(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteral(["\n\tpadding: 0;\n\tfont-size: 13px;\n\tmargin: ", ";\n\tfont-weight: 400;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcolor: ", ";\n\t\n\tspan {\n\t\tmargin-right: 5px;\n\t}\n"])), function (props) {
  return props.parentTask ? '4px 0 0 0' : '16px 0 0 0';
}, function (props) {
  return props.theme.colors.textGray;
});
/******************************
 * top_bar_and_chip.js
 ******************************/

var TopBar = Styled__default.div(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteral(["\n\theight: 12px;\n\twidth: 100%;\n\tz-index: 1;\n\tmargin-bottom: -1px;\n\tposition: relative;\n\tbox-sizing: border-box;\n"])));
var Chip = Styled__default.div(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteral(["\n\toutline: none;\n\tposition: absolute;\n\tright: 1.7px;\n\ttop: 2.5px;\n\twidth: 21px;\n\theight: 10px;\n\ttransform: rotate(20deg);\n\t", ";\n\toverflow:hidden;\n\tborder-top: ", ";\n"])), function (props) {
  return getBackgroundColorStyle(props);
}, function (props) {
  return '2px solid ' + getBorderColor(props);
});
var LeftBar = Styled__default.div(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteral(["\n\theight: 100%;\n\twidth: calc(100% - 21px);\n\t", ";\n\tborder-top: ", ";\n\tborder-left: ", ";\n\n"])), function (props) {
  return getBackgroundColorStyle(props);
}, function (props) {
  return '2px solid ' + getBorderColor(props);
}, function (props) {
  return '2px solid ' + getBorderColor(props);
});
var ContentLineSection = Styled__default.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n\tposition: relative;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tdisplay:flex;\n\tflex-direction:row;\n\talign-items:baseline;\n"])));
var LabelsSection = Styled__default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\tmargin-top: 12px;\n\tposition: relative;\n\tz-index: 0;\n\twidth:100%;\n"])));
var ImageSection = Styled__default.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n\tbackground-color: #fff;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tdisplay: block;\n\tmargin-top: 12px;\n\tmin-height: 20px;\n\tposition: relative;\n\ttext-decoration: none;\n\tz-index: 0;\n\twidth:100%;\n"])));
var ImageWrapper = Styled__default.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n\tbackground-color: white;\n\t\n\tbackground-image: url(\"", "\");\n\tbackground-size: contain;\n\tbackground-position: 50%;\n\tbackground-repeat: no-repeat;\n\tuser-select: none;\n"])), function (props) {
  return props.url;
});
var BottomLine = Styled__default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n\tdisplay:flex;\n\tmargin-top: 12px;\n\tflex-direction:row;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmax-height:26px;\n"])));
var DetailsSection = Styled__default.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n\tdisplay:flex;\n\tflex-direction:row;\n\tfont-size: 10px;\n\tfont-weight: 500;\n\tcolor:", ";\n"])), function (props) {
  return props.theme.colors.textGray;
});
var DetailElement = Styled__default.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n\tdisplay:flex;\n\tflex-direction:row;\n\tmargin-right: 15px;\n\t> span{\n\t\tmargin-right:4px;\n\t}\n"])));
var BottomLineDetailElement = Styled__default.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n\tmargin-right: 4px;\n\tpadding-top: 1px;\n"])));
/******************************
 * Loader
 ******************************/

var LoadingLineWrapper = Styled__default.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n\tdisplay:flex;\n\tflex-direction:column;\n\twidth:100%;\n"])));
var LoadingLine = Styled__default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n\twidth:", ";\n\theight:10px;\n\tbackground:", ";\n\tmargin-bottom:8px;\n "])), function (props) {
  return props.small ? '33%' : '100%';
}, function (props) {
  return props.theme.colors.fixedElementGrey;
});
var TopBarAndChip = function TopBarAndChip(_ref) {
  var cardDisabled = _ref.cardDisabled,
    isSelected = _ref.isSelected,
    isFavoured = _ref.isFavoured;
  return /*#__PURE__*/React__default.createElement(TopBar, null, /*#__PURE__*/React__default.createElement(LeftBar, {
    cardDisabled: cardDisabled,
    isSelected: isSelected,
    isFavoured: isFavoured
  }), /*#__PURE__*/React__default.createElement(Chip, {
    cardDisabled: cardDisabled,
    isSelected: isSelected,
    isFavoured: isFavoured
  }));
};
TopBarAndChip.propTypes = {
  /**
   * toggles selected visual on card
   */
  isSelected: PropTypes__default.bool,
  /**
   * toggles favoured visual on card
   */
  isFavoured: PropTypes__default.bool,
  /**
   * toggles disabled visual on card
   */
  cardDisabled: PropTypes__default.bool
};
var _templateObject$C;
var SimpleTooltip = function SimpleTooltip(_ref) {
  var text = _ref.text,
    cy = _ref.cy,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledSpan$7, {
    title: text,
    "data-cy": cy
  }, children);
};
var StyledSpan$7 = Styled__default.span(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n\tdisplay: flex;\n"])));
SimpleTooltip.propTypes = {
  text: PropTypes__default.string,
  cy: PropTypes__default.string,
  children: PropTypes__default.any.isRequired
};
var _templateObject$D;
var SIZE$9 = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var PriorityIcon = function PriorityIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick,
    intl = _ref.intl,
    shouldShow = _ref.shouldShow;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$9.SMALL:
        return '11';
      case SIZE$9.STANDARD:
        return '13';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$9.SMALL:
        return '14';
      case SIZE$9.STANDARD:
        return '16';
      default:
        return '16';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$8, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size),
    title: intl.formatMessage({
      id: 'common.high_priority'
    }),
    shouldShow: shouldShow
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0v16h1.647V9.6H14V0z",
    fill: color,
    fillRule: "evenodd"
  })));
};
PriorityIcon.SIZE = SIZE$9;
PriorityIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  shouldShow: PropTypes__default.bool,
  size: PropTypes__default.oneOf([SIZE$9.SMALL, SIZE$9.STANDARD]),
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  })
};
PriorityIcon.defaultProps = {
  color: CSS_CONSTANTS.v2_border_invalid,
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  }
};
var StyledSpan$8 = Styled__default.span(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n\tdisplay: ", "; // Dirty hack for google translate\n\theight: ", ";\n\twidth: ", ";\n\tsvg {\n\t\tvertical-align:text-top;\n\t}\n"])), function (props) {
  return props.shouldShow ? 'inline' : 'none';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$E;
var SIZE$a = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var BugIcon = function BugIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick,
    intl = _ref.intl,
    shouldShow = _ref.shouldShow;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$a.SMALL:
        return '11';
      case SIZE$a.STANDARD:
        return '13';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$a.SMALL:
        return '14';
      case SIZE$a.STANDARD:
        return '16';
      default:
        return '16';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$9, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size),
    title: intl.formatMessage({
      id: 'common.bug'
    }),
    shouldShow: shouldShow
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M8 12.8c-2.22 0-4-1.88-4-4 0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.122-1.78 4-4 4zM7.2 2.4c0-.44.36-.8.8-.8.44 0 .8.36.8.8 0 .44-.36.8-.8.8-.44 0-.8-.36-.8-.8zm8.8 4h-2.948a5.927 5.927 0 0 0-.21-.4L15.2 4.428V1.6h-1.6v1.972l-1.754 1.169a5.599 5.599 0 0 0-1.78-1.141c.207-.354.334-.76.334-1.2C10.4 1.077 9.323 0 8 0a2.403 2.403 0 0 0-2.4 2.4c0 .44.127.846.334 1.2a5.599 5.599 0 0 0-1.78 1.14L2.4 3.573V1.6H.8v2.828L3.158 6c-.076.13-.144.264-.21.4H0V8h2.464a5.62 5.62 0 0 0-.064.8c0 .272.026.538.064.8H0v1.6h2.948c.077.16.16.317.252.469l-1.6 1.6V16h1.6v-2.069l1.016-1.015a5.57 5.57 0 0 0 7.568 0l1.016 1.015V16h1.6v-2.731l-1.6-1.6c.091-.152.175-.308.252-.469H16V9.6h-2.464c.038-.262.064-.528.064-.8a5.62 5.62 0 0 0-.064-.8H16V6.4z"
  })));
};
BugIcon.SIZE = SIZE$a;
BugIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  shouldShow: PropTypes__default.bool,
  size: PropTypes__default.oneOf([SIZE$a.SMALL, SIZE$a.STANDARD]),
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  })
};
BugIcon.defaultProps = {
  color: CSS_CONSTANTS.v2_text_gray,
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  }
};
var StyledSpan$9 = Styled__default.span(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n\tdisplay: ", "; // Dirty hack for google translate\n\theight: ", ";\n\twidth: ", ";\n\tsvg{\n\t\tvertical-align:text-top;\n\t}\n"])), function (props) {
  return props.shouldShow ? 'inline' : 'none';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$F;
var SIZE$b = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var DependencyIcon = function DependencyIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$b.SMALL:
        return '11';
      case SIZE$b.STANDARD:
        return '13';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$b.SMALL:
        return '14';
      case SIZE$b.STANDARD:
        return '16';
      default:
        return '16';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$a, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 16 20"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M14.385 1.414L12.97 2.828l-1.414-1.414L12.97 0l1.414 1.414zM7.313 5.656L3.778 9.192l1.414 1.414 3.536-3.535-1.415-1.415zm5.413 7.587l2.708 2.708-1.414 1.414-2.708-2.708L7.07 18.9a1.998 1.998 0 0 1-2.828 0L.584 15.244a2.003 2.003 0 0 1 0-2.828l1.794-1.795-.014-.015a1.986 1.986 0 0 1-.586-1.414c0-.534.208-1.036.586-1.414L5.9 4.242c.502-.5 1.247-.662 1.913-.499l1.622-1.622a1 1 0 0 1 1.414 0l1.415 1.414a.996.996 0 0 1 0 1.414l-1.61 1.612a1.994 1.994 0 0 1-.51 1.923L6.606 12.02c-.378.378-.88.586-1.414.586a1.987 1.987 0 0 1-1.398-.572L2 13.83l3.656 3.656 4.242-4.243a2 2 0 0 1 2.83 0z"
  })));
};
DependencyIcon.SIZE = SIZE$b;
DependencyIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$b.SMALL, SIZE$b.STANDARD])
};
var StyledSpan$a = Styled__default.span(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$G;
var SIZE$c = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var BlockedIcon = function BlockedIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick,
    intl = _ref.intl,
    shouldShow = _ref.shouldShow;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$c.SMALL:
        return '14';
      case SIZE$c.STANDARD:
        return '16';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$c.SMALL:
        return '14';
      case SIZE$c.STANDARD:
        return '16';
      default:
        return '16';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$b, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size),
    title: intl.formatMessage({
      id: 'common.blocked'
    }),
    shouldShow: shouldShow
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M8 1.6A6.407 6.407 0 0 0 1.6 8c0 3.529 2.87 6.4 6.4 6.4 3.528 0 6.4-2.871 6.4-6.4 0-3.529-2.872-6.4-6.4-6.4zM8 16c-4.412 0-8-3.589-8-8s3.588-8 8-8 8 3.589 8 8-3.588 8-8 8zm3.765-10.635L9.131 8l2.634 2.634-1.13 1.131L8 9.132l-2.635 2.633-1.13-1.131L6.867 8 4.234 5.365l1.131-1.131L8 6.868l2.634-2.634 1.131 1.131z"
  })));
};
BlockedIcon.SIZE = SIZE$c;
BlockedIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  shouldShow: PropTypes__default.bool,
  size: PropTypes__default.oneOf([SIZE$c.SMALL, SIZE$c.STANDARD]),
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  })
};
BlockedIcon.defaultProps = {
  color: CSS_CONSTANTS.v2_border_invalid,
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  }
};
var StyledSpan$b = Styled__default.span(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n\tdisplay: ", "; // Dirty hack for google translate\n\theight: ", ";\n\twidth: ", ";\n\tsvg{\n\t\tvertical-align:text-top;\n\t}\n"])), function (props) {
  return props.shouldShow ? 'inline' : 'none';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$H;
var SIZE$d = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var SubtaskIcon = function SubtaskIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$d.SMALL:
        return '13';
      case SIZE$d.STANDARD:
        return '20';
      default:
        return '20';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$d.SMALL:
        return '13';
      case SIZE$d.STANDARD:
        return '16';
      default:
        return '16';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$c, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    fill: color,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: color
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Icon-Archieve",
    transform: "translate(-223.000000, -39.000000)",
    fill: color
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M225,53 L241,53 L241,41 L225,41 L225,53 Z M225,55 C223.897,55 223,54.102 223,53 L223,41 C223,39.897 223.897,39 225,39 L241,39 C242.103,39 243,39.897 243,41 L243,53 C243,54.102 242.103,55 241,55 L225,55 Z M231.375,46 L231.375,44 L238.541,44 L238.541,46 L231.375,46 Z M231.375,50 L231.375,48 L238.541,48 L238.541,50 L231.375,50 Z M229.6253,44.9998 C229.6253,45.6898 229.0653,46.2498 228.3753,46.2498 C227.6853,46.2498 227.1253,45.6898 227.1253,44.9998 C227.1253,44.3098 227.6853,43.7498 228.3753,43.7498 C229.0653,43.7498 229.6253,44.3098 229.6253,44.9998 Z M229.6253,48.9998 C229.6253,49.6898 229.0653,50.2498 228.3753,50.2498 C227.6853,50.2498 227.1253,49.6898 227.1253,48.9998 C227.1253,48.3098 227.6853,47.7498 228.3753,47.7498 C229.0653,47.7498 229.6253,48.3098 229.6253,48.9998 Z",
    id: "ico-subtask"
  })))));
};
SubtaskIcon.SIZE = SIZE$d;
SubtaskIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$d.SMALL, SIZE$d.STANDARD])
};
SubtaskIcon.defaultProps = {
  color: '#ADAFB8'
};
var StyledSpan$c = Styled__default.span(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$I;
var SIZE$e = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var AttachmentIcon = function AttachmentIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$e.SMALL:
        return '13';
      case SIZE$e.STANDARD:
        return '20';
      default:
        return '20';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$e.SMALL:
        return '13';
      case SIZE$e.STANDARD:
        return '20';
      default:
        return '20';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$d, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    fill: color,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Icon-Archieve",
    transform: "translate(-410.000000, -37.000000)",
    fill: color
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M425.6572,38.4419 C423.6082,36.3939 420.4862,36.5419 418.2322,38.7959 L412.2212,44.8059 C409.4002,47.6279 409.2482,51.7319 411.8682,54.3519 C414.4882,56.9719 418.5932,56.8199 421.4142,53.9989 L426.3642,49.0479 L424.9502,47.6339 L420.0002,52.5839 C417.9512,54.6329 415.1262,54.7809 413.2822,52.9379 C411.4382,51.0939 411.5872,48.2689 413.6362,46.2199 L419.6462,40.2099 C420.8792,38.9769 422.7772,38.3909 424.2432,39.8559 C425.3662,40.9789 424.9102,42.7029 423.5242,44.0879 L417.5732,50.0979 C416.8442,50.8259 416.3222,51.0049 415.7682,50.4519 C415.2902,49.9729 415.4532,49.4339 416.1802,48.7059 L421.7792,43.0489 L420.3642,41.6349 L414.7662,47.2919 C413.2312,48.8269 413.0602,50.5719 414.3542,51.8659 C415.6472,53.1599 417.3932,53.0469 418.9282,51.5119 L424.9382,45.5019 C427.5792,42.8609 427.4472,40.2319 425.6572,38.4419",
    id: "ico-attachment"
  })))));
};
AttachmentIcon.SIZE = SIZE$e;
AttachmentIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$e.SMALL, SIZE$e.STANDARD])
};
AttachmentIcon.defaultProps = {
  color: '#ADAFB8' //757575
};

var StyledSpan$d = Styled__default.span(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$J;
var SIZE$f = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var CommentIcon = function CommentIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$f.SMALL:
        return '13';
      case SIZE$f.STANDARD:
        return '20';
      default:
        return '20';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$f.SMALL:
        return '13';
      case SIZE$f.STANDARD:
        return '20';
      default:
        return '20';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$e, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    fill: color,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Icon-Archieve",
    transform: "translate(-316.000000, -39.000000)",
    fill: color
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M318.0004,41 L318.0004,53 L322.0004,53 L322.0004,55 L324.6664,53 L334.0004,53 L334.0004,41 L318.0004,41 Z M320.0004,59 L320.0004,55 L318.0004,55 C316.8964,55 316.0004,54.103 316.0004,53 L316.0004,41 C316.0004,39.897 316.8964,39 318.0004,39 L334.0004,39 C335.1034,39 336.0004,39.897 336.0004,41 L336.0004,53 C336.0004,54.103 335.1034,55 334.0004,55 L325.3334,55 L320.0004,59 Z M320,46 L320,44 L332,44 L332,46 L320,46 Z M320,50 L320,48 L332,48 L332,50 L320,50 Z",
    id: "ico-comments"
  })))));
};
CommentIcon.SIZE = SIZE$f;
CommentIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$f.SMALL, SIZE$f.STANDARD])
};
CommentIcon.defaultProps = {
  color: '#ADAFB8'
};
var StyledSpan$e = Styled__default.span(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$K;
var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
    hasEntitiesChecked = _ref.hasEntitiesChecked,
    onClick = _ref.onClick,
    onChange = _ref.onChange,
    small = _ref.small,
    userpilot = _ref.userpilot,
    cy = _ref.cy,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(StyledInput, {
    readOnly: true,
    small: small,
    className: hasEntitiesChecked ? 'group-has-entities-checked' : '',
    type: "checkbox",
    checked: checked,
    onChange: onChange ? onChange : null,
    onClick: onClick ? onClick : null,
    "data-userpilot": userpilot,
    "data-cy": cy,
    disabled: disabled
  });
};
var StyledInput = Styled__default.input(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n\tcursor: pointer;\n\theight: ", ";\n    width: ", ";\n    margin:0;\n    -webkit-appearance: none;\n\t-moz-appearance: none;\n    appearance: none;\n    border: solid 2px ", ";\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n\tbackground-color: ", ";\n\t&:enabled {\n\t\t&:hover, &:focus, &:checked {\n\t\t\tborder: solid 2px ", ";\n\t\t}\n\t}\n\t&:checked {\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t}\n    &:after {\n        box-sizing: unset;/*to overide the global box-sizing:inherit on all :after from the app*/\n        content: '';\n        display: block;\n        width: ", ";\n        height:  ", ";\n        border: solid white;\n        border-width: 0 2px 2px 0;\n        transform: translateX(-50%) rotate(40deg);\n        position: relative;\n        left: 50%;\n        top:  -1px;\n\t}\n    &.group-has-entities-checked {\n        &:after {\n            transform: translateX(-50%) rotate(90deg);\n            border-bottom-style: none;\n            top: -1px;\n        }\n    }\n    &:focus{\n        outline: none;\n    }\n"])), function (props) {
  return props.small ? '15px' : '18px';
}, function (props) {
  return props.small ? '15px' : '18px';
}, function (props) {
  return props.theme.colors !== undefined ? props.theme.colors.veryLightGray : '#e6e6e6';
}, function (props) {
  return props.theme.colors ? props.theme.colors.white : '#fff';
}, function (props) {
  return props.theme.colors ? props.theme.colors.forecastPurple : '#6e0fea';
}, function (props) {
  return props.disabled ? props.theme.colors.mediumLightGray : props.theme.colors.forecastPurple;
}, function (props) {
  return props.disabled && props.theme.colors.mediumLightGray;
}, function (props) {
  return props.small ? '5px' : '6px';
}, function (props) {
  return props.small ? '8px' : '10px';
});
Checkbox.propTypes = {
  small: PropTypes__default.bool,
  /**
   * The element is checked or not.
   */
  checked: PropTypes__default.bool,
  /**
   * If the checkbox represents multiple elements,
   * and some or checked, some not.
   */
  hasEntitiesChecked: PropTypes__default.bool,
  /**
   * Callback of the input.
   */
  onClick: PropTypes__default.func,
  onChange: PropTypes__default.func,
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string,
  disabled: PropTypes__default.bool
};
Checkbox.defaultProps = {
  checked: false,
  hasEntitiesChecked: false
};
var _templateObject$L, _templateObject2$l, _templateObject3$g, _templateObject4$b, _templateObject5$7;
var AssigneeGroupWrapper = Styled__default.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\n\tflex-wrap: no-wrap;\n\toverflow: hidden;\n\talign-items: center;\n\tfont-size: 11px;\n\t/* font-weight: 500; * */\n\t/* color: $color-white; */\n\t/* letter-spacing: -0.5px; */\n\theight: 26px;\n\t/* text-align: center; */\n\tjustify-content: ", ";\n"])), function (props) {
  return props.alignStart ? 'flex-start' : 'flex-end';
});
var getColor = function getColor(props) {
  switch (props.type) {
    case 'counter':
      return '#3f4b57';
    case 'initials':
      return '#6e0fea';
  }
};
var Hexagon = Styled__default.div(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: relative;\n\tbackground-color: ", ";\n\tfont-weight: 500;\n\ttext-transform: uppercase;\n\tcolor: white;\n\tfont-size: 9px;\n\t&:before,\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 0;\n\t\tleft: 0px;\n\t\tborder-left: 12.5px solid transparent;\n\t\tborder-right: 12.5px solid transparent;\n\t}\n\t&:before {\n\t\tbottom: 100%;\n\t\tborder-bottom: ", ";\n\t}\n\n\t&:after {\n\t\ttop: 100%;\n\t\twidth: 0;\n\t\tborder-top: ", ";\n\t}\n\t&.EXTRA_SMALL {\n\t\twidth: 21px;\n\t\theight: 12.12px;\n\t\tmargin: 6.06px 0;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-left: 10.5px solid transparent;\n\t\t\tborder-right: 10.5px solid transparent;\n\t\t}\n\t\t&:before {\n\t\t\tborder-bottom: ", ";\n\t\t}\n\t\t&:after {\n\t\t\tborder-top: ", ";\n\t\t}\n\n\t}\n\t&.SMALL {\n\t\twidth: 23px;\n\t\theight: 13.28px;\n\t\tmargin-right: 0px;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-left: 11.5px solid transparent;\n\t\t\tborder-right: 11.5px solid transparent;\n\t\t}\n\t\t&:before {\n\t\t\tborder-bottom: ", ";\n\t\t}\n\t\t&:after {\n\t\t\tborder-top: ", ";\n\t\t}\n\n\t}\n"])), function (props) {
  return getColor(props);
}, function (props) {
  return "7.22px solid ".concat(getColor(props));
}, function (props) {
  return "7.22px solid ".concat(getColor(props));
}, function (props) {
  return "6.06px solid ".concat(getColor(props));
}, function (props) {
  return "6.06px solid ".concat(getColor(props));
}, function (props) {
  return "6.64px solid ".concat(getColor(props));
}, function (props) {
  return "6.64px solid ".concat(getColor(props));
});
var AssigneeWrapper = Styled__default.div(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n\tmargin-right: ", ";\n\theight: 26px;\n\twidth: 26px;\n\tdisplay: flex;\n\talign-items: center;\n"])), function (props) {
  return props.useMargin && (props.iconSpaceBetween ? "".concat(props.iconSpaceBetween, "px") : '-7px');
});
var Image = Styled__default.img(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n\theight: 26px;\n\t\n"])));
var AssigneeGroupText = Styled__default.span(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n\tmargin-left: 4px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
var _templateObject$M, _templateObject2$m, _templateObject3$h;
var HexagonCountWrapper = Styled__default.div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n\tz-index:1;\n"])));
var NumberWrapper = Styled__default.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n\tposition:absolute;\n\tline-height:26px;\n\theight:26px;\n\twidth:22px;\n\ttext-align:center;\n\tcolor:#535353;\n\tfont-weight: 500;\n"])));
var SVGWrapper = Styled__default.div(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n\theight:26px;\n\ttext-align:center;\n\n"])));
var HexagonCount = function HexagonCount(_ref) {
  var number = _ref.number,
    remainingNames = _ref.remainingNames;
  return /*#__PURE__*/React__default.createElement(HexagonCountWrapper, {
    title: remainingNames
  }, /*#__PURE__*/React__default.createElement(NumberWrapper, null, "+", number), /*#__PURE__*/React__default.createElement(SVGWrapper, null, /*#__PURE__*/React__default.createElement("svg", {
    width: "22",
    height: "26",
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0.5 6.78532L11 0.58077L21.5 6.78531V19.2147L11 25.4192L0.5 19.2147V6.78532Z",
    fill: "white",
    stroke: "#DBDBDB"
  }))));
};
HexagonCount.propTypes = {
  number: PropTypes__default.number,
  remainingNames: PropTypes__default.string
};
var _templateObject$N, _templateObject2$n;
var CountWrapper = Styled__default.div(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n\tz-index:1;\n"])));
var NumberWrapper$1 = Styled__default.div(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n\tline-height:26px;\n\theight:26px;\n\twidth:22px;\n\ttext-align:center;\n\tcolor:#535353;\n\tfont-weight: 700;\n"])));
var Count = function Count(_ref) {
  var number = _ref.number,
    remainingNames = _ref.remainingNames;
  return /*#__PURE__*/React__default.createElement(CountWrapper, {
    title: remainingNames
  }, /*#__PURE__*/React__default.createElement(NumberWrapper$1, null, "+", number));
};
Count.propTypes = {
  number: PropTypes__default.number,
  remainingNames: PropTypes__default.string
};
var AssigneeGroup = function AssigneeGroup(_ref) {
  var showCount = _ref.showCount,
    showSingleName = _ref.showSingleName,
    assignees = _ref.assignees,
    alignStart = _ref.alignStart,
    iconSpaceBetween = _ref.iconSpaceBetween,
    hideCountFrame = _ref.hideCountFrame;
  if (assignees.length === 0) {
    return /*#__PURE__*/React__default.createElement("div", null);
  }
  var isLastElement = function isLastElement(index) {
    return index === assignees.length - 1;
  }; // only want a counter for the assignees if counter shows 2 or more,
  // if 1, we can just show the image,

  var getShowCount = function getShowCount() {
    return assignees.length > showCount ? showCount - 1 : assignees.length;
  };
  var getRemainingNames = function getRemainingNames() {
    var names = '';
    assignees.forEach(function (assignee, index) {
      if (index >= showCount - 1) names += assignee.fullName + (!isLastElement(index) ? ' ; ' : '');
    });
    return names;
  };
  return /*#__PURE__*/React__default.createElement(AssigneeGroupWrapper, {
    alignStart: alignStart
  }, assignees.slice(0, getShowCount()).map(function (assignee, index) {
    return /*#__PURE__*/React__default.createElement(AssigneeWrapper, {
      key: index,
      iconSpaceBetween: iconSpaceBetween,
      useMargin: !isLastElement(index),
      title: assignee.fullName
    }, assignee.imageSource ? /*#__PURE__*/React__default.createElement(Image, {
      crossOrigin: "use-credentials",
      src: assignee.imageSource
    }) : /*#__PURE__*/React__default.createElement(Hexagon, {
      type: 'initials',
      className: "SMALL"
    }, TextUtils.getInitials(assignee.fullName)));
  }), showSingleName && assignees.length === 1 && /*#__PURE__*/React__default.createElement(AssigneeGroupText, null, assignees[0].fullName), assignees.length > showCount && (hideCountFrame ? /*#__PURE__*/React__default.createElement(Count, {
    number: assignees.length - showCount + 1,
    remainingNames: getRemainingNames()
  }) : /*#__PURE__*/React__default.createElement(HexagonCount, {
    number: assignees.length - showCount + 1,
    remainingNames: getRemainingNames()
  })));
};
AssigneeGroup.propTypes = {
  showCount: PropTypes__default.number,
  // Toggle whether or not to show the full name along with the icon if only one element is selected
  showSingleName: PropTypes__default.bool,
  assignees: PropTypes__default.arrayOf(PropTypes__default.shape({
    fullName: PropTypes__default.string.isRequired,
    imageSource: PropTypes__default.string
  })),
  alignStart: PropTypes__default.bool,
  // Margin between assignee icons
  iconSpaceBetween: PropTypes__default.number,
  compact: PropTypes__default.bool,
  hideCountFrame: PropTypes__default.bool
};
var Card = function Card(_ref) {
  var theEyeOptions = _ref.theEyeOptions,
    id = _ref.id,
    name = _ref.name,
    isSelected = _ref.isSelected,
    isFavoured = _ref.isFavoured,
    cardDisabled = _ref.cardDisabled,
    starIcon = _ref.starIcon,
    projectIndicatorIcon = _ref.projectIndicatorIcon,
    showProjectIndicator = _ref.showProjectIndicator,
    highPriority = _ref.highPriority,
    isBug = _ref.isBug,
    hasDependencies = _ref.hasDependencies,
    showBlocked = _ref.showBlocked,
    imageComponent = _ref.imageComponent,
    deadline = _ref.deadline,
    labels = _ref.labels,
    onCardClick = _ref.onCardClick,
    todosSubtasksCount = _ref.todosSubtasksCount,
    attachmentsCount = _ref.attachmentsCount,
    commentsCount = _ref.commentsCount,
    onContextMenu = _ref.onContextMenu,
    contextMenuElement = _ref.contextMenuElement,
    showCheckbox = _ref.showCheckbox,
    onCheckboxClick = _ref.onCheckboxClick,
    progress = _ref.progress,
    assignees = _ref.assignees,
    showContext = _ref.showContext,
    showTimeReg = _ref.showTimeReg,
    timeRegPopupElement = _ref.timeRegPopupElement,
    intl = _ref.intl,
    showProgressBar = _ref.showProgressBar,
    cy = _ref.cy,
    parentTaskName = _ref.parentTaskName,
    clientName = _ref.clientName;
  var getId = function getId(id) {
    return 'T' + id;
  };
  var handleCardClick = function handleCardClick() {
    onCardClick(id);
  };
  var handleCheckboxClick = function handleCheckboxClick(e) {
    e.stopPropagation();
    onCheckboxClick && onCheckboxClick(e);
  };
  var getDeadlineFormat = function getDeadlineFormat(date) {
    var daysFromNow = date.startOf('day').diff(moment().startOf('day'), 'days');
    switch (daysFromNow) {
      case -1:
        return intl.formatMessage({
          id: 'common.yesterday'
        });
      case 0:
        return intl.formatMessage({
          id: 'common.today'
        });
      case 1:
        return intl.formatMessage({
          id: 'common.tomorrow'
        });
      default:
        return date.format('DD MMM');
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Container$9, {
    cardDisabled: cardDisabled,
    onClick: handleCardClick,
    "data-cy": cy
  }, theEyeOptions.progress && showProgressBar ? /*#__PURE__*/React__default.createElement(ProgressBar, {
    isSelected: isSelected,
    progress: progress
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "progress-bar-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "progress-bar"
  }))) : null, /*#__PURE__*/React__default.createElement(ShadowBox, {
    className: "shadow-box",
    cardDisabled: cardDisabled,
    isSelected: isSelected,
    isFavoured: isFavoured
  }), /*#__PURE__*/React__default.createElement(TopBarAndChip, {
    cardDisabled: cardDisabled,
    isSelected: isSelected,
    isFavoured: isFavoured
  }), /*#__PURE__*/React__default.createElement(ContentContainer$3, {
    onContextMenu: onContextMenu
  }, /*#__PURE__*/React__default.createElement(TopLine, null, /*#__PURE__*/React__default.createElement(TopLineSection, null, showCheckbox ? /*#__PURE__*/React__default.createElement(TopLineItem, null, /*#__PURE__*/React__default.createElement(Checkbox, {
    cy: "selector-checkbox",
    onClick: handleCheckboxClick,
    checked: isSelected,
    userpilot: 'bulk-update-checkbox'
  })) : null, showProjectIndicator && /*#__PURE__*/React__default.createElement(TopLineItem, {
    "data-cy": "card-project-indicator"
  }, projectIndicatorIcon()), theEyeOptions.highPriority && highPriority ? /*#__PURE__*/React__default.createElement(TopLineItem, null, /*#__PURE__*/React__default.createElement(SimpleTooltip, null, /*#__PURE__*/React__default.createElement(PriorityIcon, {
    active: true,
    size: PriorityIcon.SIZE.SMALL,
    shouldShow: theEyeOptions.highPriority && highPriority
  }))) : null, theEyeOptions.bug && isBug ? /*#__PURE__*/React__default.createElement(TopLineItem, null, /*#__PURE__*/React__default.createElement(SimpleTooltip, null, /*#__PURE__*/React__default.createElement(BugIcon, {
    active: true,
    size: BugIcon.SIZE.SMALL,
    color: '#535353',
    shouldShow: theEyeOptions.bug && isBug
  }))) : null, theEyeOptions.dependencies && hasDependencies ? /*#__PURE__*/React__default.createElement(TopLineItem, null, /*#__PURE__*/React__default.createElement(SimpleTooltip, null, /*#__PURE__*/React__default.createElement(DependencyIcon, {
    active: true,
    size: DependencyIcon.SIZE.SMALL,
    color: '#535353'
  }))) : null, showBlocked ? /*#__PURE__*/React__default.createElement(TopLineItem, null, /*#__PURE__*/React__default.createElement(SimpleTooltip, null, /*#__PURE__*/React__default.createElement(BlockedIcon, {
    active: true,
    size: BlockedIcon.SIZE.SMALL,
    shouldShow: showBlocked
  }))) : null), /*#__PURE__*/React__default.createElement(TopLineSection, null, /*#__PURE__*/React__default.createElement(TopLineItem, {
    last: true
  }, /*#__PURE__*/React__default.createElement(SimpleTooltip, null, starIcon({
    isFavoured: isFavoured
  }))), showContext ? /*#__PURE__*/React__default.createElement(TopLineItemHover, {
    last: true
  }, /*#__PURE__*/React__default.createElement(VerticalDotsIcon, {
    onClick: onContextMenu,
    size: VerticalDotsIcon.SIZE.MEDIUM,
    color: '#545454',
    cy: "card-context-menu"
  })) : null)), parentTaskName ? /*#__PURE__*/React__default.createElement(ParentTaskNameSection, null, /*#__PURE__*/React__default.createElement("p", null, parentTaskName)) : null, /*#__PURE__*/React__default.createElement(ContentLineSection, null, parentTaskName ? /*#__PURE__*/React__default.createElement(SubTaskIconItem, null, /*#__PURE__*/React__default.createElement(SubTaskIcon, {
    size: SIZE.SMALL
  })) : null, /*#__PURE__*/React__default.createElement(NameText, {
    parentTask: parentTaskName
  }, /*#__PURE__*/React__default.createElement("span", {
    "data-cy": "card-task-name"
  }, name), theEyeOptions.taskId ? /*#__PURE__*/React__default.createElement(IdText, null, "#".concat(getId(id))) : null)), theEyeOptions.dates && deadline ? /*#__PURE__*/React__default.createElement(DeadlineSection, null, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.deadline_colon'
  }), " "), /*#__PURE__*/React__default.createElement(DateText, null, getDeadlineFormat(deadline))) : null, theEyeOptions.clientName && clientName ? /*#__PURE__*/React__default.createElement(ClientSection, null, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.client'
  }) + ':'), /*#__PURE__*/React__default.createElement(DateText, null, clientName)) : null, theEyeOptions.imagePreview && imageComponent ? /*#__PURE__*/React__default.createElement(ImageSection, null, imageComponent) : null, theEyeOptions.labels && labels ? /*#__PURE__*/React__default.createElement(LabelsSection, null, labels()) : null, /*#__PURE__*/React__default.createElement(BottomLine, null, /*#__PURE__*/React__default.createElement(DetailsSection, null, theEyeOptions.todosSubtasks && todosSubtasksCount > 0 ? /*#__PURE__*/React__default.createElement(DetailElement, null, /*#__PURE__*/React__default.createElement(SubtaskIcon, {
    size: SubtaskIcon.SIZE.SMALL
  }), todosSubtasksCount) : null, theEyeOptions.attachments && attachmentsCount > 0 ? /*#__PURE__*/React__default.createElement(DetailElement, null, /*#__PURE__*/React__default.createElement(AttachmentIcon, {
    size: AttachmentIcon.SIZE.SMALL
  }), attachmentsCount) : null, theEyeOptions.comments && commentsCount > 0 ? /*#__PURE__*/React__default.createElement(DetailElement, null, /*#__PURE__*/React__default.createElement(CommentIcon, {
    size: CommentIcon.SIZE.SMALL
  }), commentsCount) : null), /*#__PURE__*/React__default.createElement(GroupedItems, null, /*#__PURE__*/React__default.createElement(BottomLineDetailElement, null, showTimeReg && timeRegPopupElement ? timeRegPopupElement() : null), theEyeOptions.assigned && assignees.length > 0 ? /*#__PURE__*/React__default.createElement(AssigneeGroup, {
    showCount: 3,
    assignees: assignees
  }) : null)))), showContext && contextMenuElement ? contextMenuElement() : null);
};
Card.propTypes = {
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  }),
  /**
   * enable context
   */
  showContext: PropTypes__default.bool,
  /**
   * Elements to show (or not) in the row
   */
  theEyeOptions: PropTypes__default.shape({
    checkbox: PropTypes__default.bool,
    projectId: PropTypes__default.bool,
    highPriority: PropTypes__default.bool,
    bug: PropTypes__default.bool,
    dependencies: PropTypes__default.bool,
    taskId: PropTypes__default.bool,
    clientName: PropTypes__default.bool,
    imagePreview: PropTypes__default.bool,
    dates: PropTypes__default.bool,
    labels: PropTypes__default.bool,
    taskDetails: PropTypes__default.bool,
    todosSubtasks: PropTypes__default.bool,
    attachments: PropTypes__default.bool,
    comments: PropTypes__default.bool,
    assigned: PropTypes__default.bool,
    owner: PropTypes__default.bool,
    status: PropTypes__default.bool,
    progress: PropTypes__default.bool,
    estimate: PropTypes__default.bool,
    timeEntries: PropTypes__default.bool,
    remaining: PropTypes__default.bool,
    star: PropTypes__default.bool
  }),
  assignees: PropTypes__default.arrayOf(PropTypes__default.shape({
    fullName: PropTypes__default.string.isRequired,
    imageSource: PropTypes__default.string
  })),
  /**
   * Task id
   */
  id: PropTypes__default.number.isRequired,
  showTimeReg: PropTypes__default.bool,
  cardDisabled: PropTypes__default.bool,
  timeRegPopupElement: PropTypes__default.func,
  /**
   * percentage of task done
   */
  progress: PropTypes__default.number,
  /**
   * Task name
   */
  name: PropTypes__default.string.isRequired,
  /**
   * toggles selected visual on card
   */
  isSelected: PropTypes__default.bool,
  /**
   * toggles star icon
   */
  isFavoured: PropTypes__default.bool,
  /**
   * The star icon from web-components, optionally wrapped in another component
   */
  starIcon: PropTypes__default.func.isRequired,
  /**
   * Project IndicatorIcon from web-components, optionally wrapped in another component
   */
  projectIndicatorIcon: PropTypes__default.func.isRequired,
  /**
   * Should the project indicator be shown?
   */
  showProjectIndicator: PropTypes__default.bool.isRequired,
  /**
   * Project id of the tast
   */
  projectId: PropTypes__default.number,
  /**
   * Project color for coloring the project indicator icon
   */
  projectColor: PropTypes__default.string,
  /**
   * high priority icon on card
   */
  highPriority: PropTypes__default.bool,
  /**
   * Task is a bug
   */
  isBug: PropTypes__default.bool,
  /**
   * Toggles dependency icon
   */
  hasDependencies: PropTypes__default.bool,
  /**
   * Toggles blocked icon
   */
  showBlocked: PropTypes__default.bool,
  /**
   * Cover image of the task
   */
  coverImage: PropTypes__default.func,
  /**
   * Component displaying the image if more advanced features are needed
   */
  imageComponent: PropTypes__default.element,
  /**
   * function to be called on card click
   */
  onCardClick: PropTypes__default.func,
  showProgressBar: PropTypes__default.bool,
  /**
   * deadline of the task
   */
  deadline: PropTypes__default.object,
  /**
   * Labels of the task
   */
  labels: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.func]),
  /**
   * Number of Todos or subtasks of the task
   */
  todosSubtasksCount: PropTypes__default.number,
  /**
   * Number of documents attached to the task
   */
  attachmentsCount: PropTypes__default.number,
  /**
   * Number of comments on the task
   */
  commentsCount: PropTypes__default.number,
  /**
   * Function to open the context menu
   */
  onContextMenu: PropTypes__default.func,
  /**
   * Context menu
   */
  contextMenuElement: PropTypes__default.func,
  /**
   * Cypress information
   */
  cy: PropTypes__default.string,
  showCheckbox: PropTypes__default.bool,
  onCheckboxClick: PropTypes__default.func,
  /**
   * Name of the immediate parent task name
   */
  parentTaskName: PropTypes__default.string,
  /**
   * Name of the client
   */
  clientName: PropTypes__default.string
};
Card.defaultProps = {
  progress: 0,
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  },
  assignees: [],
  theEyeOptions: {
    checkbox: true,
    projectId: true,
    highPriority: true,
    bug: true,
    dependencies: true,
    taskId: true,
    imagePreview: true,
    dates: true,
    labels: true,
    taskDetails: true,
    todosSubtasks: true,
    attachments: true,
    comments: true,
    assigned: true,
    owner: true,
    status: true,
    progress: true,
    estimate: true,
    timeEntries: true,
    remaining: true,
    star: true
  },
  onCardClick: function onCardClick() {
    return false;
  }
};
var CardLoader = function CardLoader(_ref) {
  var height = _ref.height;
  return /*#__PURE__*/React__default.createElement(Container$9, {
    height: height
  }, /*#__PURE__*/React__default.createElement(ShadowBox, {
    className: "shadow-box"
  }), /*#__PURE__*/React__default.createElement(TopBarAndChip, null), /*#__PURE__*/React__default.createElement(ContentContainer$3, null, /*#__PURE__*/React__default.createElement(TopLine, null), /*#__PURE__*/React__default.createElement(ContentLineSection, null, /*#__PURE__*/React__default.createElement(LoadingLineWrapper, null, /*#__PURE__*/React__default.createElement(LoadingLine, null), /*#__PURE__*/React__default.createElement(LoadingLine, {
    small: true
  })))));
};
CardLoader.propTypes = {
  height: PropTypes__default.number
};
var _templateObject$O, _templateObject2$o, _templateObject3$i, _templateObject4$c, _templateObject5$8, _templateObject6$6, _templateObject7$5, _templateObject8$5, _templateObject9$4, _templateObject10$4, _templateObject11$4, _templateObject12$4, _templateObject13$4, _templateObject14$4, _templateObject15$4, _templateObject16$3, _templateObject17$3, _templateObject18$2, _templateObject19$2, _templateObject20$2, _templateObject21$1;
var getBackgroundColorStyle$1 = function getBackgroundColorStyle(props) {
  if (props.isSelected) return '#f0e7fc';else if (props.isFavoured) return '#fefdf3';else return '#fff';
};
var getBorderColor$1 = function getBorderColor(props) {
  if (props.isSelected) return '#6e0fea';
  if (props.isFavoured) return '#e6e6e6';else return '#e6e6e6';
};
var TaskItemsContainer = Styled__default.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n\tmargin-right: 16px;\n"])));
var LoaderContainer = Styled__default.div(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight:237.19px;\n"])));
var Line = Styled__default.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n\toverflow: hidden;\n\tposition: relative;\n\theight: auto;\n"])));
var TaskContainer = Styled__default.div(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n\t\n"])));
var TableRow$1 = Styled__default.div(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n\toutline: none;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tjustify-content: stretch;\n\talign-items: center;\n\theight: 40px;\n\toverflow:hidden;\n\t\n"])));
var TableRowHeader = Styled__default(TableRow$1)(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral(["\n\tfont-size: 9px;\n\tline-height: 1;\n\tletter-spacing: 1px;\n\tcolor: #a1a1a1;\n\tfont-weight: 500;\n\tmargin-right: 16px;\n\ttext-transform: uppercase;\n\tz-index:2;\n\tbackground:", ";\n\t", ";\n\t", ";\n\twidth: 100%;\n\theight:24px;\n\tmargin-bottom:1px;\n\t>div{\n\t\tborder-radius: 1px;\n\t}\n"])), function (props) {
  return props.isInContainer ? '#f3f3f3' : '#f5f5f8';
}, function (props) {
  return props.stickyTopPosition !== null ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null ? 'top:' + props.stickyTopPosition + 'px;' : '';
});
var TaskItemTableRow = Styled__default(TableRow$1)(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral(["\n\tfont-size: 13px;\n\tposition: relative;\n\tcolor: #535353;\n\tborder:  ", ";\n\tborder-top:none;\n\tborder-right:none;\n\n\t>div{\n\t\t/*border to on each sub element because of the corner at the end of the row*/\n\t\tborder-top:  ", ";\n\t\tbackground:", ";\n\t\ttransition: background-color 0.2s ease;\n\t\t&:last-child{\n\t\t\tsvg{\n\t\t\t\tfill:", ";\n\t\t\t\ttransition: fill 0.2s ease;\n\t\t\t}\n\t\t\tborder-top:none;\n\t\t\tbackground:none;\n\t\t}\n\t\t&.context-menu{\n\t\t\t>span {\n\t\t\t\topacity:0;\n\t\t\t}\n\t\t}\n\t\t.time-registration-icon{\n\t\t\t\topacity:0;\n\t\t}\n\t}\n\t&:hover{\n\t\t>div{\n\t\t\t/*border to on each sub element because of the corner at the end of the row*/\n\t\t\tborder-top:  ", ";\n\t\t\tbackground: #f3f3f3;\n\t\t\ttransition: background-color 0.2s ease;\n\t\t\t\n\t\t\t&:last-child{\n\t\t\t\tsvg{\n\t\t\t\t\tfill: #f3f3f3;\n\t\t\t\t\ttransition: fill 0.2s ease;\n\t\t\t\t}\n\t\t\t\tborder-top:none;\n\t\t\t\tbackground:none;\n\t\t\t}\n\t\t\t&.context-menu{\n\t\t\t\t>span {\n\t\t\t\t\topacity:1;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.time-registration-icon{\n\t\t\t\topacity:1;\n\t\t\t}\n\t\t}\n\t}\n\t.clickable{\n\t\tcursor: pointer;\n\t\ttext-decoration: none;\n\t\tcolor: #535353;\n\t\toutline:none;\n\t\t&:hover{\n\t\t\tcolor: #6f49c5;\n\t\t}\n\t}\n"])), function (props) {
  return '1px solid ' + getBorderColor$1(props);
}, function (props) {
  return '1px solid ' + getBorderColor$1(props);
}, function (props) {
  return getBackgroundColorStyle$1(props);
}, function (props) {
  return getBackgroundColorStyle$1(props);
}, function (props) {
  return '1px solid ' + getBorderColor$1(props);
});
var NumberColumn = Styled__default.span(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteral(["\n\ttext-align:right;\n\tflex:1;\n"])));
var TableHeaderItemContainer = Styled__default.div(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tcursor:", ";;\n\tp  {\n\t\tdisplay: inline-block;\n\t}\n\tcolor: ", ";\n\t&:hover {\n\t\tcolor: ", ";\n\t\ttransition:color 0.2s ease;\n\t}\n"])), function (props) {
  return props.sortable && 'pointer';
}, function (props) {
  return props.sort && '#6e0fea';
}, function (props) {
  return props.sortable && '#6e0fea';
});
var TableRowItem = Styled__default.div(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteral(["\n\tbox-sizing: content-box;\n\tpadding-top: 0;\n\tpadding-bottom: 0;\n\theight: 100%;\n\tpadding-left: 16px;\n    user-select: none; //avoid the selection when resizing\t\n\tspan {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\t/*TODO delete when a propper dropdown has been made*/\n\t.drop-down-v2, .unfocused-assigned-container, .focused-assigned-container{\n\t\tbox-sizing:border-box;\n\t}\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
var StaticTableRowItem = Styled__default(TableRowItem)(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteral(["\n\tmin-width: ", ";\n\tmax-width: ", ";\n\twidth: ", ";\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\t\n"])), function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
});
var StaticTableRowItemMultiple = Styled__default(StaticTableRowItem)(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteral(["\n\tjustify-content: flex-end;\n"])));
var InvisibleTableRowItem = Styled__default(StaticTableRowItem)(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteral(["\n\tpadding-left:0;\n"])));
var CornerTableRowItem = Styled__default(TableRowItem)(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteral(["\n\tmin-width: ", ";\n\tmax-width: ", ";\n\twidth: ", ";\n\theight: 100%;\n\tbackground:none;\n\tmargin:0;\n    padding:0;\n"])), function (props) {
  return props.width ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width ? props.width + 'px' : 'auto';
});
var GrowableTableRowItem = Styled__default(TableRowItem)(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteral(["\n\tflex: 1;\n\theight: 100%;\n\tdisplay: grid;\n\talign-items: center;\n\tmin-width:200px;\n\t", ";\n\t", "\n\t\n\tdiv{\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\tspan{\n\t\tmargin-right:5px;\n\t}\n\t.header{\n\t\theight:100%;\n\t\tdisplay:flex;\n\t\tjustify-content:space-between;\n\t}\n\t .resizer{\n\t\topacity:", ";\n\t}\n\t&:hover{\n\t\tbackground:rgba(0, 0, 0, 0.05);\n\t\t.resizer{\n\t\t\topacity:1;\n\t\t}\n\t} \n"])), function (props) {
  return 'width:' + props.width + 'px;';
}, function (props) {
  return props.resizing ? 'background:rgba(0, 0, 0, 0.05);' : null;
}, function (props) {
  return props.resizing ? 1 : 0;
});
var Resizer = Styled__default.div(_templateObject16$3 || (_templateObject16$3 = _taggedTemplateLiteral(["\n\twidth:4px;\n\tfont-weight:900;\n\tcursor:col-resize;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: rgba(0, 0, 0, 0.2);\n\theight:100%;\n\tborder-radius: 1px;\n"])));
var Container$a = Styled__default.div(_templateObject17$3 || (_templateObject17$3 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
var NestedDropdownStyle = Styled__default.div(_templateObject18$2 || (_templateObject18$2 = _taggedTemplateLiteral(["\n\tmargin: 5px 0 0 0;\n\twidth: 340px;\n"])));
var Row = Styled__default.div(_templateObject19$2 || (_templateObject19$2 = _taggedTemplateLiteral(["\n\tmargin-bottom: ", ";\n"])), function (props) {
  return props.last ? '0px' : '24px';
});
var Text$4 = Styled__default.p(_templateObject20$2 || (_templateObject20$2 = _taggedTemplateLiteral(["\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 13px;\n\tcolor: #535353;\n\tmax-width: 702px;\n"])));
var TimeRegPopup = Styled__default.div(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteral(["\n\tmargin-right:5px;\n\theight: 16px;// the height of the svg\n"])));
var COLORS = {
  red50: '#FFEAED',
  red100: '#FFCBD0',
  red200: '#F69695',
  red300: '#EE6C6C',
  red400: '#F84746',
  red500: '#FD3027',
  red600: '#EF2327',
  red700: '#DD1322',
  red800: '#D0021B',
  pink50: '#FCE4F4',
  pink100: '#F9BAE4',
  pink200: '#F98BD2',
  pink300: '#FB54BD',
  pink400: '#FF00AA',
  pink500: '#FF0094',
  pink600: '#F2008F',
  pink700: '#DA0089',
  pink800: '#C30084',
  purple50: '#F3E5F5',
  purple100: '#E1BEE7',
  purple200: '#CE93D8',
  purple300: '#BA68C8',
  purple400: '#AB47BC',
  purple500: '#9B27B0',
  purple600: '#8D24AA',
  purple700: '#7A1FA2',
  purple800: '#691B9A',
  brand50: '#F0E6FD',
  brand100: '#D7C1F9',
  brand200: '#BC97F5',
  brand300: '#A069F2',
  brand400: '#8843EF',
  brand500: '#6E0FEB',
  brand600: '#6207E5',
  brand700: '#5000DD',
  brand800: '#3B00D7',
  blue50: '#E2F1FF',
  blue100: '#B9DCFF',
  blue200: '#8AC7FF',
  blue300: '#56B0FF',
  blue400: '#279FFF',
  blue500: '#008EFF',
  blue600: '#0081FF',
  blue700: '#146DEA',
  blue800: '#1C5BD8',
  pine50: '#E0F2F1',
  pine100: '#B2DFDB',
  pine200: '#80CBC3',
  pine300: '#4DB6AB',
  pine400: '#26A69A',
  pine500: '#009687',
  pine600: '#00897A',
  pine700: '#00796A',
  pine800: '#00695B',
  green50: '#E1FAED',
  green100: '#B5F3D3',
  green200: '#7DEAB7',
  green300: '#05E298',
  green400: '#00DA80',
  green500: '#00D06B',
  green600: '#00BF5F',
  green700: '#00AC51',
  green800: '#009A45',
  yellow50: '#FFFBE5',
  yellow100: '#FFF4BF',
  yellow200: '#FDEF95',
  yellow300: '#FBE96A',
  yellow400: '#F7E346',
  yellow500: '#F4DE16',
  yellow600: '#E5CC12',
  yellow700: '#D1B608',
  yellow800: '#BD9F01',
  orange50: '#FFF8E1',
  orange100: '#FFECB4',
  orange200: '#FFDF83',
  orange300: '#FFD451',
  orange400: '#FFC92D',
  orange500: '#FFC015',
  orange600: '#FFB210',
  orange700: '#FF9F0F',
  orange800: '#FF8E0F',
  dark100: '#91919B',
  dark200: '#81818B',
  dark300: '#6F6F7A',
  dark400: '#5E5E69',
  dark500: '#4C4C58',
  dark600: '#3B3B47',
  dark700: '#292936',
  dark800: '#181825',
  light100: '#FFFFFF',
  light200: '#F7F7FE',
  light300: '#E6E6ED',
  light400: '#D5D5DD',
  light500: '#C4C4CC',
  light600: '#B2B2BB',
  light700: '#A5A5AE',
  light800: '#9A9AA4'
};
var theme = {
  typographyDark: {
    primary: COLORS.light100,
    secondary: COLORS.light600,
    disabled: COLORS.dark200
  },
  typographyLight: {
    primary: COLORS.dark500,
    secondary: COLORS.light700,
    disabled: COLORS.light500
  },
  background: {
    primary: COLORS.light100,
    secondary: COLORS.light200,
    tertiary: COLORS.light300
  },
  border: {
    primary: COLORS.light300,
    secondary: COLORS.light500
  },
  name: 'forecast',
  fontFamily: '"neue-haas-grotesk-text","sans-serif"',
  fontSizes: {
    "default": '20px',
    buttonStandard: '10px'
  },
  colors: {
    green: '#05e298',
    darkPurple: '#470c93',
    forecastPurple: COLORS.brand500,
    forecastPurpleMedium: COLORS.brand400,
    forecastPurpleLight: COLORS.brand50,
    hoverPurple: '#6f49c5',
    starYellow: '#F6DA1A',
    starYellowLight: '#fefdf3',
    darkGray: '#4a4a4a',
    textGray: '#535353',
    mediumGray: '#f3f3f3',
    textLightGray: '#545454',
    lightGray: '#9f9f9f',
    mediumLightGray: '#a1a1a1',
    mediumVeryLightGray: '#cecece',
    veryLightGray: '#e6e6e6',
    veryVeryLightGray: '#f5f5f5',
    fixedElementGrey: '#f5f5f8',
    warningRed: '#E4253B',
    white: '#fff',
    negativeValue: '#d0021b',
    opaqueGray: polished.rgba(0, 0, 0, 0.3),
    nonOpaqueGray: '#b1b1b1' //Exactly color match to opaqueGray, but not opaque
  },

  borderWidths: {
    standard: '1px'
  }
};
var Corner = function Corner(_ref) {
  var selected = _ref.selected;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "14",
    height: "42",
    viewBox: "0 0 14 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0L14 9.5V42H0V0Z",
    fill: selected ? theme.colors.forecastPurple : '#DDDDDD'
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 1L13 10V41H0V1Z"
  }));
};
Corner.propTypes = {
  /**
   * The element is checked or not.
   */
  selected: PropTypes__default.bool
};
var _templateObject$P, _templateObject2$p;
var KebabMenuStyled = Styled__default.span(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content:center;\n\tcursor:pointer;\n\tposition :absolute;\n\twidth: 16px;\n\theight:30px;\n\tright: 8px;\n\tborder-radius: 4px;\n\t&:hover{\n\t\tbackground-color: rgba(0, 0, 0, 0.2);\n\t}\n"])));
var StyledSVG = Styled__default.svg(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n\talign-self:center;\n"])));
var KebabMenuIcon = function KebabMenuIcon(_ref) {
  var onClick = _ref.onClick,
    userpilot = _ref.userpilot,
    cy = _ref.cy;
  return /*#__PURE__*/React__default.createElement(KebabMenuStyled, {
    onClick: onClick,
    "data-userpilot": userpilot,
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    height: "18px",
    width: "4px"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M-.107143-.07242846h24V23.927572h-24z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(-10 -3.0019999)",
    fill: "#757575"
  }, /*#__PURE__*/React__default.createElement("circle", {
    r: "2",
    cy: "5",
    cx: "12"
  }), /*#__PURE__*/React__default.createElement("circle", {
    r: "2",
    cy: "12",
    cx: "12"
  }), /*#__PURE__*/React__default.createElement("circle", {
    r: "2",
    cy: "19",
    cx: "12"
  }))));
};
KebabMenuIcon.propTypes = {
  onClick: PropTypes__default.func,
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string
};
var TaskRow = function TaskRow(_ref) {
  var checkboxIcon = _ref.checkboxIcon,
    isSelected = _ref.isSelected,
    isFavoured = _ref.isFavoured,
    taskId = _ref.taskId,
    taskName = _ref.taskName,
    projectName = _ref.projectName,
    clientName = _ref.clientName,
    openCardModal = _ref.openCardModal,
    projectIndicatorIcon = _ref.projectIndicatorIcon,
    assigneesElement = _ref.assigneesElement,
    ownerElement = _ref.ownerElement,
    statusElement = _ref.statusElement,
    startDate = _ref.startDate,
    deadline = _ref.deadline,
    progress = _ref.progress,
    phase = _ref.phase,
    estimate = _ref.estimate,
    timeEntries = _ref.timeEntries,
    timeRegPopup = _ref.timeRegPopup,
    remaining = _ref.remaining,
    labels = _ref.labels,
    starIcon = _ref.starIcon,
    _onContextMenu = _ref.onContextMenu,
    contextMenuElement = _ref.contextMenuElement,
    columns = _ref.columns,
    isBug = _ref.isBug,
    isHighPriority = _ref.isHighPriority,
    isBlocked = _ref.isBlocked,
    cy = _ref.cy,
    intl = _ref.intl;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line, {
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(TaskItemTableRow, {
    isSelected: isSelected,
    isFavoured: isFavoured,
    onContextMenu: function onContextMenu(e) {
      return _onContextMenu ? _onContextMenu(e) : {};
    }
  }, columns.checkbox && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 18
  }, checkboxIcon({
    checked: isSelected
  })), columns.projectId && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 50,
    "data-userpilot": 'task-row-project-indicator'
  }, projectIndicatorIcon), columns.projectName && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166,
    "data-userpilot": 'task-row-project-name'
  }, /*#__PURE__*/React__default.createElement("span", {
    title: projectName
  }, projectName)), columns.taskId && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 60
  }, /*#__PURE__*/React__default.createElement("a", {
    className: openCardModal ? 'clickable' : '',
    "data-cy": "task-name",
    onKeyDown: openCardModal ? function (e) {
      return e.key === ' ' || e.key === 'Enter' ? openCardModal(e) : null;
    } : null,
    onClick: openCardModal ? function (e) {
      return openCardModal(e);
    } : null,
    href: window.location.href + (window.location.href.endsWith('/') ? 'T' + taskId : '/T' + taskId),
    tabIndex: '0',
    title: taskName
  }, "T", taskId)), /*#__PURE__*/React__default.createElement(GrowableTableRowItem, null, /*#__PURE__*/React__default.createElement("div", {
    className: openCardModal ? 'clickable' : '',
    "data-cy": "task-name",
    onKeyDown: openCardModal ? function (e) {
      return e.key === ' ' || e.key === 'Enter' ? openCardModal(e) : null;
    } : null,
    onClick: openCardModal ? function (e) {
      return openCardModal(e);
    } : null,
    href: window.location.href + (window.location.href.endsWith('/') ? 'T' + taskId : '/T' + taskId),
    tabIndex: '0',
    title: taskName
  }, /*#__PURE__*/React__default.createElement(PriorityIcon, {
    intl: intl,
    shouldShow: isHighPriority
  }), /*#__PURE__*/React__default.createElement(BugIcon, {
    intl: intl,
    shouldShow: isBug
  }), /*#__PURE__*/React__default.createElement(BlockedIcon, {
    intl: intl,
    shouldShow: isBlocked
  }), taskName)), columns.assignedPerson && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, assigneesElement ? assigneesElement : /*#__PURE__*/React__default.createElement("div", null, "Person dropdown")), columns.owner && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, ownerElement ? ownerElement : /*#__PURE__*/React__default.createElement("div", null, "Owner Dropdown")), columns.client && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166,
    "data-userpilot": 'task-row-client'
  }, /*#__PURE__*/React__default.createElement("span", {
    title: clientName
  }, clientName)), columns.status && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, statusElement ? statusElement : /*#__PURE__*/React__default.createElement("div", null, "Status dropdown")), columns.startDate && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 90
  }, /*#__PURE__*/React__default.createElement("span", null, startDate)), columns.deadline && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 90
  }, /*#__PURE__*/React__default.createElement("span", null, deadline)), columns.phase && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, /*#__PURE__*/React__default.createElement("span", {
    title: phase
  }, phase)), columns.progress && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 70
  }, /*#__PURE__*/React__default.createElement(NumberColumn, null, progress)), columns.estimate && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 60
  }, /*#__PURE__*/React__default.createElement(NumberColumn, null, estimate)), columns.timeEntries && /*#__PURE__*/React__default.createElement(StaticTableRowItemMultiple, {
    width: 80
  }, /*#__PURE__*/React__default.createElement(TimeRegPopup, null, timeRegPopup), timeEntries), columns.remaining && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 60
  }, /*#__PURE__*/React__default.createElement(NumberColumn, null, remaining)), columns.labels && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(LabelGroup, {
    labels: labels,
    overflowStyle: 'TOOLTIP'
  })), columns.star && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 14,
    "data-userpilot": 'task-row-star'
  }, starIcon && starIcon({
    isFavoured: isFavoured
  })), _onContextMenu && /*#__PURE__*/React__default.createElement(InvisibleTableRowItem, {
    width: 16,
    className: 'context-menu'
  }, /*#__PURE__*/React__default.createElement(KebabMenuIcon, {
    onClick: function onClick(e) {
      return _onContextMenu(e);
    }
  })), /*#__PURE__*/React__default.createElement(CornerTableRowItem, {
    width: 14
  }, /*#__PURE__*/React__default.createElement(Corner, {
    selected: isSelected
  })))), contextMenuElement && contextMenuElement());
};
TaskRow.propTypes = {
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  }),
  /**
   * The checkbox icon from web-components, optionally wrapped in another component
   */
  checkboxIcon: PropTypes__default.func.isRequired,
  /**
   * Toggles selected visual on row
   */
  isSelected: PropTypes__default.bool,
  /**
   * Task favourit status
   */
  isFavoured: PropTypes__default.bool,
  /**
   * The star icon from web-components, optionally wrapped in another component
   */
  starIcon: PropTypes__default.func,
  /**
   * Company Task id
   */
  taskId: PropTypes__default.number.isRequired,
  /**
   * Name of the task
   */
  taskName: PropTypes__default.string.isRequired,
  /**
   * Name of the project
   */
  projectName: PropTypes__default.string.isRequired,
  /**
   * Name of the client attached to the project
   */
  clientName: PropTypes__default.string,
  /**
   * Function used to open the Task Modal
   */
  openCardModal: PropTypes__default.func,
  /**
   * Project IndicatorIcon from web-components, optionally wrapped in another component
   */
  projectIndicatorIcon: PropTypes__default.func.isRequired,
  /**
   *	Dropdown containing the status of the task
   */
  statusElement: PropTypes__default.func,
  /**
   *	Dropdown for the assignees of the task
   */
  assigneesElement: PropTypes__default.func,
  /**
   *	Dropdown for the owners of the task
   */
  ownerElement: PropTypes__default.func,
  /**
   * Phase name of the task
   */
  phase: PropTypes__default.string,
  /**
   * Start date of the task, in the format "10 May"
   */
  startDate: PropTypes__default.any,
  /**
   * Deadline of the task, in the format "10 May"
   */
  deadline: PropTypes__default.any,
  /**
   * Progress of the task as percentage
   */
  progress: PropTypes__default.string,
  /**
   * Remaining time of the task, in time format
   */
  remaining: PropTypes__default.string,
  /**
   * Time estimated for the task, in time format
   */
  estimate: PropTypes__default.string,
  /**
   * Time registered on the task, in time format
   */
  timeEntries: PropTypes__default.string,
  /**
   * Pop op next to the time entries to add time to the task
   */
  timeRegPopup: PropTypes__default.node,
  /**
   * An array of label definitions
   */
  labels: PropTypes__default.arrayOf(PropTypes__default.shape({
    /**
     * The name of the label, which is also displayed as text
     */
    name: PropTypes__default.string.isRequired,
    /**
     * The color of the label. Text color will be the inverse of this
     */
    color: PropTypes__default.string.isRequired
  })),
  /**
   * Function to open the context menu
   */
  onContextMenu: PropTypes__default.func,
  /**
   * Context menu
   */
  contextMenuElement: PropTypes__default.func,
  /**
   * Elements to show (or not) in the row
   */
  columns: PropTypes__default.shape({
    checkbox: PropTypes__default.bool,
    projectId: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    taskId: PropTypes__default.bool,
    assignedPerson: PropTypes__default.bool,
    owner: PropTypes__default.bool,
    client: PropTypes__default.bool,
    status: PropTypes__default.bool,
    startDate: PropTypes__default.bool,
    deadline: PropTypes__default.bool,
    phase: PropTypes__default.bool,
    progress: PropTypes__default.bool,
    estimate: PropTypes__default.bool,
    timeEntries: PropTypes__default.bool,
    remaining: PropTypes__default.bool,
    labels: PropTypes__default.bool,
    star: PropTypes__default.bool
  }).isRequired,
  /**
   * Task indicator: bug
   */
  isBug: PropTypes__default.bool,
  /**
   * Task indicator:high priority
   */
  isHighPriority: PropTypes__default.bool,
  /**
   * Task indicator: blocked
   */
  isBlocked: PropTypes__default.bool,
  /**
   * Cypress data information
   */
  cy: PropTypes__default.string
};
TaskRow.defaultProps = {
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  },
  openCardModal: function openCardModal() {
    return false;
  }
};
var TaskRowHeader = function TaskRowHeader(_ref) {
  var intl = _ref.intl,
    columns = _ref.columns,
    sortBy = _ref.sortBy,
    onSortByChange = _ref.onSortByChange,
    stickyTopPosition = _ref.stickyTopPosition,
    isInContainer = _ref.isInContainer,
    tracking = _ref.tracking;
  var taskNameColumn = React.useRef(null);
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    taskWidth = _useState2[0],
    setTaskWidth = _useState2[1];
  var _useState3 = React.useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    originalTaskWidth = _useState4[0],
    _setOriginalTaskWidth = _useState4[1];
  var originalTaskWidthRef = React.useRef(originalTaskWidth);
  var setOriginalTaskWidth = function setOriginalTaskWidth(data) {
    originalTaskWidthRef.current = data;
    _setOriginalTaskWidth(data);
  };
  var _useState5 = React.useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    mouseDownPositionX = _useState6[0],
    _setMouseDownPositionX = _useState6[1];
  var mouseDownPositionXRef = React.useRef(mouseDownPositionX);
  var setMouseDownPositionX = function setMouseDownPositionX(data) {
    mouseDownPositionXRef.current = data;
    _setMouseDownPositionX(data);
  };
  var handleSortByClick = function handleSortByClick(name) {
    // not allowing sort by
    if (!onSortByChange) {
      return;
    }
    var sortByCopy = _objectSpread2({}, sortBy);
    if (name === sortByCopy.column) {
      if (sortByCopy.ascending) {
        sortByCopy.ascending = false;
      } else {
        sortByCopy.column = null;
      }
    } else {
      sortByCopy.column = name;
      sortByCopy.ascending = true;
    }
    onSortByChange(sortByCopy);
  };
  var isSortedColumn = function isSortedColumn(name) {
    return sortBy.column === name;
  };
  var getSortDirection = function getSortDirection() {
    return sortBy.ascending ? SortDirectionIcon.DIRECTION.UP : SortDirectionIcon.DIRECTION.DOWN;
  };
  var isSortable = function isSortable() {
    return !!onSortByChange;
  };
  var onMouseMove = function onMouseMove(e) {
    if (mouseDownPositionXRef.current > 0) {
      var distance = e.x - mouseDownPositionXRef.current;
      var newVal = originalTaskWidthRef.current + distance;
      if (taskWidth === null) {
        //there is a 32px jump I haven't identified yet
        setTaskWidth(newVal > 200 ? newVal - 32 : null);
      } else {
        setTaskWidth(newVal > 200 ? newVal : null);
      }
    }
  };
  var handleMouseDown = function handleMouseDown(e) {
    setMouseDownPositionX(e.nativeEvent.x);
    setOriginalTaskWidth(taskWidth || taskNameColumn.current.getBoundingClientRect().width);
    document.getElementById('app').style.cursor = 'col-resize';
    window.addEventListener('mouseup', onMouseUpHandler);
    window.addEventListener('mousemove', onMouseMove);
  };
  var onMouseUpHandler = function onMouseUpHandler() {
    setMouseDownPositionX(-1);
    tracking.trackEvent('Task Name resized');
    document.getElementById('app').style.cursor = 'inherit';
    window.removeEventListener('mouseup', onMouseUpHandler);
    window.removeEventListener('mousemove', onMouseMove);
    return false;
  };
  return /*#__PURE__*/React__default.createElement(TableRowHeader, {
    stickyTopPosition: stickyTopPosition,
    isInContainer: isInContainer
  }, columns.checkbox && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 18
  }), columns.projectId && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 50
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('project');
    },
    sort: isSortedColumn('project'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.project_id_short'
  })), isSortedColumn('project') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    size: SortDirectionIcon.SIZE.STANDARD,
    direction: getSortDirection()
  }))), columns.projectName && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('project-name');
    },
    sort: isSortedColumn('project-name'),
    sortable: isSortable
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.project-name'
  })), isSortedColumn('project-name') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    size: SortDirectionIcon.SIZE.STANDARD,
    direction: getSortDirection()
  }))), columns.taskId && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 50
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('id');
    },
    sort: isSortedColumn('id'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.id'
  })), isSortedColumn('id') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), /*#__PURE__*/React__default.createElement(GrowableTableRowItem, {
    ref: taskNameColumn,
    width: taskWidth,
    resizable: true,
    resizing: mouseDownPositionX > -1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'header'
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('name');
    },
    sortable: isSortable(),
    sort: isSortedColumn('name')
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.name'
  })), isSortedColumn('name') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection(),
    size: SortDirectionIcon.SIZE.STANDARD
  })), /*#__PURE__*/React__default.createElement(Resizer, {
    className: 'resizer',
    "data-userpilot": 'task-resizer',
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e);
    }
  }))), columns.assignedPerson && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('assigned');
    },
    sort: isSortedColumn('assigned'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.assignees'
  })), isSortedColumn('assigned') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.owner && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, intl.formatMessage({
    id: 'common.owner'
  })), columns.client && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('client');
    },
    sort: isSortedColumn('client'),
    sortable: isSortable
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.client'
  })), isSortedColumn('client') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    size: SortDirectionIcon.SIZE.STANDARD,
    direction: getSortDirection()
  }))), columns.status && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166,
    "data-userpilot": 'task-row-header-status'
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('status');
    },
    sort: isSortedColumn('status'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.status'
  })), isSortedColumn('status') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.startDate && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 90
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('start_date');
    },
    sort: isSortedColumn('start_date'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.start_date'
  })), isSortedColumn('start_date') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.deadline && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 90
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('deadline');
    },
    sort: isSortedColumn('deadline'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.deadline'
  })), isSortedColumn('deadline') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.phase && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, {
    onClick: function onClick() {
      return handleSortByClick('phase');
    },
    sort: isSortedColumn('phase'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.phase'
  })), isSortedColumn('phase') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.progress && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 70,
    title: intl.formatMessage({
      id: 'common.progress'
    })
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, null, /*#__PURE__*/React__default.createElement(NumberColumn, null, intl.formatMessage({
    id: 'common.progress.short'
  })))), columns.estimate && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 60
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, null, /*#__PURE__*/React__default.createElement(NumberColumn, null, intl.formatMessage({
    id: 'common.estimate'
  })))), columns.timeEntries && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 80
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, null, /*#__PURE__*/React__default.createElement(NumberColumn, null, intl.formatMessage({
    id: 'common.time_entries'
  })), isSortedColumn('time entries') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.remaining && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 60
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, null, /*#__PURE__*/React__default.createElement(NumberColumn, null, intl.formatMessage({
    id: 'common.remaining'
  })), isSortedColumn('remaining') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.labels && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer, null, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.labels'
  })))), columns.star && /*#__PURE__*/React__default.createElement(StaticTableRowItem, {
    width: 14
  }), /*#__PURE__*/React__default.createElement(InvisibleTableRowItem, {
    width: 16
  }), /*#__PURE__*/React__default.createElement(CornerTableRowItem, {
    width: 14
  }));
};
TaskRowHeader.propTypes = {
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  }),
  /**
   * value of the css element top if the header should be on position sticky
   */
  stickyTopPosition: PropTypes__default.number,
  /**
   * Elements to show (or not) in the row
   */
  columns: PropTypes__default.shape({
    checkbox: PropTypes__default.bool,
    projectId: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    taskId: PropTypes__default.bool,
    assignedPerson: PropTypes__default.bool,
    owner: PropTypes__default.bool,
    client: PropTypes__default.bool,
    status: PropTypes__default.bool,
    startDate: PropTypes__default.bool,
    deadline: PropTypes__default.bool,
    phase: PropTypes__default.bool,
    progress: PropTypes__default.bool,
    estimate: PropTypes__default.bool,
    timeEntries: PropTypes__default.bool,
    remaining: PropTypes__default.bool,
    labels: PropTypes__default.bool,
    star: PropTypes__default.bool
  }).isRequired,
  onSortByChange: PropTypes__default.func,
  /**
   * Neccessary information to know the context of the list.
   * Lists in a containers are the one in sprints or miletsones.
   */
  isInContainer: PropTypes__default.bool,
  tracking: PropTypes__default.object,
  sortBy: PropTypes__default.shape({
    column: PropTypes__default.string,
    ascending: PropTypes__default.bool
  })
};
TaskRowHeader.defaultProps = {
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  },
  tracking: {
    trackEvent: function trackEvent(_ref3) {
      var tracked = _ref3.tracked;
      return tracked;
    }
  },
  stickyTopPosition: null,
  sortBy: {
    column: null,
    ascending: true
  }
};
var _templateObject$Q, _templateObject2$q, _templateObject3$j, _templateObject4$d, _templateObject5$9, _templateObject6$7, _templateObject7$6, _templateObject8$6, _templateObject9$5, _templateObject10$5, _templateObject11$5, _templateObject12$5, _templateObject13$5, _templateObject14$5, _templateObject15$5, _templateObject16$4, _templateObject17$4, _templateObject18$3, _templateObject19$3, _templateObject20$3, _templateObject21$2, _templateObject22$1;
var getBackgroundColorStyle$2 = function getBackgroundColorStyle(props) {
  if (props.isSelected) return '#f0e7fc';else if (props.isFavoured) return '#fefdf3';else return '#fff';
};
var getBorderColor$2 = function getBorderColor(props) {
  if (props.isSelected) return '#6e0fea';
  if (props.isFavoured) return '#e6e6e6';else return '#e6e6e6';
};
var TaskItemsContainer$1 = Styled__default.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n\tmargin-right: 16px;\n"])));
var LoaderContainer$1 = Styled__default.div(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight:237.19px;\n"])));
var Line$1 = Styled__default.div(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n\toverflow: hidden;\n\tposition: relative;\n\theight: auto;\n"])));
var TaskContainer$1 = Styled__default.div(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n\t\n"])));
var TableRow$2 = Styled__default.div(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral(["\n\toutline: none;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tjustify-content: stretch;\n\talign-items: center;\n\theight: 48px;\n\toverflow:hidden;\n\t\n"])));
var TableRowHeader$1 = Styled__default(TableRow$2)(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral(["\n\tfont-size: 9px;\n\tline-height: 1;\n\tletter-spacing: 1px;\n\tcolor: #a1a1a1;\n\tfont-weight: 500;\n\tmargin-right: 16px;\n\ttext-transform: uppercase;\n\tz-index:1;\n\tbackground:", "; \n\t", ";\n\t", ";\n\tborder-bottom:  ", ";\n\twidth: 100%;\n\theight: 40px;\n\t// padding-bottom:8px;\n\t>div{\n\t\tborder-radius: 1px;\n\t\t>div{\n\t\t\tpadding-top: 8px;\n\t\t\tpadding-bottom: 8px;\n\t\t}\n\t}\n"])), function (props) {
  return props.isInContainer ? '#f3f3f3' : '#f5f5f8';
}, function (props) {
  return props.stickyTopPosition !== null ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null ? 'top:' + props.stickyTopPosition + 'px;' : '';
}, function (props) {
  return '1px solid ' + getBorderColor$2(props);
});
var TaskItemTableRow$1 = Styled__default(TableRow$2)(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral(["\n\tfont-size: 13px;\n\tposition: relative;\n\tcolor: #535353;\n\tborder-bottom:  ", ";\t\t\t\n\t>div{\n\t\t/*border to on each sub element because of the corner at the end of the row*/\n\t\tbackground:", ";\n\t\ttransition: background-color 0.2s ease;\t\t\n\t\t&.context-menu{\n\t\t\t>span {\n\t\t\t\topacity:0;\n\t\t\t}\n\t\t}\n\t\t.time-registration-icon{\n\t\t\t\topacity:0;\n\t\t}\n\t}\n\t&:hover{\n\t\t>div{\n\t\t\t/*border to on each sub element because of the corner at the end of the row*/\n\t\t\tbackground: #f3f3f3;\n\t\t\ttransition: background-color 0.2s ease;\n\t\t\t&.context-menu{\n\t\t\t\t>span {\n\t\t\t\t\topacity:1;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.time-registration-icon{\n\t\t\t\topacity:1;\n\t\t\t}\n\t\t}\n\t}\n\t.clickable{\n\t\tcursor: pointer;\n\t\ttext-decoration: none;\n\t\tcolor: #535353;\n\t\toutline:none;\n\t\t&:hover{\n\t\t\tcolor: #6f49c5;\n\t\t}\n\t}\n"])), function (props) {
  return '1px solid ' + getBorderColor$2(props);
}, function (props) {
  return getBackgroundColorStyle$2(props);
});
var NumberColumn$1 = Styled__default.span(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteral(["\n\ttext-align:right;\n\tflex:1;\n"])));
var TableHeaderItemContainer$1 = Styled__default.div(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tcursor:", ";;\n\tp  {\n\t\tdisplay: inline-block;\n\t}\n\tcolor: ", ";\n\t&:hover {\n\t\tcolor: ", ";\n\t\ttransition:color 0.2s ease;\n\t}\n"])), function (props) {
  return props.sortable && 'pointer';
}, function (props) {
  return props.sort && '#6e0fea';
}, function (props) {
  return props.sortable && '#6e0fea';
});
var TableRowItem$1 = Styled__default.div(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteral(["\n\tbox-sizing: content-box;\n\tpadding-top: 0;\n\tpadding-bottom: 0;\n\theight: 100%;\n\tpadding-left: 16px;\n    user-select: none; //avoid the selection when resizing\t\n\tspan {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\t/*TODO delete when a propper dropdown has been made*/\n\t.drop-down-v2, .unfocused-assigned-container, .focused-assigned-container{\n\t\tbox-sizing:border-box;\n\t}\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
var StaticTableRowItem$1 = Styled__default(TableRowItem$1)(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteral(["\n\tmin-width: ", ";\n\tmax-width: ", ";\n\twidth: ", ";\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\t\n"])), function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
});
var StaticTableRowItemMultiple$1 = Styled__default(StaticTableRowItem$1)(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteral(["\n\tjustify-content: flex-end;\n"])));
var InvisibleTableRowItem$1 = Styled__default(StaticTableRowItem$1)(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteral(["\n\tpadding-left:0;\n"])));
var CornerTableRowItem$1 = Styled__default(TableRowItem$1)(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteral(["\n\tmin-width: ", ";\n\tmax-width: ", ";\n\twidth: ", ";\n\theight: 100%;\n\tbackground:none;\n\tmargin:0;\n    padding:0;\n"])), function (props) {
  return props.width ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width ? props.width + 'px' : 'auto';
});
var GrowableTableRowItem$1 = Styled__default(TableRowItem$1)(_templateObject15$5 || (_templateObject15$5 = _taggedTemplateLiteral(["\n\tflex: 1;\n\theight: 100%;\n\tdisplay: grid;\n\talign-content: space-evenly;\n\talign-items: center;\n\tmin-width:200px;\n\t", ";\n\t", "\n\t\n\tdiv{\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\tspan{\n\t\tmargin-right:5px;\n\t}\n\t.header{\n\t\theight:100%;\n\t\tdisplay:flex;\n\t\tjustify-content:space-between;\n\t}\n\t .resizer{\n\t\topacity:", ";\n\t}\n\t&:hover{\n\t\tbackground:rgba(0, 0, 0, 0.05);\n\t\t.resizer{\n\t\t\topacity:1;\n\t\t}\n\t} \n"])), function (props) {
  return 'width:' + props.width + 'px;';
}, function (props) {
  return props.resizing ? 'background:rgba(0, 0, 0, 0.05);' : null;
}, function (props) {
  return props.resizing ? 1 : 0;
});
var Resizer$1 = Styled__default.div(_templateObject16$4 || (_templateObject16$4 = _taggedTemplateLiteral(["\n\twidth:4px;\n\tfont-weight:900;\n\tcursor:col-resize;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: rgba(0, 0, 0, 0.2);\n\theight:100%;\n\tborder-radius: 1px;\n"])));
var Container$b = Styled__default.div(_templateObject17$4 || (_templateObject17$4 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
var NestedDropdownStyle$1 = Styled__default.div(_templateObject18$3 || (_templateObject18$3 = _taggedTemplateLiteral(["\n\tmargin: 5px 0 0 0;\n\twidth: 340px;\n"])));
var Row$1 = Styled__default.div(_templateObject19$3 || (_templateObject19$3 = _taggedTemplateLiteral(["\n\tmargin-bottom: ", ";\n"])), function (props) {
  return props.last ? '0px' : '24px';
});
var Text$5 = Styled__default.p(_templateObject20$3 || (_templateObject20$3 = _taggedTemplateLiteral(["\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 13px;\n\tcolor: #535353;\n\tmax-width: 702px;\n"])));
var TimeRegPopup$1 = Styled__default.div(_templateObject21$2 || (_templateObject21$2 = _taggedTemplateLiteral(["\n\tmargin-right:5px;\n\theight: 20px;// the height of the svg\n"])));
var TaskParentName = Styled__default.div(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteral(["\n\tcolor: #A5A5AE;\n\tfont-size: 11px;\n"])));
var TaskRow$1 = function TaskRow(_ref) {
  var checkboxIcon = _ref.checkboxIcon,
    isSelected = _ref.isSelected,
    isFavoured = _ref.isFavoured,
    taskId = _ref.taskId,
    taskName = _ref.taskName,
    parentTaskName = _ref.parentTaskName,
    projectName = _ref.projectName,
    clientName = _ref.clientName,
    openCardModal = _ref.openCardModal,
    projectIndicatorIcon = _ref.projectIndicatorIcon,
    assigneesElement = _ref.assigneesElement,
    ownerElement = _ref.ownerElement,
    statusElement = _ref.statusElement,
    startDate = _ref.startDate,
    deadline = _ref.deadline,
    progress = _ref.progress,
    phase = _ref.phase,
    estimate = _ref.estimate,
    timeEntries = _ref.timeEntries,
    timeRegPopup = _ref.timeRegPopup,
    remaining = _ref.remaining,
    labels = _ref.labels,
    starIcon = _ref.starIcon,
    _onContextMenu = _ref.onContextMenu,
    contextMenuElement = _ref.contextMenuElement,
    columns = _ref.columns,
    isBug = _ref.isBug,
    isHighPriority = _ref.isHighPriority,
    isBlocked = _ref.isBlocked,
    cy = _ref.cy,
    intl = _ref.intl,
    noTimeReg = _ref.noTimeReg,
    progressRegistrationPopup = _ref.progressRegistrationPopup;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line$1, {
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(TaskItemTableRow$1, {
    isSelected: isSelected,
    isFavoured: isFavoured,
    onContextMenu: function onContextMenu(e) {
      return _onContextMenu ? _onContextMenu(e) : {};
    }
  }, columns.checkbox && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 18
  }, checkboxIcon({
    checked: isSelected
  })), columns.projectId && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 50,
    "data-userpilot": 'task-row-project-indicator'
  }, projectIndicatorIcon), columns.projectName && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166,
    "data-userpilot": 'task-row-project-name'
  }, /*#__PURE__*/React__default.createElement("span", {
    title: projectName
  }, projectName)), columns.taskId && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 60
  }, /*#__PURE__*/React__default.createElement("a", {
    className: openCardModal ? 'clickable' : '',
    "data-cy": "task-name",
    onKeyDown: openCardModal ? function (e) {
      return e.key === ' ' || e.key === 'Enter' ? openCardModal(e) : null;
    } : null,
    onClick: openCardModal ? function (e) {
      return openCardModal(e);
    } : null,
    href: window.location.href + (window.location.href.endsWith('/') ? 'T' + taskId : '/T' + taskId),
    tabIndex: '0',
    title: taskName
  }, "T", taskId)), /*#__PURE__*/React__default.createElement(GrowableTableRowItem$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: openCardModal ? 'clickable' : '',
    "data-cy": "task-name",
    onKeyDown: openCardModal ? function (e) {
      return e.key === ' ' || e.key === 'Enter' ? openCardModal(e) : null;
    } : null,
    onClick: openCardModal ? function (e) {
      return openCardModal(e);
    } : null,
    href: window.location.href + (window.location.href.endsWith('/') ? 'T' + taskId : '/T' + taskId),
    tabIndex: '0',
    title: taskName
  }, parentTaskName && /*#__PURE__*/React__default.createElement(TaskParentName, null, parentTaskName), /*#__PURE__*/React__default.createElement(PriorityIcon, {
    intl: intl,
    shouldShow: isHighPriority
  }), /*#__PURE__*/React__default.createElement(BugIcon, {
    intl: intl,
    shouldShow: isBug
  }), /*#__PURE__*/React__default.createElement(BlockedIcon, {
    intl: intl,
    shouldShow: isBlocked
  }), taskName)), columns.assignedPerson && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, assigneesElement ? assigneesElement : /*#__PURE__*/React__default.createElement("div", null, "Person dropdown")), columns.owner && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, ownerElement ? ownerElement : /*#__PURE__*/React__default.createElement("div", null, "Owner Dropdown")), columns.client && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166,
    "data-userpilot": 'task-row-client'
  }, /*#__PURE__*/React__default.createElement("span", {
    title: clientName
  }, clientName)), columns.status && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, statusElement ? statusElement : /*#__PURE__*/React__default.createElement("div", null, "Status dropdown")), columns.startDate && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 90
  }, /*#__PURE__*/React__default.createElement("span", null, startDate)), columns.deadline && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 90
  }, /*#__PURE__*/React__default.createElement("span", null, deadline)), columns.phase && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, /*#__PURE__*/React__default.createElement("span", {
    title: phase
  }, phase)), columns.progress && (noTimeReg ? /*#__PURE__*/React__default.createElement(StaticTableRowItemMultiple$1, {
    width: 70
  }, /*#__PURE__*/React__default.createElement(TimeRegPopup$1, null, progressRegistrationPopup), progress) : /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 70
  }, /*#__PURE__*/React__default.createElement(NumberColumn$1, null, progress))), columns.estimate && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 60
  }, /*#__PURE__*/React__default.createElement(NumberColumn$1, null, estimate)), columns.timeEntries && /*#__PURE__*/React__default.createElement(StaticTableRowItemMultiple$1, {
    width: 80
  }, /*#__PURE__*/React__default.createElement(TimeRegPopup$1, null, timeRegPopup), timeEntries), columns.remaining && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 60
  }, /*#__PURE__*/React__default.createElement(NumberColumn$1, null, remaining)), columns.labels && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(LabelGroup, {
    labels: labels,
    overflowStyle: 'TOOLTIP'
  })), columns.star && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 14,
    "data-userpilot": 'task-row-star'
  }, starIcon && starIcon({
    isFavoured: isFavoured
  })), _onContextMenu && /*#__PURE__*/React__default.createElement(InvisibleTableRowItem$1, {
    width: 16,
    className: 'context-menu'
  }, /*#__PURE__*/React__default.createElement(KebabMenuIcon, {
    onClick: function onClick(e) {
      return _onContextMenu(e);
    }
  })), /*#__PURE__*/React__default.createElement(InvisibleTableRowItem$1, {
    width: 14
  }))), contextMenuElement && contextMenuElement());
};
TaskRow$1.propTypes = {
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  }),
  /**
   * The checkbox icon from web-components, optionally wrapped in another component
   */
  checkboxIcon: PropTypes__default.func.isRequired,
  /**
   * Toggles selected visual on row
   */
  isSelected: PropTypes__default.bool,
  /**
   * Task favourit status
   */
  isFavoured: PropTypes__default.bool,
  /**
   * The star icon from web-components, optionally wrapped in another component
   */
  starIcon: PropTypes__default.func,
  /**
   * Company Task id
   */
  taskId: PropTypes__default.number.isRequired,
  /**
   * Name of the task
   */
  taskName: PropTypes__default.string.isRequired,
  /**
   * Name of the parent task (Using task hierarchy)
   */
  parentTaskName: PropTypes__default.string,
  /**
   * Name of the project
   */
  projectName: PropTypes__default.string.isRequired,
  /**
   * Name of the client attached to the project
   */
  clientName: PropTypes__default.string,
  /**
   * Function used to open the Task Modal
   */
  openCardModal: PropTypes__default.func,
  /**
   * Project IndicatorIcon from web-components, optionally wrapped in another component
   */
  projectIndicatorIcon: PropTypes__default.func.isRequired,
  /**
   *    Dropdown containing the status of the task
   */
  statusElement: PropTypes__default.func,
  /**
   *    Dropdown for the assignees of the task
   */
  assigneesElement: PropTypes__default.func,
  /**
   *    Dropdown for the owners of the task
   */
  ownerElement: PropTypes__default.func,
  /**
   * Phase name of the task
   */
  phase: PropTypes__default.string,
  /**
   * Start date of the task, in the format "10 May"
   */
  startDate: PropTypes__default.any,
  /**
   * Deadline of the task, in the format "10 May"
   */
  deadline: PropTypes__default.any,
  /**
   * Progress of the task as percentage
   */
  progress: PropTypes__default.string,
  /**
   * Remaining time of the task, in time format
   */
  remaining: PropTypes__default.string,
  /**
   * Time estimated for the task, in time format
   */
  estimate: PropTypes__default.string,
  /**
   * Time registered on the task, in time format
   */
  timeEntries: PropTypes__default.string,
  /**
   * Pop op next to the time entries to add time to the task
   */
  timeRegPopup: PropTypes__default.node,
  /**
   * An array of label definitions
   */
  labels: PropTypes__default.arrayOf(PropTypes__default.shape({
    /**
     * The name of the label, which is also displayed as text
     */
    name: PropTypes__default.string.isRequired,
    /**
     * The color of the label. Text color will be the inverse of this
     */
    color: PropTypes__default.string.isRequired
  })),
  /**
   * Function to open the context menu
   */
  onContextMenu: PropTypes__default.func,
  /**
   * Context menu
   */
  contextMenuElement: PropTypes__default.func,
  /**
   * Elements to show (or not) in the row
   */
  columns: PropTypes__default.shape({
    checkbox: PropTypes__default.bool,
    projectId: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    taskId: PropTypes__default.bool,
    assignedPerson: PropTypes__default.bool,
    owner: PropTypes__default.bool,
    client: PropTypes__default.bool,
    status: PropTypes__default.bool,
    startDate: PropTypes__default.bool,
    deadline: PropTypes__default.bool,
    phase: PropTypes__default.bool,
    progress: PropTypes__default.bool,
    estimate: PropTypes__default.bool,
    timeEntries: PropTypes__default.bool,
    remaining: PropTypes__default.bool,
    labels: PropTypes__default.bool,
    star: PropTypes__default.bool
  }).isRequired,
  /**
   * Task indicator: bug
   */
  isBug: PropTypes__default.bool,
  /**
   * Task indicator:high priority
   */
  isHighPriority: PropTypes__default.bool,
  /**
   * Task indicator: blocked
   */
  isBlocked: PropTypes__default.bool,
  /**
   * Cypress data information
   */
  cy: PropTypes__default.string,
  /**
   * Determin wheter or not the user has no time registration enabled
   * If true, no time registration is enabled
   */
  noTimeReg: PropTypes__default.bool,
  /**
   * Popup for entering progress for a task where time registration is not used
   */
  progressRegistrationPopup: PropTypes__default.node
};
TaskRow$1.defaultProps = {
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  },
  openCardModal: function openCardModal() {
    return false;
  }
};
var TaskRowHeader$1 = function TaskRowHeader(_ref) {
  var intl = _ref.intl,
    columns = _ref.columns,
    sortBy = _ref.sortBy,
    onSortByChange = _ref.onSortByChange,
    stickyTopPosition = _ref.stickyTopPosition,
    isInContainer = _ref.isInContainer,
    tracking = _ref.tracking;
  var taskNameColumn = React.useRef(null);
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    taskWidth = _useState2[0],
    setTaskWidth = _useState2[1];
  var _useState3 = React.useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    originalTaskWidth = _useState4[0],
    _setOriginalTaskWidth = _useState4[1];
  var originalTaskWidthRef = React.useRef(originalTaskWidth);
  var setOriginalTaskWidth = function setOriginalTaskWidth(data) {
    originalTaskWidthRef.current = data;
    _setOriginalTaskWidth(data);
  };
  var _useState5 = React.useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    mouseDownPositionX = _useState6[0],
    _setMouseDownPositionX = _useState6[1];
  var mouseDownPositionXRef = React.useRef(mouseDownPositionX);
  var setMouseDownPositionX = function setMouseDownPositionX(data) {
    mouseDownPositionXRef.current = data;
    _setMouseDownPositionX(data);
  };
  var handleSortByClick = function handleSortByClick(name) {
    // not allowing sort by
    if (!onSortByChange) {
      return;
    }
    var sortByCopy = _objectSpread2({}, sortBy);
    if (name === sortByCopy.column) {
      if (sortByCopy.ascending) {
        sortByCopy.ascending = false;
      } else {
        sortByCopy.column = null;
      }
    } else {
      sortByCopy.column = name;
      sortByCopy.ascending = true;
    }
    onSortByChange(sortByCopy);
  };
  var isSortedColumn = function isSortedColumn(name) {
    return sortBy.column === name;
  };
  var getSortDirection = function getSortDirection() {
    return sortBy.ascending ? SortDirectionIcon.DIRECTION.UP : SortDirectionIcon.DIRECTION.DOWN;
  };
  var isSortable = function isSortable() {
    return !!onSortByChange;
  };
  var onMouseMove = function onMouseMove(e) {
    if (mouseDownPositionXRef.current > 0) {
      var distance = e.x - mouseDownPositionXRef.current;
      var newVal = originalTaskWidthRef.current + distance;
      if (taskWidth === null) {
        //there is a 32px jump I haven't identified yet
        setTaskWidth(newVal > 200 ? newVal - 32 : null);
      } else {
        setTaskWidth(newVal > 200 ? newVal : null);
      }
    }
  };
  var handleMouseDown = function handleMouseDown(e) {
    setMouseDownPositionX(e.nativeEvent.x);
    setOriginalTaskWidth(taskWidth || taskNameColumn.current.getBoundingClientRect().width);
    document.getElementById('app').style.cursor = 'col-resize';
    window.addEventListener('mouseup', onMouseUpHandler);
    window.addEventListener('mousemove', onMouseMove);
  };
  var onMouseUpHandler = function onMouseUpHandler() {
    setMouseDownPositionX(-1);
    tracking.trackEvent('Task Name resized');
    document.getElementById('app').style.cursor = 'inherit';
    window.removeEventListener('mouseup', onMouseUpHandler);
    window.removeEventListener('mousemove', onMouseMove);
    return false;
  };
  return /*#__PURE__*/React__default.createElement(TableRowHeader$1, {
    stickyTopPosition: stickyTopPosition,
    isInContainer: isInContainer
  }, columns.checkbox && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 18
  }), columns.projectId && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 50
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('project');
    },
    sort: isSortedColumn('project'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.project_id_short'
  })), isSortedColumn('project') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    size: SortDirectionIcon.SIZE.STANDARD,
    direction: getSortDirection()
  }))), columns.projectName && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('project-name');
    },
    sort: isSortedColumn('project-name'),
    sortable: isSortable
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.project-name'
  })), isSortedColumn('project-name') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    size: SortDirectionIcon.SIZE.STANDARD,
    direction: getSortDirection()
  }))), columns.taskId && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 50
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('id');
    },
    sort: isSortedColumn('id'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.id'
  })), isSortedColumn('id') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), /*#__PURE__*/React__default.createElement(GrowableTableRowItem$1, {
    ref: taskNameColumn,
    width: taskWidth,
    resizable: true,
    resizing: mouseDownPositionX > -1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'header'
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('name');
    },
    sortable: isSortable(),
    sort: isSortedColumn('name')
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.name'
  })), isSortedColumn('name') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection(),
    size: SortDirectionIcon.SIZE.STANDARD
  })), /*#__PURE__*/React__default.createElement(Resizer$1, {
    className: 'resizer',
    "data-userpilot": 'task-resizer',
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown(e);
    }
  }))), columns.assignedPerson && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('assigned');
    },
    sort: isSortedColumn('assigned'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.assignees'
  })), isSortedColumn('assigned') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.owner && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, intl.formatMessage({
    id: 'common.owner'
  })), columns.client && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('client');
    },
    sort: isSortedColumn('client'),
    sortable: isSortable
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.client'
  })), isSortedColumn('client') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    size: SortDirectionIcon.SIZE.STANDARD,
    direction: getSortDirection()
  }))), columns.status && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166,
    "data-userpilot": 'task-row-header-status'
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('status');
    },
    sort: isSortedColumn('status'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.status'
  })), isSortedColumn('status') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.startDate && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 90
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('start_date');
    },
    sort: isSortedColumn('start_date'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.start_date'
  })), isSortedColumn('start_date') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.deadline && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 90
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('deadline');
    },
    sort: isSortedColumn('deadline'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.deadline'
  })), isSortedColumn('deadline') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.phase && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, {
    onClick: function onClick() {
      return handleSortByClick('phase');
    },
    sort: isSortedColumn('phase'),
    sortable: isSortable()
  }, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.phase'
  })), isSortedColumn('phase') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.progress && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 70,
    title: intl.formatMessage({
      id: 'common.progress'
    })
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, null, /*#__PURE__*/React__default.createElement(NumberColumn$1, null, intl.formatMessage({
    id: 'common.progress.short'
  })))), columns.estimate && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 60
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, null, /*#__PURE__*/React__default.createElement(NumberColumn$1, null, intl.formatMessage({
    id: 'common.estimate'
  })))), columns.timeEntries && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 80
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, null, /*#__PURE__*/React__default.createElement(NumberColumn$1, null, intl.formatMessage({
    id: 'common.time_entries'
  })), isSortedColumn('time entries') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.remaining && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 60
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, null, /*#__PURE__*/React__default.createElement(NumberColumn$1, null, intl.formatMessage({
    id: 'common.remaining'
  })), isSortedColumn('remaining') && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
    direction: getSortDirection()
  }))), columns.labels && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 166
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$1, null, /*#__PURE__*/React__default.createElement("p", null, intl.formatMessage({
    id: 'common.labels'
  })))), columns.star && /*#__PURE__*/React__default.createElement(StaticTableRowItem$1, {
    width: 14
  }), /*#__PURE__*/React__default.createElement(InvisibleTableRowItem$1, {
    width: 16
  }), /*#__PURE__*/React__default.createElement(InvisibleTableRowItem$1, {
    width: 14
  }));
};
TaskRowHeader$1.propTypes = {
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  }),
  /**
   * value of the css element top if the header should be on position sticky
   */
  stickyTopPosition: PropTypes__default.number,
  /**
   * Elements to show (or not) in the row
   */
  columns: PropTypes__default.shape({
    checkbox: PropTypes__default.bool,
    projectId: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    taskId: PropTypes__default.bool,
    assignedPerson: PropTypes__default.bool,
    owner: PropTypes__default.bool,
    client: PropTypes__default.bool,
    status: PropTypes__default.bool,
    startDate: PropTypes__default.bool,
    deadline: PropTypes__default.bool,
    phase: PropTypes__default.bool,
    progress: PropTypes__default.bool,
    estimate: PropTypes__default.bool,
    timeEntries: PropTypes__default.bool,
    remaining: PropTypes__default.bool,
    labels: PropTypes__default.bool,
    star: PropTypes__default.bool
  }).isRequired,
  onSortByChange: PropTypes__default.func,
  /**
   * Neccessary information to know the context of the list.
   * Lists in a containers are the one in sprints or miletsones.
   */
  isInContainer: PropTypes__default.bool,
  tracking: PropTypes__default.object,
  sortBy: PropTypes__default.shape({
    column: PropTypes__default.string,
    ascending: PropTypes__default.bool
  })
};
TaskRowHeader$1.defaultProps = {
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  },
  tracking: {
    trackEvent: function trackEvent(_ref3) {
      var tracked = _ref3.tracked;
      return tracked;
    }
  },
  stickyTopPosition: null,
  sortBy: {
    column: null,
    ascending: true
  }
};
var _templateObject$R, _templateObject2$r, _templateObject3$k, _templateObject4$e, _templateObject5$a, _templateObject6$8, _templateObject7$7, _templateObject8$7, _templateObject9$6, _templateObject10$6, _templateObject11$6, _templateObject12$6, _templateObject13$6, _templateObject14$6, _templateObject15$6, _templateObject16$5, _templateObject17$5, _templateObject18$4, _templateObject19$4, _templateObject20$4;
var getBorderColor$3 = function getBorderColor(props) {
  return props.theme.colors.veryLightGray;
};
var TaskItemsContainer$2 = Styled__default.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n\tmargin-right: 16px;\n"])));
var LoaderContainer$2 = Styled__default.div(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight:237.19px;\n"])));
var Line$2 = Styled__default.div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n\tposition: relative;\n\theight: auto;\n\t&:last-of-type{\n\t\t> div{\n\t\t\tborder-bottom: ", ";\n\t\t}\n\t}\n"])), function (props) {
  return '1px solid ' + getBorderColor$3(props);
});
var TableRow$3 = Styled__default.div(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n\toutline: none;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tjustify-content: stretch;\n\talign-items: ", ";\n"])), function (props) {
  return props.header && props.entryRow ? 'center' : 'flex-start';
});
var TableRowHeader$2 = Styled__default(TableRow$3)(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral(["\n\tfont-size: 9px;\n\tline-height: 1;\n\tletter-spacing: 1px;\n\tcolor: #a1a1a1;\n\tfont-weight: 500;\n\tz-index:2;\n\t", ";\n\t", ";\n\t", ";\n\twidth: 100%;\n\theight: 30px;\n\tmargin-bottom:1px;\n\t>div{\n\t\tborder-radius: 1px;\n\t}\n"])), function (props) {
  return props.stickyTopPosition !== null ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null ? 'top:' + props.stickyTopPosition + 'px;' : '';
}, function (props) {
  return props.stickyTopPosition !== null ? 'background: white' : '';
});
var InvoiceItemTableRow = Styled__default(TableRow$3)(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral(["\n\tfont-size: 13px;\n\tposition: relative;\n\tcolor: ", ";\n\tborder: ", ";\n\t", ";\n\t", ";\n\tborder-bottom:none;\n\n\t&:hover{\n\t\tbackground:", ";\n\t\ttransition: background-color 0.2s ease;\n\t}\n\t.clickable{\n\t\tcursor: pointer;\n\t\ttext-decoration: none;\n\t\tcolor:", ";\n\t\toutline:none;\n\t\t&:hover{\n\t\t\tcolor:", ";\n\t\t}\n\t}\n"])), function (props) {
  return props.theme.colors.textGray;
}, function (props) {
  return '1px solid ' + getBorderColor$3(props);
}, function (props) {
  return props.entryRow ? 'border-left: 0px' : '';
}, function (props) {
  return props.entryRow ? 'border-right: 0px' : '';
}, function (props) {
  return props.customHoverBackground !== true ? props.theme.colors.mediumGray : 'white';
}, function (props) {
  return props.theme.colors.textGray;
}, function (props) {
  return props.theme.colors.hoverPurple;
});
var NumberColumn$2 = Styled__default.span(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteral(["\n\ttext-align:right;\n\tflex:1;\n\twidth: 100%;\n"])));
var TableHeaderItemContainer$2 = Styled__default.div(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteral(["\n\talign-items: center;\n\tdisplay: block;\n\tmin-height: 9px;\n\twidth: 100%;\n\tcursor:", ";\n\ttext-transform: uppercase;\n\ttext\n\tp  {\n\t\tdisplay: inline-block;\n\t\tmargin: 0;\n\t}\n\tcolor: ", ";\n\t&:hover {\n\t\tcolor: ", ";\n\t\ttransition:color 0.2s ease;\n\t}\n\t&.sub-header {\n\t\tmargin-top: 4px;\n\t\tmargin-bottom: 8px;\n\t\tdisplay: flex;\n\t}\n"])), function (props) {
  return props.sortable && 'pointer';
}, function (props) {
  return props.sort && props.theme.colors.forecastPurple;
}, function (props) {
  return props.sortable && props.theme.colors.forecastPurple;
});
var SubHeaderItem = Styled__default.div(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteral(["\n\twidth: ", ";\n\ttext-align: right;\n\t&:not(:first-child){\n\t\tpadding-left: 16px;\n\t}\n\t&.price {\n\t\tmin-width: 130px;\n\t}\n\t&.hours {\n\t\tmin-width: 80px;\n\t}\n"])), function (props) {
  return props.width !== undefined ? props.width + 'px' : '100%';
});
var TableRowItem$2 = Styled__default.div(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteral(["\n\tbox-sizing: content-box;\n\tpadding-top: ", "\n\tpadding-bottom: ", "\n\t", ";\t\n\tpadding-left: 16px;\n\talign-items: center;\n\tjustify-content: ", ";\n\t", ";\n\tspan {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\t/*TODO delete when a propper dropdown has been made*/\n\t.drop-down-v2, .unfocused-assigned-container, .focused-assigned-container{\n\t\tbox-sizing:border-box;\n\t}\n\twhite-space: nowrap;\n\t/* disabled because dropdwons are not visible */\n\t/* overflow: hidden;   */\n\ttext-overflow: ellipsis;\n\t&.price-small {\t\n\t\twidth: 110px;\n\t}\n\t&.price {\n\t\twidth: 110px;\n\t}\n\t&.fixed-price {\n\t\twidth: 110px;\n\t}\n\t&.hours {\n\t\tmin-width: 80px;\n\t}\n\t&.project {\n\t\tmin-width: 150px;\n\t}\n\t&.client {\n\t\tmin-width: 90px;\n\t}\n\t&.status {\n\t\twidth: 102px;\n\t\t.drop-down-v2 {\n\t\t\twidth: 102px;\n\t\t}\n\t}\n\t&.date {\n\t\tmin-width: 85px;\n\t}\n\t&.datepicker {\n\t\tmin-width: 140px;\n\t}\n\t&.hours-price-header {\n\t\twidth: 226px;\n\t}\n\t&.description {\n\t\t", ";\n\t\t&.has-error {\n\t\t\theight: 50px;\n\t\t}\n\t}\n\t&.quantity  {\n\t\tmin-width: 70px;\n\t}\n\t\n\t&.price-input  {\n\t\twidth: 110px;\n\t}\n\t\n\t&.percentage  {\n\t\tmin-width: 75px;\n\t}\n\t\n\t&.totalPrice  {\n\t\twidth: 110px;\n\t}\n\n\t&.invoiceId {\n\t\tmin-width: 29px;\n\n\t\t&:hover{\n\t\t\t", "\n\t\t\t", "\n\t\t}\n\t}\n\n\t&.invoiceName {\n\t\tmin-width: 110px;\n\n\t\t&:hover{\n\t\t\t", "\n\t\t\t", "\n\t\t}\n\t}\n\n\t&.name {\n\t\twidth: 110px;\n\t}\n\n\t&.paid {\n\t\tmin-width: 100px;\n\t}\n\n\t&.notes {\n\t\tjustify-content: flex-start;\n\t\tmin-width: 180px;\n\t}\n\t&.export {\n\t\tmin-width: 80px;\n\t}\n\t&.integration-links {\n\t\tmin-width: 80px;\n\t\tjustify-content: center;\n\t}\n\t&.xero-account {\n\t\tmin-width: 100px;\t\n\t}\n\t&.quickbooks-item {\n\t\tmin-width: 100px;\t\n\t}\n\t&.economic-product {\n\t\tmin-width: 130px;\t\n\t}\n\t&:last-child {\n\t\tpadding-right: 16px;\n\t}\n\t.tooltip-container {\n\t\twidth: 100%;\n\t}\n\t\n\t&.context-menu{\n\t\t&.entry-row {\n\t\t\tpadding-left: 0px;\n\t\t\tpadding-right: 0px;\n\t\t\tmargin-right: 15px;\n\t\t}\n\t\t>span {\n\t\t\tposition: unset;\n\t\t\tmargin: auto;\n\t\t}\n\t}\n"])), function (props) {
  return !props.header ? '9px;' : '0;';
}, function (props) {
  return !props.header ? '9px;' : '0;';
}, function (props) {
  return !props.header && props.customHeight === null ? 'height: 30px;' : props.customHeight !== null ? "height: ".concat(props.customHeight, "px;") : '';
}, function (props) {
  return props.alignRight === true ? 'flex-end' : 'flex-start';
}, function (props) {
  return props.alignRight === true ? 'text-align: right;' : '';
}, function (props) {
  return props.customWidth !== null ? "min-width: ".concat(props.customWidth, "px;") : 'min-width: 260px;';
}, function (props) {
  return !props.header ? 'cursor: pointer;' : null;
}, function (props) {
  return !props.header ? 'color: ' + props.theme.colors.forecastPurple + ';' : null;
}, function (props) {
  return !props.header ? 'cursor: pointer;' : null;
}, function (props) {
  return !props.header ? 'color: ' + props.theme.colors.forecastPurple + ';' : null;
});
var StaticTableRowItem$2 = Styled__default(TableRowItem$2)(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteral(["\n\tmin-width: ", ";\n\tmax-width: ", ";\n\twidth: ", ";\n\tdisplay: flex;\n\t", "\n\n\t&.project {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\t\n\t\tspan {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\n"])), function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
}, function (props) {
  return props.width !== undefined ? props.width + 'px' : 'auto';
}, function (props) {
  return props.multiLine === true ? 'flex-direction: column;' : '';
});
var StaticTableRowItemMultiple$2 = Styled__default(StaticTableRowItem$2)(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteral(["\n\tjustify-content: flex-end;\n"])));
var InvisibleTableRowItem$2 = Styled__default(StaticTableRowItem$2)(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteral(["\n\tpadding-left:0;\n"])));
var GrowableTableRowItem$2 = Styled__default(TableRowItem$2)(_templateObject14$6 || (_templateObject14$6 = _taggedTemplateLiteral(["\n\tflex: 1;\n\tdisplay: grid;\n\tmin-width:200px;\n\t", ";\n\t", "\n\t\n\tdiv{\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\tspan{\n\t\tmargin-right:5px;\n\t}\n\t .resizer{\n\t\topacity:", ";\n\t}\n\t&.project, &.invoiceName {\n\t\tdisplay: flex;\n\t\tflex-direction: ", ";\n\t\t&:not(.entry-row) {\n\t\t\t", "\n\t\t}\n\t\t&.entry-row {\n\t\t\tborder-left: 0px;\n\t\t\tpadding-left: 0px;\n\t\t\tspan {\n\t\t\t\tmargin-right: 0px;\n\t\t\t}\n\t\t}\n\t\ta {\n\t\t\tmargin-right: 16px;\n\t\t}\n\t\tspan {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n"])), function (props) {
  return 'width:' + props.width + 'px;';
}, function (props) {
  return props.resizing ? 'background:rgba(0, 0, 0, 0.05);' : null;
}, function (props) {
  return props.resizing ? 1 : 0;
}, function (props) {
  return props.header ? 'column' : 'row';
}, function (props) {
  return props.header !== true ? 'border-right: 1px solid ' + getBorderColor$3(props) + ';' : '';
});
var Container$c = Styled__default.div(_templateObject15$6 || (_templateObject15$6 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
var NestedDropdownStyle$2 = Styled__default.div(_templateObject16$5 || (_templateObject16$5 = _taggedTemplateLiteral(["\n\tmargin: 5px 0 0 0;\n\twidth: 340px;\n"])));
var Row$2 = Styled__default.div(_templateObject17$5 || (_templateObject17$5 = _taggedTemplateLiteral(["\n\tmargin-bottom: ", ";\n"])), function (props) {
  return props.last ? '0px' : '24px';
});
var Text$6 = Styled__default.p(_templateObject18$4 || (_templateObject18$4 = _taggedTemplateLiteral(["\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 13px;\n\tcolor: #535353;\n\tmax-width: 702px;\n"])));
var TimeRegPopup$2 = Styled__default.div(_templateObject19$4 || (_templateObject19$4 = _taggedTemplateLiteral(["\n\tmargin-right:5px;\n\theight: 16px;// the height of the svg\n"])));
var ProjectIndicator = Styled__default.div(_templateObject20$4 || (_templateObject20$4 = _taggedTemplateLiteral(["\n\tflex-grow: 0;\n\toverflow: inherit !important;\n"])));
var _templateObject$S, _templateObject2$s;
var MeatballMenuStyled = Styled__default.span(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content:center;\n\tcursor:pointer;\n\twidth: 60px;\n\theight:30px;\n\tborder-radius: 4px;\n\tpadding-left: 15px;\n"])));
var StyledSVG$1 = Styled__default.svg(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n\talign-self:center;\n"])));
var MeatballMenuIcon = function MeatballMenuIcon(_ref) {
  var onClick = _ref.onClick,
    userpilot = _ref.userpilot,
    cy = _ref.cy;
  return /*#__PURE__*/React__default.createElement(MeatballMenuStyled, {
    style: {
      overflow: 'visible'
    },
    onClick: onClick,
    "data-userpilot": userpilot,
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(StyledSVG$1, {
    xmlns: "http://www.w3.org/2000/svg",
    height: "18px",
    width: "40px"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M-.107143-.07242846h24V23.927572h-24z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(-10 -3.0019999)",
    fill: "#757575"
  }, /*#__PURE__*/React__default.createElement("circle", {
    r: "2",
    cy: "12",
    cx: "12"
  }), /*#__PURE__*/React__default.createElement("circle", {
    r: "2",
    cy: "12",
    cx: "18"
  }), /*#__PURE__*/React__default.createElement("circle", {
    r: "2",
    cy: "12",
    cx: "24"
  }))));
};
MeatballMenuIcon.propTypes = {
  onClick: PropTypes__default.func,
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string
};
var InvoiceRow = function InvoiceRow(_ref) {
  var customProjectField = _ref.customProjectField,
    projectColumn = _ref.projectColumn,
    invoiceId = _ref.invoiceId,
    invoiceName = _ref.invoiceName,
    onInvoiceClick = _ref.onInvoiceClick,
    amounts = _ref.amounts,
    _onContextMenu = _ref.onContextMenu,
    contextMenuElement = _ref.contextMenuElement,
    columns = _ref.columns,
    cy = _ref.cy,
    client = _ref.client,
    description = _ref.description,
    hasDescriptionError = _ref.hasDescriptionError,
    quantity = _ref.quantity,
    unitPrice = _ref.unitPrice,
    tax = _ref.tax,
    discount = _ref.discount,
    totalPrice = _ref.totalPrice,
    status = _ref.status,
    name = _ref.name,
    date = _ref.date,
    dueDate = _ref.dueDate,
    isSelected = _ref.isSelected,
    onSelect = _ref.onSelect,
    simpleDate = _ref.simpleDate,
    datePickerDate = _ref.datePickerDate,
    notes = _ref.notes,
    integrationLinks = _ref.integrationLinks,
    isFirstRow = _ref.isFirstRow,
    isEntryRow = _ref.isEntryRow,
    isOverviewTab = _ref.isOverviewTab,
    isInvoicesTab = _ref.isInvoicesTab,
    xeroAccount = _ref.xeroAccount,
    quickbooksItem = _ref.quickbooksItem,
    economicProduct = _ref.economicProduct,
    sageIntacctLocation = _ref.sageIntacctLocation,
    sageIntacctAccount = _ref.sageIntacctAccount,
    customHeight = _ref.customHeight,
    customWidth = _ref.customWidth,
    showMeatballMenu = _ref.showMeatballMenu,
    customHoverBackground = _ref.customHoverBackground;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line$2, {
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(InvoiceItemTableRow, {
    onContextMenu: function onContextMenu(e) {
      return _onContextMenu(e);
    },
    entryRow: isEntryRow,
    customHoverBackground: customHoverBackground
  }, onSelect ? /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    alignLeft: true,
    "data-userpilot": 'project-checkbox'
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    checked: isSelected,
    onClick: onSelect
  }), ' ') : null, columns.simpleDate && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    alignLeft: true,
    className: 'date'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, simpleDate)), columns.datePicker && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    alignLeft: true,
    className: 'datepicker'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, datePickerDate)), columns.project && (customProjectField ? customProjectField : /*#__PURE__*/React__default.createElement(GrowableTableRowItem$2, {
    className: 'project ' + (isEntryRow ? 'entry-row' : ''),
    customHeight: customHeight
  }, projectColumn)), columns.name && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'name'
  }, /*#__PURE__*/React__default.createElement("span", null, name)), columns.notes && /*#__PURE__*/React__default.createElement(GrowableTableRowItem$2, {
    alignLeft: true,
    className: 'notes'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, notes)), columns.invoiceId && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'invoiceId',
    onClick: onInvoiceClick ? onInvoiceClick : null
  }, /*#__PURE__*/React__default.createElement("span", null, invoiceId)), columns.invoiceName && /*#__PURE__*/React__default.createElement(GrowableTableRowItem$2, {
    className: 'invoiceName',
    onClick: onInvoiceClick ? onInvoiceClick : null
  }, /*#__PURE__*/React__default.createElement("span", null, invoiceName)), columns.client && /*#__PURE__*/React__default.createElement(GrowableTableRowItem$2, {
    className: 'client'
  }, /*#__PURE__*/React__default.createElement("span", null, client)), (columns.uninvoicedTimeRegMinutes || columns.uninvoicedRetainerMinutes) && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'hours'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.uninvoicedMinutes)), columns.uninvoicedPrice && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.uninvoicedPrice)), columns.uninvoicedFixedPrice && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'fixed-price'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.uninvoicedPrice)), columns.uninvoicedExpenses && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.uninvoicedExpenses)), columns.uninvoicedAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.totalUninvoiced)), columns.overviewInvoicedAmount === true ? /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.invoicedAmount)) : null, columns.description && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'description' + (hasDescriptionError ? ' has-error' : ''),
    customHeight: customHeight,
    customWidth: customWidth
  }, /*#__PURE__*/React__default.createElement("span", null, description)), columns.xeroAccount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'xero-account',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement("span", null, xeroAccount)), columns.quickbooksItem && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'quickbooks-item',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement("span", null, quickbooksItem)), columns.economicProduct && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'economic-product',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement("span", null, economicProduct)), columns.sageIntacctAccount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'sageIntacct-account',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement("span", null, sageIntacctAccount)), columns.sageIntacctLocation && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'sageIntacct-location',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement("span", null, sageIntacctLocation)), columns.quantity && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'quantity',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, quantity)), columns.unitPrice && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-input',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, unitPrice)), columns.discount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'percentage',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, discount)), columns.tax && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'percentage',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, tax)), columns.totalPrice && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'totalPrice',
    customHeight: customHeight
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, totalPrice)), columns.status && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'status'
  }, /*#__PURE__*/React__default.createElement("span", null, status)), columns.date && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'date'
  }, /*#__PURE__*/React__default.createElement("span", null, date)), columns.invoicedAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-small'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.invoicedAmount)), columns.paidAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-small'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.paidAmount)), columns.paidInput && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-input'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.paidAmount)), columns.unpaidAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-small'
  }, /*#__PURE__*/React__default.createElement(NumberColumn$2, null, amounts.unpaidAmount)), columns.dueDate && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'date'
  }, /*#__PURE__*/React__default.createElement("span", null, dueDate)), columns.integrationLink && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'integration-links'
  }, integrationLinks), columns.hasContextMenu && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    customHeight: customHeight,
    width: showMeatballMenu !== true ? 20 : 30,
    className: 'context-menu ' + (isEntryRow ? 'entry-row' : '')
  }, showMeatballMenu !== true ? /*#__PURE__*/React__default.createElement(KebabMenuIcon, {
    onClick: function onClick(e) {
      return _onContextMenu(e);
    },
    cy: cy + '-context-menu',
    userpilot: isFirstRow ? 'context-menu-wrapper' + (isOverviewTab ? '-overview' : isInvoicesTab ? '-invoices' : '') : null
  }) : /*#__PURE__*/React__default.createElement(MeatballMenuIcon, {
    onClick: function onClick(e) {
      return _onContextMenu(e);
    },
    cy: cy + '-context-menu',
    userpilot: isFirstRow ? 'context-menu-wrapper' + (isOverviewTab ? '-overview' : isInvoicesTab ? '-invoices' : '') : null
  })))), contextMenuElement && contextMenuElement());
};
InvoiceRow.propTypes = {
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  }),
  projectColumn: PropTypes__default.string,
  customProjectField: PropTypes__default.string,
  description: PropTypes__default.string,
  unitPrice: PropTypes__default.string,
  customHeight: PropTypes__default.number,
  customWidth: PropTypes__default.number,
  showMeatballMenu: PropTypes__default.bool,
  customHoverBackground: PropTypes__default.bool,
  tax: PropTypes__default.string,
  discount: PropTypes__default.string,
  totalPrice: PropTypes__default.string,
  quantity: PropTypes__default.string,
  invoiceId: PropTypes__default.string,
  invoiceName: PropTypes__default.string,
  onInvoiceClick: PropTypes__default.func,
  simpleDate: PropTypes__default.string,
  datePickerDate: PropTypes__default.string,
  notes: PropTypes__default.string,
  name: PropTypes__default.string,
  /**
   * is project selected
   */
  isSelected: PropTypes__default.bool,
  /**
   * select callback
   */
  onSelect: PropTypes__default.func,
  /**
   * Client name
   */
  client: PropTypes__default.string,
  /**
   * Entry status dropdown
   */
  status: PropTypes__default.element,
  /**
   * Entry date
   */
  date: PropTypes__default.string,
  /**
   * Entry due date
   */
  dueDate: PropTypes__default.string,
  /**
   * paidAmount
   */
  paidAmount: PropTypes__default.string,
  /**
   * unpaidAmount
   */
  unpaidAmount: PropTypes__default.string,
  /**
   * Amounts of hours and prices
   */
  amounts: PropTypes__default.object,
  /**
   * Name of the project
   */
  invoicedAmount: PropTypes__default.number,
  /**
   * Name of the client attached to the project
   */
  clientName: PropTypes__default.string,
  /**
   * Currency of the company
   */
  currency: PropTypes__default.string,
  /**
   * Array of integration logos, or a string that says "Not exported"
   */
  integrationLinks: PropTypes__default.arrayOf(PropTypes__default.any),
  /**
   * Function to open the context menu
   */
  onContextMenu: PropTypes__default.func,
  /**
   * Context menu
   */
  contextMenuElement: PropTypes__default.func,
  /**
   * True if it*s the first row of the table
   */
  isFirstRow: PropTypes__default.bool,
  /**
   * True if it*s in the entries table
   */
  isEntryRow: PropTypes__default.bool,
  /**
   * True if description has an error
   */
  hasDescriptionError: PropTypes__default.bool,
  /**
   * True if it*s in the overview tab
   */
  isOverviewTab: PropTypes__default.bool,
  /**
   * True if it*s in the invoices tab
   */
  isInvoicesTab: PropTypes__default.bool,
  /**
   * True if it*s in a modal
   */
  isInModal: PropTypes__default.bool,
  /**
   * Xero Account dropdown
   */
  xeroAccount: PropTypes__default.element,
  /**
   * Quickbooks item dropdown
   */
  quickbooksItem: PropTypes__default.element,
  /**
   * E-conomic product dropdown
   */
  economicProduct: PropTypes__default.element,
  /**
   * Sage Intacct location dropdown
   */
  sageIntacctLocation: PropTypes__default.element,
  /**
   * Sage Intacct account dropdown
   */
  sageIntacctAccount: PropTypes__default.element,
  /**
   * Elements to show (or not) in the row
   */
  columns: PropTypes__default.shape({
    project: PropTypes__default.bool,
    invoiceName: PropTypes__default.bool,
    invoiceId: PropTypes__default.bool,
    uninvoicedTimeRegMinutes: PropTypes__default.bool,
    uninvoicedRetainerMinutes: PropTypes__default.bool,
    uninvoicedPrice: PropTypes__default.bool,
    uninvoicedFixedPrice: PropTypes__default.bool,
    uninvoicedExpenses: PropTypes__default.bool,
    uninvoicedAmount: PropTypes__default.bool,
    overviewInvoicedAmount: PropTypes__default.bool,
    client: PropTypes__default.bool,
    status: PropTypes__default.bool,
    name: PropTypes__default.bool,
    date: PropTypes__default.bool,
    dueDate: PropTypes__default.bool,
    invoicedAmount: PropTypes__default.bool,
    paidAmount: PropTypes__default.bool,
    paidInput: PropTypes__default.bool,
    unpaidAmount: PropTypes__default.bool,
    description: PropTypes__default.bool,
    unitPrice: PropTypes__default.bool,
    tax: PropTypes__default.bool,
    discount: PropTypes__default.bool,
    totalPrice: PropTypes__default.bool,
    quantity: PropTypes__default.bool,
    simpleDate: PropTypes__default.bool,
    datePicker: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    integrationLink: PropTypes__default.bool,
    hasContextMenu: PropTypes__default.bool,
    xeroAccount: PropTypes__default.bool,
    quickbooksItem: PropTypes__default.bool,
    economicProduct: PropTypes__default.bool,
    sageIntacctLocation: PropTypes__default.bool,
    sageIntacctAccount: PropTypes__default.bool
  }).isRequired,
  /**
   * Cypress data information
   */
  cy: PropTypes__default.string
};
InvoiceRow.defaultProps = {
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  }
};
var _templateObject$T, _templateObject2$t, _templateObject3$l;
var Wrapper = Styled__default.div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n\tposition: relative;\n"])));
var Tooltip$1 = Styled__default.div(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tpadding: 10px 16px;\n\tbackground-color: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: 5px;\n\tleft: ", ";\n\ttop: ", ";\n\tbox-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05);\n\n\t//text\n\tfont-size: 11px;\n\tcolor: ", ";\n\tfont-weight: 500;\n\n\tcursor: pointer;\n\tz-index: 9;\n"])), CSS_CONSTANTS.v2_tooltip_grey, CSS_CONSTANTS.v2_grey, function (props) {
  return props.position ? props.position.left + 'px' : '-1000px';
}, function (props) {
  return props.position ? props.position.top + 'px' : '-1000px';
}, CSS_CONSTANTS.v2_text_gray);
var TriangleWrapper = Styled__default.div(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tleft: ", ";\n\ttop: ", ";\n"])), function (props) {
  return props.position ? props.position.left + 'px' : null;
}, function (props) {
  return props.position ? props.position.top + 'px' : null;
});
var Triangle = function Triangle() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "30",
    height: "13",
    viewBox: "0 0 87 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M8.8404 27.1077L43.5 1.24767L78.1596 27.1077H8.8404Z",
    fill: "#EBEBEB",
    stroke: "#CBCBCB",
    strokeWidth: "2"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2611 26.1077L77.69 28.1077H9.42L11.8489 26.1077H75.2611Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M75.2611 26.1077L76.5324 24.5638L75.9786 24.1077H75.2611V26.1077ZM77.69 28.1077V30.1077H83.2652L78.9613 26.5638L77.69 28.1077ZM9.42 28.1077L8.14868 26.5638L3.84479 30.1077H9.42V28.1077ZM11.8489 26.1077V24.1077H11.1314L10.5775 24.5638L11.8489 26.1077ZM73.9898 27.6516L76.4187 29.6516L78.9613 26.5638L76.5324 24.5638L73.9898 27.6516ZM77.69 26.1077H9.42V30.1077H77.69V26.1077ZM10.6913 29.6516L13.1202 27.6516L10.5775 24.5638L8.14868 26.5638L10.6913 29.6516ZM11.8489 28.1077H75.2611V24.1077H11.8489V28.1077Z",
    fill: "#EBEBEB"
  }));
};
var TooltipContainer = function TooltipContainer(_ref) {
  var children = _ref.children,
    text = _ref.text;
  // Not the prettiest solution, but it's better than having to conditionally render the entire wrapper if the tooltip is conditional
  if (text === null) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  var childrenWrapperRef = React.useRef(null);
  var tooltipRef = React.useRef(null);
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    tootltipPosition = _useState2[0],
    setTootltipPosition = _useState2[1];
  var _useState3 = React.useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    arrowPosition = _useState4[0],
    setArrowPosition = _useState4[1];
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    tooltipVisible = _useState6[0],
    setTooltipVisible = _useState6[1];
  var positionTootltip = function positionTootltip() {
    var iconBoundingRect = childrenWrapperRef.current.getBoundingClientRect();
    var tooltipSize = tooltipRef.current.getBoundingClientRect();
    var position = {
      top: null,
      bottom: null,
      left: null,
      right: null,
      oneRowTooltip: false
    };
    position.left = (iconBoundingRect.width - tooltipSize.width) / 2;
    var positionTootltip = {
      top: -9,
      left: tooltipSize.width / 2 - 15
    };
    setTootltipPosition(position);
    setArrowPosition(positionTootltip);
  };
  React.useEffect(function () {
    if (tooltipVisible) {
      positionTootltip();
    }
  }, [tooltipVisible]);
  var handleMouseEnter = function handleMouseEnter() {
    setTooltipVisible(true);
  };
  var handleMouseLeave = function handleMouseLeave() {
    setTooltipVisible(false);
  };
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    className: 'tooltip-container',
    ref: childrenWrapperRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, children, tooltipVisible ? /*#__PURE__*/React__default.createElement(Tooltip$1, {
    ref: tooltipRef,
    position: tootltipPosition
  }, /*#__PURE__*/React__default.createElement(TriangleWrapper, {
    position: arrowPosition
  }, /*#__PURE__*/React__default.createElement(Triangle, null)), text) : null);
};
TooltipContainer.propTypes = {
  text: PropTypes__default.string,
  cy: PropTypes__default.string,
  children: PropTypes__default.any.isRequired
};
var InvoiceRowHeader = function InvoiceRowHeader(_ref) {
  var intl = _ref.intl,
    columns = _ref.columns,
    invoicedAmount = _ref.invoicedAmount,
    paidAmount = _ref.paidAmount,
    unpaidAmount = _ref.unpaidAmount,
    totalUninvoicedMinutes = _ref.totalUninvoicedMinutes,
    totalUninvoicedPrice = _ref.totalUninvoicedPrice,
    totalUninvoicedExpenses = _ref.totalUninvoicedExpenses,
    totalUninvoiced = _ref.totalUninvoiced,
    totalInvoicedAmount = _ref.totalInvoicedAmount,
    stickyTopPosition = _ref.stickyTopPosition,
    isInContainer = _ref.isInContainer,
    isEntryRow = _ref.isEntryRow,
    invoiceId = _ref.invoiceId,
    customWidth = _ref.customWidth;
  var hasSubHeader = columns.simpleDate || columns.client || columns.status || columns.date || columns.invoicedAmount || columns.paidAmount || columns.unpaidAmount || columns.dueDate || columns.uninvoicedTimeRegMinutes || columns.uninvoicedRetainerMinutes || columns.uninvoicedFixedPrice || columns.uninvoicedExpenses || columns.uninvoicedAmount || columns.overviewInvoicedAmount;
  return /*#__PURE__*/React__default.createElement(TableRowHeader$2, {
    stickyTopPosition: stickyTopPosition,
    isInContainer: isInContainer,
    entryRow: isEntryRow,
    header: true
  }, columns.simpleDate && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'date',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.date'
  }))), columns.datePicker && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'datepicker',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.date'
  }))), columns.project && /*#__PURE__*/React__default.createElement(GrowableTableRowItem$2, {
    className: 'project ' + (isEntryRow ? 'project-large entry-row' : ''),
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.project'
  }))), columns.name && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'name',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.name'
  }))), columns.notes && /*#__PURE__*/React__default.createElement(GrowableTableRowItem$2, {
    className: 'notes',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.notes'
  }))), columns.invoiceId && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'invoiceId',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, invoiceId)), columns.invoiceName && /*#__PURE__*/React__default.createElement(GrowableTableRowItem$2, {
    className: 'invoiceName',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'project_section.invoice_name'
  }))), columns.description && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'description',
    multiLine: hasSubHeader,
    header: true,
    customWidth: customWidth
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.description'
  }))), columns.xeroAccount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'xero-account',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'integrations.xero.xero_account'
  }))), columns.quickbooksItem && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'quickbooks-item',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'integrations.quickbooks.item_or_service'
  }))), columns.economicProduct && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'economic-product',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'integrations.economic.product'
  }))), columns.sageIntacctAccount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'sageIntacct-account',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'integrations.sageIntacct.account'
  }))), columns.sageIntacctLocation && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'sageIntacct-location',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'integrations.sageIntacct.location'
  }))), columns.client && /*#__PURE__*/React__default.createElement(GrowableTableRowItem$2, {
    className: 'client',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.client'
  }))), columns.quantity && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'quantity',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.quantity'
  }))), columns.unitPrice && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-input',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.unit_price'
  }))), columns.discount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'percentage',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'project_section.xero_modal_table_discount'
  }))), columns.tax && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'percentage',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.tax'
  }))), columns.totalPrice && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'totalPrice',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'expense_item_modal.total_price'
  }))), columns.status && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'status',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.status'
  }))), columns.date && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'date',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'invoicing.invoice_date'
  }))), columns.invoicedAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-small',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TooltipContainer, {
    text: intl.formatMessage({
      id: 'invoicing.invoiced_tooltip'
    })
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.total_invoiced'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, null, invoicedAmount)) : null)), columns.paidAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-small',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TooltipContainer, {
    text: intl.formatMessage({
      id: 'invoicing.paid_tooltip'
    })
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'settings_subscription.paid'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, null, paidAmount)) : null)), columns.paidInput && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-input',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'settings_subscription.paid'
  }))), columns.unpaidAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price-small',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TooltipContainer, {
    text: intl.formatMessage({
      id: 'invoicing.unpaid_tooltip'
    })
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'settings_subscription.unpaid'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, null, unpaidAmount)) : null)), columns.dueDate && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'date',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.due_date'
  }))), columns.uninvoicedTimeRegMinutes && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'hours-price-header',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.uninvoiced_time_registrations'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, {
    className: 'hours'
  }, totalUninvoicedMinutes), /*#__PURE__*/React__default.createElement(SubHeaderItem, {
    className: 'price'
  }, totalUninvoicedPrice)) : null), columns.uninvoicedRetainerMinutes && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'hours-price-header',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.uninvoiced_locked_periods'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, {
    className: 'hours'
  }, totalUninvoicedMinutes), /*#__PURE__*/React__default.createElement(SubHeaderItem, {
    className: 'price'
  }, totalUninvoicedPrice)) : null), columns.uninvoicedFixedPrice && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'hours-price-header',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.uninvoiced_fixed_price'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, null, totalUninvoicedPrice)) : null), columns.uninvoicedExpenses && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.uninvoiced_expenses'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, null, totalUninvoicedExpenses)) : null), columns.uninvoicedAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.total_uninvoiced'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, null, totalUninvoiced)) : null), columns.overviewInvoicedAmount && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'price',
    alignRight: true,
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.total_invoiced'
  })), hasSubHeader ? /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, {
    className: 'sub-header'
  }, /*#__PURE__*/React__default.createElement(SubHeaderItem, null, totalInvoicedAmount)) : null), columns["export"] && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'export',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null, intl.formatMessage({
    id: 'common.export'
  }))), columns.integrationLink && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    className: 'integration-links',
    multiLine: hasSubHeader,
    header: true
  }, /*#__PURE__*/React__default.createElement(TableHeaderItemContainer$2, null)), columns.hasContextMenu && /*#__PURE__*/React__default.createElement(StaticTableRowItem$2, {
    width: 20,
    className: 'context-menu ' + (isEntryRow ? 'entry-row' : '')
  }));
};
InvoiceRowHeader.propTypes = {
  intl: PropTypes__default.shape({
    formatMessage: PropTypes__default.func
  }),
  /**
   * Entry status
   */
  client: PropTypes__default.string,
  /**
   * Entry status
   */
  status: PropTypes__default.string,
  /**
   * Entry date
   */
  date: PropTypes__default.string,
  /**
   * Entry date
   */
  dueDate: PropTypes__default.string,
  /**
   * paidAmount
   */
  paidAmount: PropTypes__default.string,
  /**
   * unpaidAmount
   */
  unpaidAmount: PropTypes__default.string,
  /**
   * invoicedAmount
   */
  invoicedAmount: PropTypes__default.string,
  /**
   * Uninvoiced minutes
   */
  totalUninvoicedMinutes: PropTypes__default.number,
  /**
   * Custom width
   */
  customWidth: PropTypes__default.number,
  /**
   * Uninvoiced time registration price
   */
  totalUninvoicedPrice: PropTypes__default.string,
  /**
   * Uninvoiced expenses price
   */
  totalUninvoicedExpenses: PropTypes__default.string,
  /**
   * Uninvoiced time registration + uninvoiced expenses
   */
  totalUninvoiced: PropTypes__default.string,
  /**
   * Name of the project
   */
  totalInvoicedAmount: PropTypes__default.string,
  /**
   * Currency symbol
   */
  currencySymbol: PropTypes__default.string,
  /**
   * value of the css element top if the header should be on position sticky
   */
  stickyTopPosition: PropTypes__default.number,
  /**
   * Elements to show (or not) in the row
   */
  columns: PropTypes__default.shape({
    project: PropTypes__default.bool,
    invoiceName: PropTypes__default.bool,
    invoiceId: PropTypes__default.bool,
    uninvoicedTimeRegMinutes: PropTypes__default.bool,
    uninvoicedTimeRegPrice: PropTypes__default.bool,
    uninvoicedExpenses: PropTypes__default.bool,
    uninvoicedAmount: PropTypes__default.bool,
    invoicedAmount: PropTypes__default.bool,
    client: PropTypes__default.bool,
    description: PropTypes__default.bool,
    xeroAccount: PropTypes__default.bool,
    quickbooksItem: PropTypes__default.bool,
    economicProduct: PropTypes__default.bool,
    sageIntacctLocation: PropTypes__default.bool,
    sageIntacctAccount: PropTypes__default.bool,
    quantity: PropTypes__default.bool,
    unitPrice: PropTypes__default.bool,
    tax: PropTypes__default.bool,
    discount: PropTypes__default.bool,
    totalPrice: PropTypes__default.bool,
    status: PropTypes__default.bool,
    name: PropTypes__default.bool,
    date: PropTypes__default.bool,
    simpleDate: PropTypes__default.bool,
    datePicker: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    dueDate: PropTypes__default.bool,
    paidAmount: PropTypes__default.bool,
    paidInput: PropTypes__default.bool,
    unpaidAmount: PropTypes__default.bool,
    overviewInvoicedAmount: PropTypes__default.bool,
    uninvoicedFixedPrice: PropTypes__default.bool,
    uninvoicedRetainerMinutes: PropTypes__default.bool,
    uninvoicedRetainerPrice: PropTypes__default.bool,
    "export": PropTypes__default.bool,
    integrationLink: PropTypes__default.bool,
    hasContextMenu: PropTypes__default.bool
  }).isRequired,
  onSortByChange: PropTypes__default.func,
  /**
   * Neccessary information to know the context of the list.
   * Lists in a containers are the one in sprints or miletsones.
   */
  isInContainer: PropTypes__default.bool,
  isEntryRow: PropTypes__default.bool,
  invoiceId: PropTypes__default.element,
  tracking: PropTypes__default.func,
  sortBy: PropTypes__default.shape({
    column: PropTypes__default.string,
    ascending: PropTypes__default.bool
  })
};
InvoiceRowHeader.defaultProps = {
  intl: {
    formatMessage: function formatMessage(_ref2) {
      var id = _ref2.id;
      return id;
    }
  },
  tracking: {
    trackEvent: function trackEvent(_ref3) {
      var tracked = _ref3.tracked;
      return tracked;
    }
  },
  stickyTopPosition: null,
  sortBy: {
    column: null,
    ascending: true
  }
};
var _templateObject$U, _templateObject2$u, _templateObject3$m, _templateObject4$f, _templateObject5$b, _templateObject6$9, _templateObject7$8, _templateObject8$8;
var Line$3 = Styled__default.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n\tposition: relative;\n    overflow: hidden;\n\theight: auto;\n"])));
var BaseLevelTableRow = Styled__default.div(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n\nbox-sizing: border-box;\ndisplay: flex;\njustify-content: stretch;\nalign-items: center;\nheight: 48px;\nbackground: white;\nborder-top: 1px solid #e6e6e6;\nborder-bottom: ", " solid #e6e6e6;\n/* z-index: -2; */\n", ";\n", ";\n", ";\npadding-left: ", "\n\n&:hover {\n    cursor: pointer; \n    background-color:#f8f3fe;\n}\n"])), function (_ref) {
  var isLastRow = _ref.isLastRow,
    isExpanded = _ref.isExpanded;
  return isLastRow === true && !isExpanded || isExpanded ? '1px' : 0;
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'z-index:2;' : '';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'top: 36px;' : '';
}, function (_ref2) {
  var numberOfParents = _ref2.numberOfParents;
  return numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;';
});
var BaseLevelItem = Styled__default.div(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-start;\nalign-items: center;\nbox-sizing: border-box;\nfont-size: 13px;\ncolor: #080927;\nfont-weight: 400;\nline-height: normal;\npadding-right: 16px;\nwidth: 166px;\nheight: 100%;\norder: ", ";\n\nspan {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n\nabbr {\n    text-decoration: none;\n}\n"])), function (props) {
  return props.order;
});
var BaseLevelRightItem = Styled__default.div(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-end;\nalign-items: center;\nbox-sizing: border-box;\nfont-size: 13px;\ncolor: #080927;\nfont-weight: 400;\nline-height: normal;\n\npadding-right: 16px;\nwidth: 166px;\nheight: 100%;\norder: ", ";\n\nspan {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n"])), function (props) {
  return props.order;
});
var BaseLevelGreyItem = Styled__default(BaseLevelItem)(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral(["\ncolor: #a1a1a1;\n"])));
var BaseLevelDetailItem = Styled__default.div(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral(["\ndisplay:  grid;\nflex:1;\nmin-width: 166px;\nbox-sizing: content-box;\nheight: 100%;\n\npadding-right: 16px;\nfont-size: 13px;\ncolor: #080927;\nalign-items: center;\norder: ", ";\nabbr {\n    text-decoration: none;\n}\nspan {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    >div {\n        display: flex;\n        flex: 1;\n        justify-content: flex-start;\n        align-items: center;\n        \n\n        span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n    }\n}\n"])), function (props) {
  return props.order;
});
var MainItem = Styled__default.div(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteral(["\ndisplay: grid;\njustify-content: flex-start;\nalign-items: center;\nflex: 1;\nheight: 100%;\nbox-sizing: content-box;\nmin-width: 166px;\nfont-size: 13px;\ncolor: #080927;\npadding-left: 16px;\norder: ", ";\nspan {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        >div {\n        display: flex;\n        flex: auto;\n        justify-content: flex-start;\n        align-items: center;\n        min-width: 166px;\n        \n\n        span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n\n        p{\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n    }\n        }\n\nabbr{\n    text-decoration: none;\n}\n\n"])), function (props) {
  return props.order;
});
var CaretIconWrapper = Styled__default.div(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteral(["\nbox-sizing: border-box;\n\norder: ", ";\n"])), function (props) {
  return props.order;
});
var BaseLevelRow = function BaseLevelRow(_ref) {
  var isLastRow = _ref.isLastRow,
    isExpanded = _ref.isExpanded,
    mainItem = _ref.mainItem,
    enabledColumns = _ref.enabledColumns,
    showBottom = _ref.showBottom,
    stickyTopPosition = _ref.stickyTopPosition,
    isVisible = _ref.isVisible,
    baseLevelItems = _ref.baseLevelItems,
    baseLevelRightItems = _ref.baseLevelRightItems,
    baseLevelDetailItems = _ref.baseLevelDetailItems,
    baseLevelGreyItems = _ref.baseLevelGreyItems,
    numberOfParents = _ref.numberOfParents;
  var show = function show() {
    //look on task_row on defaultProps
    //call this function "onToggleExpand / onShow / anything with on. This tells that is a callback"
    showBottom();
  };
  var list = [];
  var index = 0;
  if (isVisible) {
    //add the caret icon to the list
    if (enabledColumns.caretIcon !== undefined && enabledColumns.caretIcon !== 0) {
      list.push( /*#__PURE__*/React__default.createElement(CaretIconWrapper, {
        order: enabledColumns.caretIcon,
        key: index
      }, /*#__PURE__*/React__default.createElement(CaretIcon, {
        size: CaretIcon.SIZE.STANDARD,
        color: '#000',
        direction: isExpanded === true && CaretIcon.DIRECTION.UP
      }))); //write index++ directly in the key

      index++;
    } //add the main item to the list

    if (enabledColumns.mainItem !== undefined && enabledColumns.mainItem !== 0) {
      list.push( /*#__PURE__*/React__default.createElement(MainItem, {
        key: index,
        order: enabledColumns.mainItem
      }, /*#__PURE__*/React__default.createElement("span", null, mainItem)));
      index++;
    }
    if (baseLevelItems) {
      //looping through the base level items
      for (var _i = 0, _Object$keys = Object.keys(baseLevelItems); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BaseLevelItem, {
            order: enabledColumns[key],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, baseLevelItems[key])));
          index++;
        }
      }
    }
    if (baseLevelRightItems) {
      //looping through the base level items
      for (var _i2 = 0, _Object$keys2 = Object.keys(baseLevelRightItems); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];
        if (enabledColumns[_key] !== undefined && enabledColumns[_key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BaseLevelRightItem, {
            order: enabledColumns[_key],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, baseLevelRightItems[_key])));
          index++;
        }
      }
    }
    if (baseLevelDetailItems) {
      //looping through the base level detailitems
      for (var _i3 = 0, _Object$keys3 = Object.keys(baseLevelDetailItems); _i3 < _Object$keys3.length; _i3++) {
        var _key2 = _Object$keys3[_i3];
        if (enabledColumns[_key2] !== undefined && enabledColumns[_key2] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BaseLevelDetailItem, {
            order: enabledColumns[_key2],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, baseLevelDetailItems[_key2])));
          index++;
        }
      }
    }
    if (baseLevelGreyItems) {
      //looping through the base level grey items
      for (var _i4 = 0, _Object$keys4 = Object.keys(baseLevelGreyItems); _i4 < _Object$keys4.length; _i4++) {
        var _key3 = _Object$keys4[_i4];
        if (enabledColumns[_key3] !== undefined && enabledColumns[_key3] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BaseLevelGreyItem, {
            order: enabledColumns[_key3],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, baseLevelGreyItems[_key3])));
          index++;
        }
      }
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BaseLevelTableRow, {
    isExpanded: isExpanded,
    numberOfParents: numberOfParents,
    onClick: isExpanded !== undefined ? show : function () {},
    isLastRow: isLastRow,
    stickyTopPosition: stickyTopPosition
  }, list));
};
BaseLevelRow.propTypes = {
  isLastRow: PropTypes__default.bool,
  isExpanded: PropTypes__default.bool,
  reportedTime: PropTypes__default.string,
  assigneesElement: PropTypes__default.object,
  projectName: PropTypes__default.string,
  roleName: PropTypes__default.string,
  price: PropTypes__default.string,
  cost: PropTypes__default.string,
  notes: PropTypes__default.string,
  taskName: PropTypes__default.string,
  personIcon: PropTypes__default.object,
  timeRegType: PropTypes__default.string,
  showBottom: PropTypes__default.func,
  stickyTopPosition: PropTypes__default.number,
  projectIcon: PropTypes__default.object,
  timeRegDetail: PropTypes__default.string || PropTypes__default.object,
  date: PropTypes__default.string,
  departmentName: PropTypes__default.string,
  clientName: PropTypes__default.string,
  billable: PropTypes__default.string,
  mainItem: PropTypes__default.object,
  isVisible: PropTypes__default.object,
  baseLevelItems: PropTypes__default.object,
  baseLevelDetailItems: PropTypes__default.object,
  baseLevelGreyItems: PropTypes__default.object,
  baseLevelHexagonItems: PropTypes__default.object,
  baseLevelRightItems: PropTypes__default.object,
  numberOfParents: PropTypes__default.number,
  enabledColumns: PropTypes__default.shape({
    projectIcon: PropTypes__default.bool,
    caretIcon: PropTypes__default.bool,
    personIcon: PropTypes__default.bool,
    personName: PropTypes__default.bool,
    reportedTime: PropTypes__default.bool,
    timeRegType: PropTypes__default.bool,
    timeRegDetail: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    roleName: PropTypes__default.bool,
    price: PropTypes__default.bool,
    cost: PropTypes__default.bool,
    date: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    taskName: PropTypes__default.bool,
    showBottom: PropTypes__default.bool,
    departmentName: PropTypes__default.bool,
    clientName: PropTypes__default.bool,
    billable: PropTypes__default.bool,
    mainItem: PropTypes__default.bool
  }).isRequired
};
var _templateObject$V, _templateObject2$v, _templateObject3$n, _templateObject4$g, _templateObject5$c, _templateObject6$a, _templateObject7$9;
var TableRowCalculationsHeader = Styled__default.div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: stretch;\nalign-items: center;\nbackground: white;\n/* width: auto; */\nz-index:3;\n", ";\n", ";\npadding-left: ", ";\n"])), function (props) {
  return props.stickyTopPosition !== null ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null ? 'top: 0px;' : '';
}, function (_ref) {
  var numberOfGroupings = _ref.numberOfGroupings;
  return numberOfGroupings === 1 ? '48px;' : numberOfGroupings === 2 ? '92px;' : numberOfGroupings === 0 && '16px;';
});
var BaseLevelSpaceHeaderStyle = Styled__default.div(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\nflex: 1;\nbox-sizing: border-box;\n"])));
var BaseLevelCalculationsHeaderStyle = Styled__default.div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\ndisplay:flex;\nflex-direction: column;\nbox-sizing: border-box;\npadding-bottom: 8px;\nalign-items: flex-end;\njustify-content: flex-start;\nheight: 36px;\nwidth: 166px;\nbackground: white;\ncolor: #a1a1a1;\nfont-weight: 400;\nline-height: 1.22;\nfont-size: 9px;\npadding-left: 16px;\npadding-right: 16px;\norder: ", ";\ndiv:first-child {\n    display: flex;\n    flex-direction: row;\n    ", ";\n", ";\n}\n"])), function (props) {
  return props.order;
}, function (props) {
  return props.sortItem !== false ? "&:hover {\n    cursor: pointer;\n    color:#6e0fea;\n    font-weight: 500;\n       }" : '';
}, function (props) {
  return props.isSorting !== null ? " \n    cursor: pointer; \n    color:#6e0fea;\n    font-weight: 500;  " : '';
});
var BaseLevelOnlyTextHeaderStyle = Styled__default.div(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\ndisplay:flex;\nflex-direction: column;\nbox-sizing: border-box;\npadding-bottom: 8px;\nalign-items: flex-start;\njustify-content: flex-start;\nheight: 36px;\nwidth: 166px;\nbackground: white;\ncolor: #a1a1a1;\nfont-weight: 400;\nline-height: 1.22;\nfont-size: 9px;\norder: ", ";\ndiv {\n    display: flex;\n    flex-direction: row;\n    ", ";\n", ";\n}\n\n"])), function (props) {
  return props.order;
}, function (props) {
  return props.sortItem !== false ? "&:hover {\n    cursor: pointer;\n    color:#6e0fea;\n    font-weight: 500;\n       }" : '';
}, function (props) {
  return props.isSorting !== null ? " \n    cursor: pointer; \n    color:#6e0fea;\n    font-weight: 500;  " : '';
});
var BaseLevelCalculationsHeaderDetailStyle = Styled__default.div(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral(["\ndisplay:grid;\nflex:1;\nmin-width: 166px;\nbox-sizing: border-box;\npadding-bottom: 8px;\nalign-items: flex-start;\njustify-content: flex-start;\nheight: 36px;\nfont-size: 9px;\nbackground: white;\ncolor: #a1a1a1;\norder: ", ";\nfont-weight: 400;\nline-height: 1.22;\nletter-spacing: 0;\ndiv {\n    display: flex;\n    flex-direction: row;\n    ", ";\n", ";\n}\n"])), function (props) {
  return props.order;
}, function (props) {
  return props.sortItem !== false ? "&:hover {\n    cursor: pointer;\n    color:#6e0fea;\n    font-weight: 500;\n       }" : '';
}, function (props) {
  return props.isSorting !== null ? " \n    cursor: pointer; \n    color:#6e0fea;\n    font-weight: 500;  " : '';
});
var Title$1 = Styled__default.div(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteral(["\nfont-size: 9px;\nfont-weight: 500;\npadding-bottom: 3px;\ntext-transform: uppercase;\nletter-spacing: 1px;\n"])));
var Calculation = Styled__default.div(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteral(["\nfont-size: 13px;\nfont-weight: 500;\npadding-bottom: 8px;\ncolor: #080927;\nletter-spacing: 0px;\n"])));
var BaseLevelCalculationsHeader = function BaseLevelCalculationsHeader(_ref) {
  var columns = _ref.columns,
    onlyTextItems = _ref.onlyTextItems,
    calculationItems = _ref.calculationItems,
    needingSpace = _ref.needingSpace,
    stickyTopPosition = _ref.stickyTopPosition,
    calculationFlexItems = _ref.calculationFlexItems,
    numberOfGroupings = _ref.numberOfGroupings;
  var index = 0;
  var list = [];
  var getSortDirection = function getSortDirection(sortBy) {
    return sortBy === 'ascending' ? SortDirectionIcon.DIRECTION.UP : SortDirectionIcon.DIRECTION.DOWN;
  };
  if (onlyTextItems) {
    var _loop = function _loop() {
      var key = _Object$keys[_i];
      if (columns[key] !== undefined && columns[key] !== 0) {
        list.push( /*#__PURE__*/React__default.createElement(BaseLevelOnlyTextHeaderStyle, {
          order: columns[key],
          key: index,
          sortItem: onlyTextItems[key].sortItem ? onlyTextItems[key].sortItem : false,
          isSorting: onlyTextItems[key].isSorting ? onlyTextItems[key].isSorting : null
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Title$1, {
          onClick: function onClick() {
            return onlyTextItems[key].onClickHandler && onlyTextItems[key].onClickHandler(key);
          }
        }, onlyTextItems[key].text), onlyTextItems[key].isSorting && onlyTextItems[key].isSorting !== null && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
          size: SortDirectionIcon.SIZE.SMALL,
          direction: getSortDirection(onlyTextItems[key].isSorting)
        }))));
        index++;
      }
    };
    for (var _i = 0, _Object$keys = Object.keys(onlyTextItems); _i < _Object$keys.length; _i++) {
      _loop();
    }
  }
  if (calculationFlexItems) {
    var _loop2 = function _loop2() {
      var key = _Object$keys2[_i2];
      if (columns[key] !== undefined && columns[key] !== 0) {
        list.push( /*#__PURE__*/React__default.createElement(BaseLevelCalculationsHeaderDetailStyle, {
          order: columns[key],
          key: index,
          sortItem: calculationFlexItems[key].sortItem ? calculationFlexItems[key].sortItem : false,
          isSorting: calculationFlexItems[key].isSorting ? calculationFlexItems[key].isSorting : null
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Title$1, {
          onClick: function onClick() {
            return calculationFlexItems[key].onClickHandler && calculationFlexItems[key].onClickHandler(key);
          }
        }, calculationFlexItems[key].text), calculationFlexItems[key].isSorting && calculationFlexItems[key].isSorting !== null && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
          size: SortDirectionIcon.SIZE.SMALL,
          direction: getSortDirection(calculationFlexItems[key].isSorting)
        }))));
        index++;
      }
    };
    for (var _i2 = 0, _Object$keys2 = Object.keys(calculationFlexItems); _i2 < _Object$keys2.length; _i2++) {
      _loop2();
    }
  }
  if (calculationItems) {
    var _loop3 = function _loop3() {
      var key = _Object$keys3[_i3];
      if (columns[key] !== undefined && columns[key] !== 0) {
        list.push( /*#__PURE__*/React__default.createElement(BaseLevelCalculationsHeaderStyle, {
          order: columns[key],
          key: index,
          sortItem: calculationItems[key].sortItem ? calculationItems[key].sortItem : false,
          isSorting: calculationItems[key].isSorting ? calculationItems[key].isSorting : null
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Title$1, {
          onClick: function onClick() {
            return calculationItems[key].onClickHandler && calculationItems[key].onClickHandler(key);
          }
        }, calculationItems[key].text), calculationItems[key].isSorting && calculationItems[key].isSorting !== null && /*#__PURE__*/React__default.createElement(SortDirectionIcon, {
          size: SortDirectionIcon.SIZE.SMALL,
          direction: getSortDirection(calculationItems[key].isSorting)
        })), /*#__PURE__*/React__default.createElement(Calculation, null, calculationItems[key].total)));
        index++;
      }
    };
    for (var _i3 = 0, _Object$keys3 = Object.keys(calculationItems); _i3 < _Object$keys3.length; _i3++) {
      _loop3();
    }
  }
  return /*#__PURE__*/React__default.createElement(TableRowCalculationsHeader, {
    stickyTopPosition: stickyTopPosition,
    numberOfGroupings: numberOfGroupings
  }, needingSpace === true && /*#__PURE__*/React__default.createElement(BaseLevelSpaceHeaderStyle, null), list);
};
BaseLevelCalculationsHeader.propTypes = {
  columns: PropTypes__default.shape({
    reportedTime: PropTypes__default.bool,
    personIcon: PropTypes__default.bool,
    date: PropTypes__default.bool,
    timeRegType: PropTypes__default.bool,
    timeRegDetail: PropTypes__default.bool,
    timeRegId: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    roleName: PropTypes__default.bool,
    price: PropTypes__default.bool,
    cost: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    taskName: PropTypes__default.bool,
    needingSpace: PropTypes__default.bool,
    departmentName: PropTypes__default.bool,
    billable: PropTypes__default.bool,
    clientName: PropTypes__default.bool,
    project: PropTypes__default.bool,
    task: PropTypes__default.bool
  }).isRequired,
  stickyTopPosition: PropTypes__default.number,
  totalCost: PropTypes__default.string,
  totalPrice: PropTypes__default.string,
  totalReportedTime: PropTypes__default.string,
  needingSpace: PropTypes__default.bool,
  numberOfGroupings: PropTypes__default.number,
  onlyTextItems: PropTypes__default.object,
  calculationItems: PropTypes__default.object,
  calculationFlexItems: PropTypes__default.object
};
var _templateObject$W, _templateObject2$w;
var TableRowHeader$3 = Styled__default.div(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: stretch;\nalign-items: flex-end;\nbackground: white;\n/* width: auto; */\nheight: 100%;\nz-index:3;\n", ";\n", ";\n"])), function (props) {
  return props.stickyTopPosition !== null ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null ? 'top:' + props.stickyTopPosition + 'px;' : '';
});
var BaseLevelHeaderStyle = Styled__default.div(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\nbox-sizing: border-box;\npadding-bottom: 8px;\ndisplay: flex;\nalign-items: flex-end;\njustify-content: flex-start;\nheight: 36px;\nwidth: 166px;\nbackground: white;\ncolor: #a1a1a1;\nfont-weight: 65Md;\nline-height: 1.22;\nletter-spacing: 1px;\nfont-size: 9px;\ntext-transform: uppercase;\npadding-left: 16px;\n"])));
var BaseLevelSimpleHeader = function BaseLevelSimpleHeader(_ref) {
  var columns = _ref.columns,
    stickyTopPosition = _ref.stickyTopPosition;
  return /*#__PURE__*/React__default.createElement(TableRowHeader$3, {
    stickyTopPosition: stickyTopPosition
  }, columns.reportedTime !== undefined && columns.reportedTime !== 0 && /*#__PURE__*/React__default.createElement(BaseLevelHeaderStyle, null, /*#__PURE__*/React__default.createElement("span", null, "Reported Time")), columns.personName !== undefined && columns.personName !== 0 && /*#__PURE__*/React__default.createElement(BaseLevelHeaderStyle, null, /*#__PURE__*/React__default.createElement("p", null, "Person")), columns.projectName !== undefined && columns.projectName !== 0 && /*#__PURE__*/React__default.createElement(BaseLevelHeaderStyle, null, /*#__PURE__*/React__default.createElement("p", null, "Project")), columns.taskName !== undefined && columns.taskName !== 0 && /*#__PURE__*/React__default.createElement(BaseLevelHeaderStyle, null, /*#__PURE__*/React__default.createElement("p", null, "Task")), columns.roleName !== undefined && columns.roleName !== 0 && /*#__PURE__*/React__default.createElement(BaseLevelHeaderStyle, {
    width: 166
  }, /*#__PURE__*/React__default.createElement("p", null, "Role")), columns.price !== undefined && columns.price !== 0 && /*#__PURE__*/React__default.createElement(BaseLevelHeaderStyle, null, /*#__PURE__*/React__default.createElement("p", null, "Price")), columns.cost !== undefined && columns.cost !== 0 && /*#__PURE__*/React__default.createElement(BaseLevelHeaderStyle, null, /*#__PURE__*/React__default.createElement("p", null, "Cost")), columns.notes !== undefined && columns.notes !== 0 && /*#__PURE__*/React__default.createElement(BaseLevelHeaderStyle, null, /*#__PURE__*/React__default.createElement("p", null, "Notes")));
};
BaseLevelSimpleHeader.propTypes = {
  columns: PropTypes__default.shape({
    reportedTime: PropTypes__default.bool,
    personName: PropTypes__default.bool,
    timeRegType: PropTypes__default.bool,
    timeRegDetail: PropTypes__default.bool,
    timeRegId: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    roleName: PropTypes__default.bool,
    price: PropTypes__default.bool,
    cost: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    taskName: PropTypes__default.bool
  }).isRequired,
  stickyTopPosition: PropTypes__default.number
};
var _templateObject$X, _templateObject2$x, _templateObject3$o, _templateObject4$h, _templateObject5$d, _templateObject6$b, _templateObject7$a;
var BottomOneTableRow = Styled__default.div(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral(["\nbox-sizing: border-box;\ndisplay: flex;\njustify-content: stretch;\nalign-items: center;\nheight: 28px;\noverflow:hidden;\npadding-left: ", "\n\n\n&:hover {\n    cursor: pointer;\n    background-color:#f8f3fe;\n}\n"])), function (_ref) {
  var numberOfParents = _ref.numberOfParents;
  return numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;';
});
var TypeAndDetailContainer = Styled__default.div(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: stretch;\nalign-items: center;\nflex: 1;\nheight: 100%\nbox-sizing: border-box;\nfont-size: 13px;\ncolor: #080927;\n\n>.type{\n    width: 166px;\n}\n\n>.detail{\n    flex: 1;\n}\n"])));
var BottomOneItem = Styled__default.div(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-start;\nalign-items: center;\nbox-sizing: border-box;\nfont-size: 13px;\ncolor: #080927;\n\npadding-right: 16px;\nwidth: 166px;\nheight: 100%;\norder: ", ";\nspan {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\nabbr{\n    text-decoration: none;\n}\n\n&:hover {\n    cursor: pointer;\n}\n"])), function (props) {
  return props.order;
});
var BottomOneRightItem = Styled__default.div(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-end;\nalign-items: center;\nbox-sizing: border-box;\nfont-size: 13px;\ncolor: #080927;\n\npadding-right: 16px;\nwidth: 166px;\nheight: 100%;\norder: ", ";\nspan {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n\n&:hover {\n    cursor: pointer;\n}\n"])), function (props) {
  return props.order;
});
var BottomOneGreyItem = Styled__default(BottomOneItem)(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral(["\ncolor: #a1a1a1;\n"])));
var BottomOneSpaceItem = Styled__default.div(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteral(["\nflex: 1;\nbox-sizing: border-box;\n"])));
var BottomOneDetailItem = Styled__default.div(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteral(["\ndisplay:  flex;\nflex:1;\nbox-sizing: border-box;\nwidth: 166px;\nheight: 100%;\n\npadding-right: 16px;\nfont-size: 13px;\ncolor: #080927;\nalign-items: center;\njustify-content: flex-start;\norder: ", ";\n\n    span{\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        \n    >div {\n        display: flex;\n        flex: auto;\n        justify-content: flex-start;\n        align-items: center;\n        \n\n        span {\n\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n\n    }\n    }\n\n    abbr{\n        text-decoration: none;\n    }\n\n"])), function (props) {
  return props.order;
});
var BottomOneRow = function BottomOneRow(_ref) {
  var enabledColumns = _ref.enabledColumns,
    isLastRow = _ref.isLastRow,
    isVisible = _ref.isVisible,
    bottomOneItems = _ref.bottomOneItems,
    bottomOneDetailItems = _ref.bottomOneDetailItems,
    bottomOneGreyItems = _ref.bottomOneGreyItems,
    bottomOneRightItems = _ref.bottomOneRightItems,
    numberOfParents = _ref.numberOfParents;
  var list = [];
  var index = 0;
  if (isVisible) {
    // if (enabledColumns.needingSpace) {
    // 	list.push(<BottomOneSpaceItem key={index} />);
    // 	index++;
    // }
    if (bottomOneItems) {
      //looping through the bottom 1 simple items
      for (var _i = 0, _Object$keys = Object.keys(bottomOneItems); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomOneItem, {
            order: enabledColumns[key],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, bottomOneItems[key])));
          index++;
        }
      }
    }
    if (bottomOneRightItems) {
      //looping through the bottom 1 right aligned items
      for (var _i2 = 0, _Object$keys2 = Object.keys(bottomOneRightItems); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];
        if (enabledColumns[_key] !== undefined && enabledColumns[_key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomOneRightItem, {
            order: enabledColumns[_key],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, bottomOneRightItems[_key])));
          index++;
        }
      }
    }
    if (bottomOneDetailItems) {
      //looping through the bottom 1  flex 1 items
      for (var _i3 = 0, _Object$keys3 = Object.keys(bottomOneDetailItems); _i3 < _Object$keys3.length; _i3++) {
        var _key2 = _Object$keys3[_i3];
        if (enabledColumns[_key2] !== undefined && enabledColumns[_key2] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomOneDetailItem, {
            order: enabledColumns[_key2],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, bottomOneDetailItems[_key2])));
          index++;
        }
      }
    }
    if (bottomOneGreyItems) {
      //looping through the bottom 1 simple grey items
      for (var _i4 = 0, _Object$keys4 = Object.keys(bottomOneGreyItems); _i4 < _Object$keys4.length; _i4++) {
        var _key3 = _Object$keys4[_i4];
        if (enabledColumns[_key3] !== undefined && enabledColumns[_key3] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomOneGreyItem, {
            order: enabledColumns[_key3],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, bottomOneGreyItems[_key3])));
          index++;
        }
      }
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Line, null, /*#__PURE__*/React__default.createElement(BottomOneTableRow, {
    isLastRow: isLastRow,
    numberOfParents: numberOfParents
  }, list)));
};
BottomOneRow.propTypes = {
  isVisible: PropTypes__default.bool,
  timeRegType: PropTypes__default.string,
  timeRegDetail: PropTypes__default.func,
  isLastRow: PropTypes__default.bool,
  timeRegId: PropTypes__default.string,
  reportedTime: PropTypes__default.string,
  assigneesElement: PropTypes__default.object,
  projectName: PropTypes__default.string,
  roleName: PropTypes__default.string,
  price: PropTypes__default.string,
  cost: PropTypes__default.string,
  notes: PropTypes__default.string,
  taskName: PropTypes__default.string,
  personIcon: PropTypes__default.object,
  showBottom: PropTypes__default.func,
  numberOfParents: PropTypes__default.number,
  date: PropTypes__default.string,
  departmentName: PropTypes__default.string,
  clientName: PropTypes__default.string,
  billable: PropTypes__default.string,
  personName: PropTypes__default.string,
  bottomOneItems: PropTypes__default.object,
  bottomOneDetailItems: PropTypes__default.object,
  bottomOneGreyItems: PropTypes__default.object,
  bottomOneRightItems: PropTypes__default.object,
  enabledColumns: PropTypes__default.shape({
    needingSpace: PropTypes__default.bool,
    timeRegType: PropTypes__default.bool,
    personName: PropTypes__default.bool,
    timeRegDetail: PropTypes__default.bool,
    timeRegId: PropTypes__default.bool,
    reportedTime: PropTypes__default.bool,
    assigneesElement: PropTypes__default.func,
    projectName: PropTypes__default.bool,
    roleName: PropTypes__default.bool,
    price: PropTypes__default.bool,
    cost: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    taskName: PropTypes__default.bool,
    personIcon: PropTypes__default.bool,
    showBottom: PropTypes__default.bool,
    date: PropTypes__default.bool,
    clientName: PropTypes__default.bool,
    departmentName: PropTypes__default.bool,
    billable: PropTypes__default.bool
  }).isRequired
};
var _templateObject$Y, _templateObject2$y, _templateObject3$p, _templateObject4$i, _templateObject5$e, _templateObject6$c, _templateObject7$b, _templateObject8$9, _templateObject9$7;
var Line$4 = Styled__default.div(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n\tposition: relative;\n    overflow: hidden;\n\theight: auto;\n"])));
var BottomTwoLevelTableRow = Styled__default.div(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral(["\n\nbox-sizing: border-box;\ndisplay: flex;\njustify-content: stretch;\nalign-items: center;\nheight: 40px;\nbackground: white;\npadding-left: ", "\nborder-top: ", " solid #e6e6e6;\nborder-bottom: ", " solid #e6e6e6;\n\n", ";\n", ";\n", ";\n\n&:hover {\n    cursor: pointer; \n    background-color:#f8f3fe;\n}\n"])), function (_ref) {
  var numberOfParents = _ref.numberOfParents;
  return numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;';
}, function (_ref2) {
  var isFirstRow = _ref2.isFirstRow;
  return isFirstRow ? 0 : '1px';
}, function (_ref3) {
  var isExpanded = _ref3.isExpanded;
  return isExpanded ? '1px' : 0;
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'z-index:1;' : '';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'top: 84px;' : '';
});
var BottomTwoLevelItem = Styled__default.div(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-start;\nalign-items: center;\nbox-sizing: border-box;\nfont-size: 13px;\ncolor: #080927;\nfont-weight: 400;\nline-height: normal;\n\npadding-right: 16px;\nwidth: 166px;\nheight: 100%;\norder: ", ";\n\nspan {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n\nabbr {\n    text-decoration: none;\n}\n"])), function (props) {
  return props.order;
});
var BottomTwoLevelRightItem = Styled__default.div(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-end;\nalign-items: center;\nbox-sizing: border-box;\nfont-size: 13px;\ncolor: #080927;\nfont-weight: 400;\nline-height: normal;\npadding-right: 16px;\nwidth: 166px;\nheight: 100%;\norder: ", ";\n\nspan {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n"])), function (props) {
  return props.order;
});
var BottomTwoLevelGreyItem = Styled__default(BottomTwoLevelItem)(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral(["\ncolor: #a1a1a1;\n"])));
var BottomTwoLevelDetailItem = Styled__default.div(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteral(["\ndisplay:  grid;\nflex:1;\nbox-sizing: content-box;\nmin-width: 166px;\nheight: 100%;\n\npadding-right: 16px;\nfont-size: 13px;\ncolor: #080927;\nalign-items: center;\norder: ", ";\n\n\nspan {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n\n        >div {\n        display: flex;\n        flex: auto;\n        justify-content: flex-start;\n        align-items: center;\n        min-width: 166px;\n\n        >span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n\n        p{\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n\n        }\n    }\n\nabbr{\n    text-decoration: none;\n}\n\n\n"])), function (props) {
  return props.order;
});
var BottomTwoSpaceItem = Styled__default.div(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteral(["\nflex: 1;\nbox-sizing: border-box;\n"])));
var MainItem$1 = Styled__default.div(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteral(["\ndisplay:  grid;\nflex:1;\nbox-sizing: content-box;\njustify-content: flex-start;\nmin-width: 166px;\nheight: 100%;\npadding-left: 16px;\nfont-size: 13px;\ncolor: #080927;\nalign-items: center;\norder: ", ";\n\nspan {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        \n\n        >div {\n        display: flex;\n        flex: auto;\n        justify-content: flex-start;\n        align-items: center;\n        min-width: 166px;\n\n        span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n\n        p{\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        }\n    }\n\n    }\n\nabbr{\n    text-decoration: none;\n}\n"])), function (props) {
  return props.order;
});
var CaretIconWrapper$1 = Styled__default.div(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteral(["\nbox-sizing: border-box;\n\norder: ", ";\n"])), function (props) {
  return props.order;
});
var BottomTwoLevelRow = function BottomTwoLevelRow(_ref) {
  var isLastRow = _ref.isLastRow,
    isFirstRow = _ref.isFirstRow,
    isExpanded = _ref.isExpanded,
    mainItem = _ref.mainItem,
    enabledColumns = _ref.enabledColumns,
    showBottom = _ref.showBottom,
    stickyTopPosition = _ref.stickyTopPosition,
    numberOfLevels = _ref.numberOfLevels,
    isVisible = _ref.isVisible,
    bottomTwoItems = _ref.bottomTwoItems,
    bottomTwoRightItems = _ref.bottomTwoRightItems,
    bottomTwoDetailItems = _ref.bottomTwoDetailItems,
    bottomTwoGreyItems = _ref.bottomTwoGreyItems,
    numberOfParents = _ref.numberOfParents;
  var show = function show() {
    showBottom();
  };
  var list = [];
  var index = 0;
  if (isVisible) {
    // if (enabledColumns.needingSpace) {
    // 	list.push(<BottomTwoSpaceItem key={index} />);
    // 	index++;
    // }
    //add the caret icon to the list
    if (enabledColumns.caretIcon !== undefined && enabledColumns.caretIcon !== 0) {
      list.push( /*#__PURE__*/React__default.createElement(CaretIconWrapper$1, {
        key: index,
        order: enabledColumns.caretIcon
      }, /*#__PURE__*/React__default.createElement(CaretIcon, {
        size: CaretIcon.SIZE.STANDARD,
        color: '#000',
        direction: isExpanded === true && CaretIcon.DIRECTION.UP
      })));
      index++;
    } //add the main item to the list

    if (enabledColumns.mainItem !== undefined && enabledColumns.mainItem !== 0) {
      list.push( /*#__PURE__*/React__default.createElement(MainItem$1, {
        key: index,
        order: enabledColumns.mainItem
      }, /*#__PURE__*/React__default.createElement("span", null, mainItem)));
      index++;
    }
    if (bottomTwoItems) {
      //looping through the bottom 2 simple items
      for (var _i = 0, _Object$keys = Object.keys(bottomTwoItems); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomTwoLevelItem, {
            order: enabledColumns[key],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, bottomTwoItems[key])));
          index++;
        }
      }
    }
    if (bottomTwoRightItems) {
      //looping through the bottom 2 simple right aligned items
      for (var _i2 = 0, _Object$keys2 = Object.keys(bottomTwoRightItems); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];
        if (enabledColumns[_key] !== undefined && enabledColumns[_key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomTwoLevelRightItem, {
            order: enabledColumns[_key],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, bottomTwoRightItems[_key])));
          index++;
        }
      }
    }
    if (bottomTwoDetailItems) {
      //looping through the bottom 2 flex 1 items
      for (var _i3 = 0, _Object$keys3 = Object.keys(bottomTwoDetailItems); _i3 < _Object$keys3.length; _i3++) {
        var _key2 = _Object$keys3[_i3];
        if (enabledColumns[_key2] !== undefined && enabledColumns[_key2] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomTwoLevelDetailItem, {
            order: enabledColumns[_key2],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, bottomTwoDetailItems[_key2])));
          index++;
        }
      }
    }
    if (bottomTwoGreyItems) {
      //looping through the bottom 2 simple grey items
      for (var _i4 = 0, _Object$keys4 = Object.keys(bottomTwoGreyItems); _i4 < _Object$keys4.length; _i4++) {
        var _key3 = _Object$keys4[_i4];
        if (enabledColumns[_key3] !== undefined && enabledColumns[_key3] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomTwoLevelGreyItem, {
            order: enabledColumns[_key3],
            key: index
          }, /*#__PURE__*/React__default.createElement("span", null, bottomTwoGreyItems[_key3])));
          index++;
        }
      }
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BottomTwoLevelTableRow, {
    isFirstRow: isFirstRow,
    isExpanded: isExpanded,
    numberOfParents: numberOfParents,
    numberOfLevels: numberOfLevels,
    onClick: isExpanded !== undefined ? show : function () {},
    isLastRow: isLastRow,
    stickyTopPosition: stickyTopPosition
  }, list));
};
BottomTwoLevelRow.propTypes = {
  isVisible: PropTypes__default.bool,
  numberOfLevels: PropTypes__default.bool,
  isLastRow: PropTypes__default.bool,
  isFirstRow: PropTypes__default.bool,
  isExpanded: PropTypes__default.bool,
  mainItem: PropTypes__default.object,
  reportedTime: PropTypes__default.string,
  assigneesElement: PropTypes__default.object,
  projectName: PropTypes__default.string,
  roleName: PropTypes__default.string,
  price: PropTypes__default.string,
  cost: PropTypes__default.string,
  notes: PropTypes__default.string,
  taskName: PropTypes__default.string,
  personIcon: PropTypes__default.object,
  timeRegType: PropTypes__default.string,
  showBottom: PropTypes__default.func,
  stickyTopPosition: PropTypes__default.number,
  projectIcon: PropTypes__default.object,
  timeRegDetail: PropTypes__default.string,
  date: PropTypes__default.string,
  departmentName: PropTypes__default.string,
  clientName: PropTypes__default.string,
  billable: PropTypes__default.string,
  bottomTwoItems: PropTypes__default.object,
  bottomTwoDetailItems: PropTypes__default.object,
  bottomTwoGreyItems: PropTypes__default.object,
  bottomTwoRightItems: PropTypes__default.object,
  numberOfParents: PropTypes__default.number,
  enabledColumns: PropTypes__default.shape({
    needingSpace: PropTypes__default.bool,
    projectIcon: PropTypes__default.bool,
    mainItem: PropTypes__default.bool,
    caretIcon: PropTypes__default.bool,
    personIcon: PropTypes__default.bool,
    personName: PropTypes__default.bool,
    reportedTime: PropTypes__default.bool,
    timeRegType: PropTypes__default.bool,
    timeRegDetail: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    roleName: PropTypes__default.bool,
    price: PropTypes__default.bool,
    cost: PropTypes__default.bool,
    date: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    taskName: PropTypes__default.bool,
    showBottom: PropTypes__default.bool,
    departmentName: PropTypes__default.bool,
    clientName: PropTypes__default.bool,
    billable: PropTypes__default.bool
  }).isRequired
};
var _templateObject$Z, _templateObject2$z, _templateObject3$q, _templateObject4$j, _templateObject5$f;
var Line$5 = Styled__default.div(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral(["\n\tposition: relative;\n    overflow: hidden;\n\theight: auto;\n"])));
var BottomTwoLevelTableRow$1 = Styled__default.div(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral(["\n\nbox-sizing: border-box;\ndisplay: flex;\njustify-content: stretch;\nalign-items: center;\nheight: 30px;\nbackground: white;\npadding-left: ", "\n\n\n", ";\n", ";\n", ";\n\n"])), function (_ref) {
  var numberOfParents = _ref.numberOfParents;
  return numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'z-index:1;' : '';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'top: 84px;' : '';
});
var BottomTwoLevelItem$1 = Styled__default.div(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-start;\nalign-items: center;\nbox-sizing: border-box;\npadding-right: 16px;\nwidth:166px;\nheight: 10px;\norder: ", ";\n\n.blurry-text {\n\tbox-sizing: border-box;\n\tbackground-color: #e6e6ed;\n\tborder-radius: 2px;\n\t filter: blur(4px); \n\t width: 80%;\n\theight: 10px;\t\n\t} \n\t\n"])), function (props) {
  return props.order;
});
var BottomTwoLevelRightItem$1 = Styled__default.div(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-end;\nalign-items: center;\nbox-sizing: border-box;\npadding-right: 16px; \nwidth: 166px;\nheight: 100%;\norder: ", ";\n\n.blurry-text {\n\tbox-sizing: border-box;\n\tbackground-color: #e6e6ed;\n\tborder-radius: 2px;\n\tfilter: blur(4px);\n\twidth: 80%;\n\theight: 10px;\t\n\t}\n"])), function (props) {
  return props.order;
});
var BottomTwoLevelDetailItem$1 = Styled__default.div(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral(["\ndisplay: grid;\nflex:1;\nalign-items: center;\nbox-sizing: content-box;\nmin-width: 166px;\nheight: 100%;\npadding-right: 16px;\norder: ", ";\n.blurry-text {\n\tbox-sizing: border-box;\n\tbackground-color: #e6e6ed;\n\tborder-radius: 2px;\n\tfilter: blur(4px);\n\twidth: 80%;\n\theight: 10px;\t\n\t}\n"])), function (props) {
  return props.order;
});
var BottomTwoLevelBlurryRow = function BottomTwoLevelBlurryRow(_ref) {
  var enabledColumns = _ref.enabledColumns,
    isVisible = _ref.isVisible,
    bottomTwoItems = _ref.bottomTwoItems,
    bottomTwoRightItems = _ref.bottomTwoRightItems,
    bottomTwoDetailItems = _ref.bottomTwoDetailItems,
    numberOfParents = _ref.numberOfParents;
  var list = [];
  var index = 0;
  if (isVisible) {
    if (bottomTwoItems) {
      //looping through the bottom 2 simple items
      for (var _i = 0, _Object$keys = Object.keys(bottomTwoItems); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomTwoLevelItem$1, {
            order: enabledColumns[key],
            key: index
          }, bottomTwoItems[key] !== null && /*#__PURE__*/React__default.createElement("div", {
            className: "blurry-text"
          })));
          index++;
        }
      }
    }
    if (bottomTwoRightItems) {
      //looping through the bottom 2 simple right aligned items
      for (var _i2 = 0, _Object$keys2 = Object.keys(bottomTwoRightItems); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];
        if (enabledColumns[_key] !== undefined && enabledColumns[_key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomTwoLevelRightItem$1, {
            order: enabledColumns[_key],
            key: index
          }, bottomTwoRightItems[_key] !== null && /*#__PURE__*/React__default.createElement("div", {
            className: "blurry-text"
          })));
          index++;
        }
      }
    }
    if (bottomTwoDetailItems) {
      //looping through the bottom 2 flex 1 items
      for (var _i3 = 0, _Object$keys3 = Object.keys(bottomTwoDetailItems); _i3 < _Object$keys3.length; _i3++) {
        var _key2 = _Object$keys3[_i3];
        if (enabledColumns[_key2] !== undefined && enabledColumns[_key2] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomTwoLevelDetailItem$1, {
            order: enabledColumns[_key2],
            key: index
          }, bottomTwoDetailItems[_key2] !== null && /*#__PURE__*/React__default.createElement("div", {
            className: "blurry-text"
          })));
          index++;
        }
      }
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BottomTwoLevelTableRow$1, {
    numberOfParents: numberOfParents
  }, list));
};
BottomTwoLevelBlurryRow.propTypes = {
  isVisible: PropTypes__default.bool,
  numberOfLevels: PropTypes__default.bool,
  isFirstRow: PropTypes__default.bool,
  isExpanded: PropTypes__default.bool,
  mainItem: PropTypes__default.object,
  reportedTime: PropTypes__default.string,
  assigneesElement: PropTypes__default.object,
  projectName: PropTypes__default.string,
  roleName: PropTypes__default.string,
  price: PropTypes__default.string,
  cost: PropTypes__default.string,
  notes: PropTypes__default.string,
  taskName: PropTypes__default.string,
  personIcon: PropTypes__default.object,
  timeRegType: PropTypes__default.string,
  projectIcon: PropTypes__default.object,
  timeRegDetail: PropTypes__default.string,
  date: PropTypes__default.string,
  departmentName: PropTypes__default.string,
  clientName: PropTypes__default.string,
  billable: PropTypes__default.string,
  bottomTwoItems: PropTypes__default.object,
  bottomTwoDetailItems: PropTypes__default.object,
  bottomTwoGreyItems: PropTypes__default.object,
  bottomTwoRightItems: PropTypes__default.object,
  numberOfParents: PropTypes__default.number,
  enabledColumns: PropTypes__default.shape({
    needingSpace: PropTypes__default.bool,
    projectIcon: PropTypes__default.bool,
    mainItem: PropTypes__default.bool,
    caretIcon: PropTypes__default.bool,
    personIcon: PropTypes__default.bool,
    personName: PropTypes__default.bool,
    reportedTime: PropTypes__default.bool,
    timeRegType: PropTypes__default.bool,
    timeRegDetail: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    roleName: PropTypes__default.bool,
    price: PropTypes__default.bool,
    cost: PropTypes__default.bool,
    date: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    taskName: PropTypes__default.bool,
    showBottom: PropTypes__default.bool,
    departmentName: PropTypes__default.bool,
    clientName: PropTypes__default.bool,
    billable: PropTypes__default.bool
  }).isRequired
};
var _templateObject$_, _templateObject2$A, _templateObject3$r, _templateObject4$k, _templateObject5$g;
var Line$6 = Styled__default.div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteral(["\n\tposition: relative;\n    overflow: hidden;\n\theight: auto;\n"])));
var BottomOneLevelTableRow = Styled__default.div(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteral(["\n\nbox-sizing: border-box;\ndisplay: flex;\njustify-content: stretch;\nalign-items: center;\nheight: 28px;\nbackground: white;\npadding-left: ", "\n\n\n", ";\n", ";\n", ";\n\n"])), function (_ref) {
  var numberOfParents = _ref.numberOfParents;
  return numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'z-index:1;' : '';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'position:sticky;' : '';
}, function (props) {
  return props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'top: 84px;' : '';
});
var BottomOneLevelItem = Styled__default.div(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-start;\nalign-items: center;\nbox-sizing: border-box;\npadding-right: 16px;\nwidth:166px;\nheight: 10px;\norder: ", ";\n\n.blurry-text {\n\tbox-sizing: border-box;\n\tbackground-color: #e6e6ed;\n\tborder-radius: 2px;\n\t filter: blur(4px); \n\t width: 80%;\n\theight: 10px;\t\n\t} \n\t\n"])), function (props) {
  return props.order;
});
var BottomOneLevelRightItem = Styled__default.div(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral(["\ndisplay: flex;\njustify-content: flex-end;\nalign-items: center;\nbox-sizing: border-box;\npadding-right: 16px; \nwidth: 166px;\nheight: 100%;\norder: ", ";\n\n.blurry-text {\n\tbox-sizing: border-box;\n\tbackground-color: #e6e6ed;\n\tborder-radius: 2px;\n\tfilter: blur(4px);\n\twidth: 80%;\n\theight: 10px;\t\n\t}\n"])), function (props) {
  return props.order;
});
var BottomOneLevelDetailItem = Styled__default.div(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteral(["\ndisplay: grid;\nflex:1;\nalign-items: center;\nbox-sizing: content-box;\nmin-width: 166px;\nheight: 100%;\npadding-right: 16px;\norder: ", ";\n.blurry-text {\n\tbox-sizing: border-box;\n\tbackground-color: #e6e6ed;\n\tborder-radius: 2px;\n\tfilter: blur(4px);\n\twidth: 80%;\n\theight: 10px;\t\n\t}\n"])), function (props) {
  return props.order;
});
var BottomOneLevelBlurryRow = function BottomOneLevelBlurryRow(_ref) {
  var enabledColumns = _ref.enabledColumns,
    isVisible = _ref.isVisible,
    bottomOneItems = _ref.bottomOneItems,
    bottomOneRightItems = _ref.bottomOneRightItems,
    bottomOneDetailItems = _ref.bottomOneDetailItems,
    numberOfParents = _ref.numberOfParents;
  var list = [];
  var index = 0;
  if (isVisible) {
    if (bottomOneItems) {
      //looping through the bottom 2 simple items
      for (var _i = 0, _Object$keys = Object.keys(bottomOneItems); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomOneLevelItem, {
            order: enabledColumns[key],
            key: index
          }, bottomOneItems[key] !== null && /*#__PURE__*/React__default.createElement("div", {
            className: "blurry-text"
          })));
          index++;
        }
      }
    }
    if (bottomOneRightItems) {
      //looping through the bottom 2 simple right aligned items
      for (var _i2 = 0, _Object$keys2 = Object.keys(bottomOneRightItems); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];
        if (enabledColumns[_key] !== undefined && enabledColumns[_key] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomOneLevelRightItem, {
            order: enabledColumns[_key],
            key: index
          }, bottomOneRightItems[_key] !== null && /*#__PURE__*/React__default.createElement("div", {
            className: "blurry-text"
          })));
          index++;
        }
      }
    }
    if (bottomOneDetailItems) {
      //looping through the bottom 2 flex 1 items
      for (var _i3 = 0, _Object$keys3 = Object.keys(bottomOneDetailItems); _i3 < _Object$keys3.length; _i3++) {
        var _key2 = _Object$keys3[_i3];
        if (enabledColumns[_key2] !== undefined && enabledColumns[_key2] !== 0) {
          list.push( /*#__PURE__*/React__default.createElement(BottomOneLevelDetailItem, {
            order: enabledColumns[_key2],
            key: index
          }, bottomOneDetailItems[_key2] !== null && /*#__PURE__*/React__default.createElement("div", {
            className: "blurry-text"
          })));
          index++;
        }
      }
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BottomOneLevelTableRow, {
    numberOfParents: numberOfParents
  }, list));
};
BottomOneLevelBlurryRow.propTypes = {
  isVisible: PropTypes__default.bool,
  numberOfLevels: PropTypes__default.bool,
  isFirstRow: PropTypes__default.bool,
  isExpanded: PropTypes__default.bool,
  mainItem: PropTypes__default.object,
  reportedTime: PropTypes__default.string,
  assigneesElement: PropTypes__default.object,
  projectName: PropTypes__default.string,
  roleName: PropTypes__default.string,
  price: PropTypes__default.string,
  cost: PropTypes__default.string,
  notes: PropTypes__default.string,
  taskName: PropTypes__default.string,
  personIcon: PropTypes__default.object,
  timeRegType: PropTypes__default.string,
  projectIcon: PropTypes__default.object,
  timeRegDetail: PropTypes__default.string,
  date: PropTypes__default.string,
  departmentName: PropTypes__default.string,
  clientName: PropTypes__default.string,
  billable: PropTypes__default.string,
  bottomOneItems: PropTypes__default.object,
  bottomOneDetailItems: PropTypes__default.object,
  bottomOneGreyItems: PropTypes__default.object,
  bottomOneRightItems: PropTypes__default.object,
  numberOfParents: PropTypes__default.number,
  enabledColumns: PropTypes__default.shape({
    needingSpace: PropTypes__default.bool,
    projectIcon: PropTypes__default.bool,
    mainItem: PropTypes__default.bool,
    caretIcon: PropTypes__default.bool,
    personIcon: PropTypes__default.bool,
    personName: PropTypes__default.bool,
    reportedTime: PropTypes__default.bool,
    timeRegType: PropTypes__default.bool,
    timeRegDetail: PropTypes__default.bool,
    projectName: PropTypes__default.bool,
    roleName: PropTypes__default.bool,
    price: PropTypes__default.bool,
    cost: PropTypes__default.bool,
    date: PropTypes__default.bool,
    notes: PropTypes__default.bool,
    taskName: PropTypes__default.bool,
    showBottom: PropTypes__default.bool,
    departmentName: PropTypes__default.bool,
    clientName: PropTypes__default.bool,
    billable: PropTypes__default.bool
  }).isRequired
};
var _templateObject$$;
var RadioButton = function RadioButton(_ref) {
  var checked = _ref.checked,
    onClick = _ref.onClick,
    userpilot = _ref.userpilot,
    disabled = _ref.disabled,
    cy = _ref.cy;
  return /*#__PURE__*/React__default.createElement(StyledInput$1, {
    type: "radio",
    checked: checked,
    onClick: onClick,
    "data-userpilot": userpilot,
    "data-cy": cy,
    disabled: disabled
  });
};
var StyledInput$1 = Styled__default.input(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: 22px;\n    width: 22px;\n    appearance: none;\n    border: solid 2px ", ";\n    border-radius: 11px;\n    transition: background-color 0.2s ease;\n    background-color: ", "; \n    &:hover, &:focus, &:checked {\n\t\t", "\n\t}\n    &:checked{\n        background-color: ", ";\n    }\n    &:after {\n        content: '';\n\t\tposition: relative;\n\t\tbackground: ", ";\n        width: 6px;\n        height: 6px;\n\t\tborder-radius: 3px;\n\t\tleft: 6px;\n\t\ttop: 6px;\n\t}\n    &:focus{\n        outline: none;\n    }\n"])), function (props) {
  return props.theme.colors !== undefined ? props.theme.colors.veryLightGray : '#e6e6e6';
}, function (props) {
  return props.theme.colors ? props.disabled ? props.theme.colors.mediumGray : props.theme.colors.white : '#fff';
}, function (props) {
  return !props.disabled ? props.theme.colors ? 'border: solid 2px ' + props.theme.colors.forecastPurple + ';' : 'border: solid 2px #6e0fea;' : '';
}, function (props) {
  return !props.disabled ? props.theme.colors ? props.theme.colors.forecastPurple : '#6e0fea' : '#D7C1F9';
}, function (props) {
  return props.disabled ? props.theme.colors.mediumGray : 'white';
});
RadioButton.propTypes = {
  /**
   * The element is checked or not.
   */
  checked: PropTypes__default.bool,
  /**
   * Callback of the input.
   */
  onClick: PropTypes__default.func,
  userpilot: PropTypes__default.string,
  cy: PropTypes__default.string,
  disabled: PropTypes__default.bool
};
RadioButton.defaultProps = {
  checked: false
};
var Triangle$1 = function Triangle() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "30",
    height: "13",
    viewBox: "0 0 87 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M8.8404 27.1077L43.5 1.24767L78.1596 27.1077H8.8404Z",
    fill: "#EBEBEB",
    stroke: "#CBCBCB",
    strokeWidth: "2"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2611 26.1077L77.69 28.1077H9.42L11.8489 26.1077H75.2611Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M75.2611 26.1077L76.5324 24.5638L75.9786 24.1077H75.2611V26.1077ZM77.69 28.1077V30.1077H83.2652L78.9613 26.5638L77.69 28.1077ZM9.42 28.1077L8.14868 26.5638L3.84479 30.1077H9.42V28.1077ZM11.8489 26.1077V24.1077H11.1314L10.5775 24.5638L11.8489 26.1077ZM73.9898 27.6516L76.4187 29.6516L78.9613 26.5638L76.5324 24.5638L73.9898 27.6516ZM77.69 26.1077H9.42V30.1077H77.69V26.1077ZM10.6913 29.6516L13.1202 27.6516L10.5775 24.5638L8.14868 26.5638L10.6913 29.6516ZM11.8489 28.1077H75.2611V24.1077H11.8489V28.1077Z",
    fill: "#EBEBEB"
  }));
};
var _templateObject$10, _templateObject2$B;
var TooltipWrapper = Styled__default.div(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tmax-width: 360px;\n\tdisplay: flex;\n\tflex-direction: row;\n\n\t.hidden {\n\t\topacity: 0;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t.info-box-content {\n\t\tmin-height: 46px;\n\t}\n\t.info-box-text-container {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 10px 12px;\n\t\tcolor: $v2-text-gray;\n\t\tfont-size: 11px;\n\t\tfont-weight: 500;\n\n\t\t.wrapper {\n\t\t\tdisplay: flex;\n\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-bottom: 16px;\n\t\t\t}\n\n\t\t\t.header {\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t\tfont-size: 12px;\n\n\t\t\t\t&:not(.first) {\n\t\t\t\t\tborder-top: 1px solid ", ";\n\t\t\t\t\tpadding-top: 16px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.title {\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t\tdisplay: flex;\n\t\t\t\t.title-text {\n\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.details {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.detail {\n\t\t\t\t\tpadding: 5px 8px;\n\t\t\t\t\t&.boxed {\n\t\t\t\t\t\tborder: 1px solid ", ";\n\t\t\t\t\t\tbackground-color: #fff;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.description {\n\t\t\t\tfont-weight: normal;\n\t\t\t}\n\t\t}\n\t}\n\t.info-box-text {\n\t\tpadding: 13px;\n\t\tfont-family: $text-font-family;\n\t\tfont-size: 11px;\n\t\tfont-weight: 500;\n\t\tfont-style: normal;\n\t\tfont-stretch: normal;\n\t\tline-height: normal;\n\t\tcolor: $v2-text-gray;\n\t\twhite-space: pre-line;\n\t}\n\t.triangleBorder {\n\t\tz-index: 1099;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\theight: 0;\n\t\tborder-style: solid;\n\t\t&.left,\n\t\t&.right,\n\t\t&.topMiddle {\n\t\t\ttop: 0px;\n\t\t}\n\t\t&.lowerLeft,\n\t\t&.lowerRight,\n\t\t&.bottomMiddle {\n\t\t\tbottom: 0;\n\t\t}\n\t\t&.left,\n\t\t&.lowerLeft {\n\t\t\tborder-width: 15px 16px 15px 0;\n\t\t\tborder-color: transparent ", " transparent transparent;\n\t\t\tleft: -15px;\n\t\t}\n\t\t&.right,\n\t\t&.lowerRight {\n\t\t\tright: -15px;\n\t\t\tborder-width: 15px 0 15px 16px;\n\t\t\tborder-color: transparent transparent transparent ", ";\n\t\t}\n\t\t&.topMiddle {\n\t\t\tleft: 50%;\n\t\t\tborder-width: 16px 15px 0 15px;\n\t\t\tborder-color: ", " transparent transparent transparent;\n\t\t}\n\t\t&.bottomMiddle {\n\t\t\tleft: 50%;\n\t\t\tborder-width: 0 15px 16px 15px;\n\t\t\tborder-color: transparent transparent ", " transparent;\n\t\t}\n\t}\n\t.triangle {\n\t\tz-index: 1100;\n\t\tposition: absolute;\n\n\t\t&.right,\n\t\t&.lowerRight {\n\t\t\ttransform: rotate(90deg);\n\t\t}\n\n\t\t&.left,\n\t\t&.lowerLeft {\n\t\t\ttransform: rotate(-90deg);\n\t\t}\n\t\t&.bottomMiddle {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t\t&.topMiddle {\n\t\t\ttop: -8px;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, 0%);\n\t\t}\n\n\t\t&.left,\n\t\t&.right {\n\t\t\ttop: 8px;\n\t\t}\n\n\t\t&.lowerLeft,\n\t\t&.lowerRight,\n\t\t&.bottomMiddle {\n\t\t\tbottom: 5px;\n\t\t}\n\t\t&.left,\n\t\t&.lowerLeft {\n\t\t\tleft: -14px;\n\t\t}\n\t\t&.right,\n\t\t&.lowerRight {\n\t\t\tright: -14px;\n\t\t}\n\t}\n\t&.grey {\n\t\t.info-box-content {\n\t\t\tborder-radius: 4px;\n\t\t\tbox-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05);\n\t\t\tbackground-color: ", ";\n\t\t\tborder: solid 1px ", ";\n\t\t}\n\t\t.info-box-content {\n\t\t\tmin-height: 30px;\n\t\t}\n\t\t.info-box-text {\n\t\t\tpadding: 8px 16px;\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n\t&.bordered {\n\t\t.info-box-content {\n\t\t\tborder: solid 1px ", ";\n\t\t}\n\t}\n"])), CSS_CONSTANTS.v2_text_gray, CSS_CONSTANTS.app_border_color, CSS_CONSTANTS.v2_grey, CSS_CONSTANTS.v2_grey, CSS_CONSTANTS.v2_grey, CSS_CONSTANTS.v2_grey, CSS_CONSTANTS.v2_tooltip_grey, CSS_CONSTANTS.v2_grey, CSS_CONSTANTS.v2_text_gray, CSS_CONSTANTS.v2_grey);
var TooltipContentWrapper = Styled__default.div(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteral(["\n\tposition: relative;\n\tbackground: #ebebeb;\n\tborder: 1px solid #cbcbcb;\n"])));
var _this$1 = undefined;
var DeprecatedTooltip = function DeprecatedTooltip(_ref) {
  var infoText = _ref.infoText,
    triangleLocation = _ref.triangleLocation,
    shown = _ref.shown,
    width = _ref.width,
    customMaxWidth = _ref.customMaxWidth,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    noHidden = _ref.noHidden;
  var style = {
    top: top === null ? undefined : "".concat(top, "px"),
    bottom: bottom === null ? undefined : "".concat(bottom, "px"),
    left: left === null ? undefined : "".concat(left, "px"),
    right: right === null ? undefined : "".concat(right, "px")
  };
  if (width) {
    style.width = width + 'px';
  }
  if (customMaxWidth) {
    style.maxWidth = customMaxWidth + 'px';
  }
  var container = document.querySelector('#root-portal-container');
  return shown && container ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement(TooltipWrapper //ref={div => (this.component = div)}
  , {
    className: triangleLocation && triangleLocation.includes('right') ? ' flex' : '',
    style: style,
    onMouseEnter: function onMouseEnter() {
      return _this$1.setState({
        keepOpened: true
      });
    },
    onMouseLeave: function onMouseLeave() {
      return _this$1.setState({
        keepOpened: false
      });
    }
  }, /*#__PURE__*/React__default.createElement(TooltipContentWrapper, null, triangleLocation ? /*#__PURE__*/React__default.createElement("div", {
    className: "triangle ".concat(triangleLocation)
  }, /*#__PURE__*/React__default.createElement(Triangle$1, null)) : null, /*#__PURE__*/React__default.createElement("div", {
    className: 'info-box-content'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'info-box-text-container'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: 'info-box-text'
  }, infoText))))), container) : noHidden ? null : /*#__PURE__*/React__default.createElement("div", {
    className: 'hidden'
  });
};
DeprecatedTooltip.propTypes = {
  infoText: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object, PropTypes__default.array]).isRequired,
  triangleLocation: PropTypes__default.oneOf(['bottomMiddle', 'topMiddle', 'topRight', 'right', 'left', 'lowerLeft', 'lowerRight']),
  shown: PropTypes__default.bool.isRequired,
  autoPlaceOffset: PropTypes__default.object,
  timer: PropTypes__default.number,
  // prop that sets how long should pass unitl the tooltip is shown
  duration: PropTypes__default.number,
  // props that sets how long time should the tooltip be shown for after it has appeared
  infinteDuration: PropTypes__default.bool,
  // prop that will show the tooltip for as long as the element is hovered,
  translatedMessage: PropTypes__default.bool // should be set to true if detail messages you are passing are not language keys but already translated messages
};

var _templateObject$11;
var SIZE$g = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var CheckmarkIcon = function CheckmarkIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE$g.STANDARD : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#7CD99F' : _ref$color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$g.STANDARD:
        return '12';
      default:
        return '12';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$g.STANDARD:
        return '10';
      default:
        return '10';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$f, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M1 6.40971L4.46144 9L11 1",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
CheckmarkIcon.SIZE = SIZE$g;
CheckmarkIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  size: PropTypes__default.oneOf([SIZE$g.SMALL, SIZE$g.STANDARD])
};
var StyledSpan$f = Styled__default.span(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$12, _templateObject2$C, _templateObject3$s, _templateObject4$l, _templateObject5$h, _templateObject6$d, _templateObject7$c, _templateObject8$a, _templateObject9$8;
var ColorPickerWrapper = Styled__default.div(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteral(["\n    display:flex;\n    flex-direction:column;\n    border:1px solid #e6e6e6;\n    border-radius: 4px;\n"])));
var ProjectColorsSection = Styled__default.div(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteral(["\n    display:flex;\n    flex-direction:row;\n    flex-wrap:wrap;\n    padding: 16px;\n"])));
var ColorsWrapper = Styled__default.div(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral(["\n\tdisplay:flex;\n\tflex-direction:row;\n\tjustify-content: space-around;\n\tflex: 1;\n"])));
var ColorWrapper = Styled__default.div(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteral(["\n\tposition: relative;\n "])));
var SelectionBox = Styled__default.div(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: -4px;\n\tright: -4px;\n\twidth: 31px;\n\theight: 31px;\n\tborder: 2px solid ", ";\n\tbox-sizing: border-box;\n\tfilter: blur(1px);\n\tborder-radius: 6px;\n\n"])), function (props) {
  return props.isSelected ? props.color : 'transparent';
});
var ColorBox = Styled__default.div(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteral(["\n    height:23px;\n    width:23px;\n    border-radius:3px;\n\tbackground-color:", ";\n\tdisplay:flex;\n\tjustify-content:center;\n"])), function (props) {
  return props.color;
});
var HexPicker = Styled__default.div(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteral(["\n\tmargin: 16px 0 0 0;\n\tpadding: 16px 0 0 0;\n\twidth:100%;\n\tborder-top: solid 1px #e6e6e6;\n\n\tdisplay:flex;\n\tflex-direction:row;\n\talign-items:center;\n"])));
var CustomHexText = Styled__default.div(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteral(["\n\twidth:167px;\n\tfont-size: 13px;\n"])));
var HexColorInputWrapper = Styled__default.div(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteral(["\n\twidth:176px;\n\tmargin-right:19px;\n"])));
var ColorPicker = function ColorPicker(_ref) {
  var chooseColor = _ref.chooseColor,
    selectedColor = _ref.selectedColor,
    showHexPicker = _ref.showHexPicker;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    _erroCustomHexColor = _useState2[0],
    setErroCustomHexColor = _useState2[1];
  var _useState3 = React.useState(projectColors.includes(selectedColor) ? '' : selectedColor),
    _useState4 = _slicedToArray(_useState3, 2),
    _customHexColor = _useState4[0],
    setCustomHexColor = _useState4[1];
  var onSelectColor = function onSelectColor(color) {
    chooseColor(color);
    if (_erroCustomHexColor) {
      setCustomHexColor('');
    }
    setErroCustomHexColor(false);
  };
  var onSelectCustomColor = function onSelectCustomColor(color) {
    var formatedHex = color ? color.replace('#', '') : '';
    if (formatedHex.length === 6 && !isNaN(Number('0x' + formatedHex))) {
      chooseColor(color);
      setCustomHexColor(color || '');
      setErroCustomHexColor(false);
    } else {
      setErroCustomHexColor(true);
    }
  };
  return /*#__PURE__*/React__default.createElement(ColorPickerWrapper, null, /*#__PURE__*/React__default.createElement(ProjectColorsSection, null, /*#__PURE__*/React__default.createElement(ColorsWrapper, null, projectColors.map(function (color, idx) {
    var isSelected = selectedColor === color;
    return /*#__PURE__*/React__default.createElement(ColorWrapper, {
      key: idx,
      onClick: function onClick() {
        return onSelectColor(color);
      }
    }, /*#__PURE__*/React__default.createElement(SelectionBox, {
      color: color,
      isSelected: selectedColor === color
    }), /*#__PURE__*/React__default.createElement(ColorBox, {
      color: color,
      isSelected: isSelected
    }, isSelected && /*#__PURE__*/React__default.createElement(CheckmarkIcon, {
      color: 'white'
    })));
  })), showHexPicker && /*#__PURE__*/React__default.createElement(HexPicker, null, /*#__PURE__*/React__default.createElement(CustomHexText, null, "Custom HEX"), /*#__PURE__*/React__default.createElement(HexColorInputWrapper, null, /*#__PURE__*/React__default.createElement(HexColorInput, {
    value: _customHexColor,
    placeholder: projectColors[0],
    callback: onSelectCustomColor,
    alignLeft: true
  })), /*#__PURE__*/React__default.createElement(ColorWrapper, null, /*#__PURE__*/React__default.createElement(SelectionBox, {
    color: _customHexColor,
    isSelected: selectedColor === _customHexColor && !_erroCustomHexColor
  }), /*#__PURE__*/React__default.createElement(ColorBox, {
    color: !_erroCustomHexColor && _customHexColor || projectColors[0],
    isSelected: selectedColor === _customHexColor && !_erroCustomHexColor
  }, selectedColor === _customHexColor && !_erroCustomHexColor && /*#__PURE__*/React__default.createElement(CheckmarkIcon, {
    color: 'white'
  }))))));
};
ColorPicker.propTypes = {
  chooseColor: PropTypes__default.func,
  selectedColor: PropTypes__default.string,
  showHexPicker: PropTypes__default.bool
};
ColorPicker.defaultProps = {
  chooseColor: function chooseColor(color) {
    return console.log(color);
  },
  showHexPicker: false
};
var _templateObject$13;
var StyledSwitch = Styled__default.div(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteral(["\n    display: flex;\n\tflex-direction: column;\n\tposition: relative;\n\t.switch-container {\n\t\theight: 26px;\n\t\tborder: 2px solid transparent;\n\t\tborder-radius: 13px;\n\t\tbackground-color: #dbdbdb;\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\tcursor: pointer;\n\t\t-webkit-transition: 0.2s;\n\t\ttransition: 0.2s;\n\t\toutline: none;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\t.locked-switch {\n\t\topacity: 0.5;\n\t}\n\n\t.toggled-on {\n\t\tbackground-color:#6e0fea;\n\t}\n\n\t.switch-box {\n\t\tdisplay: none;\n\t}\n\n\t.switch-slider {\n\t\tposition: absolute;\n\t\tcursor: pointer;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tleft: 3px;\n\t\tright: 0;\n\t\tbottom: 0;\n\n\t\theight: 20px;\n\t\twidth: 20px;\n\n\t\tbackground-color: #ffffff;\n\t\tborder-radius: 26px;\n\n\t\t-webkit-transition: 0.2s;\n\t\ttransition: 0.2s;\n\t}\n\n\t.toggled-on .switch-slider {\n\t\tleft: 80%;\n\t\ttransform: translate(-60%, -50%);\n\t}\n\n\t.switch-container:focus .switch-slider {\n\t\tbackground-color: #a9a9a9;\n\t}\n"])));
var Switch = function Switch(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    locked = _ref.locked,
    id = _ref.id,
    onBlur = _ref.onBlur,
    cy = _ref.cy;
  var handleOnChange = function handleOnChange(e) {
    e.stopPropagation();
    if (onChange) {
      onChange(checked);
    }
  };
  var keyPressHandler = function keyPressHandler(e) {
    e.preventDefault();
    if (e.key === 'Enter' || e.key === ' ') handleOnChange(e);
  };
  return /*#__PURE__*/React__default.createElement(StyledSwitch, null, /*#__PURE__*/React__default.createElement("label", {
    style: {
      height: 18,
      width: 30
    },
    className: (checked ? 'switch-container toggled-on' : 'switch-container') + (locked ? ' locked-switch' : ''),
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      return keyPressHandler(e);
    },
    onBlur: onBlur
  }, /*#__PURE__*/React__default.createElement("input", {
    "data-cy": 'switch-slider' + (cy ? '-' + cy : ''),
    style: {
      height: 18
    },
    type: "checkbox",
    className: "switch-box",
    disabled: locked,
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    checked: checked,
    id: id
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      height: 18 * (3 / 5),
      width: 18 * (3 / 5)
    },
    className: "switch-slider"
  })));
};
Switch.propTypes = {
  onChange: PropTypes__default.func,
  checked: PropTypes__default.bool.isRequired,
  locked: PropTypes__default.bool,
  id: PropTypes__default.string,
  onBlur: PropTypes__default.func,
  cy: PropTypes__default.string
};
Switch.defaultProps = {
  checked: false
};
var _templateObject$14, _templateObject2$D, _templateObject3$t, _templateObject4$m;
var SelectDropdownContainer = Styled__default.div(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteral(["\n"])));
var DropdownMenu = Styled__default.div(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteral(["\n\tborder-radius: 6px;\n\tbox-shadow: 0px 4px 8px 4px rgba(0, 0, 0, 0.1);;\n    width: fit-content;\n    padding: 10px 0;\n\tposition: absolute;\n\tbackground: white;\n\tz-index: 10;\n"])));
var SelectDropdownStyled = Styled__default.div(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteral(["\n    width: fit-content;\n\tcursor: ", ";\n\tborder-radius: 4px;\n\tfont-size: 12px;\n\tline-height: 12px;\n    padding: 5px 0px 5px 8px;\n\tdisplay: flex;\n    align-items: center;\n    column-gap: 8px;\n    border: 1px solid transparent;\n    \n    :hover, &.expanded {\n\t    background-color: ", ";\n    }\n\tcolor: ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return !disabled && '#F7F7FE';
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && '#a1a1a1';
});
var OptionStyle = Styled__default(PopupElement)(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteral(["\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tpadding: 0;\n\tmargin: 0;\n\tfont-size: 12px;\n\tpadding: 4px 12px;\n\tcursor: ", ";\n\tcolor: ", ";\n"])), function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? '#a1a1a1' : '#545454';
});
var SelectDropdown = function SelectDropdown(_ref) {
  var selectedValue = _ref.selectedValue,
    cy = _ref.cy,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    children = _ref.children;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var buttonGroupRef = React.useRef();
  var toggleExpanded = function toggleExpanded() {
    setExpanded(!disabled && !expanded);
  };
  var selectedOption = React.useMemo(function () {
    return React__default.Children.toArray(children).find(function (child) {
      return selectedValue === child.props.value;
    });
  }, [children, selectedValue]);
  var handleClickOutside = function handleClickOutside(event) {
    if (buttonGroupRef.current && !buttonGroupRef.current.contains(event.target)) {
      setExpanded(false);
    }
  };
  var handleOnClick = function handleOnClick(value) {
    setExpanded(false);
    onClick(value);
  };
  React.useEffect(function () {
    // Bind the event listener
    document.addEventListener('click', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
    };
  });
  return /*#__PURE__*/React__default.createElement(SelectDropdownContainer, {
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(SelectDropdownStyled, {
    onClick: toggleExpanded,
    className: expanded && 'expanded',
    ref: buttonGroupRef,
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement("span", null, selectedOption), /*#__PURE__*/React__default.createElement(IconContainer$2, null, /*#__PURE__*/React__default.createElement(CaretIcon, {
    color: disabled ? '#a1a1a1' : '#4C4C58',
    direction: expanded ? CaretIcon.DIRECTION.UP : CaretIcon.DIRECTION.DOWN,
    tabIndex: "-1"
  }))), expanded && /*#__PURE__*/React__default.createElement(DropdownMenu, null, React__default.Children.map(children, function (child) {
    var _child$props = child.props,
      value = _child$props.value,
      disabled = _child$props.disabled;
    return /*#__PURE__*/React__default.createElement(OptionStyle, {
      onClick: function onClick() {
        return !disabled && handleOnClick(value);
      },
      disabled: disabled
    }, child);
  })));
};
SelectDropdown.propTypes = {
  selectedValue: PropTypes__default.any.isRequired,
  onClick: PropTypes__default.func.isRequired,
  children: PropTypes__default.node.isRequired,
  cy: PropTypes__default.string,
  disabled: PropTypes__default.bool
};
var Option = function Option(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    cy = _ref.cy;
  var textColor = disabled && '#a1a1a1';
  return /*#__PURE__*/React__default.createElement("div", {
    color: textColor,
    "data-cy": cy,
    title: children
  }, children);
};
Option.propTypes = {
  children: PropTypes__default.any,
  value: PropTypes__default.any,
  disabled: PropTypes__default.bool,
  cy: PropTypes__default.string
};
SelectDropdown.Option = Option;
var _templateObject$15;
var DeactivatedIcon = function DeactivatedIcon(_ref) {
  var text = _ref.text,
    isBold = _ref.isBold;
  //return <StyledIcon>{intl.formatMessage({id: 'team.deactivated-group-title'})}</StyledIcon>;
  return /*#__PURE__*/React__default.createElement(StyledIcon, {
    isBold: isBold
  }, text);
};
DeactivatedIcon.propTypes = {
  text: PropTypes__default.string,
  isBold: PropTypes__default.bool
};
var StyledIcon = Styled__default.div(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteral(["\n\tfont-size: 11px;\n\tborder: 1px solid ", ";\n\tborder-radius: 11px;\n\tpadding: 4px 8px;\n\t", "\n\talign-self: center;\n    color: ", ";\n    margin-left: 8px;\n"])), CSS_CONSTANTS.v2_button_very_light_grey, function (props) {
  return props.isBold ? 'font-weight: 500;' : 'font-weight: 400;';
}, CSS_CONSTANTS.v2_text_gray);
var _templateObject$16, _templateObject2$E, _templateObject3$u, _templateObject4$n;
// eslint-disable-next-line no-unused-vars

var Hexagon$1 = function Hexagon(_ref) {
  var searchString = _ref.searchString,
    value = _ref.value,
    text = _ref.text,
    imgUrl = _ref.imgUrl,
    active = _ref.active,
    children = _ref.children,
    intl = _ref.intl,
    cy = _ref.cy;
  return /*#__PURE__*/React__default.createElement(Container$d, {
    "data-cy": cy
  }, /*#__PURE__*/React__default.createElement(HexagonContainer, {
    title: text
  }, imgUrl ? /*#__PURE__*/React__default.createElement(Image$1, {
    crossOrigin: "use-credentials",
    src: imgUrl
  }) : /*#__PURE__*/React__default.createElement(HexagonImg, {
    className: "SMALL initials"
  }, TextUtils.getInitials(text))), children, active === false && /*#__PURE__*/React__default.createElement(DeactivatedIcon, {
    intl: intl
  }));
};
Hexagon$1.propTypes = {
  text: PropTypes__default.string.isRequired,
  subText: PropTypes__default.string,
  imgUrl: PropTypes__default.string,
  searchString: PropTypes__default.string,
  cy: PropTypes__default.string,
  value: PropTypes__default.any,
  active: PropTypes__default.bool,
  intl: PropTypes__default.any,
  children: PropTypes__default.any
};
Hexagon$1.defaultProps = {
  color: '#470c93'
};
var Container$d = Styled__default.div(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteral(["\n\tbackground-color: transparent;\n\tdisplay: flex;\n\tflex-direction: row;\n\tpadding: 5px 0;\n\talign-items: center;\n\t/* max-width: 100%; */\n\theight: 36px;\n"])));
var HexagonContainer = Styled__default.div(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteral(["\n\t\n\twidth: 28px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"])));
var Image$1 = Styled__default.img(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteral(["\n\theight: 26px;\n"])));
var HexagonImg = Styled__default.div(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 11px;\n\n\tposition: relative;\n\tbackground-color: ", ";\n\ttext-transform: uppercase;\n\tcolor: white;\n\t\n\t&:before,\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 0;\n\t\tleft: 0px;\n\t\tborder-left: 12.5px solid transparent;\n\t\tborder-right: 12.5px solid transparent;\n\t}\n\n\t&:before {\n\t\tbottom: 100%;\n\t\tborder-bottom: ", ";\n\t}\n\n\t&:after {\n\t\ttop: 100%;\n\t\twidth: 0;\n\t\tborder-top: ", ";\n\t}\n\t&.EXTRA_SMALL {\n\t\twidth: 21px;\n\t\theight: 12.12px;\n\t\tmargin: 6.06px 0;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-left: 10.5px solid transparent;\n\t\t\tborder-right: 10.5px solid transparent;\n\t\t}\n\t\t&:before {\n\t\t\tborder-bottom: ", ";\n\t\t}\n\t\t&:after {\n\t\t\tborder-top: ", ";\n\t\t}\n\t\t.initials {\n\t\t\tfont-size: 9px;\n\t\t}\n\t}\n\t&.SMALL {\n\t\twidth: 23px;\n\t\theight: 13.28px;\n\t\tmargin-right: 5px;\n\t\t&:before,\n\t\t&:after {\n\t\t\tborder-left: 11.5px solid transparent;\n\t\t\tborder-right: 11.5px solid transparent;\n\t\t}\n\t\t&:before {\n\t\t\tborder-bottom: ", ";\n\t\t}\n\t\t&:after {\n\t\t\tborder-top: ", ";\n\t\t}\n\t\t.initials {\n\t\t\tfont-size: 10px;\n\t\t}\n\t}\n\n"])), function (props) {
  return props.theme.colors.forecastPurple;
}, function (props) {
  return "7.22px solid ".concat(props.theme.colors.forecastPurple);
}, function (props) {
  return "7.22px solid ".concat(props.theme.colors.forecastPurple);
}, function (props) {
  return "6.06px solid ".concat(props.theme.colors.forecastPurple);
}, function (props) {
  return "6.06px solid ".concat(props.theme.colors.forecastPurple);
}, function (props) {
  return "6.64px solid ".concat(props.theme.colors.forecastPurple);
}, function (props) {
  return "6.64px solid ".concat(props.theme.colors.forecastPurple);
});
var _templateObject$17, _templateObject2$F, _templateObject3$v, _templateObject4$o, _templateObject5$i;
// eslint-disable-next-line no-unused-vars

var HexagonText = function HexagonText(_ref) {
  var searchString = _ref.searchString,
    value = _ref.value,
    text = _ref.text,
    subText = _ref.subText,
    imgUrl = _ref.imgUrl,
    active = _ref.active,
    intl = _ref.intl;
  return /*#__PURE__*/React__default.createElement(Hexagon$1, {
    searchString: searchString,
    value: value,
    text: text,
    subText: subText,
    imgUrl: imgUrl,
    active: active,
    intl: intl
  }, subText ? /*#__PURE__*/React__default.createElement(TextContainer$2, null, /*#__PURE__*/React__default.createElement(HeadingText, {
    title: text
  }, text), /*#__PURE__*/React__default.createElement(SubText, {
    title: subText
  }, subText)) : /*#__PURE__*/React__default.createElement(Text$7, {
    title: text
  }, text));
};
HexagonText.propTypes = {
  text: PropTypes__default.string.isRequired,
  subText: PropTypes__default.string,
  imgUrl: PropTypes__default.string,
  searchString: PropTypes__default.string,
  value: PropTypes__default.any,
  active: PropTypes__default.bool,
  intl: PropTypes__default.any
};
var Container$e = Styled__default.div(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteral(["\n\tbackground-color: transparent;\n\tdisplay: flex;\n\tflex-direction: row;\n\tpadding: 5px 0;\n\talign-items: center;\n\t/* max-width: 100%; */\n\theight: 36px;\n"])));
var TextContainer$2 = Styled__default.div(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n\t/* max-width: 100%; */\n\tflex-grow: 1;\n  \toverflow: hidden;\n"])));
var Text$7 = Styled__default.div(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteral(["\n\twhite-space: nowrap;\n  \toverflow: hidden;\n  \ttext-overflow: ellipsis;\n\tpadding: 0;\n\tmargin: 0;\n\tflex-grow: 1;\n\tfont-size: 13px;\n\tcolor: ", ";\n"])), function (props) {
  return props.theme.colors.textLightGray;
});
var HeadingText = Styled__default(Text$7)(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteral(["\n\tfont-size: 13px;\n\tfont-weight: 500;\n"])));
var SubText = Styled__default(Text$7)(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteral(["\n\tfont-size:11px;\n"])));
var _templateObject$18, _templateObject2$G, _templateObject3$w, _templateObject4$p, _templateObject5$j;
// eslint-disable-next-line no-unused-vars

var IconText = function IconText(_ref) {
  var children = _ref.children,
    searchString = _ref.searchString,
    value = _ref.value,
    text = _ref.text,
    title = _ref.title;
  return /*#__PURE__*/React__default.createElement(Container$f, null, /*#__PURE__*/React__default.createElement(IconContainer$4, null, children), /*#__PURE__*/React__default.createElement(TextContainer$3, null, title ? /*#__PURE__*/React__default.createElement(Title$2, null, title) : null, /*#__PURE__*/React__default.createElement(Text$8, null, text)));
};
var TextContainer$3 = Styled__default.div(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteral(["\n\tcursor: default;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content:space-between;\n"])));
var Title$2 = Styled__default.div(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteral(["\n\topacity: 0.7;\n\tfont-size: 9px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
var Container$f = Styled__default.div(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteral(["\n\tbackground-color: transparent;\n\tdisplay: flex;\n\tflex-direction: row;\n\tpadding: 5px 0;\n\twidth: 100%;\n\talign-items: center;\n"])));
var IconContainer$4 = Styled__default.div(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-right: 5px;\n"])));
var Text$8 = Styled__default.p(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteral(["\n\tpadding: 0;\n\tmargin: 0;\n\tflex-grow: 1;\n\tfont-size: 13px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcolor: ", ";\n"])), function (props) {
  return props.theme.colors.textLightGray;
});
IconText.propTypes = {
  children: PropTypes__default.any,
  text: PropTypes__default.string,
  searchString: PropTypes__default.string,
  value: PropTypes__default.any,
  title: PropTypes__default.any
};

// eslint-disable-next-line no-unused-vars

var IconTextIcon = function IconTextIcon(_ref) {
  var children = _ref.children,
    searchString = _ref.searchString,
    value = _ref.value,
    text = _ref.text;
  return /*#__PURE__*/React__default.createElement(Container$f, null, /*#__PURE__*/React__default.createElement(IconContainer$4, null, children[0]), /*#__PURE__*/React__default.createElement(Text$8, null, text), /*#__PURE__*/React__default.createElement(IconContainer$4, null, children[1]));
};
IconTextIcon.propTypes = {
  children: PropTypes__default.arrayOf(PropTypes__default.element).isRequired,
  text: PropTypes__default.string,
  searchString: PropTypes__default.string,
  value: PropTypes__default.any
};
var _templateObject$19;
var Loader = Styled__default.div(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteral(["\ndisplay: flex;\nwidth: 80px;\nheight: 10px;\nbackground-color: #f5f5f8;\nborder-radius: 2px;\n"])));
var CalculationLoader = function CalculationLoader() {
  return /*#__PURE__*/React__default.createElement(Loader, null);
};
var _templateObject$1a, _templateObject2$H;
var UnapprovedIconWrapper = Styled__default.div(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 24px;\n    border-radius: 4px;\n    background-color: rgba(208, 2, 27, 0.1);\n    margin-right: 8px;\n    padding: 0 8px;\n"])));
var UnapprovedText = Styled__default.div(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteral(["\n    font-weight: 600;\n    font-size: 11px;\n    color: #d0021b;\n"])));
var UnapprovedIcon = function UnapprovedIcon(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React__default.createElement(UnapprovedIconWrapper, null, /*#__PURE__*/React__default.createElement(UnapprovedText, null, text));
};
UnapprovedIcon.propTypes = {
  text: PropTypes__default.string
};
var _templateObject$1b, _templateObject2$I;
var StyledSpan$g = Styled__default.span(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var StyledSVG$2 = Styled__default.svg(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tfill: ", ";\n\t&:hover\t{ \n\t\tfill: ", ";\n\t}\n"])), function (props) {
  return props.active ? props.theme.colors.starYellow : props.theme.colors.textGray;
}, function (props) {
  return props.theme.colors.starYellow;
});
var SIZE$h = {
  STANDARD: 'standard',
  LARGE: 'large'
};
var StarIcon = function StarIcon(_ref) {
  var size = _ref.size,
    active = _ref.active,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$h.STANDARD:
        return '14';
      case SIZE$h.LARGE:
        return '32';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$h.STANDARD:
        return '14';
      case SIZE$h.LARGE:
        return '32';
      default:
        return '14';
    }
  };
  var handleStarClick = function handleStarClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick();
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$g, {
    onClick: handleStarClick,
    width: getWidth(size),
    height: getHeight(size),
    "data-cy": 'star-icon'
  }, /*#__PURE__*/React__default.createElement(StyledSVG$2, {
    xmlns: "http://www.w3.org/2000/svg",
    width: getWidth(size),
    height: getHeight(size),
    viewBox: '0 0 14 14',
    active: active
  }, active ? /*#__PURE__*/React__default.createElement("path", {
    fillRule: "nonzero",
    d: "M3.46 13.798a1.391 1.391 0 0 1-1.9-.45 1.352 1.352 0 0 1-.141-1.12l1.183-3.753L.445 6.506a1.354 1.354 0 0 1-.079-1.93c.262-.28.63-.439 1.016-.439h2.926L5.73.832A1.388 1.388 0 0 1 8.272.83l1.424 3.306h2.922c.763 0 1.382.612 1.382 1.366 0 .38-.161.745-.445 1.003l-2.157 1.969 1.183 3.753c.227.72-.18 1.485-.908 1.71-.38.117-.793.066-1.133-.14L7 11.652l-3.54 2.146z"
  }) : /*#__PURE__*/React__default.createElement("path", {
    fillRule: "nonzero",
    d: "M3.46 13.798a1.391 1.391 0 0 1-1.9-.45 1.352 1.352 0 0 1-.141-1.12l1.183-3.753L.445 6.506a1.354 1.354 0 0 1-.079-1.93c.262-.28.63-.439 1.016-.439h2.926L5.73.832A1.388 1.388 0 0 1 8.272.83l1.424 3.306h2.922c.763 0 1.382.612 1.382 1.366 0 .38-.161.745-.445 1.003l-2.157 1.969 1.183 3.753c.227.72-.18 1.485-.908 1.71-.38.117-.793.066-1.133-.14L7 11.652l-3.54 2.146zm7.636-.895c.078.047.173.06.261.032a.314.314 0 0 0 .21-.395l-1.384-4.387 2.652-2.419a.313.313 0 0 0-.217-.546H8.994l-1.7-3.946a.32.32 0 0 0-.587 0L5.011 5.189H1.382a.32.32 0 0 0-.235.101.313.313 0 0 0 .018.445l2.652 2.42-1.384 4.386a.312.312 0 0 0 .033.26.321.321 0 0 0 .438.103L7 10.42l4.096 2.483z"
  })));
};
StarIcon.SIZE = SIZE$h;
StarIcon.propTypes = {
  onClick: PropTypes__default.func,
  active: PropTypes__default.bool,
  size: PropTypes__default.oneOf([SIZE$h.STANDARD])
};
var _templateObject$1c, _templateObject2$J, _templateObject3$x, _templateObject4$q, _templateObject5$k;
var CenterWrapper = Styled__default.div(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteral(["\n\tmargin-left: auto;\n\tmargin-right: auto;\n"])));
var NoWidthLimitStyle = Styled.css(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteral(["\n\tdisplay: inline-flex;\n\tmax-width: none;\n"])));
var ProjectIndicatorStyle = Styled.css(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteral(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\toverflow: hidden;\n\tcolor: ", ";\n\toutline: ", ";\n\toutline-color: black;\n\twhite-space: nowrap;\n\n\tmin-width: ", ";\n\tmax-width: ", ";\n\theight: 20px;\n\tpadding-left: ", ";\n\tpadding-right: ", ";\n\tpadding-top: 1px;\n\tborder-radius: 6px;\n\tbackground-color: ", ";\n\tfont-size: 10px;\n\tfont-weight: 700;\n\ttext-decoration: none;\n\tcursor: ", ";\n\n\t", ";\n\n\t&:hover {\n\t\tcolor: ", ";\n\t\toutline: ", ";\n\t\toutline-color: black;\n\t}\n"])), function (props) {
  return ColorUtils.getInvertedTextColor(props.color);
}, function (props) {
  return props.showOutline ? '' : 'none';
}, function (props) {
  return props.small ? '38px' : '46px';
}, function (props) {
  return props.small ? '38px' : '46px';
}, function (props) {
  return props.small ? '4px' : '6px';
}, function (props) {
  return props.small ? '4px' : '6px';
}, function (props) {
  return props.color;
}, function (props) {
  return props.isDisabled ? 'inherit' : 'pointer';
}, function (props) {
  return props.noWidthLimit && NoWidthLimitStyle;
}, function (props) {
  return ColorUtils.getInvertedTextColor(props.color);
}, function (props) {
  return props.showOutline ? 'solid' : 'none';
});
var ProjectIndicatorLink = Styled__default.a(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteral(["\n\t", "\n"])), ProjectIndicatorStyle);
var ProjectIndicatorNoLink = Styled__default.div(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteral(["\n\t", "\n"])), ProjectIndicatorStyle);
var ProjectIndicator$1 = function ProjectIndicator(_ref) {
  var htmlId = _ref.htmlId,
    showOutline = _ref.showOutline,
    customId = _ref.customId,
    name = _ref.name,
    id = _ref.id,
    color = _ref.color,
    isConnectedProject = _ref.isConnectedProject,
    clearSubPath = _ref.clearSubPath,
    noTitle = _ref.noTitle,
    small = _ref.small,
    link = _ref.link,
    disableLink = _ref.disableLink,
    noWidthLimit = _ref.noWidthLimit,
    project = _ref.project;

  /*********************************************************************
   This is web-front logic, should really not be here in web-components
  **********************************************************************/
  var getNavigationString = function getNavigationString(project, clearSubPath) {
    if (!project) return null;
    var curLocArr = window.location.href.split('/');
    var pageName = curLocArr[curLocArr.length - 1];
    if (project.companyProjectGroupId) {
      return '/connected/X-' + project.companyProjectGroupId + '/' + (clearSubPath || pageName === 'my-list' ? '' : pageName);
    }
    return '/project/P-' + project.companyProjectId + '/' + (clearSubPath || pageName === 'my-list' ? '' : pageName);
  };
  var getCustomTitle = function getCustomTitle(customId, name) {
    return "".concat(customId, " - ").concat(name);
  };
  var getOldTitle = function getOldTitle() {
    return (project.companyProjectGroupId ? 'X' + project.companyProjectGroupId : 'P' + project.companyProjectId) + ' - ' + project.name;
  };
  var getNewTitle = function getNewTitle() {
    if (isConnectedProject) {
      return "X".concat(id);
    } else {
      return "P".concat(id, " - ").concat(name);
    }
  };
  var getOldIconText = function getOldIconText(connected) {
    return connected ? 'X' + project.companyProjectGroupId : 'P' + project.companyProjectId;
  };
  var getNewIconText = function getNewIconText() {
    return isConnectedProject ? "X".concat(id) : "P".concat(id);
  };
  var title = customId ? getCustomTitle(customId, name) : project ? getOldTitle() : getNewTitle();
  var iconText = customId ? customId : project ? getOldIconText(isConnected) : getNewIconText();
  var href = disableLink ? null : link ? link : getNavigationString(project, clearSubPath);
  var isConnected = project && project.companyProjectGroupId || isConnectedProject;
  var ProjectIndicatorComponent = disableLink ? ProjectIndicatorNoLink : ProjectIndicatorLink;
  return isConnected ? /*#__PURE__*/React__default.createElement(ProjectIndicatorComponent, {
    id: htmlId,
    showOutline: showOutline,
    onClick: disableLink ? null : function (e) {
      return e.stopPropagation();
    },
    isDisabled: disableLink,
    href: href,
    title: noTitle ? '' : title,
    color: project ? project.projectColor || color : color,
    noWidthLimit: noWidthLimit,
    small: small
  }, /*#__PURE__*/React__default.createElement(CenterWrapper, null, iconText)) : /*#__PURE__*/React__default.createElement(ProjectIndicatorComponent, {
    id: htmlId,
    showOutline: showOutline,
    onClick: disableLink ? null : function (e) {
      return e.stopPropagation();
    },
    isDisabled: disableLink,
    href: href,
    title: noTitle ? '' : title,
    color: project ? project.projectColor : color,
    noWidthLimit: noWidthLimit,
    small: small
  }, /*#__PURE__*/React__default.createElement(CenterWrapper, null, /*#__PURE__*/React__default.createElement("div", {
    "data-cy": "project-id"
  }, iconText)));
};
ProjectIndicator$1.propTypes = {
  htmlId: PropTypes__default.string,
  showOutline: PropTypes__default.bool,
  customId: PropTypes__default.string,
  name: PropTypes__default.string,
  id: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  color: PropTypes__default.string,
  isConnectedProject: PropTypes__default.bool,
  clearSubPath: PropTypes__default.bool,
  noTitle: PropTypes__default.bool,
  small: PropTypes__default.bool,
  link: PropTypes__default.string,
  disableLink: PropTypes__default.bool,
  noWidthLimit: PropTypes__default.bool,
  project: PropTypes__default.object
};
ProjectIndicator$1.defaultProps = {
  clearSubPath: false
};
var _templateObject$1d, _templateObject2$K;
var ProjectIndicatorStyle$1 = Styled__default.a(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteral(["\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\toverflow: hidden;\n\toutline:none;\n\t\n\tmin-width: 46px;\n\tmax-width: 46px;\n\theight: 20px;\n\tpadding-left: 6px;\n\tpadding-right: 6px;\n\tborder-radius: 6px;\n\n\tbackground-color: #F2F2F2;\n\tcolor: ", ";\n\tfont-size: 10px;\n\tfont-weight: 700;\n\ttext-decoration: none;\n"])), ColorUtils.getInvertedTextColor('#F2F2F2'));
var Container$g = Styled__default.div(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteral(["\n    display: flex;\n\n\t> *:not(:last-child) {\n\t\tmargin-right: 8px;\n\t}\n"])));
var ProjectIndicatorList = function ProjectIndicatorList(_ref) {
  var children = _ref.children,
    _ref$visibleCount = _ref.visibleCount,
    visibleCount = _ref$visibleCount === void 0 ? 3 : _ref$visibleCount;
  var childrenArray = React__default.Children.toArray(children);
  var showCounter = childrenArray.length > visibleCount;
  var visibleChildren = childrenArray.slice(0, showCounter ? visibleCount - 1 : visibleCount);
  var countNumber = childrenArray.length - visibleChildren.length;
  return /*#__PURE__*/React__default.createElement(Container$g, null, visibleChildren.map(function (child) {
    return child;
  }), showCounter && /*#__PURE__*/React__default.createElement(ProjectIndicatorStyle$1, null, "+".concat(countNumber)));
};
ProjectIndicatorList.propTypes = {
  children: PropTypes__default.node.isRequired,
  visibleCount: PropTypes__default.number
};
var _templateObject$1e, _templateObject2$L;
var Container$h = Styled__default.div(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteral(["\ndisplay:flex;\nflex-direction:row;\njustify-content:center;\nflex: 1;\nmin-width: 0;\n"])));
var Text$9 = Styled__default.div(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteral(["\npadding-left:9px;\nflex: 1;\nwhite-space: nowrap;\noverflow: hidden;\ntext-overflow: ellipsis;\n"])));
var ProjectIndicatorText = function ProjectIndicatorText(_ref) {
  var name = _ref.name,
    id = _ref.id,
    color = _ref.color,
    isConnectedProject = _ref.isConnectedProject,
    clearSubPath = _ref.clearSubPath,
    project = _ref.project,
    text = _ref.text,
    noTitle = _ref.noTitle,
    disableLink = _ref.disableLink;
  return /*#__PURE__*/React__default.createElement(Container$h, null, /*#__PURE__*/React__default.createElement(ProjectIndicator$1, {
    name: name,
    id: id,
    color: color,
    isConnectedProject: isConnectedProject,
    clearSubPath: clearSubPath,
    project: project,
    noTitle: noTitle,
    disableLink: disableLink
  }), /*#__PURE__*/React__default.createElement(Text$9, {
    title: text
  }, text));
};
ProjectIndicatorText.propTypes = {
  name: PropTypes__default.string,
  id: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  color: PropTypes__default.string,
  isConnectedProject: PropTypes__default.bool,
  text: PropTypes__default.string,
  project: PropTypes__default.object,
  clearSubPath: PropTypes__default.bool,
  noTitle: PropTypes__default.bool,
  disableLink: PropTypes__default.bool
};
ProjectIndicatorText.defaultProps = {
  clearSubPath: false
};
var _templateObject$1f;
var SIZE$i = {
  SMALL: 'small',
  MEDIUM: 'medium',
  STANDARD: 'standard'
};
var PlusIcon = function PlusIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$i.SMALL:
        return '6';
      case SIZE$i.MEDIUM:
        return '9';
      case SIZE$i.STANDARD:
        return '14';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$i.SMALL:
        return '6';
      case SIZE$i.MEDIUM:
        return '9';
      case SIZE$i.STANDARD:
        return '14';
      default:
        return '14';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$h, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Top-Menu---Hover",
    transform: "translate(-22.000000, -18.000000)",
    fill: color
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Top-Menu",
    transform: "translate(-1342.000000, 0.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "PlusButton",
    transform: "translate(1342.000000, 0.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Plus",
    transform: "translate(22.000000, 18.000000)"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-5",
    x: "6",
    y: "0",
    width: "2",
    height: "14"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-5",
    transform: "translate(7.000000, 7.000000) rotate(-270.000000) translate(-7.000000, -7.000000) ",
    x: "6",
    y: "0",
    width: "2",
    height: "14"
  }))))))));
};
PlusIcon.SIZE = SIZE$i;
PlusIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$i.SMALL, SIZE$i.MEDIUM, SIZE$i.STANDARD])
};
var StyledSpan$h = Styled__default.span(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1g;
var SIZE$j = {
  SMALL: 'small',
  MEDIUM: 'medium',
  STANDARD: 'standard'
};
var MinusIcon = function MinusIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$j.SMALL:
        return '6';
      case SIZE$j.MEDIUM:
        return '9';
      case SIZE$j.STANDARD:
        return '14';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$j.SMALL:
        return '6';
      case SIZE$j.MEDIUM:
        return '9';
      case SIZE$j.STANDARD:
        return '14';
      default:
        return '14';
    }
  };
  var handleClick = function handleClick(e) {
    /*
              We only want to stop propagation if onClick is set i props
              otherwise we want the click to propagate up
          */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$i, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Top-Menu---Hover",
    transform: "translate(-22.000000, -18.000000)",
    fill: color
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Top-Menu",
    transform: "translate(-1342.000000, 0.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "MinusButton",
    transform: "translate(1342.000000, 0.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Minus",
    transform: "translate(22.000000, 18.000000)"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-5",
    transform: "translate(7.000000, 7.000000) rotate(-270.000000) translate(-7.000000, -7.000000) ",
    x: "6",
    y: "0",
    width: "2",
    height: "14"
  }))))))));
};
MinusIcon.SIZE = SIZE$j;
MinusIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$j.SMALL, SIZE$j.MEDIUM, SIZE$j.STANDARD])
};
var StyledSpan$i = Styled__default.span(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1h;
var SIZE$k = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var CopyIcon = function CopyIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$k.SMALL:
        return '10';
      case SIZE$k.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$k.SMALL:
        return '10';
      case SIZE$k.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$j, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M15.8501 20.125C15.8501 20.4565 15.7184 20.7745 15.484 21.0089C15.2496 21.2433 14.9316 21.375 14.6001 21.375H5.8501C5.51858 21.375 5.20063 21.2433 4.96621 21.0089C4.73179 20.7745 4.6001 20.4565 4.6001 20.125V8.875C4.6001 8.54348 4.73179 8.22554 4.96621 7.99112C5.20063 7.7567 5.51858 7.625 5.8501 7.625H12.2076C12.5389 7.62507 12.8566 7.75665 13.0909 7.99083L15.4843 10.3842C15.7184 10.6185 15.85 10.9362 15.8501 11.2675V20.125Z",
    stroke: "#535353",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.14014 7.625V3.875C8.14014 3.54348 8.27183 3.22554 8.50625 2.99112C8.74067 2.7567 9.05862 2.625 9.39014 2.625H15.7476C16.0789 2.62507 16.3966 2.75665 16.631 2.99083L19.0243 5.38417C19.2585 5.6185 19.3901 5.93621 19.3901 6.2675V15.125C19.3901 15.4565 19.2584 15.7745 19.024 16.0089C18.7896 16.2433 18.4717 16.375 18.1401 16.375H15.9001",
    stroke: "#535353",
    strokeWidth: "1.2",
    strokeinecap: "round",
    strokeLinejoin: "round"
  })));
};
CopyIcon.SIZE = SIZE$k;
CopyIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf([SIZE$k.SMALL, SIZE$k.STANDARD])
};
var StyledSpan$j = Styled__default.span(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1i;
var SIZE$l = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var NotBillableIcon = function NotBillableIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$l.SMALL:
        return '14';
      case SIZE$l.STANDARD:
        return '16';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$l.SMALL:
        return '14';
      case SIZE$l.STANDARD:
        return '16';
      default:
        return '16';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$k, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    fill: color,
    height: getHeight(size),
    viewBox: "0 0 24 24",
    width: getWidth(size),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"
  })));
};
NotBillableIcon.SIZE = SIZE$l;
NotBillableIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$l.SMALL, SIZE$l.STANDARD])
};
var StyledSpan$k = Styled__default.span(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1j;
var SIZE$m = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var WarningIcon$1 = function WarningIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE$m.STANDARD : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000' : _ref$color,
    onClick = _ref.onClick,
    updated = _ref.updated;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$m.SMALL:
        return '14';
      case SIZE$m.STANDARD:
        return '16';
      default:
        return '14';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$m.SMALL:
        return '14';
      case SIZE$m.STANDARD:
        return '16';
      default:
        return '16';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$l, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, updated ? /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M7.39331 5.44109C7.39331 5.10542 7.66542 4.83331 8.00109 4.83331C8.33676 4.83331 8.60887 5.10542 8.60887 5.44109V9.08776C8.60887 9.42343 8.33676 9.69554 8.00109 9.69554C7.66542 9.69554 7.39331 9.42343 7.39331 9.08776V5.44109Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.0278 12.2799H8.01225C7.55734 12.2785 7.18457 11.9182 7.1673 11.4633C7.15922 11.2433 7.23984 11.0294 7.39102 10.8695C7.54221 10.7096 7.75126 10.6173 7.97117 10.6133H7.98672C8.44155 10.6138 8.8149 10.9735 8.83278 11.4283C8.84147 11.6487 8.76096 11.8634 8.60946 12.0237C8.45795 12.184 8.24825 12.2764 8.0278 12.2799Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37596 2.02282C7.06226 0.71261 8.93771 0.71261 9.62401 2.02282L14.7538 11.816C15.3932 13.0367 14.5077 14.5 13.1297 14.5H2.87024C1.49222 14.5 0.606807 13.0367 1.24622 11.816L6.37596 2.02282ZM8.73818 2.48682C8.42622 1.89127 7.57375 1.89127 7.26179 2.48682L2.13205 12.28C1.84141 12.8348 2.24387 13.5 2.87024 13.5H13.1297C13.7561 13.5 14.1586 12.8348 13.8679 12.28L8.73818 2.48682Z",
    fill: color
  })) : /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M8.566.235a.8.8 0 0 0-1.131 0l-7.2 7.2a.8.8 0 0 0 0 1.13l7.2 7.2a.798.798 0 0 0 1.13 0l7.2-7.2a.8.8 0 0 0 0-1.13l-7.2-7.2z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8 12.2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M7.2 9.188h1.6L9.6 4.8H6.4z"
  })));
};
WarningIcon$1.SIZE = SIZE$m;
WarningIcon$1.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  size: PropTypes__default.oneOf([SIZE$m.SMALL, SIZE$m.STANDARD]),
  updated: PropTypes__default.bool
};
var StyledSpan$l = Styled__default.span(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-self: center;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1k;
var SIZE$n = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var FilterIcon = function FilterIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$n.SMALL:
        return '11';
      case SIZE$n.STANDARD:
        return '15';
      default:
        return '15';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$n.SMALL:
        return '11';
      case SIZE$n.STANDARD:
        return '15';
      default:
        return '15';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$m, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M2.596 3.75L7.5 5.928l4.903-2.18L7.5 1.57 2.596 3.75zM7.5 7.5a.753.753 0 0 1-.304-.065l-6.75-3a.75.75 0 0 1 0-1.37l6.75-3a.749.749 0 0 1 .608 0l6.75 3a.749.749 0 0 1 0 1.37l-6.75 3a.753.753 0 0 1-.304.064zm3.75 2.722v1.649l-3.44 1.563a.754.754 0 0 1-.599.009L3.751 12v-1.625l3.736 1.557 3.763-1.71zm1.875-3.852v1.649L7.81 10.434a.754.754 0 0 1-.599.01L1.875 8.218V6.594l5.612 2.338 5.638-2.562z"
  })));
};
FilterIcon.SIZE = SIZE$n;
FilterIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$n.SMALL, SIZE$n.STANDARD])
};
var StyledSpan$m = Styled__default.span(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1l;
var SIZE$o = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var DragHandleIcon = function DragHandleIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$o.SMALL:
        return '14';
      case SIZE$o.STANDARD:
        return '15';
      default:
        return '15';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$o.SMALL:
        return '14';
      case SIZE$o.STANDARD:
        return '15';
      default:
        return '15';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$n, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "drag-handle",
    fill: color
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle",
    x: "5",
    y: "1",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: "9",
    y: "1",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-Copy",
    x: "5",
    y: "5",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: "9",
    y: "5",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: "5",
    y: "9",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: "9",
    y: "9",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: "5",
    y: "13",
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: "9",
    y: "13",
    width: "2",
    height: "2"
  })))));
};
DragHandleIcon.SIZE = SIZE$o;
DragHandleIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  opacity: PropTypes__default.number,
  size: PropTypes__default.oneOf([SIZE$o.SMALL, SIZE$o.STANDARD])
};
DragHandleIcon.defaultProps = {
  opacity: 1
};
var StyledSpan$n = Styled__default.span(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1m;
var SIZE$p = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var CollapseIcon = function CollapseIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$p.SMALL:
        return '16';
      case SIZE$p.STANDARD:
        return '24';
      default:
        return '15';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$p.SMALL:
        return '16';
      case SIZE$p.STANDARD:
        return '24';
      default:
        return '15';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$o, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    x: "0px",
    y: "0px",
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 24 24",
    style: {
      enableBackground: 'new 0 0 24 24'
    }
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Frame_-_24px"
  }, /*#__PURE__*/React__default.createElement("rect", {
    fill: "none",
    width: "24",
    height: "24"
  })), /*#__PURE__*/React__default.createElement("g", {
    id: "Line_Icons"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    fill: color,
    points: "12,13 16,13 16,11 12,11 12,8 7,12 12,16"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "2",
    y: "11",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "2",
    y: "8",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "2",
    y: "5",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "8",
    y: "2",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "5",
    y: "2",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "2",
    y: "2",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "2",
    y: "14",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "2",
    y: "17",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "2",
    y: "20",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "5",
    y: "20",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "8",
    y: "20",
    fill: color,
    width: "2",
    height: "2"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    fill: color,
    points: "11,2 11,7 13,7 13,4 20,4 20,20 13,20 13,18 11,18 11,22 22,22 22,2"
  })))));
};
CollapseIcon.SIZE = SIZE$p;
CollapseIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  opacity: PropTypes__default.number,
  size: PropTypes__default.oneOf([SIZE$p.SMALL, SIZE$p.STANDARD])
};
CollapseIcon.defaultProps = {
  opacity: 1
};
var StyledSpan$o = Styled__default.span(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-items: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1n;
var SIZE$q = {
  SMALL: 'small',
  STANDARD: 'standard',
  LARGE: 'large'
};
var LockIconStyle = Styled__default.span(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-items: center;\n\tcursor: pointer;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var LockIcon = function LockIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$q.SMALL:
        return '10';
      case SIZE$q.STANDARD:
        return '16';
      case SIZE$q.LARGE:
        return '40';
      default:
        return '10';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$q.SMALL:
        return '10';
      case SIZE$q.STANDARD:
        return '16';
      case SIZE$q.LARGE:
        return '40';
      default:
        return '10';
    }
  };
  var handleClick = function handleClick(e) {
    /*
        We only want to stop propagation if onClick is set i props
        otherwise we want the click to propagate up
      */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(LockIconStyle, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7083 16V11.6667C11.7083 9.46758 12.5819 7.35856 14.1369 5.80357C15.6918 4.24858 17.8009 3.375 19.9999 3.375C22.199 3.375 24.3081 4.24858 25.863 5.80357C27.418 7.35856 28.2916 9.46758 28.2916 11.6667V16H28.3333C31.0947 16 33.3333 18.2386 33.3333 21V31.6667C33.3333 34.4281 31.0947 36.6667 28.3333 36.6667H11.6666C8.9052 36.6667 6.66663 34.4281 6.66663 31.6667V21C6.66663 18.2386 8.9052 16 11.6666 16H11.7083ZM15.5511 7.21779C16.731 6.03787 18.3313 5.375 19.9999 5.375C21.6686 5.375 23.2689 6.03787 24.4488 7.21779C25.6287 8.3977 26.2916 9.99801 26.2916 11.6667V16H13.7083V11.6667C13.7083 9.99801 14.3712 8.3977 15.5511 7.21779ZM11.6666 18H28.3333C29.9901 18 31.3333 19.3432 31.3333 21V31.6667C31.3333 33.3235 29.9901 34.6667 28.3333 34.6667H11.6666C10.0098 34.6667 8.66663 33.3235 8.66663 31.6667V21C8.66663 19.3432 10.0098 18 11.6666 18Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 23.1667C20.5522 23.1667 21 23.6144 21 24.1667V27.5C21 28.0523 20.5522 28.5 20 28.5C19.4477 28.5 19 28.0523 19 27.5V24.1667C19 23.6144 19.4477 23.1667 20 23.1667Z",
    fill: color
  })));
};
LockIcon.SIZE = SIZE$q;
LockIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$q.SMALL, SIZE$q.STANDARD, SIZE$q.LARGE])
};
var _templateObject$1o;
var SIZE$r = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var EmailIcon = function EmailIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE$r.STANDARD : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#535353' : _ref$color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$r.STANDARD:
        return '12';
      default:
        return '12';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$r.STANDARD:
        return '10';
      default:
        return '10';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$p, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 16 12",
    fill: "none"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2.68433V10C1.5 10.1137 1.60297 10.25 1.78539 10.25H14.2101C14.3925 10.25 14.4955 10.1137 14.4955 10V2.68431L9.83726 6.14472L9.83721 6.14475C9.30696 6.53871 8.66021 6.75007 7.99771 6.75007C7.33521 6.75007 6.68846 6.53871 6.15821 6.14475L6.15817 6.14472L1.5 2.68433ZM13.2378 1.75H2.75766L7.0527 4.94064L7.05275 4.94068C7.32082 5.13985 7.65301 5.25007 7.99771 5.25007C8.34241 5.25007 8.6746 5.13985 8.94267 4.94068L8.94272 4.94064L13.2378 1.75ZM1.78539 0.25C0.824145 0.25 0 1.00913 0 2V10C0 10.9909 0.824145 11.75 1.78539 11.75H14.2101C15.1713 11.75 15.9955 10.9909 15.9955 10V2C15.9955 1.00913 15.1713 0.25 14.2101 0.25H1.78539Z",
    fill: color
  })));
};
EmailIcon.SIZE = SIZE$r;
EmailIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  size: PropTypes__default.oneOf([SIZE$r.SMALL, SIZE$r.STANDARD])
};
var StyledSpan$p = Styled__default.span(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1p;
var SIZE$s = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var TimesheetsIcon = function TimesheetsIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$s.SMALL:
        return '13';
      case SIZE$s.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$s.SMALL:
        return '13';
      case SIZE$s.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$q, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M16.5 0.001L12.361 0H5.642L1.5 0.001L1.35554 0.00786658C0.594888 0.0805513 0 0.721304 0 1.501V20.501L0.00686658 20.6455C0.0795513 21.4061 0.720304 22.001 1.5 22.001H9.5L9.58988 21.9929C9.82312 21.9506 10 21.7465 10 21.501C10 21.2249 9.77614 21.001 9.5 21.001H1.5L1.41012 20.9929C1.17688 20.9506 1 20.7465 1 20.501V1.501L1.00806 1.41112C1.05039 1.17788 1.25454 1.001 1.5 1.001H5.952H12.052H16.5L16.5899 1.00906C16.8231 1.05139 17 1.25554 17 1.501L16.9979 8.50143L17.0059 8.59131C17.0483 8.82456 17.2524 9.00143 17.4979 9.00143C17.774 9.00143 17.9979 8.77758 17.9979 8.50143L18 1.501L17.9931 1.35654C17.9204 0.595888 17.2797 0.001 16.5 0.001ZM14.001 6.501C14.001 6.22486 13.7771 6.001 13.501 6.001H4.4977L4.40782 6.00906C4.17457 6.05139 3.9977 6.25554 3.9977 6.501C3.9977 6.77714 4.22155 7.001 4.4977 7.001H13.501L13.5908 6.99294C13.8241 6.95061 14.001 6.74646 14.001 6.501ZM10.5 10.001C10.7761 10.001 11 10.2249 11 10.501C11 10.7465 10.8231 10.9506 10.5899 10.9929L10.5 11.001H4.4977C4.22155 11.001 3.9977 10.7771 3.9977 10.501C3.9977 10.2555 4.17457 10.0514 4.40782 10.0091L4.4977 10.001H10.5ZM9 14.501C9 14.2249 8.77614 14.001 8.5 14.001H4.4977L4.40782 14.0091C4.17457 14.0514 3.9977 14.2555 3.9977 14.501C3.9977 14.7771 4.22155 15.001 4.4977 15.001H8.5L8.58988 14.9929C8.82312 14.9506 9 14.7465 9 14.501ZM11 17.501C11 13.9111 13.9101 11.001 17.5 11.001C21.0899 11.001 24 13.9111 24 17.501C24 21.0909 21.0899 24.001 17.5 24.001C13.9101 24.001 11 21.0909 11 17.501ZM23 17.501C23 14.4634 20.5376 12.001 17.5 12.001C14.4624 12.001 12 14.4634 12 17.501C12 20.5386 14.4624 23.001 17.5 23.001C20.5376 23.001 23 20.5386 23 17.501ZM17.9919 14.4111C17.9496 14.1779 17.7455 14.001 17.5 14.001C17.2239 14.001 17 14.2249 17 14.501V17.501L17.0081 17.5909C17.0504 17.8241 17.2545 18.001 17.5 18.001H19.5L19.5899 17.9929C19.8231 17.9506 20 17.7465 20 17.501L19.9919 17.4111C19.9496 17.1779 19.7455 17.001 19.5 17.001H18V14.501L17.9919 14.4111Z",
    fill: color
  })));
};
TimesheetsIcon.SIZE = SIZE$s;
TimesheetsIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string.isRequired,
  size: PropTypes__default.oneOf([SIZE$s.SMALL, SIZE$s.STANDARD])
};
TimesheetsIcon.defaultProps = {
  color: '#535353'
};
var StyledSpan$q = Styled__default.span(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1q;
var SIZE$t = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var EyeIcon = function EyeIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick,
    isOpen = _ref.isOpen;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$t.SMALL:
        return '10';
      case SIZE$t.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$t.SMALL:
        return '10';
      case SIZE$t.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$r, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, isOpen ? /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M3.84618 10.578C3.38337 11.197 3.2 11.6933 3.2 12C3.2 12.3067 3.38337 12.8029 3.84618 13.422C4.29469 14.0219 4.95485 14.6683 5.77707 15.2641C7.42532 16.4585 9.65482 17.4 12 17.4C14.343 17.4 16.572 16.4459 18.2216 15.2438C19.0444 14.6442 19.7053 13.9955 20.1545 13.3971C20.6194 12.7778 20.8 12.2897 20.8 12C20.8 11.7103 20.6194 11.2222 20.1545 10.6029C19.7053 10.0045 19.0444 9.35576 18.2216 8.75619C16.572 7.55405 14.343 6.59999 12 6.59999C9.65482 6.59999 7.42532 7.54147 5.77707 8.73584C4.95485 9.33166 4.29469 9.97809 3.84618 10.578ZM5.07294 7.76414C6.87471 6.45852 9.34521 5.39999 12 5.39999C14.657 5.39999 17.128 6.47433 18.9284 7.78639C19.8306 8.44392 20.5821 9.1737 21.1142 9.8825C21.6306 10.5704 22 11.3181 22 12C22 12.6819 21.6306 13.4296 21.1142 14.1175C20.5821 14.8263 19.8306 15.5561 18.9284 16.2136C17.128 17.5257 14.657 18.6 12 18.6C9.34521 18.6 6.87471 17.5415 5.07294 16.2358C4.17016 15.5817 3.41782 14.8531 2.88508 14.1405C2.36663 13.4471 2 12.6933 2 12C2 11.3067 2.36663 10.5529 2.88508 9.85948C3.41782 9.1469 4.17016 8.41833 5.07294 7.76414Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 9.59999C10.6745 9.59999 9.59999 10.6745 9.59999 12C9.59999 13.3255 10.6745 14.4 12 14.4C13.3255 14.4 14.4 13.3255 14.4 12C14.4 10.6745 13.3255 9.59999 12 9.59999ZM8.39999 12C8.39999 10.0118 10.0118 8.39999 12 8.39999C13.9882 8.39999 15.6 10.0118 15.6 12C15.6 13.9882 13.9882 15.6 12 15.6C10.0118 15.6 8.39999 13.9882 8.39999 12Z",
    fill: "#4C4C58"
  })) : /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M20.1538 10.578C20.6166 11.197 20.8 11.6933 20.8 12C20.8 12.3 20.6244 12.7831 20.1795 13.3874C19.7481 13.9733 19.1121 14.6064 18.3176 15.1948C18.0513 15.392 17.9953 15.7678 18.1925 16.0341C18.3897 16.3004 18.7655 16.3564 19.0317 16.1592C19.9048 15.5126 20.6315 14.7974 21.1459 14.0988C21.6467 13.4185 22 12.6806 22 12C22 11.3067 21.6334 10.5529 21.1149 9.85948C20.5822 9.1469 19.8298 8.41833 18.9271 7.76414C17.1253 6.45852 14.6548 5.39999 12 5.39999C11.0354 5.39999 10.0962 5.54175 9.20668 5.78379C8.88694 5.87079 8.69826 6.20053 8.78526 6.52027C8.87226 6.84002 9.202 7.0287 9.52174 6.94169C10.3199 6.72453 11.1529 6.59999 12 6.59999C14.3452 6.59999 16.5747 7.54147 18.2229 8.73584C19.0452 9.33166 19.7053 9.97809 20.1538 10.578ZM5.8187 7.97827C5.62113 7.71225 5.2453 7.65676 4.97927 7.85434C4.10325 8.50497 3.37437 9.22268 2.85851 9.91907C2.35764 10.5952 2.00001 11.3291 2.00001 12C2.00001 12.6819 2.36944 13.4296 2.88579 14.1175C3.41786 14.8263 4.16936 15.5561 5.07164 16.2136C6.87205 17.5257 9.34302 18.6 12 18.6C12.966 18.6 13.9066 18.4597 14.7977 18.2196C15.1177 18.1334 15.3071 17.8041 15.2209 17.4842C15.1347 17.1642 14.8054 16.9747 14.4855 17.0609C13.6854 17.2765 12.8498 17.4 12 17.4C9.657 17.4 7.42796 16.4459 5.77838 15.2438C4.95565 14.6442 4.29466 13.9955 3.84548 13.3971C3.38058 12.7778 3.20001 12.2897 3.20001 12C3.20001 11.7159 3.37372 11.2396 3.82277 10.6334C4.25683 10.0474 4.89647 9.41061 5.69477 8.8177C5.9608 8.62012 6.01628 8.2443 5.8187 7.97827Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 9.59998C13.3255 9.59998 14.4 10.6745 14.4 12C14.4 12.3314 14.6687 12.6 15 12.6C15.3314 12.6 15.6 12.3314 15.6 12C15.6 10.0118 13.9882 8.39998 12 8.39998C11.6687 8.39998 11.4 8.66861 11.4 8.99998C11.4 9.33135 11.6687 9.59998 12 9.59998ZM9.00003 11.4C8.66865 11.4 8.40003 11.6686 8.40003 12C8.40003 13.9882 10.0118 15.6 12 15.6C12.3314 15.6 12.6 15.3314 12.6 15C12.6 14.6686 12.3314 14.4 12 14.4C10.6745 14.4 9.60003 13.3255 9.60003 12C9.60003 11.6686 9.3314 11.4 9.00003 11.4Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.87575 3.87572C3.64143 4.11003 3.64143 4.48993 3.87575 4.72425L19.2757 20.1243C19.5101 20.3586 19.89 20.3586 20.1243 20.1243C20.3586 19.8899 20.3586 19.51 20.1243 19.2757L4.72427 3.87572C4.48996 3.6414 4.11006 3.6414 3.87575 3.87572Z",
    fill: "#4C4C58"
  })));
};
EyeIcon.SIZE = SIZE$t;
EyeIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf([SIZE$t.SMALL, SIZE$t.STANDARD]),
  isOpen: PropTypes__default.bool
};
var StyledSpan$r = Styled__default.span(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1r;
var SIZE$u = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var ReloadIcon = function ReloadIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$u.SMALL:
        return '10';
      case SIZE$u.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$u.SMALL:
        return '10';
      case SIZE$u.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$s, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.3538 4.73999V9.58374H14.51",
    stroke: "#4C4C58",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.0143 19.37C10.663 19.3708 9.33745 19 8.18263 18.2983C7.0278 17.5965 6.08815 16.5907 5.4664 15.3909C4.84466 14.1911 4.56477 12.8434 4.65732 11.4952C4.74988 10.1471 5.21132 8.8503 5.99119 7.7467C6.77106 6.64311 7.83935 5.77518 9.07924 5.2378C10.3191 4.70042 11.6829 4.51429 13.0215 4.69974C14.36 4.8852 15.6218 5.43511 16.6689 6.28936C17.716 7.1436 18.5081 8.26928 18.9585 9.54334",
    stroke: "#4C4C58",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
ReloadIcon.SIZE = SIZE$u;
ReloadIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf([SIZE$u.SMALL, SIZE$u.STANDARD])
};
var StyledSpan$s = Styled__default.span(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1s;
/**
 * This Icon Component is used to show the expand / collapse icon based on a state.
 *
 * @param isOpen Should the icon be shown as expanded?
 * @param onClick This function will be called when clicking on the icon
 * @param hover Should there be a hover effect. Default is true.
 * @param cy data-cy for cypress. Optional.
 * @returns {JSX.Element} The Icon Component
 */

var ExpandableIcon = function ExpandableIcon(_ref) {
  var isOpen = _ref.isOpen,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$hover = _ref.hover,
    hover = _ref$hover === void 0 ? true : _ref$hover,
    _ref$cy = _ref.cy,
    cy = _ref$cy === void 0 ? undefined : _ref$cy;
  return /*#__PURE__*/React__default.createElement(StyledDiv, {
    onClick: onClick,
    hover: hover,
    "data-cy": cy
  }, isOpen ? /*#__PURE__*/React__default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0.175737 14.9758C-0.058579 15.2101 -0.058579 15.59 0.175737 15.8243C0.410051 16.0586 0.78995 16.0586 1.02426 15.8243L5.39999 11.4486V15C5.39999 15.3314 5.66862 15.6 5.99999 15.6C6.33137 15.6 6.59999 15.3314 6.59999 15V10C6.59999 9.66865 6.33137 9.40002 5.99999 9.40002H0.999994C0.668623 9.40002 0.399994 9.66865 0.399994 10C0.399994 10.3314 0.668623 10.6 0.999994 10.6H4.5515L0.175737 14.9758Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.6 6.00002C15.6 6.3314 15.3314 6.60002 15 6.60002H9.99999C9.66862 6.60002 9.39999 6.3314 9.39999 6.00002V1.00002C9.39999 0.668654 9.66862 0.400025 9.99999 0.400025C10.3314 0.400025 10.6 0.668654 10.6 1.00002V4.55147L14.9757 0.175737C15.21 -0.058579 15.5899 -0.058579 15.8243 0.175737C16.0586 0.410051 16.0586 0.78995 15.8243 1.02426L11.4485 5.40002H15C15.3314 5.40002 15.6 5.66865 15.6 6.00002Z",
    fill: "#4C4C58"
  })) : /*#__PURE__*/React__default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M6.42426 10.4242C6.65857 10.1899 6.65857 9.81003 6.42426 9.57571C6.18994 9.3414 5.81004 9.3414 5.57573 9.57571L1.2 13.9514V10.4C1.2 10.0686 0.931371 9.8 0.6 9.8C0.268629 9.8 0 10.0686 0 10.4V15.4C0 15.7314 0.268629 16 0.6 16H5.6C5.93137 16 6.2 15.7314 6.2 15.4C6.2 15.0686 5.93137 14.8 5.6 14.8H2.0485L6.42426 10.4242Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.4 -6.10352e-05C10.0686 -6.10352e-05 9.79998 0.268568 9.79998 0.599939C9.79998 0.93131 10.0686 1.19994 10.4 1.19994H13.9515L9.57572 5.5757C9.3414 5.81001 9.3414 6.18991 9.57572 6.42423C9.81003 6.65854 10.1899 6.65854 10.4242 6.42423L14.8 2.0485V5.59994C14.8 5.93131 15.0686 6.19994 15.4 6.19994C15.7313 6.19994 16 5.93131 16 5.59994V0.599939C16 0.268568 15.7313 -6.10352e-05 15.4 -6.10352e-05H10.4Z",
    fill: "#4C4C58"
  })));
};
ExpandableIcon.propTypes = {
  isOpen: PropTypes__default.bool.isRequired,
  onClick: PropTypes__default.func,
  hover: PropTypes__default.bool,
  cy: PropTypes__default.string
};
var StyledDiv = Styled__default.div(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\t\n\talign-self: center;\n\tjustify-content: center;\n    align-items: center;\n\theight: 32px;\n\twidth: 32px;\n\tborder: 1px solid #FFFFFF;\n\tborder-radius: 4px;\n\t\n\t", "\n"])), function (_ref2) {
  var hover = _ref2.hover;
  return hover && "&:hover {\n\t\tbackground-color:#F7F7FE;\n\t\tborder: 1px solid #F7F7FE;\n\t";
});
var _templateObject$1t;
var SIZE$v = {
  SMALL: 'small',
  MEDIUM: 'medium',
  STANDARD: 'standard'
};
var NewTabIcon = function NewTabIcon(_ref) {
  var size = _ref.size,
    color = _ref.color,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$v.SMALL:
        return '12';
      case SIZE$v.MEDIUM:
        return '16';
      case SIZE$v.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$v.SMALL:
        return '12';
      case SIZE$v.MEDIUM:
        return '16';
      case SIZE$v.STANDARD:
        return '24';
      default:
        return '24';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$t, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.0759 12.8501C10.8416 12.6158 10.8416 12.2359 11.0759 12.0016L18.4687 4.60882L14.6997 4.60883C14.3684 4.60883 14.0997 4.3402 14.0997 4.00883C14.0997 3.67746 14.3684 3.40883 14.6997 3.40883L19.9172 3.40881C20.0764 3.40881 20.229 3.47203 20.3415 3.58455C20.454 3.69707 20.5172 3.84969 20.5172 4.00882L20.5172 9.18088C20.5172 9.51225 20.2486 9.78088 19.9172 9.78088C19.5858 9.78087 19.3172 9.51224 19.3172 9.18087L19.3172 5.45733L11.9244 12.8501C11.6901 13.0845 11.3102 13.0845 11.0759 12.8501Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.60002 7.40002C4.60002 6.40591 5.40591 5.60002 6.40002 5.60002H9.76253C10.0939 5.60002 10.3625 5.3314 10.3625 5.00002C10.3625 4.66865 10.0939 4.40002 9.76253 4.40002H6.40002C4.74317 4.40002 3.40002 5.74317 3.40002 7.40002V17.6C3.40002 19.2569 4.74317 20.6 6.40002 20.6H16.6C18.2569 20.6 19.6 19.2569 19.6 17.6V14.2375C19.6 13.9062 19.3314 13.6375 19 13.6375C18.6687 13.6375 18.4 13.9062 18.4 14.2375V17.6C18.4 18.5941 17.5941 19.4 16.6 19.4H6.40002C5.40591 19.4 4.60002 18.5941 4.60002 17.6V7.40002Z",
    fill: color
  })));
};
NewTabIcon.SIZE = SIZE$v;
NewTabIcon.propTypes = {
  onClick: PropTypes__default.func,
  color: PropTypes__default.string,
  size: PropTypes__default.oneOf([SIZE$v.SMALL, SIZE$v.MEDIUM, SIZE$v.STANDARD])
};
var StyledSpan$t = Styled__default.span(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1u;
var ResetIcon = function ResetIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$u, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: dimensions,
    height: dimensions,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M9.37543 5.94429C10.4858 5.46306 11.7071 5.29637 12.9058 5.46245C14.1045 5.62854 15.2345 6.12099 16.1721 6.88599C16.6731 7.29464 17.2563 7.82157 17.7199 8.25206C17.7373 8.26819 17.7545 8.28417 17.7715 8.29999H15C14.6134 8.29999 14.3 8.61339 14.3 8.99999C14.3 9.38659 14.6134 9.69999 15 9.69999H19.3C19.6866 9.69999 20 9.38659 20 8.99999V4.7C20 4.3134 19.6866 4 19.3 4C18.9134 4 18.6 4.3134 18.6 4.7V7.15892C18.1412 6.73433 17.5662 6.21649 17.0572 5.80119C15.9206 4.87393 14.5509 4.27701 13.0979 4.0757C11.6449 3.87439 10.1646 4.07644 8.8187 4.65975C7.47282 5.24306 6.31321 6.18519 5.46667 7.38312C4.62014 8.58105 4.11925 9.98867 4.01879 11.4521C3.91832 12.9155 4.22214 14.3784 4.89703 15.6807C5.57192 16.9831 6.59189 18.0749 7.84544 18.8366C9.09898 19.5984 10.5378 20.0009 12.0047 20C12.3913 19.9998 12.7045 19.6862 12.7043 19.2996C12.7041 18.913 12.3905 18.5998 12.0039 18.6C10.7937 18.6007 9.60666 18.2687 8.57249 17.6402C7.53831 17.0118 6.69683 16.1111 6.14005 15.0366C5.58327 13.9621 5.33262 12.7553 5.4155 11.548C5.49838 10.3407 5.91161 9.17937 6.61001 8.19107C7.3084 7.20278 8.26507 6.42553 9.37543 5.94429Z",
    fill: "#393946"
  })));
};
ResetIcon.SIZE = SIZE$6;
ResetIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$u = Styled__default.div(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1v;
var SIZE$w = {
  SMALL: 'small',
  STANDARD: 'standard'
};
var FullForecastLogo = function FullForecastLogo(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$w.SMALL:
        return '10';
      case SIZE$w.STANDARD:
        return '24';
      default:
        return '176';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$w.SMALL:
        return '10';
      case SIZE$w.STANDARD:
        return '24';
      default:
        return '62';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$v, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "176",
    height: "62",
    viewBox: "0 0 176 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5939 21.9481L37.6496 14.3991C37.0929 14.0496 36.3273 14.0496 35.7706 14.3991L22.7568 21.9481C22.2 22.2976 21.7825 22.9267 21.7825 23.6257V38.6539C21.7825 39.3529 22.1304 39.982 22.7568 40.3314L35.7706 47.8805C36.3273 48.23 37.0929 48.23 37.6496 47.8805L50.6635 40.3314C51.2202 39.982 51.6377 39.3529 51.6377 38.6539V23.6257C51.5682 22.9267 51.2202 22.2976 50.5939 21.9481ZM41.1988 33.4814L37.4408 35.6482V38.8636C37.4408 39.5626 37.0929 40.1916 36.4665 40.5411L33.6828 42.1488V34.5998C33.6828 33.9008 34.0308 33.2717 34.6571 32.9222L41.1292 29.1477V33.4814H41.1988ZM41.1988 24.814L33.7524 29.1477V25.9323C33.7524 25.2334 34.1004 24.6043 34.7267 24.2548L41.1988 20.4803V24.814Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M64.6516 38.2344H68.1312V33.1319H73.8378V30.0563H68.1312V27.1206H75.5081V24.045H64.6516V38.2344Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M81.2843 27.2604C78.083 27.2604 75.4385 29.4971 75.4385 32.8523C75.4385 36.2773 78.0134 38.4441 81.2843 38.4441C84.4855 38.4441 87.1301 36.2074 87.1301 32.8523C87.1301 29.4971 84.5551 27.2604 81.2843 27.2604ZM81.2843 35.6482C79.8924 35.6482 78.7093 34.5997 78.7093 32.9222C78.7093 31.2446 79.8924 30.1961 81.2843 30.1961C82.6761 30.1961 83.8592 31.3145 83.8592 32.9222C83.8592 34.5298 82.7457 35.6482 81.2843 35.6482Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M130.347 28.4487C129.443 27.6798 128.329 27.2604 127.076 27.2604C124.223 27.2604 121.857 29.4971 121.857 32.8523C121.857 36.2773 124.153 38.4441 127.076 38.4441C128.329 38.4441 129.443 38.0248 130.347 37.2559V38.0946H133.688V27.6099H130.347V28.4487ZM127.772 35.6482C126.38 35.6482 125.197 34.5997 125.197 32.9222C125.197 31.2446 126.38 30.1961 127.772 30.1961C129.164 30.1961 130.347 31.3145 130.347 32.9222C130.347 34.5298 129.164 35.6482 127.772 35.6482Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M108.425 32.9222C108.425 29.5671 105.92 27.3303 102.858 27.3303C99.7959 27.3303 97.2905 29.5671 97.2905 32.9222C97.2905 36.3472 99.7959 38.5141 102.858 38.5141C105.155 38.5141 107.173 37.2559 108.008 35.2289L105.015 34.5998C104.598 35.3687 103.832 35.788 102.928 35.788C101.814 35.788 100.84 35.0192 100.561 33.8309H108.356C108.425 33.4814 108.425 33.2018 108.425 32.9222ZM105.085 31.9436H102.928H102.162H100.701H100.631C100.631 30.8951 101.814 30.0564 102.928 30.0564C103.971 30.0564 105.085 30.8951 105.085 31.9436Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M115.385 35.6482C114.062 35.6482 112.949 34.5998 112.949 32.9222C112.949 31.2446 114.062 30.1962 115.385 30.1962C116.428 30.1962 117.264 30.8252 117.681 31.8737L120.813 31.1048C120.047 28.7982 117.96 27.3303 115.454 27.3303C112.322 27.3303 109.748 29.5671 109.748 32.9222C109.748 36.3472 112.322 38.5141 115.454 38.5141C117.96 38.5141 120.117 37.0462 120.813 34.7396L117.681 33.9707C117.333 35.0192 116.428 35.6482 115.385 35.6482Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M158.741 24.4645L158.045 25.8624L157.349 24.4645H156.932V26.4216H157.28V25.0936L157.906 26.4216H158.115L158.741 25.0936V26.4216H159.089V24.4645H158.741Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M154.913 24.7439H155.609V26.4207H155.957V24.7439H156.652V24.4645H154.913V24.7439Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M95.8987 27.4701C94.5069 27.4701 93.115 28.0293 92.0015 29.0778L90.7489 27.6099H88.9395V38.2345H91.7232H92.2799V34.9492C92.2799 32.2931 93.463 30.965 95.8987 30.965H96.5251L96.6642 27.6099C96.3859 27.4701 96.1771 27.4701 95.8987 27.4701Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M154.009 35.0891C153.521 35.3687 153.034 35.5084 152.478 35.5084C151.573 35.5084 151.086 35.0192 151.086 33.9707V30.2661H154.217V27.6099H151.086V24.4645H148.859C148.859 26.3517 147.676 27.4701 146.075 27.54C146.005 27.54 145.866 27.54 145.797 27.54V29.1477V30.2661H147.745V34.2503C147.745 36.487 148.789 38.4442 151.921 38.4442C152.895 38.4442 153.869 38.1646 154.774 37.6753L154.009 35.0891Z",
    fill: "#6E0FEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M142.248 31.734L139.742 31.2447C139.186 31.1049 138.977 30.8952 138.977 30.4758C138.977 29.9166 139.533 29.637 140.16 29.637C141.552 29.637 141.9 30.5457 141.9 30.8952L144.962 30.2661C144.614 28.7982 143.222 27.1906 140.16 27.1906C137.794 27.1906 135.636 28.3788 135.636 30.7554C135.636 32.4329 136.68 33.4814 138.698 33.8309L140.856 34.2503C141.552 34.3901 141.9 34.6697 141.9 35.0192C141.9 35.5085 141.412 35.858 140.508 35.858C139.464 35.858 138.768 35.4386 138.629 34.5998L135.358 35.2988C135.636 36.9065 136.959 38.3743 140.299 38.3743C143.152 38.3743 145.101 37.1161 145.101 34.8095C145.17 33.1319 143.987 32.1534 142.248 31.734Z",
    fill: "#6E0FEA"
  })));
};
FullForecastLogo.SIZE = SIZE$w;
FullForecastLogo.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf([SIZE$w.SMALL, SIZE$w.STANDARD])
};
var StyledSpan$v = Styled__default.span(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-self: center;\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1w;
var MSTeamsIcon = function MSTeamsIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$w, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: dimensions,
    height: dimensions,
    viewBox: "-334.325 -518.333 2897.483 3110.001"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M1554.637 777.5h575.713c54.391 0 98.483 44.092 98.483 98.483v524.398c0 199.901-162.051 361.952-361.952 361.952h-1.711c-199.901.028-361.975-162-362.004-361.901V828.971c.001-28.427 23.045-51.471 51.471-51.471z",
    fill: "#5059C9"
  }), /*#__PURE__*/React__default.createElement("circle", {
    r: "233.25",
    cy: "440.583",
    cx: "1943.75",
    fill: "#5059C9"
  }), /*#__PURE__*/React__default.createElement("circle", {
    r: "336.917",
    cy: "336.917",
    cx: "1218.083",
    fill: "#7B83EB"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1667.323 777.5H717.01c-53.743 1.33-96.257 45.931-95.01 99.676v598.105c-7.505 322.519 247.657 590.16 570.167 598.053 322.51-7.893 577.671-275.534 570.167-598.053V877.176c1.245-53.745-41.268-98.346-95.011-99.676z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1244 777.5v838.145c-.258 38.435-23.549 72.964-59.09 87.598a91.856 91.856 0 01-35.765 7.257H667.613c-6.738-17.105-12.958-34.21-18.142-51.833a631.287 631.287 0 01-27.472-183.49V877.02c-1.246-53.659 41.198-98.19 94.855-99.52z",
    opacity: ".1"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1192.167 777.5v889.978a91.802 91.802 0 01-7.257 35.765c-14.634 35.541-49.163 58.833-87.598 59.09H691.975c-8.812-17.105-17.105-34.21-24.362-51.833-7.257-17.623-12.958-34.21-18.142-51.833a631.282 631.282 0 01-27.472-183.49V877.02c-1.246-53.659 41.198-98.19 94.855-99.52z",
    opacity: ".2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1192.167 777.5v786.312c-.395 52.223-42.632 94.46-94.855 94.855h-447.84A631.282 631.282 0 01622 1475.177V877.02c-1.246-53.659 41.198-98.19 94.855-99.52z",
    opacity: ".2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1140.333 777.5v786.312c-.395 52.223-42.632 94.46-94.855 94.855H649.472A631.282 631.282 0 01622 1475.177V877.02c-1.246-53.659 41.198-98.19 94.855-99.52z",
    opacity: ".2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1244 509.522v163.275c-8.812.518-17.105 1.037-25.917 1.037-8.812 0-17.105-.518-25.917-1.037a284.472 284.472 0 01-51.833-8.293c-104.963-24.857-191.679-98.469-233.25-198.003a288.02 288.02 0 01-16.587-51.833h258.648c52.305.198 94.657 42.549 94.856 94.854z",
    opacity: ".1"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1192.167 561.355v111.442a284.472 284.472 0 01-51.833-8.293c-104.963-24.857-191.679-98.469-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z",
    opacity: ".2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1192.167 561.355v111.442a284.472 284.472 0 01-51.833-8.293c-104.963-24.857-191.679-98.469-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z",
    opacity: ".2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1140.333 561.355v103.148c-104.963-24.857-191.679-98.469-233.25-198.003h138.395c52.305.199 94.656 42.551 94.855 94.855z",
    opacity: ".2"
  }), /*#__PURE__*/React__default.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 2075.333)",
    y2: "394.261",
    x2: "942.234",
    y1: "1683.073",
    x1: "198.099",
    gradientUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React__default.createElement("stop", {
    offset: "0",
    stopColor: "#5a62c3"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: ".5",
    stopColor: "#4d55bd"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: "#3940ab"
  })), /*#__PURE__*/React__default.createElement("path", {
    d: "M95.01 466.5h950.312c52.473 0 95.01 42.538 95.01 95.01v950.312c0 52.473-42.538 95.01-95.01 95.01H95.01c-52.473 0-95.01-42.538-95.01-95.01V561.51c0-52.472 42.538-95.01 95.01-95.01z",
    fill: "url(#a)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M820.211 828.193h-189.97v517.297h-121.03V828.193H320.123V727.844h500.088z",
    fill: "#FFF"
  })));
};
MSTeamsIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$w = Styled__default.div(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1x;
var FixedColorsIcon = Styled__default.div.attrs({
  className: 'fixed-colors'
})(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var QuickbooksIcon = function QuickbooksIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onClick(e);
  };
  var optionalHandleClick = onClick ? handleClick : undefined;
  return /*#__PURE__*/React__default.createElement(FixedColorsIcon, {
    onClick: optionalHandleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 41 41",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M40.97,20.84 C40.97,31.89 32.02,40.84 20.97,40.84 C9.92,40.84 0.97,31.89 0.97,20.84 C0.97,9.79 9.92,0.84 20.97,0.84 C32.02,0.84 40.97,9.79 40.97,20.84 Z",
    id: "Fill-1-3-2",
    fill: "#2CA01C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M27.6,13.06 L26.49,13.06 L26.49,16 L27.6,16 C30.3,16 32.49,18.19 32.49,20.89 C32.49,23.59 30.3,25.78 27.6,25.78 L24.89,25.78 L24.89,10.62 C24.89,9.02 23.6,7.73 22,7.73 L22,7.73 L22,7.73 L22,28.62 L27.59,28.62 C31.89,28.62 35.37,25.13 35.37,20.84 C35.37,16.55 31.89,13.07 27.59,13.06 L27.59,13.06 L27.6,13.06 L27.6,13.06 Z M14.26,28.62 L15.46,28.62 L15.46,25.73 L14.26,25.73 C11.56,25.73 9.37,23.54 9.37,20.84 C9.37,18.14 11.56,15.95 14.26,15.95 L16.97,15.95 L16.97,31.06 C16.97,32.66 18.26,33.95 19.86,33.95 L19.86,33.95 L19.86,33.95 L19.86,13.06 L14.27,13.06 C9.97,13.06 6.49,16.55 6.49,20.84 C6.49,25.13 9.97,28.61 14.27,28.62 L14.27,28.62 L14.26,28.62 Z",
    id: "Fill-4-2",
    fill: "#FFFFFF"
  })));
};
QuickbooksIcon.SIZE = SIZE$6;
QuickbooksIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var _templateObject$1y;
var SageIntacctIcon = function SageIntacctIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$x, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: dimensions,
    height: dimensions,
    viewBox: "0 0 64.916 36.474"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(-2.537 -2.8329)"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "sagebrilliantgreen",
    d: "m42.319 39.26c-3.0104-0.40304-5.5018-2.3048-6.3487-4.8463-0.7115-2.1351-0.29178-3.7854 0.99978-3.931 0.5839-0.0658 0.96322 0.0395 1.3276 0.36876 0.37332 0.33727 0.47035 0.58805 0.55232 1.4275 0.23999 2.4579 2.0531 4.1078 4.5142 4.1078 0.88774 0 1.4409-0.12 2.1886-0.4748 1.4464-0.68633 2.2122-1.9936 2.126-3.6289-0.0578-1.0949-0.51205-1.9292-1.4237-2.6145-0.71222-0.53539-1.6947-0.98461-3.5466-1.6216-2.5625-0.8814-3.7248-1.4462-4.8169-2.3406-2.0308-1.6631-2.7999-4.7189-1.9042-7.5653 0.38225-1.2147 0.88948-2.0471 1.8226-2.9912 1.3922-1.4084 3.2044-2.1325 5.3309-2.1301 3.8368 4e-3 6.9493 2.3836 7.6514 5.8486 0.10943 0.54004 0.13188 0.94847 0.0949 1.7257-0.0763 1.6019-0.47182 2.7477-1.1998 3.4757-0.81819 0.81819-2.0739 0.67324-2.5635-0.29591-0.24407-0.48315-0.23774-0.77166 0.0307-1.3996 0.40037-0.93635 0.54077-1.4792 0.54077-2.0908 0-1.1749-0.39365-2.1581-1.2005-2.9983-0.59144-0.61592-1.2515-0.99028-2.152-1.2206-2.3152-0.59214-4.5572 0.583-5.2915 2.7735-0.26089 0.77834-0.26172 1.9594-2e-3 2.6895 0.24387 0.68523 0.69844 1.3238 1.271 1.7854 0.64509 0.52009 2.0705 1.2074 3.6495 1.7599 2.5504 0.89231 3.415 1.2957 4.4994 2.0993 1.1089 0.8218 1.7792 1.7719 2.2021 3.1214 0.17061 0.54446 0.1981 0.80796 0.19846 1.902 3.4e-4 1.0684-0.03 1.3748-0.19097 1.9303-0.7533 2.5991-2.7651 4.4237-5.5256 5.0114-0.75112 0.1599-2.1148 0.21884-2.8343 0.12251zm-33.521-11.343c-3.049-0.48096-5.3665-2.4127-6.0762-5.0648-0.22532-0.842-0.24381-2.341-0.0392-3.1786 0.29877-1.2232 1.0201-2.2799 1.7121-2.5083 0.58548-0.19323 1.3566 0.0701 1.742 0.59482 0.30023 0.40877 0.28982 0.89449-0.03722 1.7364-0.36488 0.9393-0.43625 1.4377-0.31475 2.1982 0.24708 1.5464 1.3442 2.7377 2.9579 3.2117 0.64754 0.1902 1.8839 0.17828 2.5352-0.0244 2.2832-0.71061 3.3018-3.1729 2.1872-5.2872-0.54776-1.0391-1.791-1.8348-4.3292-2.7709-2.7129-1.0005-3.7219-1.5558-4.8368-2.662-0.87184-0.86499-1.284-1.5567-1.5738-2.6416-0.2512-0.94017-0.25117-2.5946 5.6e-5 -3.5391 0.5163-1.9412 1.8012-3.5094 3.606-4.4011 1.0912-0.53915 2.0321-0.74909 3.3485-0.74716 2.277 3e-3 3.9801 0.68226 5.4617 2.1773 1.1699 1.1806 1.7179 2.3034 1.8981 3.8892 0.17539 1.5435-0.39973 2.3207-1.6581 2.2405-0.81229-0.0517-1.3284-0.53213-1.422-1.3235-0.16631-1.4064-0.47266-2.1456-1.1838-2.8568-1.3863-1.3863-3.7741-1.632-5.4339-0.55927-1.6969 1.0968-2.1418 3.6062-0.9224 5.2032 0.63522 0.83192 1.7106 1.4449 4.2535 2.4246 1.9708 0.7593 2.6712 1.0863 3.5409 1.6532 1.2764 0.832 2.1119 1.8419 2.5368 3.0664 0.94507 2.7234 0.08103 5.873-2.0988 7.6505-0.66808 0.54479-1.8546 1.1349-2.7284 1.357-0.78267 0.19891-2.3694 0.28104-3.1255 0.16178zm16.311-9e-3c-2.3563-0.33788-4.6348-2.0486-5.6474-4.2402-0.50472-1.0924-0.67087-1.893-0.66369-3.1982 0.0075-1.3608 0.17347-2.099 0.73294-3.2597 0.7369-1.5288 1.913-2.6877 3.4841-3.4333 1.1264-0.53453 1.7306-0.6798 3.048-0.73282 1.7075-0.0687 3.0086 0.23471 4.3068 1.0044 0.64242 0.38091 1.6782 1.3214 2.1238 1.9285 0.4591 0.62544 0.97497 1.7389 1.2138 2.6199 0.21906 0.80799 0.2211 0.84397 0.25212 4.4491 0.0279 3.2472 0.0161 3.6742-0.1109 4.0068-0.44995 1.1782-2.3323 1.2526-2.9126 0.11514-0.14813-0.29035-0.1635-0.58589-0.19664-3.7817-0.03-2.893-0.0595-3.5566-0.17828-4.0096-0.35944-1.371-1.2008-2.4807-2.2857-3.0146-2.6097-1.2843-5.6341 0.29019-6.1957 3.2254-0.15345 0.80202-0.15265 1.1093 5e-3 1.8561 0.17024 0.80723 0.55624 1.5573 1.1083 2.1536 1.1151 1.2045 2.3277 1.5784 4.1446 1.2783 0.87556-0.14465 1.2229-0.0771 1.6378 0.31857 0.87671 0.83611 0.54387 1.9958-0.70714 2.4639-0.88408 0.33077-1.9882 0.41827-3.1592 0.25036zm34.085 6e-3c-2.6759-0.39254-4.9226-2.0585-6.0099-4.4564-0.82735-1.8247-0.80936-4.2211 0.0456-6.0715 0.93364-2.0207 2.6711-3.5034 4.8371-4.1279 0.91987-0.26518 3.0432-0.28385 4.0217-0.0354 3.2358 0.82177 5.3345 3.2765 5.3634 6.2734 7e-3 0.69047-0.0159 0.80451-0.24065 1.2148-0.14928 0.27255-0.38973 0.55031-0.60403 0.69775-0.64979 0.44707-1.0686 0.50046-3.9259 0.50046-2.5179 0-2.5992-5e-3 -2.9618-0.1905-0.4987-0.25483-0.69897-0.55062-0.74285-1.0972-0.0295-0.36804-5.9e-4 -0.49951 0.16208-0.73656 0.43816-0.63841 0.43651-0.638 2.7933-0.68512 1.9934-0.0398 2.125-0.0523 2.2424-0.21166 0.25707-0.349-0.0913-1.2568-0.72562-1.8912-0.77239-0.7724-1.8998-1.2008-3.1506-1.1971-1.3155 4e-3 -2.2288 0.37482-3.1204 1.2674-1.8314 1.8333-1.8687 4.7102-0.0847 6.5289 0.91091 0.92862 1.9348 1.3456 3.3038 1.3456 1.3574 0 1.9015-0.18457 4.0198-1.3637 1.8553-1.0327 3.2856 0.8794 1.7396 2.3255-1.5662 1.465-4.5035 2.2709-6.9623 1.9102z",
    fill: "#00d639",
    strokeWidth: 0.084667
  }))));
};
SageIntacctIcon.SIZE = SIZE$6;
SageIntacctIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$x = Styled__default.div(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1z;
var SalesforceIcon = function SalesforceIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$y, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 256 180",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M106.553203,159.610976 C114.801129,168.204994 126.284107,173.534815 138.983873,173.534815 C155.865892,173.534815 170.594851,164.121105 178.438396,150.146262 C185.254593,153.191874 192.799405,154.885905 200.737669,154.885905 C231.186506,154.885905 255.871995,129.985475 255.871995,99.2706935 C255.871995,68.5522694 231.186506,43.651839 200.737669,43.651839 C197.021731,43.651839 193.389583,44.0234329 189.877657,44.7338328 C182.970383,32.4129469 169.807947,24.0885163 154.700107,24.0885163 C148.375726,24.0885163 142.393793,25.5493901 137.067615,28.1469039 C130.065621,11.6765534 113.751923,0.127999726 94.7387049,0.127999726 C74.9385822,0.127999726 58.0638501,12.6565411 51.5864595,30.2271008 C48.7557888,29.6259931 45.8231119,29.3126885 42.8139304,29.3126885 C19.23958,29.3126885 0.127998772,48.6209959 0.127998772,72.4430755 C0.127998772,88.4070383 8.71473094,102.34545 21.4727861,109.802829 C18.8461277,115.846693 17.3852539,122.517167 17.3852539,129.53009 C17.3852539,156.926028 39.6262381,179.134225 67.0586069,179.134225 C83.1646497,179.134225 97.4782987,171.476477 106.553203,159.610976",
    fill: "#00A1E0",
    transform: "translate(127.999997, 89.631112) scale(1, -1) translate(-127.999997, -89.631112) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M37.1700744,75.3309413 C37.009779,74.9119875 37.2283636,74.8245536 37.2793667,74.7516921 C37.7602528,74.4019567 38.2484251,74.1505844 38.7402405,73.8700675 C41.3486835,72.4856983 43.8114035,72.0813168 46.3870588,72.0813168 C51.6330895,72.0813168 54.8900002,74.8719136 54.8900002,79.3638274 L54.8900002,79.4512613 C54.8900002,83.6043689 51.2141357,85.1126027 47.7641419,86.2018827 L47.3160434,86.3476058 C44.7148866,87.1927996 42.4707512,87.921415 42.4707512,89.6336611 L42.4707512,89.724738 C42.4707512,91.1892549 43.7822589,92.2676057 45.8150958,92.2676057 C48.0738034,92.2676057 50.755108,91.5171318 52.4819264,90.5626457 C52.4819264,90.5626457 52.9883141,90.2347688 53.174111,90.7265842 C53.2761172,90.9888857 54.1504556,93.3423133 54.2415326,93.5973287 C54.3398956,93.8742026 54.1650279,94.0782149 53.9865172,94.1875072 C52.0156126,95.3860795 49.2905911,96.2057718 46.4708496,96.2057718 L45.9462465,96.2021287 C41.1446712,96.2021287 37.7930405,93.3022395 37.7930405,89.1454888 L37.7930405,89.058055 C37.7930405,84.6754335 41.4907635,83.2546335 44.9553296,82.2637166 L45.5127204,82.092492 C48.0373727,81.3165166 50.2122895,80.6498336 50.2122895,78.872012 L50.2122895,78.7845782 C50.2122895,77.1597659 48.7987757,75.9502644 46.5182096,75.9502644 C45.6329419,75.9502644 42.8095574,75.9684798 39.760302,77.8956674 C39.3923513,78.110609 39.1774097,78.2672613 38.8932497,78.4384859 C38.7438836,78.5332059 38.3686467,78.6971444 38.2047082,78.2016859 L37.1700744,75.3309413 L37.1700744,75.3309413 Z",
    fill: "#FFFFFF",
    transform: "translate(46.001138, 84.143544) scale(1, -1) translate(-46.001138, -84.143544) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M113.969779,75.3309413 C113.809484,74.9119875 114.028068,74.8245536 114.079072,74.7516921 C114.559958,74.4019567 115.04813,74.1505844 115.539945,73.8700675 C118.148388,72.4856983 120.611108,72.0813168 123.186764,72.0813168 C128.432794,72.0813168 131.689705,74.8719136 131.689705,79.3638274 L131.689705,79.4512613 C131.689705,83.6043689 128.013841,85.1126027 124.563847,86.2018827 L124.115748,86.3476058 C121.514591,87.1927996 119.270456,87.921415 119.270456,89.6336611 L119.270456,89.724738 C119.270456,91.1892549 120.581964,92.2676057 122.614801,92.2676057 C124.873508,92.2676057 127.554813,91.5171318 129.281631,90.5626457 C129.281631,90.5626457 129.788019,90.2347688 129.973816,90.7265842 C130.075822,90.9888857 130.95016,93.3423133 131.041237,93.5973287 C131.1396,93.8742026 130.964733,94.0782149 130.786222,94.1875072 C128.815317,95.3860795 126.090296,96.2057718 123.270554,96.2057718 L122.745951,96.2021287 C117.944376,96.2021287 114.592745,93.3022395 114.592745,89.1454888 L114.592745,89.058055 C114.592745,84.6754335 118.290468,83.2546335 121.755034,82.2637166 L122.312425,82.092492 C124.837077,81.3165166 127.015637,80.6498336 127.015637,78.872012 L127.015637,78.7845782 C127.015637,77.1597659 125.598481,75.9502644 123.317914,75.9502644 C122.432647,75.9502644 119.609262,75.9684798 116.560007,77.8956674 C116.192056,78.110609 115.973471,78.2599751 115.696598,78.4384859 C115.601878,78.5004182 115.157422,78.6716428 115.004413,78.2016859 L113.969779,75.3309413 L113.969779,75.3309413 Z",
    fill: "#FFFFFF",
    transform: "translate(122.800843, 84.143544) scale(1, -1) translate(-122.800843, -84.143544) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M166.398769,84.1136744 C166.398769,81.5744499 165.925169,79.5744007 164.992541,78.1608868 C164.070843,76.7619453 162.675544,76.08069 160.730141,76.08069 C158.781095,76.08069 157.393083,76.7583022 156.485956,78.1608868 C155.567901,79.5707576 155.101587,81.5744499 155.101587,84.1136744 C155.101587,86.6492559 155.567901,88.6456621 156.485956,90.0446036 C157.393083,91.4289728 158.781095,92.102942 160.730141,92.102942 C162.675544,92.102942 164.070843,91.4289728 164.996184,90.0446036 C165.925169,88.6456621 166.398769,86.6492559 166.398769,84.1136744 M170.777747,88.8205297 C170.347864,90.2741174 169.677538,91.5564805 168.784984,92.623902 C167.89243,93.6949666 166.763076,94.5547327 165.422424,95.181342 C164.085415,95.8043081 162.504319,96.1212558 160.730141,96.1212558 C158.95232,96.1212558 157.371224,95.8043081 156.034215,95.181342 C154.693563,94.5547327 153.564209,93.6949666 152.668012,92.623902 C151.779101,91.5528374 151.108775,90.2704743 150.675249,88.8205297 C150.249009,87.3742282 150.034067,85.7931329 150.034067,84.1136744 C150.034067,82.434216 150.249009,80.8494776 150.675249,79.4068191 C151.108775,77.9568745 151.775458,76.6745115 152.671655,75.6034469 C153.564209,74.5323823 154.697206,73.6762592 156.034215,73.0678654 C157.374867,72.4594715 158.95232,72.14981 160.730141,72.14981 C162.504319,72.14981 164.081772,72.4594715 165.422424,73.0678654 C166.759433,73.6762592 167.89243,74.5323823 168.784984,75.6034469 C169.677538,76.6708684 170.347864,77.9532315 170.777747,79.4068191 C171.20763,80.8531206 171.422572,82.4378591 171.422572,84.1136744 C171.422572,85.7894898 171.20763,87.3742282 170.777747,88.8205297",
    fill: "#FFFFFF",
    transform: "translate(160.728320, 84.135533) scale(1, -1) translate(-160.728320, -84.135533) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M206.737482,76.7251427 C206.591759,77.1513827 206.180091,76.9910873 206.180091,76.9910873 C205.542553,76.7470012 204.864941,76.5211304 204.143612,76.408195 C203.411353,76.2952596 202.606233,76.2369704 201.742824,76.2369704 C199.622553,76.2369704 197.939452,76.8672227 196.733593,78.113155 C195.524092,79.3590873 194.846479,81.3737088 194.853766,84.0987303 C194.861052,86.5796656 195.458516,88.444921 196.533224,89.8657209 C197.600645,91.2792348 199.225458,92.0042071 201.393088,92.0042071 C203.200055,92.0042071 204.577138,91.7965517 206.019796,91.3411671 C206.019796,91.3411671 206.365888,91.1918009 206.529827,91.6435424 C206.91235,92.7073209 207.19651,93.468724 207.604535,94.6381516 C207.721113,94.9696716 207.436953,95.1117516 207.334947,95.1518255 C206.766627,95.3740532 205.425975,95.7347178 204.413199,95.887727 C203.465999,96.0334501 202.358504,96.1099547 201.127144,96.1099547 C199.28739,96.1099547 197.648005,95.7966501 196.245421,95.1700409 C194.846479,94.5470747 193.658836,93.6873086 192.718922,92.616244 C191.779009,91.5451794 191.064966,90.2628163 190.587723,88.8128717 C190.114123,87.3665702 189.873679,85.7781887 189.873679,84.0987303 C189.873679,80.4665826 190.853667,77.5302627 192.788141,75.3808473 C194.726258,73.2241458 197.637076,72.1275797 201.433162,72.1275797 C203.677298,72.1275797 205.979722,72.5829643 207.633679,73.2350751 C207.633679,73.2350751 207.950627,73.3880843 207.81219,73.756035 L206.737482,76.7251427 L206.737482,76.7251427 Z",
    fill: "#FFFFFF",
    transform: "translate(198.860433, 84.118767) scale(1, -1) translate(-198.860433, -84.118767) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M214.399204,86.5520198 C214.606859,87.9618906 214.996668,89.1349613 215.597776,90.0493736 C216.504902,91.4373859 217.889271,92.198789 219.834675,92.198789 C221.780078,92.198789 223.066084,91.4337428 223.987782,90.0493736 C224.599819,89.1349613 224.865764,87.9108875 224.971413,86.5520198 L214.399204,86.5520198 L214.399204,86.5520198 Z M229.142736,89.6522783 C228.771142,91.0548629 227.849444,92.4720198 227.244693,93.1204874 C226.290207,94.1478351 225.357579,94.8655213 224.432238,95.2662597 C223.222736,95.7835766 221.772791,96.1260258 220.18441,96.1260258 C218.333727,96.1260258 216.654268,95.8163643 215.291758,95.1751828 C213.925604,94.5340013 212.778035,93.6596628 211.878195,92.5703828 C210.978355,91.4847459 210.300742,90.1914536 209.870859,88.7232937 C209.437333,87.2624198 209.218749,85.6703952 209.218749,83.9909368 C209.218749,82.2823338 209.444619,80.6903092 209.892718,79.25858 C210.344459,77.8159215 211.065789,76.5444877 212.042133,75.4916385 C213.014835,74.4315031 214.268053,73.6008816 215.769001,73.0216324 C217.259019,72.4460262 219.069628,72.1472939 221.149825,72.150937 C225.430441,72.1655093 227.685505,73.1199955 228.61449,73.6336693 C228.778428,73.7247462 228.935081,73.8850416 228.738354,74.3440693 L227.769296,77.0581615 C227.623573,77.4625431 227.211905,77.3131769 227.211905,77.3131769 C226.15177,76.9197246 224.643536,76.2129677 221.127967,76.2202539 C218.829185,76.2238969 217.124225,76.9015092 216.056804,77.9616446 C214.960238,79.0472815 214.424705,80.6429492 214.329985,82.8943707 L229.153665,82.8797984 C229.153665,82.8797984 229.543474,82.8870845 229.583548,83.2659645 C229.598121,83.4262599 230.093579,86.3115768 229.142736,89.6522783 L229.142736,89.6522783 Z",
    fill: "#FFFFFF",
    transform: "translate(219.472103, 84.138465) scale(1, -1) translate(-219.472103, -84.138465) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M95.6829901,86.5520198 C95.8942885,87.9618906 96.2804547,89.1349613 96.8815624,90.0493736 C97.7886885,91.4373859 99.1730577,92.198789 101.118461,92.198789 C103.063864,92.198789 104.34987,91.4337428 105.275211,90.0493736 C105.883605,89.1349613 106.14955,87.9108875 106.255199,86.5520198 L95.6829901,86.5520198 L95.6829901,86.5520198 Z M110.422879,89.6522783 C110.051285,91.0548629 109.13323,92.4720198 108.528479,93.1204874 C107.573993,94.1478351 106.641365,94.8655213 105.716024,95.2662597 C104.506522,95.7835766 103.056578,96.1260258 101.468196,96.1260258 C99.6211562,96.1260258 97.9380547,95.8163643 96.5755439,95.1751828 C95.2093901,94.5340013 94.0618209,93.6596628 93.1619809,92.5703828 C92.2621409,91.4847459 91.5845286,90.1914536 91.1546455,88.7232937 C90.7247625,87.2624198 90.5025348,85.6703952 90.5025348,83.9909368 C90.5025348,82.2823338 90.7284055,80.6903092 91.176504,79.25858 C91.6282455,77.8159215 92.3495747,76.5444877 93.3259193,75.4916385 C94.2986209,74.4315031 95.5518393,73.6008816 97.052787,73.0216324 C98.5428054,72.4460262 100.353415,72.1472939 102.433612,72.150937 C106.714227,72.1655093 108.969291,73.1199955 109.898276,73.6336693 C110.062214,73.7247462 110.218867,73.8850416 110.022141,74.3440693 L109.056725,77.0581615 C108.907359,77.4625431 108.495691,77.3131769 108.495691,77.3131769 C107.435556,76.9197246 105.930965,76.2129677 102.40811,76.2202539 C100.112972,76.2238969 98.4080116,76.9015092 97.3405901,77.9616446 C96.2440239,79.0472815 95.7084916,80.6429492 95.6137716,82.8943707 L110.437451,82.8797984 C110.437451,82.8797984 110.827261,82.8870845 110.867334,83.2659645 C110.881907,83.4262599 111.377365,86.3115768 110.422879,89.6522783 L110.422879,89.6522783 Z",
    fill: "#FFFFFF",
    transform: "translate(100.755643, 84.138465) scale(1, -1) translate(-100.755643, -84.138465) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M63.6417638,76.8187739 C63.0625146,77.2814447 62.9823669,77.3980231 62.7856408,77.6967554 C62.4941946,78.15214 62.3448285,78.8006077 62.3448285,79.6239431 C62.3448285,80.9281646 62.7747115,81.8644354 63.6672654,82.4946877 C63.6563361,82.4910446 64.9423423,83.6058261 67.9660961,83.5657523 C70.0900099,83.5366076 71.9880529,83.223303 71.9880529,83.223303 L71.9880529,76.4836108 L71.991696,76.4836108 C71.991696,76.4836108 70.1082253,76.0792293 67.9879545,75.9517216 C64.9714869,75.7695678 63.6308346,76.822417 63.6417638,76.8187739 M69.5399053,87.2343307 C68.9387976,87.2780476 68.1591792,87.3035491 67.2265515,87.3035491 C65.9551176,87.3035491 64.7274007,87.1432537 63.5761885,86.8335922 C62.41769,86.5239307 61.37577,86.0394014 60.4795731,85.3982199 C59.5797331,84.7533953 58.8547608,83.9300599 58.3301578,82.9537153 C57.8055547,81.9773707 57.5396101,80.8261584 57.5396101,79.5365092 C57.5396101,78.2250016 57.7654809,77.0847185 58.2172224,76.1520908 C58.6689639,75.2158201 59.3210747,74.4362016 60.1516962,73.8350939 C60.9750316,73.2339863 61.99145,72.793174 63.1718069,72.5272294 C64.3339484,72.2612847 65.6527423,72.1264909 67.0954007,72.1264909 C68.6145638,72.1264909 70.1300837,72.2503555 71.5982437,72.5017278 C73.0518314,72.749457 74.836939,73.1101217 75.3323975,73.223057 C75.8242129,73.3396355 76.3706744,73.4890016 76.3706744,73.4890016 C76.7386252,73.5800786 76.7094806,73.9735309 76.7094806,73.9735309 L76.7021944,87.5294199 C76.7021944,90.5021706 75.9080036,92.7062321 74.3451237,94.0723859 C72.7895298,95.4348967 70.4980345,96.1234382 67.536213,96.1234382 C66.4250746,96.1234382 64.6363238,95.970429 63.5652592,95.7554874 C63.5652592,95.7554874 60.3265639,95.1288782 58.9931978,94.0869582 C58.9931978,94.0869582 58.7017516,93.9048044 58.862047,93.4967798 L59.9112531,90.6770383 C60.0424039,90.3127306 60.3957824,90.4365952 60.3957824,90.4365952 C60.3957824,90.4365952 60.5087177,90.4803121 60.6398685,90.5568168 C63.4923977,92.1087675 67.0990438,92.0614075 67.0990438,92.0614075 C68.7019976,92.0614075 69.9333576,91.7408167 70.7639791,91.1032783 C71.5727422,90.4839552 71.9844099,89.5476845 71.9844099,87.5731368 L71.9844099,86.9465276 C70.709333,87.1286814 69.5399053,87.2343307 69.5399053,87.2343307",
    fill: "#FFFFFF",
    transform: "translate(67.124818, 84.124965) scale(1, -1) translate(-67.124818, -84.124965) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M189.099133,94.6589745 C189.212069,94.9941376 188.975269,95.1544329 188.876906,95.1908637 C188.625533,95.2892268 187.365029,95.5551714 186.392327,95.6171037 C184.530715,95.7300391 183.496081,95.4167345 182.57074,95.0014237 C181.652684,94.586113 180.632623,93.9157868 180.064303,93.1543837 L180.064303,94.9577068 C180.064303,95.2090791 179.885792,95.4094483 179.638063,95.4094483 L175.838334,95.4094483 C175.590604,95.4094483 175.412094,95.2090791 175.412094,94.9577068 L175.412094,72.8478733 C175.412094,72.6001441 175.616106,72.3961318 175.863835,72.3961318 L179.758284,72.3961318 C180.006014,72.3961318 180.206383,72.6001441 180.206383,72.8478733 L180.206383,83.8936824 C180.206383,85.3764146 180.370321,86.8555038 180.698198,87.7844884 C181.018789,88.7025438 181.455958,89.4384453 181.995134,89.9666915 C182.537952,90.4912946 183.153632,90.8592453 183.827601,91.0669007 C184.516143,91.2781992 185.277546,91.3474176 185.816721,91.3474176 C186.592697,91.3474176 187.445177,91.1470484 187.445177,91.1470484 C187.729337,91.1142607 187.889632,91.2891284 187.984352,91.5477868 C188.239367,92.2253991 188.960697,94.254593 189.099133,94.6589745",
    fill: "#FFFFFF",
    transform: "translate(182.270544, 84.018248) scale(1, -1) translate(-182.270544, -84.018248) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M152.543767,105.761574 C152.070167,105.907297 151.640284,106.00566 151.07925,106.111309 C150.51093,106.213316 149.833318,106.264319 149.064629,106.264319 C146.383324,106.264319 144.270339,105.506559 142.787607,104.012897 C141.312161,102.526522 140.310315,100.264171 139.80757,97.2877773 L139.625416,96.2859312 L136.259213,96.2859312 C136.259213,96.2859312 135.851189,96.3005035 135.763755,95.8560481 L135.21365,92.770362 C135.173577,92.4789159 135.301084,92.2931189 135.694537,92.2931189 L138.969663,92.2931189 L135.647177,73.7425715 C135.388518,72.24891 135.089786,71.0211931 134.758266,70.0885655 C134.434032,69.1705101 134.117084,68.4819686 133.723632,67.9792239 C133.344752,67.4983378 132.98773,67.1413163 132.368407,66.9336609 C131.858377,66.7624363 131.268198,66.6822886 130.623374,66.6822886 C130.266352,66.6822886 129.789109,66.7405778 129.43573,66.8134393 C129.085995,66.8826578 128.900198,66.9591624 128.634254,67.0720978 C128.634254,67.0720978 128.251731,67.2178209 128.098721,66.8352978 C127.9785,66.5183501 127.104161,64.1175625 126.998512,63.8224732 C126.896506,63.527384 127.042229,63.2978702 127.228026,63.2286517 C127.665195,63.0756425 127.989429,62.9736363 128.583251,62.8315563 C129.406586,62.6384733 130.102414,62.627544 130.754524,62.627544 C132.117035,62.627544 133.362967,62.8206271 134.393958,63.1922209 C135.428592,63.5674579 136.332075,64.2195686 137.133552,65.1011932 C137.996961,66.0556794 138.53978,67.0538824 139.057096,68.4200362 C139.57077,69.7679747 140.011583,71.44379 140.361318,73.3964792 L143.702019,92.2931189 L148.583742,92.2931189 C148.583742,92.2931189 148.99541,92.2785466 149.079201,92.7266451 L149.632949,95.8086881 C149.669379,96.1037773 149.545515,96.2859312 149.148419,96.2859312 L144.408776,96.2859312 C144.434278,96.3915804 144.649219,98.0601096 145.192038,99.6302757 C145.425195,100.296959 145.862364,100.839777 146.230315,101.211371 C146.594623,101.575679 147.013576,101.834337 147.472604,101.983703 C147.942561,102.136713 148.478093,102.209574 149.064629,102.209574 C149.509084,102.209574 149.949896,102.158571 150.281416,102.089353 C150.740444,101.99099 150.918955,101.939986 151.039176,101.903556 C151.523706,101.757833 151.589281,101.899913 151.684001,102.13307 L152.816998,105.244257 C152.933576,105.57942 152.645773,105.7215 152.543767,105.761574",
    fill: "#FFFFFF",
    transform: "translate(139.904621, 84.445931) scale(1, -1) translate(-139.904621, -84.445931) "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M86.3217408,63.553237 C86.3217408,63.3055078 86.14323,63.1051385 85.8955008,63.1051385 L81.9646209,63.1051385 C81.7168916,63.1051385 81.542024,63.3055078 81.542024,63.553237 L81.542024,95.1897165 C81.542024,95.4374457 81.7168916,95.6378149 81.9646209,95.6378149 L85.8955008,95.6378149 C86.14323,95.6378149 86.3217408,95.4374457 86.3217408,95.1897165 L86.3217408,63.553237 L86.3217408,63.553237 Z",
    fill: "#FFFFFF",
    transform: "translate(83.931882, 79.371477) scale(1, -1) translate(-83.931882, -79.371477) "
  }))));
};
SalesforceIcon.SIZE = SIZE$6;
SalesforceIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$y = Styled__default.div(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1A;
var SIZE$x = {
  SMALL: 'small',
  STANDARD: 'standard',
  BIG: 'big',
  EXTRA_BIG: 'extra_big'
};
var GithubIcon = function GithubIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var getWidth = function getWidth(size) {
    switch (size) {
      case SIZE$x.SMALL:
        return '15';
      case SIZE$x.BIG:
        return '65';
      case SIZE$x.EXTRA_BIG:
        return '90';
      case SIZE$x.STANDARD:
      default:
        return '28';
    }
  };
  var getHeight = function getHeight(size) {
    switch (size) {
      case SIZE$x.SMALL:
        return '15';
      case SIZE$x.BIG:
        return '65';
      case SIZE$x.EXTRA_BIG:
        return '90';
      case SIZE$x.STANDARD:
      default:
        return '28';
    }
  };
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$z, {
    onClick: handleClick,
    width: getWidth(size),
    height: getHeight(size)
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: getWidth(size),
    height: getHeight(size),
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
  })));
};
GithubIcon.SIZE = SIZE$x;
GithubIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf([SIZE$x.SMALL, SIZE$x.STANDARD, SIZE$x.BIG])
};
var StyledSpan$z = Styled__default.div(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var EconomicIcon = function EconomicIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onClick(e);
  };
  var optionalHandleClick = onClick ? handleClick : undefined;
  return /*#__PURE__*/React__default.createElement(FixedColorsIcon, {
    onClick: optionalHandleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#F09000",
    d: "M 357.647 417.59 C 357.803 460.676 322.997 495.721 279.913 495.876 C 236.841 496.03 201.787 461.232 201.635 418.145 C 201.48 375.069 236.285 340.009 279.357 339.855 C 322.442 339.701 357.493 374.51 357.647 417.59"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#F09000",
    d: "M 91.465 345.848 C 91.537 366.412 74.923 383.139 54.358 383.215 C 33.792 383.285 17.065 366.678 16.99 346.112 C 16.917 325.554 33.525 308.823 54.092 308.753 C 74.658 308.677 91.391 325.285 91.465 345.848"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#F09000",
    d: "M 478.231 98.73 C 478.044 46.269 435.326 3.845 382.844 4.033 C 334.185 4.207 294.204 40.958 288.806 88.146 C 288.791 88.22 288.762 88.264 288.762 88.332 C 286.393 105.716 283.422 147.786 262.802 165.982 C 253.003 174.66 243.855 187.498 197.232 179.926 L 197.261 179.97 C 186.784 178.022 168.049 175.041 158.372 158.717 C 150.704 145.757 155.899 124.425 158.127 114.708 C 159.536 110.265 160.291 105.539 160.273 100.646 C 160.183 75.172 139.476 54.614 114.021 54.709 C 88.548 54.8 67.982 75.504 68.074 100.973 C 68.138 119.256 78.877 134.977 94.353 142.38 L 94.281 142.404 C 110.299 149.792 124.497 155.353 130.504 169.976 C 136.282 184.095 126.525 214.162 123.729 222.148 C 123.526 222.774 123.262 223.375 123.075 224.012 C 123.03 224.095 123.016 224.155 123.016 224.155 L 123.031 224.139 C 121.24 230.095 120.264 236.415 120.286 242.95 C 120.411 278.263 149.143 306.791 184.437 306.666 C 212.546 306.567 236.278 288.331 244.771 263.106 L 244.818 263.182 C 248.394 253.677 251.644 217.433 283.609 200.08 C 304.82 188.542 350.627 192.046 373.277 193.587 C 375.774 193.827 378.316 193.978 380.865 194.036 C 382.774 194.131 384.257 194.162 385.218 194.108 C 385.306 194.09 385.342 194.056 385.41 194.04 C 437.029 192.856 478.416 150.597 478.231 98.73"
  })));
};
EconomicIcon.SIZE = SIZE$6;
EconomicIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var XeroIcon = function XeroIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onClick(e);
  };
  var optionalHandleClick = onClick ? handleClick : undefined;
  return /*#__PURE__*/React__default.createElement(FixedColorsIcon, {
    onClick: optionalHandleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: dimensions,
    height: dimensions,
    viewBox: "0 0 256 256",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M128.00285,256 C198.693118,256 256,198.688775 256,128 C256,57.2998444 198.698818,0 128.00285,0 C57.3068822,0 0,57.2998444 0,128 C0,198.688775 57.3068822,256 128.00285,256",
    fill: "#1FC0E7"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M62.3672889,127.967763 L84.1671111,106.065541 C84.8896,105.337363 85.2935111,104.358874 85.2935111,103.323496 C85.2935111,101.161719 83.5413333,99.4095407 81.3852444,99.4095407 C80.3328,99.4095407 79.3486222,99.8191407 78.6090667,100.575763 L56.8206222,122.381274 L34.9468444,100.535941 C34.2072889,99.807763 33.2288,99.4095407 32.1877333,99.4095407 C30.0259556,99.4095407 28.2794667,101.161719 28.2794667,103.317807 C28.2794667,104.370252 28.7004444,105.365807 29.4513778,106.105363 L51.2512,127.93363 L29.4627556,149.778963 C28.7004444,150.541274 28.2794667,151.531141 28.2794667,152.583585 C28.2794667,154.745363 30.0316444,156.497541 32.1877333,156.497541 C33.2288,156.497541 34.2072889,156.099319 34.9468444,155.359763 L56.7921778,133.503052 L78.5521778,155.27443 C79.3258667,156.070874 80.3157333,156.497541 81.3852444,156.497541 C83.5356444,156.497541 85.2878222,154.745363 85.2878222,152.583585 C85.2878222,151.542519 84.8896,150.56403 84.1500444,149.824474 L62.3616,127.945007 L62.3672889,127.967763 Z M191.965867,127.962074 C191.965867,131.887407 195.151644,135.073185 199.076978,135.073185 C202.979556,135.073185 206.165333,131.887407 206.165333,127.962074 C206.165333,124.036741 202.979556,120.850963 199.071289,120.850963 C195.163022,120.850963 191.982933,124.036741 191.982933,127.962074 L191.965867,127.962074 Z M178.511644,127.962074 C178.511644,116.612741 187.727644,107.368296 199.071289,107.368296 C210.392178,107.368296 219.625244,116.612741 219.625244,127.962074 C219.625244,139.311407 210.397867,148.555852 199.071289,148.555852 C187.733333,148.555852 178.511644,139.322785 178.511644,127.962074 L178.511644,127.962074 Z M170.422044,127.962074 C170.422044,143.777185 183.278933,156.65683 199.071289,156.65683 C214.863644,156.65683 227.720533,143.788563 227.720533,127.967763 C227.720533,112.152652 214.863644,99.2730074 199.071289,99.2730074 C183.273244,99.2730074 170.422044,112.146963 170.422044,127.967763 L170.422044,127.962074 Z M168.391111,99.7622519 L167.196444,99.7622519 C163.584,99.7622519 160.1024,100.90003 157.195378,103.147141 C156.797156,101.406341 155.227022,100.075141 153.361067,100.075141 C151.216356,100.075141 149.492622,101.810252 149.492622,103.966341 L149.504,152.293452 C149.504,154.438163 151.267556,156.184652 153.400889,156.184652 C155.551289,156.184652 157.303467,154.438163 157.309156,152.282074 L157.309156,122.563319 C157.309156,112.664652 158.219378,108.659674 166.684444,107.601541 C167.480889,107.50483 168.322844,107.521896 168.334222,107.521896 C170.643911,107.436563 172.293689,105.837985 172.293689,103.681896 C172.293689,101.520119 170.530133,99.7679407 168.368356,99.7679407 L168.391111,99.7622519 Z M93.3774222,123.245985 C93.3774222,123.132207 93.3888,123.01843 93.3944889,122.91603 C95.6586667,113.927585 103.7824,107.288652 113.447822,107.288652 C123.232711,107.288652 131.424711,114.081185 133.586489,123.228919 L93.3717333,123.228919 L93.3774222,123.245985 Z M141.579378,122.50643 C139.895467,114.524919 135.532089,107.96563 128.893156,103.755852 C119.176533,97.5777185 106.353778,97.9190519 96.9784889,104.609185 C89.3212444,110.053452 84.9009778,118.97363 84.9009778,128.161185 C84.9009778,130.465185 85.1854222,132.791941 85.7543111,135.084563 C88.6442667,146.462341 98.4177778,155.086696 110.068622,156.514607 C113.527467,156.935585 116.895289,156.742163 120.365511,155.831941 C123.369244,155.092385 126.264889,153.886341 128.932978,152.168296 C131.703467,150.387674 134.018844,148.032474 136.271644,145.216474 C136.305778,145.159585 136.351289,145.119763 136.3968,145.062874 C137.955556,143.128652 137.665422,140.363852 135.958756,139.055407 C134.513778,137.946074 132.090311,137.496652 130.190222,139.942874 C129.780622,140.534519 129.319822,141.137541 128.824889,141.734874 C127.305956,143.413096 125.422933,145.03443 123.170133,146.297363 C120.291556,147.833363 117.026133,148.703763 113.555911,148.726519 C102.189511,148.595674 96.1137778,140.648296 93.9463111,134.982163 C93.5708444,133.918341 93.2807111,132.820385 93.0759111,131.682607 L93.0190222,131.085274 L133.808356,131.085274 C139.394844,130.960119 142.398578,127.006341 141.568,122.495052 L141.579378,122.50643 Z",
    fill: "#FFFFFF"
  }))));
};
XeroIcon.SIZE = SIZE$6;
XeroIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var _templateObject$1B;
var HubspotIcon = function HubspotIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$A, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: dimensions,
    height: dimensions,
    viewBox: "0 0 13.107 13.099",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12.027 6.222a3.33 3.33 0 0 0-1.209-1.201c-.382-.222-.777-.363-1.223-.424V3a1.17 1.17 0 0 0 .722-1.097 1.2 1.2 0 0 0-1.2-1.206 1.21 1.21 0 0 0-1.21 1.206c0 .49.26.908.707 1.097v1.588a3.49 3.49 0 0 0-1.064.334L3.275 1.685c.03-.113.056-.23.056-.353 0-.738-.598-1.336-1.336-1.336S.66.594.66 1.332s.598 1.336 1.336 1.336c.252 0 .485-.074.686-.195l.28.212L6.797 5.45c-.203.186-.392.398-.543.636-.306.485-.493 1.018-.493 1.6v.12a3.35 3.35 0 0 0 .21 1.156c.116.316.286.604.497.864l-1.274 1.277c-.377-.14-.8-.047-1.085.238-.194.193-.303.456-.302.73s.108.535.303.73.456.303.73.303.537-.108.73-.303.303-.456.302-.73a1.03 1.03 0 0 0-.048-.31l1.316-1.316c.18.125.375.23.585.32a3.42 3.42 0 0 0 1.369.288h.09c.552 0 1.073-.13 1.562-.395a3.23 3.23 0 0 0 1.224-1.153c.307-.49.475-1.033.475-1.63v-.03c0-.587-.136-1.128-.42-1.624zM10.42 8.984c-.357.397-.768.642-1.232.642H9.1c-.265 0-.525-.073-.778-.207a1.8 1.8 0 0 1-.682-.621c-.184-.26-.284-.544-.284-.845v-.09c0-.296.057-.577.2-.842.153-.3.36-.515.635-.694s.558-.265.88-.265h.03c.29 0 .567.057.827.19a1.75 1.75 0 0 1 .65.591 1.88 1.88 0 0 1 .291.83l.007.187c0 .407-.156.784-.467 1.126z",
    fill: "#f8761f"
  })));
};
HubspotIcon.SIZE = SIZE$6;
HubspotIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$A = Styled__default.div(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1C;
var PipedriveIcon = function PipedriveIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$B, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: dimensions,
    height: dimensions,
    viewBox: "0 0 820 304",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("title", null, "Pipedrive_full_logo_dark@1,5x"), /*#__PURE__*/React__default.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("polygon", {
    id: "path-1",
    points: "0 0 820 0 820 304 0 304"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M127.0461,96.3962 C127.0461,97.7153 127.5549,98.2465 128.8708,98.2465 L137.0555,98.2465 L137.0555,119.1314 L115.7823,119.1314 C107.2467,119.1314 103.264,115.0678 103.264,106.3207 L103.264,55.5118 C103.264,54.1218 102.8166,53.6703 101.4393,53.6703 L93.2546,53.6703 L93.2546,32.5995 L114.5015,32.5995 C122.9318,32.5995 127.0461,36.7959 127.0461,45.4102 L127.0461,96.3962 Z",
    id: "path-3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M184.3056,100.1951 C193.8238,100.1951 203.412,92.7849 203.412,76.1939 C203.412,61.648 195.8677,51.8828 184.639,51.8828 C175.4806,51.8828 165.6993,58.3103 165.6993,76.3621 C165.6993,87.8271 171.5417,100.1951 184.3056,100.1951 Z M189.1568,30.6438 C212.0968,30.6438 227.5187,48.8196 227.5187,75.8752 C227.5187,102.5058 211.2809,121.0977 188.0339,121.0977 C176.9631,121.0977 169.8399,116.3524 166.1467,112.9173 C166.173,113.7318 166.1993,114.6437 166.1993,115.6176 L166.1993,151.73009 L142.4084,151.73009 L142.4084,55.5126 C142.4084,54.1138 141.961,53.6712 140.5838,53.6712 L132.4078,53.6712 L132.4078,32.6003 L152.3652,32.6003 C161.5499,32.6003 163.8922,37.2749 164.3308,40.8782 C168.0766,36.6994 175.7876,30.6438 189.1568,30.6438 Z",
    id: "path-5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M254.3256,63.3859 L285.9064,63.3859 C284.9327,55.5773 279.4236,50.0794 272.2652,50.0794 C263.3524,50.0794 256.9047,54.8956 254.3256,63.3859 Z M272.2652,30.6464 C295.1087,30.6464 310.4605,47.1844 310.4605,71.7965 C310.4605,74.2931 309.9955,79.4014 309.9517,79.6139 L309.8201,81.1898 L253.4396,81.1898 C255.5011,92.6991 264.2209,100.0384 276.1339,100.0384 C288.5469,100.0384 297.9422,91.3003 298.0475,91.2206 L299.5826,89.7509 L309.9429,107.0945 L308.9867,108.0507 C308.4428,108.5819 295.6438,121.1004 274.6952,121.1004 C248.0621,121.1004 228.7363,102.0747 228.7363,75.8778 C228.7363,49.2472 246.6497,30.6464 272.2652,30.6464 Z",
    id: "path-7"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M354.535,100.1951 C363.6847,100.1951 373.4747,93.7765 373.4747,75.7158 C373.4747,63.8436 367.7112,51.8828 354.8596,51.8828 C343.5256,51.8828 335.9111,61.5152 335.9111,75.8752 C335.9111,90.6425 343.2273,100.1951 354.535,100.1951 Z M396.9323,96.3971 C396.9323,97.7162 397.4411,98.2474 398.7569,98.2474 L406.7662,98.2474 L406.7662,119.1323 L386.1685,119.1323 C377.2732,119.1323 374.8783,114.4047 374.3958,110.6686 C370.7026,114.9536 363.1408,121.0977 350.026,121.0977 C327.0773,121.0977 311.6553,102.9308 311.6553,75.8752 C311.6553,49.2445 327.7527,30.6438 350.8243,30.6438 C362.6232,30.6438 369.4745,34.8491 372.9835,38.0451 L372.9835,22.9414 C372.9835,21.5426 372.5361,21.0999 371.1588,21.0999 L362.9741,21.0999 L362.9741,0.0203 L384.221,0.0203 C392.7654,0.0203 396.9323,4.2167 396.9323,12.831 L396.9323,96.3971 Z",
    id: "path-9"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M459.672,31.4574 C461.5756,31.4574 463.5932,31.785 463.6634,31.8027 L465.1109,32.0506 L465.1109,55.9013 L463.1283,55.6003 C463.0932,55.5914 461.1106,55.2993 458.3824,55.2993 C450.689,55.2993 441.1796,59.5488 437.6005,71.4919 C436.4776,75.5556 435.8986,79.9468 435.8986,84.5062 L435.8986,119.1314 L412.1253,119.1314 L412.1253,55.5118 C412.1253,54.1129 411.6691,53.6703 410.2918,53.6703 L402.1159,53.6703 L402.1159,32.5995 L422.5557,32.5995 C430.9773,32.5995 435.267,36.5834 435.267,44.4274 L435.267,46.4017 C440.6708,37.2209 449.7766,31.4574 459.672,31.4574 Z",
    id: "path-11"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M498.9515,96.3962 C498.9515,97.7153 499.4603,98.2465 500.7761,98.2465 L508.9696,98.2465 L508.9696,119.1314 L487.714,119.1314 C479.1608,119.1314 475.1694,115.0678 475.1694,106.3207 L475.1694,55.5118 C475.1694,54.1218 474.7307,53.6703 473.3447,53.6703 L467.204,53.6703 L467.204,32.5995 L486.4244,32.5995 C494.8547,32.5995 498.9515,36.7959 498.9515,45.4102 L498.9515,96.3962 Z",
    id: "path-13"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M588.7077,32.6012 L588.7077,53.672 L585.0583,53.672 C583.1986,53.672 582.5845,54.3095 582.1459,55.4781 L558.1532,119.1332 L531.4148,119.1332 L507.4221,55.4781 C506.9835,54.3095 506.387,53.672 504.5272,53.672 L501.027,53.672 L501.027,32.6012 L514.5191,32.6012 C522.0283,32.6012 525.8706,35.1156 528.2479,41.5519 L543.7489,85.2251 C544.3366,86.8453 544.8717,88.6868 545.3191,90.4309 C545.749,88.6868 546.249,86.8718 546.7841,85.2517 L562.285,41.5608 C564.6361,35.1952 568.61,32.6012 576.0227,32.6012 L588.7077,32.6012 Z",
    id: "path-15"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M611.7108,63.3859 L643.2916,63.3859 C642.3179,55.5773 636.8175,50.0794 629.6417,50.0794 C620.7376,50.0794 614.3162,54.8956 611.7108,63.3859 Z M629.6417,30.6464 C652.5027,30.6464 667.8632,47.1844 667.8632,71.7965 C667.8632,74.2931 667.3807,79.4014 667.3544,79.6139 L667.2228,81.1898 L610.8248,81.1898 C612.8863,92.6991 621.6061,100.0384 633.5279,100.0384 C645.897,100.0384 655.3449,91.3003 655.4239,91.2206 L657.0029,89.7509 L667.3369,107.0945 L666.3719,108.0507 C665.8368,108.5819 653.029,121.1004 632.0716,121.1004 C605.4385,121.1004 586.1303,102.0747 586.1303,75.8778 C586.1303,49.2472 604.0349,30.6464 629.6417,30.6464 Z",
    id: "path-17"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    id: "path-19",
    points: "104.2255 0.0265 125.4197 0.0265 125.4197 22.5581 104.2255 22.5581"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    id: "path-21",
    points: "476.1335 0.0265 497.3365 0.0265 497.3365 22.5581 476.1335 22.5581"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M33.3002,76.3621 C33.3002,87.8271 39.1164,100.1951 51.9154,100.1951 C61.4071,100.1951 71.0042,92.7849 71.0042,76.1939 C71.0042,61.648 63.4599,51.8828 52.2312,51.8828 C43.0815,51.8828 33.3002,58.3103 33.3002,76.3621 Z M56.7402,30.6438 C79.6889,30.6438 95.1197,48.8196 95.1197,75.8752 C95.1197,102.5058 78.8643,121.0977 55.6261,121.0977 C44.5465,121.0977 37.4496,116.3524 33.7388,112.9173 C33.7652,113.7318 33.7827,114.6437 33.7827,115.6176 L33.7827,151.73009 L10.00936,151.73009 L10.00936,55.5126 C10.00936,54.1138 9.56197,53.6712 8.17592,53.6712 L0,53.6712 L0,32.6003 L19.94855,32.6003 C29.1333,32.6003 31.4843,37.2749 31.9317,40.8782 C35.66,36.6994 43.3885,30.6438 56.7402,30.6438 Z",
    id: "path-23"
  })), /*#__PURE__*/React__default.createElement("g", {
    id: "Pipedrive_full_logo_dark",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Pipedrive_full_logo"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React__default.createElement("g", {
    id: "Background",
    opacity: "0"
  }), /*#__PURE__*/React__default.createElement("g", {
    id: "Logo",
    transform: "translate(76.000000, 76.000000)"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-8",
    fill: "#26292C",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-11",
    fill: "#26292C",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-14",
    fill: "#26292C",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-17",
    fill: "#26292C",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-20",
    fill: "#26292C",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-23",
    fill: "#26292C",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-26",
    fill: "#26292C",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-29",
    fill: "#26292C",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-32",
    fill: "#26292C",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-35",
    fill: "#26292C",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React__default.createElement("use", {
    id: "Clip-5",
    fill: "#26292C",
    xlinkHref: "#path-23"
  }))))));
};
PipedriveIcon.SIZE = SIZE$6;
PipedriveIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$B = Styled__default.div(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1D;
var AdoIcon = function AdoIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$C, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    id: "f4337506-5d95-4e80-b7ca-68498c6e008e",
    xmlns: "http://www.w3.org/2000/svg",
    width: dimensions,
    height: dimensions,
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "ba420277-700e-42cc-9de9-5388a5c16e54",
    x1: "9",
    y1: "16.97",
    x2: "9",
    y2: "1.03",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    offset: "0",
    stopColor: "#0078d4"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "0.16",
    stopColor: "#1380da"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "0.53",
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "0.82",
    stopColor: "#559cec"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: "#5ea0ef"
  }))), /*#__PURE__*/React__default.createElement("title", null, "Azure DevOps"), /*#__PURE__*/React__default.createElement("path", {
    id: "a91f0ca4-8fb7-4019-9c09-0a52e2c05754",
    d: "M17,4v9.74l-4,3.28-6.2-2.26V17L3.29,12.41l10.23.8V4.44Zm-3.41.49L7.85,1V3.29L2.58,4.84,1,6.87v4.61l2.26,1V6.57Z",
    fill: "url(#ba420277-700e-42cc-9de9-5388a5c16e54)"
  })));
};
AdoIcon.SIZE = SIZE$6;
AdoIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$C = Styled__default.div(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1E;
var BambooHRIcon = function BambooHRIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$D, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    version: "1.1",
    id: "svg2",
    width: dimensions,
    height: dimensions,
    viewBox: "0 0 533.33331 533.33331"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,533.33333)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M 4000,2000 C 4000,895.441 3104.57,0 2000,0 895.434,0 0,895.441 0,2000 c 0,1104.57 895.434,2000 2000,2000 1104.57,0 2000,-895.43 2000,-2000 z m -1640.79,348.21 c -238.03,0 -365.64,-81.7 -455.12,-170.52 l -24.4,-25.61 -0.07,797.74 h -205.63 v -1305.6 c 0,-401.74 309.45,-652.048 664.52,-652.048 391.16,0 687.28,301.018 687.28,687.968 0,359.28 -308.87,668.07 -666.58,668.07 z M 1577,2083.27 l -91.26,299.05 c -54.47,157.29 -70.59,247.83 -224.06,409.88 -52.56,55.59 -251.53,177.92 -226.83,151.23 252.14,-272.17 381.09,-601.96 430.83,-693.56 -45.68,55.47 -99.23,105.28 -160.31,167.24 -52.02,52.76 -106.35,100.36 -158,132.26 -33.97,21.05 -53.05,32.65 -87.52,50.5 -155.346,80.7 -305.932,129.55 -363.745,143.98 -70.601,17.58 -140.203,22.17 -140.203,22.17 0,0 225.118,-190.05 321.547,-311.03 96.469,-120.92 194.871,-229.36 303.651,-273.69 108.77,-44.35 146.62,-57.05 232.15,-70 73.77,-11.12 163.75,-28.03 163.75,-28.03 z m 761.51,-903.69 c -258.29,0 -476.87,203.66 -476.87,476.44 0,272.94 184.3,497.1 481.5,497.1 297.27,0 472.4,-240.33 472.4,-492.06 0,-273.86 -185.33,-481.48 -477.03,-481.48",
    style: {
      fill: '#69c52f',
      'fill-opacity': 1,
      'fill-rule': 'evenodd',
      stroke: 'none'
    },
    id: "path14"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m 3748.36,395.941 c 1.08,-2.519 2.11,-4.91 3.1,-7.16 0.99,-2.242 1.84,-4.621 2.56,-7.14 0.91,2.519 1.71,4.898 2.43,7.14 0.72,2.25 1.8,4.641 3.25,7.16 l 45.62,81.797 c 1.61,2.344 3.15,3.883 4.58,4.602 1.45,0.711 3.6,1.07 6.49,1.07 H 3845 V 323.59 h -29.7 v 98.531 l 2.43,20.258 -49.4,-90.707 c -2.34,-5.043 -6.29,-7.563 -11.88,-7.563 h -4.86 c -5.58,0 -9.44,2.52 -11.61,7.563 l -49.67,89.898 2.16,-19.449 V 323.59 h -29.69 v 159.82 h 28.61 c 3.06,0 5.22,-0.359 6.48,-1.07 1.26,-0.719 2.87,-2.258 4.85,-4.602 z m -111.5,87.469 v -28.351 h -48.6 V 323.59 h -34.01 v 131.469 h -48.6 v 28.351 h 131.21",
    style: {
      fill: '#69c52f',
      'fill-opacity': 1,
      'fill-rule': 'nonzero',
      stroke: 'none'
    },
    id: "path16"
  })))));
};
BambooHRIcon.SIZE = SIZE$6;
BambooHRIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$D = Styled__default.div(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var img$1 = "data:image/png;base64,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";
var _templateObject$1F;
var HarvestIconWrapper = Styled__default.div(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteral(["\n    position: relative;\n    right: 6px;\n    z-index: 9;\n    width: 18px;\n    min-width: 18px;\n    height: 18px;\n    background-size: 18px;\n    border-radius: 3px;\n    background-image: url(", ");\n"])), img$1);
var HarvestIcon = function HarvestIcon(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React__default.createElement(HarvestIconWrapper, {
    title: title
  });
};
HarvestIcon.propTypes = {
  title: PropTypes__default.string
};
var _templateObject$1G;
var JiraIcon = function JiraIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$E, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: dimensions,
    height: dimensions,
    viewBox: "57.5 57.5 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#jiraicon)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M188.428 121.252L130.608 63.6301L125.006 58.0466L81.4807 101.423L61.5776 121.252C60.5835 122.248 60.0254 123.595 60.0254 125C60.0254 126.405 60.5835 127.752 61.5776 128.748L101.342 168.376L125.006 191.953L168.525 148.577L169.203 147.907L188.428 128.778C188.926 128.285 189.322 127.699 189.591 127.053C189.861 126.407 190 125.714 190 125.015C190 124.315 189.861 123.623 189.591 122.977C189.322 122.331 188.926 121.745 188.428 121.252ZM125.006 144.799L105.139 125L125.006 105.201L144.867 125L125.006 144.799Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M125.006 105.201C118.758 98.9754 115.235 90.5389 115.208 81.734C115.181 72.929 118.652 64.4713 124.862 58.208L81.3906 101.512L105.049 125.089L125.006 105.201Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M144.921 124.946L125.006 144.799C131.278 151.051 134.801 159.53 134.801 168.37C134.801 177.211 131.278 185.689 125.006 191.941L168.597 148.523L144.921 124.946Z",
    fill: "url(#paint1_linear)"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "121.449",
    y1: "85.1686",
    x2: "93.8007",
    y2: "112.906",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    offset: "0.18",
    stopColor: "#0052CC"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint1_linear",
    x1: "5122.74",
    y1: "5871.12",
    x2: "7949.84",
    y2: "7710.21",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    offset: "0.18",
    stopColor: "#0052CC"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "jiraicon"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "130",
    height: "134",
    fill: "white",
    transform: "translate(60 58)"
  })))));
};
JiraIcon.SIZE = SIZE$6;
JiraIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$E = Styled__default.div(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1H;
var SlackIcon = function SlackIcon(_ref) {
  var size = _ref.size,
    onClick = _ref.onClick;
  var dimensions = getDimensions(size);
  var handleClick = function handleClick(e) {
    /*
    	We only want to stop propagation if onClick is set i props
    	otherwise we want the click to propagate up
    */
    if (onClick) {
      e.stopPropagation();
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledSpan$F, {
    onClick: handleClick,
    width: dimensions,
    height: dimensions
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: dimensions,
    height: dimensions,
    viewBox: "0 0 126 126",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M27.2 80c0 7.3-5.9 13.2-13.2 13.2C6.7 93.2.8 87.3.8 80c0-7.3 5.9-13.2 13.2-13.2h13.2V80zm6.6 0c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V80z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M47 27c-7.3 0-13.2-5.9-13.2-13.2C33.8 6.5 39.7.6 47 .6c7.3 0 13.2 5.9 13.2 13.2V27H47zm0 6.7c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H13.9C6.6 60.1.7 54.2.7 46.9c0-7.3 5.9-13.2 13.2-13.2H47z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M99.9 46.9c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H99.9V46.9zm-6.6 0c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V13.8C66.9 6.5 72.8.6 80.1.6c7.3 0 13.2 5.9 13.2 13.2v33.1z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M80.1 99.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V99.8h13.2zm0-6.6c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2h33.1c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H80.1z",
    fill: "#ECB22E"
  })));
};
SlackIcon.SIZE = SIZE$6;
SlackIcon.propTypes = {
  onClick: PropTypes__default.func,
  size: PropTypes__default.oneOf(Object.values(SIZE$6))
};
var StyledSpan$F = Styled__default.div(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteral(["\n\tdisplay: inline;\n\tcursor: ", ";\n\theight: ", ";\n\twidth: ", ";\n"])), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.height + 'px';
}, function (props) {
  return props.width + 'px';
});
var _templateObject$1I, _templateObject2$M, _templateObject3$y, _templateObject4$r, _templateObject5$l, _templateObject6$e, _templateObject7$d;
var Gauge = function Gauge(_ref) {
  var _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    target = _ref.target,
    _ref$targetContent = _ref.targetContent,
    targetContent = _ref$targetContent === void 0 ? '' : _ref$targetContent,
    _ref$valueText = _ref.valueText,
    valueText = _ref$valueText === void 0 ? '' : _ref$valueText,
    affix = _ref.affix,
    _ref$startAngle = _ref.startAngle,
    startAngle = _ref$startAngle === void 0 ? -145 : _ref$startAngle,
    _ref$endAngle = _ref.endAngle,
    endAngle = _ref$endAngle === void 0 ? 145 : _ref$endAngle,
    _ref$activeColor = _ref.activeColor,
    activeColor = _ref$activeColor === void 0 ? '#88D6FF' : _ref$activeColor,
    width = _ref.width;
  var degreesPerTick = (Math.abs(startAngle) + Math.abs(endAngle)) / (Math.abs(min) + Math.abs(max));
  var valueDegrees = value * degreesPerTick + startAngle;
  var targetDegrees = target * degreesPerTick + startAngle;
  var degreesToRadian = function degreesToRadian(degrees) {
    return Math.PI / 180 * degrees;
  };
  var backgroundArcPath = d3.arc().innerRadius(0.7 * 200).outerRadius(0.9 * 200).startAngle(degreesToRadian(startAngle)).endAngle(degreesToRadian(endAngle)).cornerRadius(0.1 * 200)();
  var filledArcPath = d3.arc().innerRadius(0.7 * 200).outerRadius(0.9 * 200).startAngle(degreesToRadian(startAngle)).endAngle(degreesToRadian(valueDegrees)).cornerRadius(0.1 * 200)(); // Used to create a none rounde corner arc for the end of the filled arc

  var complimentaryFilledArcPath = d3.arc().innerRadius(0.7 * 200).outerRadius(0.9 * 200).startAngle(degreesToRadian(startAngle - startAngle * 0.05)).endAngle(degreesToRadian(valueDegrees))();
  return /*#__PURE__*/React__default.createElement(GaugeContainer, {
    width: width
  }, /*#__PURE__*/React__default.createElement(SVG, {
    width: "100%",
    height: "100%",
    viewBox: [-225, -200, 450, 400].join(' ')
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("filter", {
    id: "f1",
    x: "-90%",
    y: "-90%",
    width: "400%",
    height: "400%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React__default.createElement("feComponentTransfer", {
    "in": "SourceAlpha"
  }, /*#__PURE__*/React__default.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0.7"
  }), /*#__PURE__*/React__default.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0.7"
  }), /*#__PURE__*/React__default.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0.7"
  })), /*#__PURE__*/React__default.createElement("feGaussianBlur", {
    stdDeviation: "20"
  }), /*#__PURE__*/React__default.createElement("feOffset", {
    dx: "10",
    dy: "10",
    result: "shadow"
  }), /*#__PURE__*/React__default.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "shadow",
    operator: "over"
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: backgroundArcPath,
    fill: "#e4e4e4"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: filledArcPath,
    fill: activeColor
  }), 100 / (Math.abs(min) + Math.abs(max)) * value > 5 && /*#__PURE__*/React__default.createElement("path", {
    d: complimentaryFilledArcPath,
    fill: activeColor
  }), !!target && /*#__PURE__*/React__default.createElement("line", {
    transform: "rotate(".concat(targetDegrees, ")"),
    strokeDasharray: "10, 10",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "-190",
    stroke: "#6b73ca",
    strokeWidth: "6"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "40",
    fill: "#fff",
    filter: "url(#f1)"
  }), /*#__PURE__*/React__default.createElement("text", {
    x: "0",
    y: "150",
    className: "text",
    textAnchor: "middle",
    fill: "#535353",
    fontSize: "60"
  }, "".concat(value), !!affix && /*#__PURE__*/React__default.createElement("tspan", {
    fontSize: "40"
  }, affix)), /*#__PURE__*/React__default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(".concat(valueDegrees, ") translate(-200, -200)")
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M200.121257,7.5412075 C197.753287,7.45468566 195.759595,9.29966192 195.666558,11.6678802 L188.255672,200.308619 C188.249692,200.460838 188.246701,200.613159 188.246701,200.765495 C188.246701,207.094402 193.298362,212.24343 199.589467,212.400364 L199.958142,212.40405 C200.111395,212.40405 200.264634,212.401041 200.417769,212.395025 C206.879284,212.141179 211.911595,206.697304 211.65775,200.235789 L204.249725,11.6678802 C204.164566,9.50019389 202.479913,7.74861108 200.340919,7.55544212 L200.121257,7.5412075 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M200.048229,9.53987378 C201.244919,9.59036596 202.204254,10.5497009 202.251267,11.7463911 L209.659292,200.3143 C209.869776,205.672097 205.697055,210.186081 200.339258,210.396566 C200.21228,210.401555 200.085217,210.40405 199.958142,210.40405 L199.885255,210.40405 C194.562029,210.40405 190.246701,206.088722 190.246701,200.765495 C190.246701,200.639337 190.249178,200.513191 190.25413,200.38713 L197.665017,11.7463911 C197.71477,10.4799331 198.781771,9.49359943 200.048229,9.53987378 Z M200,196 C197.790861,196 196,197.790861 196,200 C196,202.209139 197.790861,204 200,204 C202.209139,204 204,202.209139 204,200 C204,197.790861 202.209139,196 200,196 Z",
    fill: "#535353"
  }))), /*#__PURE__*/React__default.createElement(LegendSection, null, !!target && /*#__PURE__*/React__default.createElement(LegendContainer, null, /*#__PURE__*/React__default.createElement(TargetLine, null), /*#__PURE__*/React__default.createElement(LegendText, null, targetContent)), /*#__PURE__*/React__default.createElement(LegendContainer, null, /*#__PURE__*/React__default.createElement(LegendRectangle, {
    color: activeColor
  }), /*#__PURE__*/React__default.createElement(LegendText, null, valueText))));
};
Gauge.propTypes = {
  /**
   * the minimum scale
   */
  min: PropTypes__default.number,
  /**
   * the maximum scale
   */
  max: PropTypes__default.number,
  /**
   * Value of the dial on the gauge
   */
  value: PropTypes__default.number.isRequired,
  /**
   * Optional target, to show a dotted line on the gauge
   */
  target: PropTypes__default.number,
  /**
   * text shown in the legent for the target
   */
  targetContent: PropTypes__default.node,
  /**
   * text shown in the legent for the value
   */
  valueText: PropTypes__default.string,
  /**
   * Optional changing the main color of the gauge
   */
  activeColor: PropTypes__default.string,
  /**
   * append a character or string of characters to the value
   */
  affix: PropTypes__default.string,
  /**
   * if using a high scale, the value displayed will collide with the arcs, so you can increase or decrease the start and end angle
   */
  startAngle: PropTypes__default.number,
  /**
   * if using a high scale, the value displayed will collide with the arcs, so you can increase or decrease the start and end angle
   */
  endAngle: PropTypes__default.number,
  /**
   * Width of the gauge container
   */
  width: PropTypes__default.number
};
var SVG = Styled__default.svg(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteral(["\n    text {\n        font-family: \"neue-haas-grotesk-text\";\n        font-weight: 600;\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.colors.v2_text_gray;
});
var GaugeContainer = Styled__default.div(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteral(["\n    display: inline-block;\n\tflex-direction: column;\n\t", "\n"])), function (props) {
  return props.width ? "width: ".concat(props.width, "px") : '';
});
var LegendSection = Styled__default.div(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n"])));
var LegendContainer = Styled__default.div(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\t&:not(:last-child) {\n\t\tmargin-right: 24px;\n\t}\n"])));
var LegendRectangle = Styled__default.div(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteral(["\n\tmargin: auto 10px auto 0px;\n    height: 12px;\n\twidth: 24px;\n\tbackground-color: ", "\n"])), function (props) {
  return props.color || props.theme.colors.v2_grey;
});
var TargetLine = Styled__default.div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteral(["    \n\tborder: 2px dashed #2f61d5;\n\theight: 0px;\n\twidth: 25px;\n\tmargin: auto 10px auto 0px;\n"])));
var LegendText = Styled__default.p(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteral(["\n    color: ", ";\n    margin: 0;\n    padding: 0;\n    font-size: 12px;\n"])), function (props) {
  return props.theme.colors.v2_text_gray;
});
chart_js.Chart.register(chart_js.CategoryScale, chart_js.LinearScale, chart_js.TimeScale, chart_js.PointElement, chart_js.LineElement, chart_js.Title, chart_js.Tooltip, chart_js.Legend, chart_js.Filler);
var AFFIX_POSITION = {
  PREFIX: 'PREFIX',
  SUFFIX: 'SUFFIX'
};
var Chart = function Chart(_ref) {
  var _ref$dataSets = _ref.dataSets,
    dataSets = _ref$dataSets === void 0 ? [] : _ref$dataSets,
    yAxisAffix = _ref.yAxisAffix,
    _ref$modifyOptions = _ref.modifyOptions,
    modifyOptions = _ref$modifyOptions === void 0 ? function (options) {
      return options;
    } : _ref$modifyOptions,
    _ref$usePointStyle = _ref.usePointStyle,
    usePointStyle = _ref$usePointStyle === void 0 ? false : _ref$usePointStyle;
  // used for setting timeperiod in config
  var earliestDate = moment.max();
  var latestDate = moment.min();
  var setMinMax = function setMinMax(date) {
    if (earliestDate.isAfter(date)) {
      earliestDate = date;
    }
    if (latestDate.isBefore(date)) {
      latestDate = date;
    }
  };
  var formatDataEntry = function formatDataEntry(data) {
    setMinMax(data.date);
    return {
      x: data.date.format('YYYY/MM/DD'),
      y: data.value,
      customData: data.customData
    };
  };
  var formmattedDataSets = React.useMemo(function () {
    return dataSets.map(function (dataSet) {
      return {
        type: dataSet.type || 'line',
        label: dataSet.name,
        order: dataSet.order,
        borderDash: dataSet.dashed ? [5, 5] : undefined,
        borderDashOffset: dataSet.borderDashOffset,
        borderColor: dataSet.color,
        backgroundColor: dataSet.backgroundColor || polished.transparentize(0.6, dataSet.color),
        pointStyle: dataSet.pointStyle || (usePointStyle ? 'line' : undefined),
        pointHoverRadius: dataSet.pointHoverRadius || 0,
        pointHoverBorderWidth: dataSet.pointHoverBorderWidth || 0,
        pointHoverBackgroundColor: dataSet.pointHoverBackgroundColor || '#fff',
        pointRadius: dataSet.pointRadius || 0,
        fill: dataSet.filled === true ? 'origin' : dataSet.filled || false,
        borderWidth: dataSet.borderWidth || 2,
        hideLegend: dataSet.hideLegend,
        hideLabel: dataSet.hideLabel,
        data: dataSet.data.map(formatDataEntry)
      };
    }).reverse();
  }, [dataSets]);
  var tooltipLinePlugin = {
    afterDatasetsDraw: function afterDatasetsDraw(chart) {
      if (chart.tooltip._active && chart.tooltip._active.length) {
        var activePoint = chart.tooltip._active[0],
          ctx = chart.ctx,
          y_axis = chart.scales.y,
          x = activePoint.element.x,
          topY = y_axis.top,
          bottomY = y_axis.bottom; // draw line

        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, topY);
        ctx.lineTo(x, bottomY);
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#e6e6e6';
        ctx.stroke();
        ctx.restore();
      }
    }
  };
  var getOptions = function getOptions(yAxisAffix, earliestDate, latestDate) {
    // calculate time.period
    var timeUnit = 'day';
    if (latestDate.diff(earliestDate, 'months', true) > 2) {
      timeUnit = 'month';
    } else if (latestDate.diff(earliestDate, 'months', true) > 1) {
      timeUnit = 'week';
    }
    var formatLabel = function formatLabel(label, affix) {
      if (!affix) {
        return label;
      }
      if (affix.position === AFFIX_POSITION.PREFIX) {
        return "".concat(affix.value).concat(label);
      }
      if (affix.position === AFFIX_POSITION.SUFFIX) {
        return "".concat(label).concat(affix.value);
      }
      throw Error('Affix object not formatted correctly');
    };
    var tooltip = {
      mode: 'index',
      intersect: false,
      backgroundColor: '#fff',
      borderColor: '#e6e6e6',
      borderWidth: 1,
      titleColor: '#535353',
      bodyColor: '#535353',
      footerColor: '#535353',
      padding: 12,
      usePointStyle: usePointStyle,
      callbacks: {
        title: function title(ctx) {
          var date = moment(ctx[0].label);
          return date.format('DD MMMM, YYYY');
        },
        label: function label(ctx) {
          var dataSetLabel = ctx.dataset.label ? "".concat(ctx.dataset.label, ": ") : '';
          return "".concat(dataSetLabel).concat(formatLabel(ctx.parsed.y, yAxisAffix));
        }
      }
    };
    var options = {
      budgetHeightHack: true,
      font: {
        family: 'neue-haas-grotesk-text'
      },
      elements: {
        line: {
          tension: 0
        }
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      },
      animation: {
        easing: 'easeInOutBack'
      },
      plugins: {
        tooltip: tooltip,
        filler: {
          propagate: true
        },
        datalabels: {
          display: false
        },
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: usePointStyle,
            filter: function filter(legendItem, data) {
              return !data.datasets[legendItem.datasetIndex].hideLegend;
            }
          }
        }
      },
      hover: {
        intersect: false
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            font: {
              color: 'rgba(0,0,0,0.5)'
            },
            maxTicksLimit: 5,
            padding: 20,
            callback: function callback(label) {
              return formatLabel(label, yAxisAffix);
            }
          },
          grid: {
            drawTicks: false,
            display: true,
            tickBorderDash: [8, 4]
          }
        },
        x: {
          type: 'time',
          time: {
            unit: timeUnit,
            displayFormats: {
              day: 'DD MMM ',
              week: 'DD MMM ',
              month: 'DD MMM '
            }
          },
          grid: {
            display: false
          },
          ticks: {
            font: {
              color: 'rgba(0,0,0,0.5)',
              size: 11
            },
            padding: 0
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false
    };
    return modifyOptions(options);
  };
  var dataConfig = {
    // labels: xAxisLabels,
    datasets: formmattedDataSets
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(reactChartjs2.Bar, {
    data: dataConfig,
    options: getOptions(yAxisAffix, earliestDate, latestDate),
    plugins: [tooltipLinePlugin]
  }));
};
Chart.register = chart_js.Chart.register;
Chart.propTypes = {
  dataSets: PropTypes__default.arrayOf(PropTypes__default.shape({
    type: PropTypes__default.string,
    name: PropTypes__default.string.isRequired,
    color: PropTypes__default.string.isRequired,
    filled: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),
    data: PropTypes__default.arrayOf(PropTypes__default.shape({
      date: PropTypes__default.object.isRequired,
      value: PropTypes__default.number,
      customData: PropTypes__default.object
    })).isRequired
  })).isRequired,
  usePointStyle: PropTypes__default.bool,
  yAxisAffix: PropTypes__default.shape({
    value: PropTypes__default.string.isRequired,
    position: PropTypes__default.oneOf([AFFIX_POSITION.PREFIX, AFFIX_POSITION.SUFFIX]).isRequired
  }),
  /**
   * Gives the option to modify the ChartJS options directly. Input to the function
   * is the pre-defined options and the function should return the modified options.
   */
  modifyOptions: PropTypes__default.func.isRequired
};
var _templateObject$1J, _templateObject2$N, _templateObject3$z;
var getBackgroundColor$1 = function getBackgroundColor(percent, threshold, theme) {
  if (+percent.toFixed(2) > +threshold.toFixed(2)) {
    switch (theme) {
      case 'LIGHT':
        return '#FFE3E2';
      case 'DARK':
        return '#FFC2C0';
    }
  } else {
    switch (theme) {
      case 'LIGHT':
        return '#EEFAF3';
      case 'DARK':
        return '#BFEDD3';
    }
  }
};
var Container$i = Styled__default.div(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteral(["\n    position: relative;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n"])));
var Meter = Styled__default.div(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteral(["\n\t\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: ", ";\n    background: ", ";\n"])), function (_ref) {
  var percent = _ref.percent;
  return "".concat(percent <= 1 ? 100 - percent * 100 : 0, "%");
}, function (_ref2) {
  var percent = _ref2.percent,
    threshold = _ref2.threshold,
    theme = _ref2.theme;
  return getBackgroundColor$1(percent, threshold, theme);
});
var PercentageText = Styled__default.p(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    font-weight: 500;\n    font-size: 12px;\n    z-index: 1;\n"])));
var Theme = {
  LIGHT: 'LIGHT',
  DARK: 'DARK'
};
var UtilizationMeter = function UtilizationMeter(_ref3) {
  var _ref3$percentage = _ref3.percentage,
    percentage = _ref3$percentage === void 0 ? 0 : _ref3$percentage,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? 'LIGHT' : _ref3$theme,
    content = _ref3.content,
    _ref3$checkmarkValue = _ref3.checkmarkValue,
    checkmarkValue = _ref3$checkmarkValue === void 0 ? 1 : _ref3$checkmarkValue,
    _ref3$redThreshold = _ref3.redThreshold,
    redThreshold = _ref3$redThreshold === void 0 ? 1 : _ref3$redThreshold,
    _ref3$warningThreshol = _ref3.warningThreshold,
    warningThreshold = _ref3$warningThreshol === void 0 ? 2 : _ref3$warningThreshol;
  if (!content) {
    if (percentage > warningThreshold) {
      content = /*#__PURE__*/React__default.createElement(WarningIcon$1, {
        updated: true
      });
    } else if (percentage.toFixed(2) === checkmarkValue.toFixed(2)) {
      content = /*#__PURE__*/React__default.createElement(CheckmarkIcon, null);
    } else {
      content = /*#__PURE__*/React__default.createElement(PercentageText, null, "".concat((percentage * 100).toFixed(0), "%"));
    }
  }
  return /*#__PURE__*/React__default.createElement(Container$i, null, /*#__PURE__*/React__default.createElement(Meter, {
    theme: theme,
    percent: percentage,
    threshold: redThreshold
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      zIndex: '1'
    }
  }, content));
};
UtilizationMeter.propTypes = {
  percentage: PropTypes__default.number,
  theme: PropTypes__default.oneOf(Object.values(Theme)),
  redThreshold: PropTypes__default.number,
  warningThreshold: PropTypes__default.number,
  checkmarkValue: PropTypes__default.number,
  /**
   * Optional content on top of the meter. If nothing is provided it comes with a default set.
   */
  content: PropTypes__default.node
};
exports.AIIcon = AIIcon;
exports.AdoIcon = AdoIcon;
exports.AffixedInput = AffixedInput;
exports.AssigneeGroup = AssigneeGroup;
exports.AttachmentIcon = AttachmentIcon;
exports.Badge = Badge;
exports.BambooHRIcon = BambooHRIcon;
exports.BaseLevelCalculationsHeader = BaseLevelCalculationsHeader;
exports.BaseLevelRow = BaseLevelRow;
exports.BaseLevelSimpleHeader = BaseLevelSimpleHeader;
exports.BasicNumberInput = BasicNumberInput;
exports.BasicTextInput = BasicTextInput;
exports.BetaTag = BetaTag;
exports.BlockedIcon = BlockedIcon;
exports.BottomOneLevelBlurryRow = BottomOneLevelBlurryRow;
exports.BottomOneRow = BottomOneRow;
exports.BottomTwoLevelBlurryRow = BottomTwoLevelBlurryRow;
exports.BottomTwoLevelRow = BottomTwoLevelRow;
exports.BugIcon = BugIcon;
exports.BulkSelectPopup = BulkSelectPopup;
exports.Button = Button;
exports.ButtonGroup = ButtonGroup;
exports.CalculationLoader = CalculationLoader;
exports.Card = Card;
exports.CardLoader = CardLoader;
exports.CaretIcon = CaretIcon;
exports.Chart = Chart;
exports.Checkbox = Checkbox;
exports.CheckmarkIcon = CheckmarkIcon;
exports.CircleText = CircleText;
exports.ClickableElement = ClickableElement;
exports.CollapseIcon = CollapseIcon;
exports.Collapsible = Collapsible;
exports.ColorPicker = ColorPicker;
exports.CommentIcon = CommentIcon;
exports.ContextMenu = ContextMenu;
exports.CopyIcon = CopyIcon;
exports.CrossIcon = CrossIcon;
exports.CrossIconOld = CrossIconOld;
exports.CurrencyInput = CurrencyInput;
exports.CustomScrollDiv = CustomScrollDiv;
exports.DeactivatedIcon = DeactivatedIcon;
exports.DependencyIcon = DependencyIcon;
exports.DeprecatedTooltip = DeprecatedTooltip;
exports.DragHandleIcon = DragHandleIcon;
exports.Dropdown = Dropdown;
exports.EconomicIcon = EconomicIcon;
exports.EmailIcon = EmailIcon;
exports.EmailLabel = EmailLabel;
exports.ExpandableIcon = ExpandableIcon;
exports.EyeIcon = EyeIcon;
exports.FilterIcon = FilterIcon;
exports.FullForecastLogo = FullForecastLogo;
exports.Gauge = Gauge;
exports.GithubIcon = GithubIcon;
exports.HarvestIcon = HarvestIcon;
exports.Hexagon = Hexagon$1;
exports.HexagonText = HexagonText;
exports.HoursInput = HoursInput;
exports.HubspotIcon = HubspotIcon;
exports.IconText = IconText;
exports.IconTextIcon = IconTextIcon;
exports.InputLabel = InputLabel;
exports.InvoiceRow = InvoiceRow;
exports.InvoiceRowHeader = InvoiceRowHeader;
exports.ItalicElement = ItalicElement;
exports.JiraIcon = JiraIcon;
exports.KebabMenuIcon = KebabMenuIcon;
exports.Label = Label;
exports.LabelGroup = LabelGroup;
exports.LockIcon = LockIcon;
exports.MSTeamsIcon = MSTeamsIcon;
exports.MeatballMenuIcon = MeatballMenuIcon;
exports.MinusIcon = MinusIcon;
exports.ModalHeaderInput = ModalHeaderInput;
exports.NewTabIcon = NewTabIcon;
exports.NotBillableIcon = NotBillableIcon;
exports.PageHeader = PageHeader;
exports.PageHeaderInput = PageHeaderInput;
exports.PercentageInput = PercentageInput;
exports.PipedriveIcon = PipedriveIcon;
exports.PlusIcon = PlusIcon;
exports.PriorityIcon = PriorityIcon;
exports.ProjectIndicator = ProjectIndicator$1;
exports.ProjectIndicatorList = ProjectIndicatorList;
exports.ProjectIndicatorText = ProjectIndicatorText;
exports.QuickbooksIcon = QuickbooksIcon;
exports.RadioButton = RadioButton;
exports.ReloadIcon = ReloadIcon;
exports.ResetIcon = ResetIcon;
exports.SIZE = SIZE$6;
exports.SageIntacctIcon = SageIntacctIcon;
exports.SalesforceIcon = SalesforceIcon;
exports.SavedFilter = SavedFilter;
exports.SelectDropdown = SelectDropdown;
exports.SingleText = SingleText;
exports.SlackIcon = SlackIcon;
exports.SortDirectionIcon = SortDirectionIcon;
exports.SortingIndicator = SortingIndicator;
exports.StarIcon = StarIcon;
exports.Stepper = Stepper;
exports.SubNavigation = SubNavigation;
exports.SubtaskIcon = SubtaskIcon;
exports.Switch = Switch;
exports.Tab = Tab;
exports.Table = Table;
exports.TableCell = TableCell;
exports.TableColumn = TableColumn;
exports.TableColumns = TableColumns;
exports.TableGrouping = TableGrouping;
exports.TableHeader = TableHeader;
exports.TableHeaderColumn = TableHeaderColumn;
exports.TableHeaderGrouping = TableHeaderGrouping;
exports.TableHeaderTitle = TableHeaderTitle;
exports.TableRow = TableRow;
exports.TableRows = TableRows;
exports.Tabs = Tabs;
exports.Tag = Tag;
exports.TaskRow = TaskRow;
exports.TaskRowHeader = TaskRowHeader;
exports.TaskRowHeaderV2 = TaskRowHeader$1;
exports.TaskRowV2 = TaskRow$1;
exports.TimesheetsIcon = TimesheetsIcon;
exports.Toast = Toast;
exports.Tooltip = Tooltip;
exports.UnapprovedIcon = UnapprovedIcon;
exports.UtilizationMeter = UtilizationMeter;
exports.VerticalDotsIcon = VerticalDotsIcon;
exports.WarningIcon = WarningIcon$1;
exports.WeekStepper = WeekStepper;
exports.XeroIcon = XeroIcon;
exports.YearStepper = YearStepper;
exports.theme = theme;
exports.useCollapsible = useCollapsible;